webpackJsonp([1],{

/***/ "/K/w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Qkg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjggMjMuNEwxMi4yIDEwLjZNMTIuMiAyMy40TDIxLjggMTAuNk0xNyAzM0MyNS44MzY4IDMzIDMzIDI1LjgzNjggMzMgMTdDMzMgOC4xNjMyIDI1LjgzNjggMSAxNyAxQzguMTYzMiAxIDEgOC4xNjMyIDEgMTdDMSAyNS44MzY4IDguMTYzMiAzMyAxNyAzM1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "2azS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+Jt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4K1A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55t4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Qkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Qie":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SuA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9AwD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AP3z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B7j/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "CkkA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dq3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MXkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js
var es = __webpack_require__("e6fC");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__("ESwS");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue-cookies/vue-cookies.js
var vue_cookies = __webpack_require__("ppUw");
var vue_cookies_default = /*#__PURE__*/__webpack_require__.n(vue_cookies);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__("C/JF");

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var vue_fontawesome_index_es = __webpack_require__("1e6/");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__("fhbW");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.es.js
var free_regular_svg_icons_index_es = __webpack_require__("Yu89");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__("DfMW");

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/i18n/en_US.js
/* harmony default export */ var en_US = ({
  button: {
    sendMail: "Sending mail",
    cancel: 'Cancel',
    confirm: 'Confirm',
    add: 'Add',
    settings: 'Settings',
    close: 'Close',
    delete: 'Delete',
    save: 'Save',
    edit: 'Update',
    view: 'Details',
    statistics: 'Statistics',
    infos: 'Live informations',
    export: 'Subscribers list',
    export_questions: 'Export questions',
    diffusion: 'Broadcast',
    comments: 'Comment list',
    encoding: 'Live station',
    done: 'done',
    link_export: 'export links',
    send_invitations: 'Send invitations',
    send_group_mails: 'Send group list',
    send: 'Send',
    share: 'Add screen share',
    validate: 'Validate',
    download: 'Download screen share file',
    show_live: 'Show live',
    ok: 'Ok',
    add_emails: 'Add emails',
    return: 'Return',
    copy: 'Copy',
    visualize: 'Visualize',
    restart: 'Restart',
    upload: 'Download',
    restore: 'Restore',
    flow: 'Flow'
  },
  parameters: {
    period: {
      period: 'Period',
      week: 'Week',
      month: 'Month',
      trimester: 'Trimester',
      semester: 'Semester',
      year: 'Year'
    },
    search: {
      title: 'Title',
      description: 'Description',
      search: "Search"
    },
    filter: {
      contributors: 'Contributors',
      date: 'Date',
      period: 'Period',
      search: 'Search',
      reset: 'Reset',
      no_options: 'Sorry, No matching options',
      no_contributor: 'Sorry, No matching options:'
    },
    select: {
      selectOption: 'Select'

    }
  },
  table: {
    pagination: {
      first: 'First',
      last: 'Last',
      prev: 'Prev',
      next: 'Next',
      show: 'Show',
      elements: 'Elements',
      elementPerPage: "Elements per page"
    },
    list: {
      id: 'Id',
      preview: 'Preview',
      title: 'Title',
      description: 'Description',
      active: 'Active',
      statut: "Status",
      date: 'Date',
      actions: 'Actions',
      idInscrit: "ID",
      nom: "Name",
      email: "Email",
      entreprise: "Company",
      participation: "Participation",
      subscribersList: "List of registrants"
    },
    empty: 'Sorry, there is nothing to display here.'
  },

  modal: {
    send_email: "Send an email",
    groups: "Groups",
    hour: "Hour",
    date: "Date",
    users: "Users",
    moderators: "Moderators",
    select_groups: "Select groups",
    EnterEmails: "Enter emails and press Enter",
    about: 'About',
    error: 'Please check all fields',
    errorDuplicate: "The speaker has already been updated with the same information.",
    errorEmail: "Invalid email address",
    errorEmailDuplicated: "Email is already exist",
    errorUpload: "Error while uploading image",

    success: "A speaker has been successfully added",
    successUpdate: "A speaker has been successfully updated",
    delete: {
      selection: {
        title: 'Are you sure to delete its lives?',
        subtitle: 'Selected elements deleted.',
        confirm_title: 'Deleted',
        confirm_msg: 'Deleted successfully .',
        cancel_title: 'Cancel',
        cancel_msg: 'Delete canceled',
        btn_confirm: 'Delete',
        btn_cancel: 'Cancel'
      },
      form: {
        subtitle: 'Selected elements deleted.'
      },
      title: 'Are you sure to delete this live?',
      subtitle: ' was deleted.',
      confirm_title: 'Deleted',
      confirm_msg: 'Deleted successfully .',
      cancel_title: 'Cancel',
      cancel_msg: 'Delete canceled',
      btn_confirm: 'Delete',
      btn_cancel: 'Cancel'
    },
    edit: {
      title: 'Edit the title of this screen',
      error_msg: 'Enter a name',
      btn_confirm: 'Edit',
      btn_cancel: 'Cancel'
    },
    view: {
      title: 'Live detail ',
      btn_cancel: 'Close',
      params: {
        title: 'Title',
        id: 'ID',
        description: 'Description',
        tags: 'Tags',
        date: 'Date',
        private: 'Private',
        automatic_share: 'Automatic share',
        active: 'Active',
        vignette: 'Thumbnail',
        like: 'I like',
        poll: 'Poll',
        registration: 'Subscribers registration',
        send_mails: 'send comments',
        share_file: 'Shared files',
        screen_share: 'Screen share',
        config: 'Default configuration',
        yes: 'Yes',
        no: 'No'
      }
    },
    setting: {
      diffusion: {
        title: 'Stream',
        endless: 'Available',
        archived: 'Archived',
        all: 'All',
        upcoming: 'Upcoming',
        trash: 'trash'
      }
    },
    infos: {
      title: 'Broadcast settings ',
      btn_cancel: 'Close',
      url_diffusion: 'Stream',
      name_flow: 'Key of flow',
      login: 'Login',
      pass: 'Password',
      link: 'Link',
      key: 'Key'
    },
    export: {
      title: 'Export Links of live : ',
      permalink: 'Permalink',
      permalink_participant: 'Speaker URL',
      standAlone: 'Stand alone url',
      standAlone_permalink: 'Listener URL',
      standAlone_permalink_participant: 'Participant URL',
      embed: 'Embed link',
      moderator: 'Moderator link',
      journalist: 'Prompter link',
      url: 'Export url',
      copy: 'Copy'
    },
    send_invitations: {
      title: 'Send invitations'
    },
    send_group_mails: {
      title: 'Send group list',
      insert_mails: {
        title: 'Insert emails',
        placeholder: 'Emails',
        label: 'List of emails',
        text: 'Please insert the emails in the following field'
      },
      send_mails: {
        title: 'Send to customers',
        text: 'Select emails group from the list below',
        groupLabel: 'Group list',
        mailLabel: 'Emails list'
      }
    },
    screen_share: {
      title: 'Output type',
      type: 'Choose the output type'
    },
    show_archived_live: {
      title: 'Archived live',
      not_found: 'Live not found',
      not_transcripted: 'Live not encoded'
    },
    direct: {
      start: {
        title: "Start live",
        subtitle: "Do you want to start live?"
      },
      stop: {
        title: "Stop live",
        subtitle: "Do you want to stop live?"
      },
      archiving: {
        title: {
          simple: "Are you sure you want to put this direct in the trash?",
          multi: 'Are you sure you want to put these directs in the trash?'
        },
        subtitle: {
          simple: " will be placed in the trash",
          multi: " will be placed in the trash"
        },
        success: {
          simple: ' is placed in the trash',
          multi: ' are placed in the trash'
        }
      },
      restoring: {
        title: {
          simple: "Are you sure you want to restore this direct?",
          multi: 'Are you sure you want to restore these directs?'
        },
        subtitle: {
          simple: " will be restored",
          multi: " will be restored"
        },
        success: {
          simple: ' is restored',
          multi: ' are restored'
        }
      },
      deleting: {
        title: {
          simple: "Are you sure you want to permanently delete this direct?",
          multi: "Are you sure you want to permanently delete these directs?"
        },
        subtitle: {
          simple: " will be permanently deleted",
          multi: " will be permanently deleted"
        },
        success: {
          simple: ' is deleted',
          multi: ' are deleted'
        }
      },
      checked_elements: 'The selected elements',
      flow: 'Live preview'
    }
  },
  calendar: {
    title: 'Calendar',
    allDay: 'all-day',
    back: 'Return to list',
    statistics: 'Statistics',
    view: 'View',
    edit: 'Edit',
    period: {
      show: 'show as',
      week: 'Week',
      month: 'Month',
      day: 'Day',
      today: 'Today'
    },
    months: {
      january: 'january',
      february: 'february',
      march: 'march',
      april: 'april',
      may: 'may',
      june: 'june',
      july: 'july',
      august: 'august',
      september: 'september',
      october: 'october',
      november: 'november',
      december: 'december'
    }
  },
  form_live: {
    consent: {
      title: 'Video conference recording',
      noConsent: 'Without consent (default option)',
      withConsent: "With participants' consent"
    },
    tabs: {
      pick_video: 'Please choose a video',
      required_message: 'This field is required',
      error_long_message: 'Message must not exceed 255 characters',
      general: {
        title: 'General',
        form: {
          title: 'Title',
          description: 'Description',
          types: "Display type",
          type_default: "Default",
          add_image: 'Add thumbnail',
          description_image: 'Recommended image size: 1280 x 720',
          edit_image: 'Update',
          delete_image: 'Delete',
          start_date: 'Start date',
          end_date: 'End date',
          start_hour: 'Start hour',
          end_hour: 'End hour',
          tags: 'Tags',
          themes: 'Themes',
          invalid_date: 'Invalid date ',
          invalid_hour: 'Invalid hour',
          access_live: 'Direct access modes',
          access_free: 'Free access',
          access_secure: 'Secured access',
          placeholder_pass: 'enter your password',
          secure_pass: 'Generate a secure password',
          schedule_live: 'Schedule live',
          share_live: {
            title: 'Live sharing link',
            copy: 'Copy'
          },
          archived_live: 'Automatic live archivingt',
          duration: 'Durée',
          video: {
            visible: 'Visible',
            invisible: 'Invisible'
          },
          publish: 'Publishing rights',
          multimedia_options: 'Live multimedia options',
          interactives_options: {
            title: 'Live interactive options',
            social_media: {
              fb: 'Live broadcast on your Facebook page',
              youtube: 'Archiving the video on your Youtube channel'
            }
          },
          infos: {
            vignette: "cliquez sur l'icone pour modifier la vignette de votre vidéo",
            archived_live: 'Your direct will be automatically archived and available for viewing on demand video',
            access_free: "Le direct sera visible sans mot de passe, ni autre procédure d'accès sécurisé)",
            access_secure: 'Le direct sera accessible avec le mot de passe que vous saisissez ci-dessous',
            secure_pass: 'Un mot de passe sera généré pour chaque invitation par mail',
            share_live: 'Le lien comprend le titre de votre conférence',
            themes: "Le thème s'applique pour les vidéos à la demande, vous pouvez choisir un ou plusieurs thèmes",
            rich_media: "Cette option permet d'associer des images synchronisées avec la vidéo",
            attaching_files: "Cette option permet d'ajouter des documents téléchargeables",
            tags: "Les mots clés permettent d'améliorer le référencement des vidéos"
          }
        }
      },
      configuration: {
        title: 'Configuration',
        form: {
          infos_live: 'Information display before live',
          title_before_live: 'Title (posted on the live page)',
          title_live: 'Live title',
          description: 'Description text',
          text: 'Text',
          description_before_live: 'Description (posted on the live page)',
          text_before_live: 'Text before live',
          message: {
            title: 'Message',
            description: 'Description (posted on the live page)'
          },
          video: {
            title: 'Video',
            description: 'Search...'
          },
          image: 'Image',
          countdown: 'Countdown',
          skins_live: 'Selection of the template for the live page',
          more: 'Show all',
          less: 'Show less',
          contact: 'Contact',
          informations: 'Additional live information',
          about: 'About',
          intervenants: {
            title: 'Contributors',
            add: 'Add Contributor',
            firstName: 'FirstName',
            lastName: 'LastName',
            fonction: 'Fonction',
            email: 'E-mail',
            biography: 'Biography'
          },
          email: 'E-mail',
          phone: 'Phone',
          address: 'Address',
          send_invitations: {
            title: 'Sending live invitations',
            group_emails: 'Group',
            emails: 'E-mail'
          },
          send_rule: {
            title: 'Sending rule',
            days_left: 'Day (s) before the live at',
            add_rule_button: 'Add rule'
          },

          encoding: {
            title: 'Encoding options ',
            url: 'Direct stream url',
            name: 'Direct stream name',
            key: 'Security key (optional)'
          },
          infos: {
            skins_live: 'You can edit the templates in the "Web site" function',
            message: 'Text displayed before the live broadcast',
            video: 'Video displayed before the live broadcast',
            image: 'Image displayed before the live broadcast',
            about: 'Appears on the "About" link page',
            contact: 'Appears on the "Contact" link page',
            intervenants: 'Displayed in the live page (in the "Description" link',
            group_emails: 'A group is a set of emails, groups can be edited in the "Email" function',
            send_rule: 'You can define one or more rules to send invitations by email',
            encoding: '\n' + 'This option applies if you are using an external encoder, see FAQ'
          }
        }
      },
      advanced: {
        title: 'Advanced parameters',
        type: {
          title: 'Live type',
          intranet: 'Intranet',
          internet: 'Internet'
        },
        diffusion: {
          type_source: "Live usage type",
          diffusion_social_media: "Sharing on social media",
          medias: "Medias",
          title_empreinte: 'Sources',
          webinar_empreinte: 'Empreinte Live',
          encodeur_empreinte: "Video Encoder",
          languages_empreinte: "Multilingual",
          ajoute_entree: "(add entry)",

          title: 'Stream',
          webinar: 'Live studio',
          encoding: 'Manual encoder',
          sharing: 'Screen sharing',
          externalHlst: "external Hls",
          encoder: "Encoder",
          protocol: "Protocol type",
          languages: "Languages",
          languagesPlaceholder: "Select languages",
          countries: "Countries",
          countriesPlaceholder: "Select countries",
          addyoutubeLanguage: "ADD THIS LANGUAGE",
          emptyInput: "Please enter a YouTube URL",
          select_station: "Choose a station",
          validUrl: "The YouTube URL entered is not valid",
          duplicateUrl: "This URL is already associated with another language",
          "language": {
            "orateur": "speaker",
            "FL1": "Floor Language",
            "FL2": "Floor Language 2",
            "Français": "French",
            "Anglais": "English",
            "ES": "Spanish",
            "RU": "Russian",
            "AR": "Arabic",
            "ZH": "Chinese",
            "Autres": "Other"
          },
          encodeur_automatique: "Automatic encoder",
          index_audio_port: "Audio port index",
          index_video_port: "Video port index",
          screen_share: {
            pip: 'Picture in Picture PIP',
            sbs: 'Side by Side'
          },
          type: {
            title: "Webinar choice",
            title_empreinte: "Acces Empreinte Live",
            by_link_empreinte: "Individual private access",
            private_empreinte: "Private access",
            public_empreinte: "Public access",
            by_link: "Url per user",
            private: "Private",
            public: "Public"
          },
          connexion: {
            title: "Connection type",
            title_empreinte: "Login",

            auto: "Automatic",
            auto_description: "Direct access (default)",
            by_authorization: "With permission",
            by_authorization_description: "Waiting room: Access after validation"
          }
        },
        options: {
          title: 'General options',
          title_empreinte: "Video Options",
          private_video: 'Private video',
          active_video: 'Active video',
          automatic_share: 'Automatic sharing',
          saveVideo: "Save video"
        },
        contributors: {
          header: "Profiles",
          participantTitle: 'Participants',
          importMultiParticipants: "Select one or more email addresses, or import a CSV or Excel file.",
          title: 'Administrators',
          admin_description: "Conference manager with full control.",
          participants_description: "Videoconference participants (limited rights).",
          moderators_description: "Allowed to manage comments (chat, Q&A).",
          select_item: 'Press enter to select',
          selected_item: 'Selected',
          delete_item: 'Press enter to delete',
          no_result: 'No elements found. Consider changing the search query.',
          no_options: 'List is empty..',
          add_email: 'Add this email'
        },
        rich_media: {
          title: 'Rich Media',
          tabs: {
            chapters: {
              title: 'Chapters',
              empty: 'No Chapters',
              fields: {
                title: 'Title',
                new: 'New Chapter'
              }
            },
            questions: {
              title: 'Questions',
              empty: 'No questions',
              add_new: 'Add new question',
              new: 'New question',
              edit: 'Update',
              form: {
                title: 'Question title',
                local_questions: {
                  yes_no: 'Yes-No',
                  yes_no_nsp: 'Yes-No-NSP',
                  simple_choice: 'Simple Choice',
                  multiple_choice: 'Multiple Choice',
                  response: 'Response',
                  button_add: 'Add'
                }
              }
            },
            slides: {
              title: 'Slides',
              edit: 'Update',
              delete: 'Delete',
              button_show: {
                title: 'Show',
                less: 'less',
                more: 'more'
              }
            }
          }
        },
        polls: {
          label: 'Poll',
          title: 'Polls',
          helper_create_after_save: 'Polls will be created after the live is saved.',
          loading: 'Loading polls...',
          saving: 'Saving polls...',
          empty: 'No polls yet.',
          add: 'Add poll',
          add_first: 'Create first poll',
          add_hint: 'Open a new poll tab',
          tab_label: 'Poll {number}',
          untitled: 'Untitled poll',
          options_count: '{count} options',
          incomplete: 'Incomplete',
          editor_hint: 'Edit one poll at a time while keeping the full list visible above.',
          question_label: 'Question',
          question_placeholder: 'Enter poll question',
          publish_label: 'Posted automatically, visible to everyone.',
          option_label: 'Option {number}',
          option_placeholder: 'Enter option',
          add_option: 'Add option',
          existing_hint: 'Existing polls can now add, edit, and delete options before save.',
          delete_poll: 'Delete poll',
          delete_option: 'Delete option',
          confirm_delete_poll: 'Delete this poll?',
          confirm_delete_option: 'Delete this option?',
          min_options_warning: 'A poll needs at least 2 options.',
          delete_option_error: 'Unable to delete this poll option right now.',
          complete_current_first: 'Complete the current poll before adding a new one.',
          publish_error: 'Unable to update poll visibility right now.',
          validation_question_required: 'Question is required.',
          validation_min_options: 'Each poll needs at least 2 options.',
          validation_options_required: 'All poll options are required.'
        },
        presentation: {
          label: 'Presentation',
          loading: 'Loading presentations...',
          uploading: 'Uploading presentation...',
          deleting: 'Deleting presentation...',
          empty: 'No presentation yet.',
          upload: 'Upload document',
          formats_hint: 'PDF, PPTX, DOCX',
          refresh: 'Refresh',
          open: 'Open',
          delete: 'Delete',
          file: 'File',
          untitled: 'Untitled presentation',
          slides_count: '{count} slides',
          pending: 'Waiting for live save',
          helper_create_after_save: 'Save the live first to upload a presentation.',
          queued_success: 'Presentation added. It will be uploaded after the live is saved.',
          upload_success: 'Presentation uploaded successfully.',
          upload_error: 'Unable to upload the presentation right now.',
          fetch_error: 'Unable to load presentations right now.',
          delete_success: 'Presentation deleted successfully.',
          delete_error: 'Unable to delete this presentation right now.'
        },
        documents: {
          toggle_label: 'Shared files',
          title: 'Shared documents',
          empty: 'No shared documents yet.',
          upload: 'Select files to share',
          refresh: 'Refresh',
          delete: 'Delete',
          publish_default: 'Publish to the audience by default',
          pending: 'Waiting for live save',
          private: 'Private',
          public: 'Public',
          fichier: "File(s)",
          queued_success: 'Document added. It will be uploaded after the live is saved.',
          upload_success: 'Document uploaded successfully.',
          upload_error: 'Unable to upload this document right now.',
          fetch_error: 'Unable to load documents right now.',
          delete_success: 'Document deleted successfully.',
          delete_error: 'Unable to delete this document right now.',
          publish_error: 'Unable to update this document visibility right now.',
          uploaded_by: 'Added by',
          unpublish_all: 'Unpublish all for the audience',
          unpublish_all_success: 'All documents were unpublished for the audience.',
          unpublish_all_error: 'Unable to unpublish all documents right now.',
          unpublish_all_nothing: 'No documents to unpublish for the audience.',
          copy_link: 'Copy link',
          link_copied: 'Document link copied.',
          save_first: 'Save the live first to manage shared documents online.',
          visibility: 'Visible to the audience'
        },
        attaching_files: 'Attaching files',
        attaching_files_empreinte: 'Attached files'

      },
      frontOffice: {
        title: 'Front office parameters',
        access_page_direct: "Access to the live page",
        lecteur_video: "Video player",
        sous_titrage: "Subtitling",
        mdp: "Password",
        inscri_abonne: "Subscriber registration",
        options: {
          title: 'Options',
          subtitles_empreinte: 'Live subtitles',
          autoTranscription_empreinte: 'Closed captions',
          chat_empreinte: "Chat Web",
          privateChat_empreinte: "Private chat",

          like: 'Like mention',
          subtitles: 'Real-time subtitles',
          autoTranscription: 'Auto transcription',
          chat: 'Listener chat',
          privateChat: "Backstage",
          sharing_files: 'Shared files',
          sharing_files_live_event: { text: 'Visible on the Live Streaming page', explanation: '' },
          sharing_files_emails: 'Sent by email (link)',
          sharing_files_studio_live: { text: 'Available in the meeting', explanation: '' },
          social_media: {
            title: 'Social media',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: 'Youtube'
          },
          interactive_tools: {
            title: 'Interactive tools',
            whiteBoard: 'White Board',
            outils: "Tools",
            survey: 'Survey',
            question: 'Question',
            excel: 'Excel',
            autoSip: 'SIP call'
          },
          secure_pass: '\n' + 'Secure with password',
          registration: {
            title: '\n' + 'Registration of subscribers ',
            poll: 'Poll'
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'With confirmation',
            replies: 'With answers',
            questionsBeforeLive: 'Questions before the live'
          }
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'By default',
          personalized: {
            title: 'Personalized',
            title_before_live: 'Title (posted on the live page)',
            title_live: 'Live title',
            description: 'Description text',
            text: 'Text',
            description_before_live: 'Description (posted on the live page)',
            text_before_live: 'Text before live',
            message: {
              title: 'Message',
              description: 'Description (posted on the live page)'
            },
            video: {
              title: 'Video',
              description: 'Search...'
            },
            image: 'Image',
            countdown: 'Countdown',
            pearl: 'Encoding station'
          }
        }
      },

      Program: {
        title: 'Programmes & Intervenants',
        new_title: 'Program',
        ParticpantsLimit: 'Limit of participants',
        LiveProgram: 'Live program',
        LiveProgramDescription: 'hh:mm - hh:mm \nSubject title and description',
        MaxParticipantsDistance: 'Max participants online',
        MaxInvited: 'Max participants on-site',
        Intervenants: 'Participants',
        AddParticipant: 'Add a participant',
        editParticipant: 'Edit a participant',
        Photo: 'Picture',
        Cliquez: 'Click to Upload',
        Nom: 'Last name',
        Prenom: 'First name',
        Fonction: 'Function',
        Structure: 'Structure',
        Email: 'Email',
        Annuler: 'Cancel',
        Ajouter: 'Add',
        Inscription: 'Inscription',
        Description: "Description",
        Role: "Role",
        options: {
          title: 'Options',
          like: "Mention j'aime",
          chat: 'Chat',
          sharing_files: 'Shared files',
          social_media: {
            title: 'Réseaux sociaux',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: 'Youtube'
          },
          secure_pass: 'Sécurisé avec mot de passe',
          registration: {
            title: 'Inscription des abonnés',
            poll: 'Sondage'
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'Avec confirmation',
            replies: 'With replies',
            questionsBeforeLive: 'Questions before live'
          }
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'Par défaut',
          personalized: {
            title: 'Personnalisé',
            title_before_live: 'Titre(affiché sur la page du direct)',
            title_live: 'Titre du direct',
            description: 'Texte de description',
            description_before_live: 'Description (affichée sur la page du direct)',
            text: 'Texte',
            text_before_live: 'Texte avant live',
            message: {
              title: 'Message',
              description: 'Message (affiché sur la page du direct)'
            },
            video: {
              title: 'Vidéo',
              description: 'Rechercher...'
            },
            image: 'Image',
            countdown: 'Comptes à rebours',
            pearl: "Station d'encodage"
          }
        }
      },
      SkinModel: {
        title: "Display Model",
        new_title: "Web Page",
        selectOrCreate: "Select an existing model or create a new one",
        choose: "Choose…",
        selectedSkin: "The applied model for this live is:",
        createNew: "Create a new model",
        existingSkins: "Created models",
        explanation: "You can reuse a model already used in another live.",
        newSkin: "Create a new model",
        primaryColor: "Primary color",
        secondaryColor: "Secondary color",
        primaryTextColor: "Primary text color",
        secondaryTextColor: "Secondary text color",
        liveTitle: "Title to display",
        logo: "Logo",
        beforeAfterInfo: "Before/After live info",
        beforeLiveInfo: "Before live info",
        afterLiveInfo: "After live info",
        infoText: "Text",
        showDate: "Show date",
        showHour: "Show hour",
        backgroundImage: "Background image",
        blurred: "Blurred",
        skinName: "Model name",
        addAndApply: "Apply",
        applySkin: "Edit",
        editNote: "Note: Modifying the model will affect the lives that use the same model."
      }

    }
  },
  upload_files: {
    title: 'Drag and drop',
    image_type: ' an image here',
    file_type: ' a file here',
    media_type: ' a media here',
    or: 'or ',
    click: 'click',
    selected_file: ' to select file from your computer'
  },
  vignette: {
    confirm: 'Confirm',
    edit: 'Update',
    delete: 'Delete',
    streaming_wrapper: 'LIVE STREAMING'
  },
  toast: {
    success_delete: 'Element successfully deleted!',
    success_add: 'Live successfully created!',
    success_edit: 'Live successfully updated!',
    success_diffusion: 'the broadcast was successful',
    error: 'An error occurred please try again!',
    success_send: 'Invitation was successfully sending!',
    success_send_link: 'Link was successfully sending!',
    success_download: 'Live was successfully downloaded!',
    'not-exist': "File does not exist!",
    no_emails_provided: 'No emails provided',
    no_date_provided: "No date provided",
    export_success: "File exported successfully",
    export_Error: "Error exporting Excel file",
    export_empty: "No existing data to export.",
    DeleteError: "Error occurred while deleting the participant",
    UpdateError: "Error occurred while updating the participant",
    AddError: "Error occurred while adding the participant",
    getModeratorsError: "Error occurred while getting the moderators",
    export_questions_success: "Questions exported successfully",
    no_questions_to_export: "No questions to export",
    export_questions_error: "Error occured while exporting questions"

  },
  date: {
    placeholder: 'Select a date'
  },
  statut: {
    Archive: "Archived",
    Live: "Live",
    Waiting: "Waiting",
    error: ""
  },

  startDirect: {
    title: 'Confirmation ',
    subtitle: "Do you want to start direct now ?",
    choix: 'Check this box to define this default choice and no longer display this window.',
    btn: {
      YES: 'YES',
      NO: 'NO'
    }
  },
  shareLink: {
    from: "From",
    to: "Send to ",
    selected: "Selected",
    link: "Link",
    password: "Password",
    secure_password: "Generate a secure password ",
    send_plan: "Schedule the shipment",
    planifier: "Schedule",
    date_plan: "The shipment will be scheduled on the specified date ",
    journalist: "Prompter",
    moderator: "Moderator",
    listener: "Listener",
    participant: "Participant",
    emails_placeholder: "Enter emails and press Enter"

  }
});
// CONCATENATED MODULE: ./src/i18n/fr_FR.js
/* harmony default export */ var fr_FR = ({
  button: {
    sendMail: "Envoi mail",
    cancel: 'Annuler',
    confirm: 'Confirmer',
    add: 'Ajouter',
    settings: 'Propriétés',
    close: 'Fermer',
    delete: 'Supprimer',
    save: 'Enregistrer',
    edit: 'Modifier',
    view: 'Details',
    statistics: 'Statistiques',
    infos: 'Informations du direct',
    export: 'Liste des inscrits',
    export_questions: 'Liste des questions',
    diffusion: 'Diffuser',
    comments: 'Liste des commentaires',
    encoding: 'Encodeur externe',
    done: 'Ok',
    link_export: "lien d'export",
    send_invitations: 'Envoyer des invitations',
    send_group_mails: 'Liste des groupes',
    send: 'Envoyer',
    share: "Ajouter partage d'écran",
    validate: 'Valider',
    download: "Télécharger le fichier de partage d'écran",
    show_live: 'Afficher le direct',
    ok: 'Ok',
    add_emails: 'Ajouter E-mails',
    return: 'Retour',
    copy: 'Copier',
    visualize: 'Visualiser',
    restart: 'Rediffuser',
    upload: 'Télécharger',
    restore: 'Restaurer',
    flow: 'Flux'
  },
  parameters: {
    period: {
      period: 'Période',
      week: 'Semaine',
      month: 'Mois',
      trimester: 'Trimestre',
      semester: 'Semestre',
      year: 'Année'
    },
    search: {
      title: 'Titre',
      description: 'Description',
      search: "Chercher"
    },
    filter: {
      contributors: 'Contributeur',
      date: 'Date',
      period: 'Période',
      search: 'Rechercher',
      reset: 'Réinitialiser',
      no_options: 'Désolé, aucune option correspondante',
      no_contributor: 'Désolé, aucun contributeur ne correspond à votre recherche'

    },
    select: {
      selectOption: 'Sélectionner'

    }
  },
  table: {
    pagination: {
      first: 'Premier',
      last: 'Dernier',
      prev: 'Précédent',
      next: 'Suivant',
      show: 'Afficher',
      elements: 'éléments',
      elementPerPage: "éléments par page"
    },
    list: {
      id: 'Id',
      preview: 'Aperçu',
      title: 'Titre',
      description: 'Description',
      active: 'Active',
      statut: "Statut",
      date: 'Date',
      actions: 'Actions',
      idInscrit: "ID",
      nom: "Nom",
      email: "Email",
      entreprise: "Entreprise",
      participation: "Participation",
      subscribersList: "Liste d'inscrits"
    },
    empty: "Désolé, il n'y a rien à afficher ici."
  },
  modal: {
    groups: "Groupes",
    hour: "Heure",
    date: "Date",
    users: "Utilisateurs",
    moderators: "Modérateurs",
    send_email: "Envoyer un email",
    EnterEmails: "Saisissez les e-mails et appuyez sur Entrée",
    select_groups: "Sélectionner le groupe d’utilisateurs de la liste ci-dessous",
    about: 'A propos',
    error: 'Veuillez vérifier tous les champs',
    errorDuplicate: "L'intervenant a été déjà mis à jour avec les mêmes informations.",
    errorEmail: "Adresse e-mail invalide",
    errorEmailDuplicated: "L'e-mail existe déjà",
    errorUpload: "Erreur lors du téléchargement de l'image",
    success: "Un intervenant a été ajouté avec succès",
    successUpdate: "L'intervenant a été modifié avec succès",
    delete: {
      selection: {
        title: 'Voulez-vous supprimer cette sélection de directs ?',
        subtitle: 'Les éléments sélectionnés seront supprimés.',
        confirm_title: 'Supprimé',
        confirm_msg: 'La suppression est effectuée avec succès.',
        cancel_title: 'Annuler',
        cancel_msg: 'Vous avez annulé la suppression',
        btn_confirm: 'Supprimer',
        btn_cancel: 'Annuler'
      },
      form: {
        subtitle: "L'élément sélectionné sera supprimé."
      },
      title: 'Voulez-vous supprimer ce direct ?',
      subtitle: ' sera supprimé.',
      confirm_title: 'Supprimé',
      confirm_msg: 'La suppression est effectuée avec succès.',
      cancel_title: 'Annuler',
      cancel_msg: 'Vous avez annulé la suppression',
      btn_confirm: 'Supprimer',
      btn_cancel: 'Annuler'
    },

    edit: {
      title: 'Modifier le titre de cet écran',
      error_msg: 'Entrer un nom',
      btn_confirm: 'Modifier',
      btn_cancel: 'Annuler'
    },
    view: {
      title: 'Détail du direct ',
      btn_cancel: 'Fermer',
      params: {
        title: 'Titre',
        id: 'Identifiant',
        description: 'Description',
        tags: 'Tags',
        date: 'Date',
        private: 'Privé',
        automatic_share: 'Publier automatiquement',
        active: 'Actif',
        vignette: 'Vignette',
        like: "J'aime",
        poll: 'Sondage',
        registration: 'Inscription des abonnées',
        send_mails: 'Envoi des commentaires',
        share_file: 'Documents partagés',
        screen_share: "Partage d'écran",
        config: 'Configuration par défaut',
        yes: 'Oui',
        no: 'Non'
      }
    },
    setting: {
      diffusion: {
        title: 'Diffusion',
        endless: 'En cours',
        archived: 'Archivés',
        all: 'Tout',
        upcoming: 'A venir',
        trash: 'Corbeille'
      }
    },
    infos: {
      title: 'Paramètres de diffusion ',
      btn_cancel: 'Fermer',
      url_diffusion: 'Diffusion',
      name_flow: 'Clé du flux',
      login: 'Login',
      pass: 'Mot de Passe',
      link: 'Lien',
      key: 'Clé'
    },
    export: {
      title: "Liens d'export du direct : ",
      permalink: 'Permalien',
      permalink_participant: 'URL intervenant',
      standAlone: 'Url autonome',
      standAlone_permalink: 'URL auditeur',
      standAlone_permalink_participant: 'URL participant',
      embed: "Lien d'intégration",
      moderator: "Lien modérateur",
      journalist: "Lien prompteur",
      url: "Url d'export",
      copy: 'Copier'
    },
    send_invitations: {
      title: 'Envoyer des invitations'
    },
    send_group_mails: {
      title: 'Envoyer liste des groupes',
      insert_mails: {
        title: 'Ajouter E-mails',
        placeholder: 'E-mails',
        label: 'Liste des emails',
        text: 'Veuillez insérer les e-mails dans le champ suivant'
      },
      send_mails: {
        title: 'Envoie aux clients',
        text: "Sélectionnez un groupe d'e-mails dans la liste ci-dessous",
        groupLabel: 'Liste des groupes',
        mailLabel: 'Liste des E-mails'
      }
    },
    screen_share: {
      title: 'Type de sortie',
      type: 'Sélectionner le type nde sortie'
    },
    show_archived_live: {
      title: 'Direct archivé',
      not_found: "Direct n'existe pas",
      not_transcripted: "La vidéo n’est pas encore encodée"
    },
    direct: {
      start: {
        title: "Commencer le direct",
        subtitle: "Voulez-vous commencer le direct?"
      },
      stop: {
        title: "Arrêter le direct",
        subtitle: "Voulez-vous arrêter le direct?"
      },
      archiving: {
        title: {
          simple: "Voulez-vous vraiment placer ce direct dans la corbeille ?",
          multi: 'Voulez-vous vraiment placer ces directs dans la corbeille ?'
        },
        subtitle: {
          simple: " sera placé dans la corbeille",
          multi: " seront placés dans la corbeille"
        },
        success: {
          simple: ' est placé dans la corbeille',
          multi: ' sont placés dans la corbeille'
        }
      },
      restoring: {
        title: {
          simple: "Voulez-vous restaurer ce direct  ?",
          multi: 'Voulez-vous restaurer ces directs ?'
        },
        subtitle: {
          simple: " sera restauré",
          multi: " seront restaurés"
        },
        success: {
          simple: ' est restauré',
          multi: ' sont restaurés'
        }
      },
      deleting: {
        title: {
          simple: "Voulez-vous supprimer définitivement ce direct ?",
          multi: 'Voulez-vous supprimer définitivement ces directs ?'
        },
        subtitle: {
          simple: " sera supprimé définitivement",
          multi: " seront supprimés définitivement"
        },
        success: {
          simple: ' est supprimé',
          multi: ' sont supprimés'
        }
      },
      checked_elements: 'Les éléments sélectionnés',
      flow: 'Aperçu du direct'
    }
  },
  calendar: {
    title: 'Calendrier',
    allDay: 'Toute la journée',
    back: 'Retour à la liste',
    statistics: 'Statistiques',
    view: 'Visualiser',
    edit: 'Editer',
    period: {
      show: 'Afficher par',
      week: 'Semaine',
      month: 'Mois',
      day: 'Jour',
      today: "Aujourd'hui"
    },
    months: {
      january: 'janvier',
      february: 'février',
      march: 'mars',
      april: 'avril',
      may: 'mai',
      june: 'juin',
      july: 'juillet',
      august: 'aout',
      september: 'septembre',
      october: 'octobre',
      november: 'novembre',
      december: 'décembre'
    }
  },
  form_live: {
    consent: {
      title: "Enregistrement de la visioconférence",
      noConsent: "Sans consentement",
      withConsent: "Avec consentement des participants"
    },

    tabs: {
      pick_video: 'Veuillez choisir une vidéo',
      required_message: 'Ce champ est obligatoire',
      error_long_message: 'Message ne doit pas dépasser 255 caractères',
      general: {
        title: 'Général',
        form: {
          title: 'Titre',
          description: 'Description',
          types: "Type d'affichage",
          type_default: "Par défaut",
          add_image: 'Ajouter une vignette',
          description_image: "Taille d'image recommandée: 1280 x 720",
          edit_image: 'Modifier',
          delete_image: 'Supprimer',
          start_date: 'Date de début',
          end_date: 'Date de fin',
          start_hour: 'Heure de début',
          end_hour: 'Heure de fin',
          tags: 'Tags',
          themes: 'Thèmes',
          invalid_date: 'Date invalide',
          invalid_hour: 'Heure invalide',
          access_live: "Modes d'accès au direct",
          access_free: 'Accès libre',
          access_secure: 'Accès sécurisé',
          placeholder_pass: 'Saisissez votre mot de passe',
          secure_pass: 'Générer un mot de passe sécurisé',
          schedule_live: 'Planifier le direct',
          share_live: {
            title: 'Lien de partage du direct',
            copy: 'Copier'
          },
          archived_live: 'Archivage automatique du direct',
          duration: 'Durée',
          video: {
            visible: 'Vidéo visible',
            invisible: 'Vidéo non visible'
          },
          publish: "Droits d'édition",
          multimedia_options: 'Options multimédia du direct',
          interactives_options: {
            title: 'Options interactives du direct',
            social_media: {
              fb: 'Diffusion en direct sur votre page Facebook',
              youtube: 'Archivage de la vidéo sur votre chaine Youtube'
            }
          },
          infos: {
            vignette: "cliquez sur l'icone pour modifier la vignette de votre vidéo",
            archived_live: 'Votre direct sera automatiquement archivé et disponible en visualisation vidéo à la demande',
            access_free: "Le direct sera visible sans mot de passe, ni autre procédure d'accès sécurisé)",
            access_secure: 'Le direct sera accessible avec le mot de passe que vous saisissez ci-dessous',
            secure_pass: 'Un mot de passe sera généré pour chaque invitation par mail',
            share_live: 'Le lien comprend le titre de votre conférence',
            themes: "Le thème s'applique pour les vidéos à la demande, vous pouvez choisir un ou plusieurs thèmes",
            rich_media: "Cette option permet d'associer des images synchronisées avec la vidéo",
            attaching_files: "Cette option permet d'ajouter des documents téléchargeables",
            tags: "Les mots clés permettent d'améliorer le référencement des vidéos"
          }
        }
      },
      configuration: {
        title: 'Configuration',
        form: {
          infos_live: "Affichage d'informations avant le direct ",
          message: {
            title: 'Message',
            description: 'Message (affiché sur la page du direct)'
          },
          video: {
            title: 'Vidéo',
            description: 'Rechercher...'
          },
          image: 'Image',
          countdown: 'Comptes à rebours',
          title: 'Personnalisé',
          title_before_live: 'Titre(affiché sur la page du direct)',
          title_live: 'Titre du direct',
          description: 'Texte de description',
          description_before_live: 'Description (affichée sur la page du direct)',
          text: 'Texte',
          text_before_live: 'Texte avant live',
          skins_live: 'Sélection du template de la page du direct',
          more: 'Afficher tout',
          less: 'Afficher moins',
          contact: 'Contact',
          informations: 'Informations complémentaires du direct',
          about: 'A propos',
          intervenants: {
            title: 'Intervenants',
            add: 'Ajouter intervenant',
            firstName: 'Prénom',
            lastName: 'Nom',
            fonction: 'Fonction',
            email: 'Email',
            biography: 'Biographie'
          },
          email: 'Email',
          phone: 'Téléphone',
          address: 'Addresse',
          send_invitations: {
            title: 'Envoi des invitations au direct',
            group_emails: 'Groupe',
            emails: 'Email'
          },
          send_rule: {
            title: "Règle d'envoi",
            days_left: 'Jour(s) avant le live à',
            add_rule_button: 'Ajouter une règle'
          },

          encoding: {
            title: "Options d'encodage ",
            url: 'URL du flux de direct',
            name: 'Nom du flux de direct',
            key: 'Clé de sécurisation (option)'
          },
          infos: {
            skins_live: 'Vous pouvez éditer les templates dans la fonction "Web site"',
            message: 'Texte affiché avant la diffusion du direct',
            video: 'Vidéo affichée avant la diffusion du direct',
            image: 'Image affichée avant la diffusion du direct',
            about: 'S\'affiche dans la page du lien "À propos"',
            contact: 'S\'affiche dans la page du lien "Contact"',
            intervenants: 'S\'affiche dans la page de direct (dans le lien "Description"',
            group_emails: 'Un groupe est un ensemble de mail, les groupes sont éditable dans la fonction "Email"',
            send_rule: "Vous pouvez définir une ou plusieurs règle afin d'envoyer des invitations par mail",
            encoding: "Cette option s'applique si vous utilisez un encodeur externe, voir la FAQ"
          }
        }
      },
      advanced: {
        title: 'Paramètres avancés',
        type: {
          title: 'Type du direct',
          intranet: 'Intranet',
          internet: 'Internet'
        },
        diffusion: {
          type_source: "Type d'usage du direct",
          diffusion_social_media: "Diffusion sur réseaux sociaux",
          medias: "Médias",
          title: 'Diffusion',
          title_empreinte: 'Sources',
          webinar: 'Live studio',
          webinar_empreinte: 'Empreinte Live',
          encoding: 'Encodeur manuel',
          sharing: 'Partage écran',
          encodeur_automatique: "Encodeur automatique",
          encoder: "Encodeur",
          encodeur_empreinte: "Encodeur vidéo",
          protocol: "Type de protocole",
          languages: "Langues",
          languages_empreinte: "Multilingue",
          languagesPlaceholder: "Sélectionner les langues",
          countries: "Pays",
          countriesPlaceholder: "Sélectionner les pays",
          addyoutubeLanguage: "AJOUTER CETTE LANGUE",
          emptyInput: "Veuillez saisir une URL YouTube",
          select_station: "Choisissez une station",
          validUrl: "L'URL YouTube saisie n'est pas valide",
          duplicateUrl: "Cette URL est déjà associée à une autre langue",
          ajoute_entree: "(ajouter l'entrée)",
          "language": {
            "orateur": "Orateur",
            "FL1": "Floor Langue",
            "FL2": "Floor Langue 2",
            "Français": "Français",
            "Anglais": "Anglais",
            "ES": "Espagnol",
            "RU": "Russe",
            "AR": "Arabe",
            "ZH": "Chinois",
            "Autres": "Autres"
          },
          index_audio_port: "Index audio port",
          index_video_port: "Index vidéo port",
          externalHlst: "Hls externe",
          screen_share: {
            pip: 'Picture in Picture PIP',
            sbs: 'Side by Side'
          },
          type: {
            title: "Choix de webinar ",
            title_empreinte: "Accès Empreinte Live",
            by_link: "Url par utilisateur",
            by_link_empreinte: "Accès privé individuel",
            private: " Privé",
            private_empreinte: "Accès privé",
            public: "Public",
            public_empreinte: "Accès public"
          },
          connexion: {
            title: "Type de connexion",
            title_empreinte: "Connexion",
            auto: "Automatique",
            auto_description: "Accès direct choix par défaut",
            by_authorization: "Avec autorisation",
            by_authorization_description: "Salle d’attente : accès après validation"
          }
        },
        options: {
          title: 'Options générales',
          title_empreinte: "Options vidéo",
          private_video: 'Vidéo privée',
          active_video: 'Vidéo Activée',
          automatic_share: 'Publication automatique',
          saveVideo: "Enregister la vidéo"
        },
        contributors: {
          header: "Profils",
          participantTitle: 'Participants',
          importMultiParticipants: "Choisissez une ou plusieurs adresses e-mail, ou importez un fichier CSV / Excel.",
          title: 'Administrateurs',
          admin_description: "Gestionnaire de la conférence avec contrôle total",
          participants_description: "Participants à la visioconférence (droits limités)",
          moderators_description: "Habilité à gérer les commentaires (chat, Q/R)",
          select_item: 'Appuyez sur enter pour sélectionner',
          selected_item: 'Sélectionné',
          delete_item: 'Appuyez sur Entrée pour supprimer',
          no_result: 'Aucun élément trouvé. Pensez à changer la requête de recherche.',
          no_options: 'La liste est vide..',
          add_email: 'Ajouter cet e-mail'

        },
        rich_media: {
          title: 'Richmedia',
          tabs: {
            chapters: {
              title: 'Chapitres',
              empty: 'Pas de chapitres',
              fields: {
                title: 'Titre',
                new: 'Nouveau chapitre'
              }
            },
            questions: {
              title: 'Questions',
              empty: 'Pas de questions',
              add_new: 'Ajouter une question',
              new: 'Nouveau question',
              edit: 'Modifier',
              form: {
                title: 'Question',
                local_questions: {
                  yes_no: 'Oui-Non',
                  yes_no_nsp: 'Oui-Non-NSP',
                  simple_choice: 'Choix simple',
                  multiple_choice: 'Choix multiple',
                  response: 'Réponse',
                  button_add: 'Ajouter'
                }
              }
            },
            slides: {
              title: 'Diapositives',
              edit: 'Modifier',
              delete: 'Supprimer',
              button_show: {
                title: 'Afficher',
                less: 'moins',
                more: 'plus'
              }
            }
          }
        },
        polls: {
          label: 'Sondage',
          title: 'Sondages',
          helper_create_after_save: 'Les sondages seront crees apres l\'enregistrement du direct.',
          loading: 'Chargement des sondages...',
          saving: 'Enregistrement des sondages...',
          empty: 'Aucun sondage pour le moment.',
          add: 'Ajouter un sondage',
          add_first: 'Créer le premier sondage',
          add_hint: 'Ouvrir un nouvel onglet de sondage',
          tab_label: 'Sondage {number}',
          untitled: 'Sondage sans titre',
          options_count: '{count} options',
          incomplete: 'Incomplet',
          editor_hint: 'Modifiez un sondage a la fois tout en gardant la liste visible au-dessus.',
          question_label: 'Question',
          question_placeholder: 'Saisir la question du sondage',
          publish_label: 'Publié automatiquement, visible par tous.',
          option_label: 'Option {number}',
          option_placeholder: 'Saisir une option',
          add_option: 'Ajouter une option',
          existing_hint: 'Les sondages existants peuvent maintenant etre modifies avant enregistrement.',
          delete_poll: 'Supprimer le sondage',
          delete_option: 'Supprimer l\'option',
          confirm_delete_poll: 'Supprimer ce sondage ?',
          confirm_delete_option: 'Supprimer cette option ?',
          min_options_warning: 'Un sondage doit contenir au moins 2 options.',
          delete_option_error: 'Impossible de supprimer cette option du sondage pour le moment.',
          complete_current_first: 'Veuillez completer le sondage en cours avant d en ajouter un nouveau.',
          publish_error: 'Impossible de mettre a jour la visibilite du sondage pour le moment.',
          validation_question_required: 'La question est obligatoire.',
          validation_min_options: 'Chaque sondage doit contenir au moins 2 options.',
          validation_options_required: 'Toutes les options du sondage sont obligatoires.'
        },
        presentation: {
          label: 'Présentation',
          loading: 'Chargement des présentations...',
          uploading: 'Import de la présentation...',
          deleting: 'Suppression de la présentation...',
          empty: 'Aucune présentation pour le moment.',
          upload: 'Importer un document',
          formats_hint: 'PDF, PPTX, DOCX',
          refresh: 'Actualiser',
          open: 'Ouvrir',
          delete: 'Supprimer',
          file: 'Fichier',
          untitled: 'Présentation sans titre',
          slides_count: '{count} slides',
          pending: "En attente de l'enregistrement",
          helper_create_after_save: "Enregistrez d'abord le direct pour pouvoir importer une présentation.",
          queued_success: "Présentation ajoutée. Elle sera importée après l'enregistrement du direct.",
          upload_success: 'Présentation importée avec succès.',
          upload_error: "Impossible d'importer la présentation pour le moment.",
          fetch_error: 'Impossible de charger les présentations pour le moment.',
          delete_success: 'Présentation supprimée avec succes.',
          delete_error: 'Impossible de supprimer cette présentation pour le moment.'
        },
        documents: {
          toggle_label: 'Fichiers partages',
          title: 'Documents partagés (Disponibles sur Empreinte Live)',
          empty: 'Aucun document partagé pour le moment.',
          upload: 'Sélectionner des fichiers à partager',
          refresh: 'Actualiser',
          delete: 'Supprimer',
          publish_default: 'Publier aux auditeurs par défaut',
          pending: 'En attente de l enregistrement',
          private: 'Privé',
          public: 'Public',
          fichier: "Fichier(s)",
          queued_success: "Document ajouté. Il sera importé après l'enregistrement du direct.",
          upload_success: 'Document importé avec succès.',
          upload_error: "Impossible d'importer ce document pour le moment.",
          fetch_error: 'Impossible de charger les documents pour le moment.',
          delete_success: 'Document supprimé avec succès.',
          delete_error: 'Impossible de supprimer ce document pour le moment.',
          publish_error: 'Impossible de mettre à jour la visibilité de ce document pour le moment.',
          uploaded_by: 'Ajouté par',
          unpublish_all: 'Dépublier tous pour les auditeurs',
          unpublish_all_success: 'Tous les documents ont été dépubliés pour les auditeurs.',
          unpublish_all_error: 'Impossible de dépublier tous les documents pour le moment.',
          unpublish_all_nothing: 'Aucun document à dépublier pour les auditeurs.',
          copy_link: 'Copier le lien',
          link_copied: 'Lien du document copié.',
          save_first: 'Les documents seront disponibles après l’enregistrement du direct.',
          visibility: 'Visible pour les auditeurs'
        },
        attaching_files: 'Joindre des fichiers',
        attaching_files_empreinte: 'Fichiers joints'
      },
      frontOffice: {
        title: 'Paramètres SITE WEB',
        "access_page_direct": "Accès à la page de direct",
        lecteur_video: "Lecteur vidéo",
        sous_titrage: "Sous titrage",
        mdp: "Mot de passe",
        inscri_abonne: "Inscription abonnés",
        options: {
          title: 'Options',
          like: "Mention « J’aime »",
          subtitles: 'Sous-titres en temps réel',
          subtitles_empreinte: 'Sous-titres en direct',
          autoTranscription: 'Transcription automatique',
          autoTranscription_empreinte: 'Sous-titres en différé',
          chat: 'Chat auditeur',
          chat_empreinte: "Chat Web",
          privateChat: "Chat régie",
          privateChat_empreinte: "Chat privé",
          sharing_files: 'Documents partagés',
          sharing_files_live_event: { text: 'Visible sur la page Live streaming', explanation: '' },
          sharing_files_emails: 'Envoyé par mail (lien)',
          sharing_files_studio_live: { text: 'Disponible dans le logiciel de réunion', explanation: '' },
          social_media: {
            title: 'Réseaux sociaux',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: "Youtube"
          },
          interactive_tools: {
            title: 'Outils interactifs',
            outils: "Outils",
            whiteBoard: 'Tableau blanc',
            survey: 'Sondage',
            question: 'Question',
            excel: 'Excel',
            autoSip: 'Appel SIP'
          },
          secure_pass: 'Sécurisé avec mot de passe',
          registration: {
            title: 'Inscription des abonnés',
            poll: 'Sondage'
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'Avec confirmation',
            replies: 'Avec réponses',
            questionsBeforeLive: 'Questions avant le direct'
          }
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'Par défaut',
          personalized: {
            title: 'Personnalisé',
            title_before_live: 'Titre(affiché sur la page du direct)',
            title_live: 'Titre du direct',
            description: 'Texte de description',
            description_before_live: 'Description (affichée sur la page du direct)',
            text: 'Texte',
            text_before_live: 'Texte avant live',
            message: {
              title: 'Message',
              description: 'Message (affiché sur la page du direct)'
            },
            video: {
              title: 'Vidéo',
              description: 'Rechercher...'
            },
            image: 'Image',
            countdown: 'Comptes à rebours',
            pearl: "Station d'encodage"
          }
        }
      },

      Program: {
        title: 'Programmes et Intervenants',
        new_title: 'Programme',
        ParticpantsLimit: 'Limite des participants',
        LiveProgram: 'Programme du direct',
        LiveProgramDescription: 'hh:mm - hh:mm \nTitre et description du sujet',
        MaxParticipantsDistance: 'Max participants à distance',
        MaxInvited: 'Max des invités présents',
        Intervenants: 'Intervenants',
        AddParticipant: 'Ajouter un intervenant',
        editParticipant: 'Modifier un intervenant',
        Photo: 'Photo',
        Cliquez: 'Cliquez pour télécharger',
        Nom: 'Nom',
        Prenom: 'Prénom',
        Fonction: 'Fonction',
        Structure: 'Structure',
        Email: 'Email',
        Annuler: 'Annuler',
        Ajouter: 'Ajouter',
        Inscription: 'Inscription',
        Description: "Description",
        Role: "Role",
        options: {
          title: 'Options',
          like: "Mention j'aime",
          chat: 'Chat',
          sharing_files: 'Documents partagés',
          social_media: {
            title: 'Réseaux sociaux',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: 'Youtube'
          },
          secure_pass: 'Sécurisé avec mot de passe',
          registration: {
            title: 'Inscription des abonnés',
            poll: 'Sondage'
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'Avec confirmation',
            replies: 'Avec réponses'
          }
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'Par défaut',
          personalized: {
            title: 'Personnalisé',
            title_before_live: 'Titre(affiché sur la page du direct)',
            title_live: 'Titre du direct',
            description: 'Texte de description',
            description_before_live: 'Description (affichée sur la page du direct)',
            text: 'Texte',
            text_before_live: 'Texte avant live',
            message: {
              title: 'Message',
              description: 'Message (affiché sur la page du direct)'
            },
            video: {
              title: 'Vidéo',
              description: 'Rechercher...'
            },
            image: 'Image',
            countdown: 'Comptes à rebours',
            pearl: "Station d'encodage"
          }
        }
      },
      SkinModel: {
        title: "Modèle d'affichage",
        new_title: "Page Web",
        selectOrCreate: "Sélectionner un modèle existant ou en créer un nouveau",
        choose: "Choisir…",
        selectedSkin: "Modèle appliqué à ce direct est:",
        createNew: "Créer un nouveau modèle",
        existingSkins: "Modèles créés",
        explanation: "Vous pouvez réutiliser un modèle déjà utilisé dans une autre live.",
        newSkin: "Créer un nouveau modèle",
        primaryColor: "Couleur primaire",
        secondaryColor: "Couleur secondaire",
        primaryTextColor: "Couleur texte primaire",
        secondaryTextColor: "Couleur texte secondaire",
        liveTitle: "Titre à afficher",
        logo: "Logo",
        beforeAfterInfo: "Infos avant/après live",
        beforeLiveInfo: "Infos avant le live",
        afterLiveInfo: "Infos après le live",
        infoText: "Texte",
        showDate: "Afficher la date",
        showHour: "Afficher l'heure",
        backgroundImage: "Image de fond",
        blurred: "Flouté",
        skinName: "Nom du modèle",
        addAndApply: "Appliquer",
        applySkin: "Modifier",
        editNote: "NB : La modification du modèle impactera les directs possédant le même modèle."

      }

    }
  },
  upload_files: {
    title: 'Glisser et déposer',
    image_type: ' un image ici',
    file_type: ' un fichier ici',
    media_type: ' un media ici',
    or: 'ou ',
    click: 'cliquer',
    selected_file: ' pour sélectionner un fichier de votre ordinateur'
  },
  vignette: {
    confirm: 'confirmer',
    edit: 'Modifier',
    delete: 'Supprimer',
    streaming_wrapper: 'STREAMING EN DIRECT'
  },
  toast: {
    success_delete: 'Élément supprimé avec succès!',
    success_add: 'Direct crée avec succès!',
    success_diffusion: 'La diffusion a été effectué avec succés',
    success_edit: 'Direct mis à jour avec succés!!',
    error: 'Une erreur est survenue, veuillez réessayer.!',
    success_send: 'Invitation envoyé avec succès!',
    success_send_link: 'Lien envoyé avec succès!',
    success_download: 'Direct téléchargé avec succès!',
    'not-exist': "Fichier n'existe pas!",
    no_emails_provided: 'Aucun e-mail fourni',
    no_date_provided: 'Aucune date fournie',
    export_success: "Fichier exporté avec succès",
    export_Error: "Erreur lors de l'exportation du fichier Excel",
    export_empty: "Aucune donnée existante à exporter.",
    DeleteError: "Erreur lors de la suppression de l'intervenant",
    UpdateError: "Erreur lors de la modification du participant",
    AddError: "Une erreur s'est produite lors de l'ajout du participant",
    getModeratorsError: "Une erreur s'est produite lors de la récupération des modérateurs",
    export_questions_success: "Questions exportées avec succès",
    no_questions_to_export: "Aucune question à exporter",
    export_questions_error: "Une erreur s'est produite lors de l'exportation des questions"
  },
  date: {
    placeholder: 'Sélectionnez une date'
  },
  statut: {
    Archive: "Archivé",
    Live: "En direct",
    Waiting: "En attente",
    error: ""
  },
  startDirect: {
    title: 'Confirmation ',
    subtitle: "Voulez-vous commencer le direct maintenant?",
    choix: 'Cochez cette case pour définir ce choix par défaut et ne plus afficher cette fenêtre.',
    btn: {
      YES: 'OUI',
      NO: 'NON'
    }
  },
  shareLink: {
    from: "De",
    to: "Envoyer à ",
    selected: "Sélectionné",
    link: "Lien",
    password: "Mot de passe",
    secure_password: "Générer un mot de passe sécurisé ",
    send_plan: "Planifier l'envoi",
    planifier: "Planifier",
    date_plan: "L'envoi sera planifier à la date spécifié ",
    journalist: "Prompteur",
    moderator: "Modérateur",
    listener: "Auditeur",
    participant: "Participant",
    emails_placeholder: "Entrez les adresses e-mail des destinataires"
  }
});
// CONCATENATED MODULE: ./src/i18n/index.js





vue_esm["default"].use(vue_i18n_esm["a" /* default */]);
var locale = 'fr';
/* harmony default export */ var i18n = (new vue_i18n_esm["a" /* default */]({
  locale: locale,
  messages: {
    en: en_US,
    fr: fr_FR
  }
}));
// EXTERNAL MODULE: ./node_modules/@ckeditor/ckeditor5-vue/dist/ckeditor.js
var ckeditor = __webpack_require__("6J2T");
var ckeditor_default = /*#__PURE__*/__webpack_require__.n(ckeditor);

// EXTERNAL MODULE: ./node_modules/typeface-roboto/index.css
var typeface_roboto = __webpack_require__("7SuA");
var typeface_roboto_default = /*#__PURE__*/__webpack_require__.n(typeface_roboto);

// EXTERNAL MODULE: ./src/assets/scss/main.scss
var main = __webpack_require__("MXkr");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue-toasted/dist/vue-toasted.min.js
var vue_toasted_min = __webpack_require__("IZMb");
var vue_toasted_min_default = /*#__PURE__*/__webpack_require__.n(vue_toasted_min);

// EXTERNAL MODULE: ./node_modules/cropperjs/dist/cropper.css
var cropper = __webpack_require__("5Qkr");
var cropper_default = /*#__PURE__*/__webpack_require__.n(cropper);

// EXTERNAL MODULE: ./src/assets/scss/nprogress.scss
var nprogress = __webpack_require__("9AwD");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// CONCATENATED MODULE: ./src/helpers/common.js
/* harmony default export */ var common = ({
  getSafeColor: function getSafeColor(value) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#2096f8';

    if (typeof value !== 'string' || value.length > 40) return fallback;

    var syntaxIsSafe = /^(?:#[\da-f]{3,4}|#[\da-f]{6}|#[\da-f]{8}|rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(?:,\s*(?:0|1|0?\.\d+)\s*)?\)|[a-zA-Z]{3,20})$/i.test(value);
    if (!syntaxIsSafe) return fallback;

    // Reject syntactically harmless strings that are not actual CSS colors
    // (for example, "colorembed"), so they cannot invalidate themed styles.
    return typeof CSS !== 'undefined' && CSS.supports('color', value) ? value : fallback;
  },
  buildIcons: function buildIcons(files) {
    return files.map(function (f) {
      switch (f.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/svg+xml':
          f.icon = 'file-image';
          break;
        case 'application/zip':
          f.icon = 'file-archive';
          break;
        case 'application/octet-stream':
          f.icon = 'file-excel';
          break;
        case 'video/mp4':
          f.icon = 'file-video';
          break;
        case 'application/pdf':
          f.icon = 'file-pdf';
          break;
        case 'application/msword':
          f.icon = 'file-word';
          break;
        default:
          f.icon = 'file';
      }
      return f;
    });
  },
  getMaterialColor: function getMaterialColor() {
    // colors from https://github.com/egoist/color-lib/blob/master/color.json

    var colors = ['#1abc9c',
    //Blues
    '#3498db',

    //Purples + Pinks
    '#9b59b6'];
    return colors;
  },
  getDateLive: function getDateLive(date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return date = yyyy + '-' + mm + '-' + dd;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//








console.log('app.vue');

/* harmony default export */ var App = ({
		name: 'App',
		data: function data() {
				return {
						isAuthenticated: false,
						calendar: '',
						color: '',
						isDarkTheme: false
				};
		},

		computed: {
				getColorSettings: function getColorSettings() {
						var color = common.getSafeColor(this.$route.query.color);

						return {
								'--primary-color': color
						};
				}
		},
		methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('common', ['getUserParams']), Object(vuex_esm["b" /* mapActions */])('lives', ['setCurrentLang']), {
				applyTheme: function applyTheme(theme) {
						var body = document.body;
						var html = document.documentElement;

						body.classList.remove('dark-theme', 'light-theme', 'dark-mode', 'light-mode');
						html.classList.remove('dark-theme', 'light-theme', 'dark-mode', 'light-mode');

						if (theme === 'dark') {
								this.isDarkTheme = true;
								body.classList.add('dark-theme');
								html.classList.add('dark-theme');

								body.style.backgroundColor = '#1e1e1e';
								body.style.color = '#e0e0e0';
								html.style.backgroundColor = '#1e1e1e';
						} else {
								this.isDarkTheme = false;
								body.classList.add('light-theme');
								html.classList.add('light-theme');

								body.style.backgroundColor = '#ffffff';
								body.style.color = '#212121';
								html.style.backgroundColor = '#ffffff';
						}
				},
				handleThemeMessage: function handleThemeMessage(event) {
						if (event.data && event.data.info === 'updateTheme') {
								var theme = event.data.theme;
								this.applyTheme(theme);
								localStorage.setItem('theme', theme);
						}

						if (event.data && event.data.info === 'clearTheme') {
								localStorage.removeItem('theme');
								// this.applyTheme('light');
						}
				},
				eventPostMessage: function eventPostMessage() {
						var self = this;
						var code = 'fr';
						var router = this.$router;
						if (window.dataEventPostMessage === undefined) {
								window.dataEventPostMessage = true;
								var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
								var eventer = window[eventMethod];
								var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
								eventer(messageEvent, function (event) {
										var message = event.data;
										if (message !== 'undefined') {
												if (message.info === 'updateLang') {
														code = message.lang;
														vue_esm["default"].use(vue_toasted_min_default.a, {
																iconPack: 'custom-class'
														});
														bus.$emit('setFormLang', code);
														self.$root.$emit('setFormLang', code);
														self.$root.$emit('setCalendarLang', code);
														self.setCurrentLang(code);
												}
												if (message.info === 'redirectListLive') {
														var cryptext = router.query;
														router.push({ name: 'ListLive', query: cryptext });
												}
										}
								}, false);
						}
				}
		}),
		created: function created() {
				var _this = this;

				return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
						var cryptext, urlParams, defaultTheme, savedTheme;
						return regenerator_default.a.wrap(function _callee$(_context) {
								while (1) {
										switch (_context.prev = _context.next) {
												case 0:
														cryptext = _this.$route.query.cryptext;

														window.addEventListener('message', _this.handleThemeMessage);

														urlParams = new URLSearchParams(window.location.search);
														defaultTheme = urlParams.get('dark') === 'true' ? 'dark' : 'light';
														savedTheme = localStorage.getItem('theme') || defaultTheme;

														_this.applyTheme(savedTheme);

														_context.prev = 6;
														_context.next = 9;
														return _this.getUserParams(cryptext);

												case 9:
														_this.isAuthenticated = true;
														_context.next = 15;
														break;

												case 12:
														_context.prev = 12;
														_context.t0 = _context['catch'](6);

														console.error(_context.t0);

												case 15:
												case 'end':
														return _context.stop();
										}
								}
						}, _callee, _this, [[6, 12]]);
				}))();
		},
		mounted: function mounted() {
				var _this2 = this;

				this.$nextTick(function () {
						_this2.eventPostMessage();
				});
		},
		beforeDestroy: function beforeDestroy() {
				window.removeEventListener('message', this.handleThemeMessage);
		}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c19736","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('div',{class:{ 'dark-theme': _vm.isDarkTheme },style:(_vm.getColorSettings),attrs:{"id":"app"}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("55t4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress_nprogress = __webpack_require__("Y81h");
var nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress_nprogress);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vue2-datepicker/lib/index.js
var vue2_datepicker_lib = __webpack_require__("Ppbp");
var vue2_datepicker_lib_default = /*#__PURE__*/__webpack_require__.n(vue2_datepicker_lib);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.es.js
var vue2_clock_picker_es = __webpack_require__("Ucq6");
var vue2_clock_picker_es_default = /*#__PURE__*/__webpack_require__.n(vue2_clock_picker_es);

// EXTERNAL MODULE: ./node_modules/vue-input-tag/dist/vueInputTag.common.js
var vueInputTag_common = __webpack_require__("a+8X");
var vueInputTag_common_default = /*#__PURE__*/__webpack_require__.n(vueInputTag_common);

// EXTERNAL MODULE: ./node_modules/vue2-dropzone/dist/vue2Dropzone.js
var vue2Dropzone = __webpack_require__("KvPw");
var vue2Dropzone_default = /*#__PURE__*/__webpack_require__.n(vue2Dropzone);

// EXTERNAL MODULE: ./node_modules/vue-perfect-scrollbar/dist/index.js
var dist = __webpack_require__("etTB");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("w/TU");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var lib_validators = __webpack_require__("+cKO");
var validators_default = /*#__PURE__*/__webpack_require__.n(lib_validators);

// EXTERNAL MODULE: ./node_modules/vue-carousel/dist/vue-carousel.min.js
var vue_carousel_min = __webpack_require__("/kJX");
var vue_carousel_min_default = /*#__PURE__*/__webpack_require__.n(vue_carousel_min);

// EXTERNAL MODULE: ./src/assets/icons/Upload.svg
var Upload = __webpack_require__("B7j/");
var Upload_default = /*#__PURE__*/__webpack_require__.n(Upload);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vue-cropperjs/dist/VueCropper.js
var VueCropper = __webpack_require__("sRoY");
var VueCropper_default = /*#__PURE__*/__webpack_require__.n(VueCropper);

// CONCATENATED MODULE: ./src/core/http/http-token.js


function HTTP(token) {
  return axios_default.a.create({
    baseURL: window.process.env.API_HOST_GLOBAL,
    headers: {
      Authorization: token
    }
  });
}
// EXTERNAL MODULE: ./node_modules/fos-routing/dist/routing.js
var routing = __webpack_require__("Pjem");
var routing_default = /*#__PURE__*/__webpack_require__.n(routing);

// CONCATENATED MODULE: ./src/core/router/fos_js_routes_export.js
/* harmony default export */ var fos_js_routes_export = ({
  base_url: '',
  routes: {
    api_live_get_user_params: {
      tokens: [['text', '/lives/params-live']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },

    api_get_lives_live_detail: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/live/lives-live']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_post_add_lives_live: {
      tokens: [['text', '/lives/lives-live/add']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_post_edit_lives_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/lives-live/edit']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_media_get_contributors: {
      tokens: [['text', '/video/videos/contributors/list']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_dtable_list_dtable_lives_endless: {
      tokens: [['text', '/live/endless']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_dtable_list_dtable_lives_archived: {
      tokens: [['text', '/live/archived']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_dtable_list_dtable_lives_all: {
      tokens: [['text', '/live/all']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_dtable_list_dtable_lives_upcoming: {
      tokens: [['text', '/live/upcoming']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_dtable_list_dtable_lives_trash: {
      tokens: [['text', '/live/trash']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_multi_delete_livess: {
      tokens: [['variable', '/', '\\d+', 'list'], ['text', '/multiDelete/livess']],
      defaults: [],
      requirements: {
        list: '\\d+'
      },
      hosttokens: []
    },
    api_delete_lives_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/delete-lives-live']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_post_disable_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/disable']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_post_enable_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/enable']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_post_lives_thumb: {
      tokens: [['text', '/lives/lives/upload/thumb']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_post_lives_slide: {
      tokens: [['text', '/lives/lives/upload/slide']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_survey_get_list_surveys: {
      tokens: [['text', '/survey/list-surveys']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_get_lives_by_period: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/live/lives-period']],
      defaults: [],
      requirements: {
        startDate: '\\d+',
        endDate: '\\d+'
      },
      hosttokens: []
    },
    api_video_get_list_transcoded_videos: {
      tokens: [['text', '/video/list-transcoded-videos_details']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_getInfosDetailLive: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'live/info_detail']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_getlink_export: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'lives/link_export']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_getSubscriptionUser_list: {
      tokens: [['text', '/subscription_user/users']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_send_invitations_mails: {
      tokens: [['text', 'lives/invitations/mails']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screen_share: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'lives/add-screen-share']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_get_url_download_file: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', 'lives/get-url-jnlp-file']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_get_link_video_live: {
      tokens: [['variable', '/', '[^/]++', 'id'], ['text', '/lives/get-link-video-live']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_subscription_group_get_groups: {
      tokens: [['text', '/subscription_group/groups']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_post_invitation_groups_mails: {
      tokens: [['text', '/lives/invitations/groups/mails']],
      defaults: [],
      requirements: {
        groups: 'array+',
        id: '\\d+',
        mails: 'array+'
      },
      hosttokens: []
    },
    api_parameters_get_channels_group_by_themes: {
      tokens: [['variable', '/', '[^/]++', 'ids'], ['text', '/channel/channel-by-themes']],
      defaults: {
        ids: null
      },
      requirements: [],
      hosttokens: []
    },

    api_parameters_get_live_types: {
      tokens: [['variable', '/', '[^/]++', 'ids'], ['text', '/live/types']],
      defaults: {
        ids: null
      },
      requirements: [],
      hosttokens: []
    },

    api_subscription_user_get_users_by_group: {
      tokens: [["variable", "/", "\d+", "id"], ["text", "/subscription_user/users-by-id"]],
      defaults: [],
      requirements: {
        id: "\d+"
      },
      hosttokens: []
    },
    api_post_live_revive: {
      tokens: [["variable", "/", "\d+", "id"], ["text", "/live/revive"]],
      defaults: [],
      requirements: {
        id: "\d+"
      },
      hosttokens: []
    },
    api_download_live: {
      "tokens": [["variable", "/", "\\d+", "id"], ["text", "video-api/video/download"]],
      "defaults": [],
      "requirements": {
        "id": "\\d+"
      },
      "hosttokens": []
    },
    api_live_get_skins: {
      tokens: [['text', '/live/skin']],
      defaults: [],
      requirements: [],
      hosttokens: []
    }

  },
  prefix: '',
  host: 'localhost',
  scheme: 'http'
});
// CONCATENATED MODULE: ./src/core/router/router.js

// import file with routes data


// set data
routing_default.a.setData(fos_js_routes_export);

// export library
/* harmony default export */ var router_router = (routing_default.a);
// EXTERNAL MODULE: ./node_modules/b64-to-blob/b64toBlob.js
var b64_to_blob_b64toBlob = __webpack_require__("ibJL");
var b64toBlob_default = /*#__PURE__*/__webpack_require__.n(b64_to_blob_b64toBlob);

// CONCATENATED MODULE: ./src/mixins/UploadMixin.js







/* harmony default export */ var UploadMixin = ({
  methods: {
    uploadThumbnail: function uploadThumbnail(blob, params) {
      var _this = this;

      var url = router_router.generate('api_post_lives_thumb');
      if (params) {
        this.appendProgressCircle(params);
      }
      var config = {
        header: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          if (params) {
            var percentCompleted = Math.round(params.current / params.total * 100 + progressEvent.loaded * 100 / progressEvent.total / params.total);
            _this.updateProgressCircle(params, percentCompleted);
            if (params.current === params.total && percentCompleted === 100) {
              _this.removeProgressCircle(params);
            }
          }
        }
      };
      var formData = new FormData();

      formData.append('empApiFileForm[thumb]', blob);
      if (params && params.type) {
        formData.append('type', params.type);
      }

      return new promise_default.a(function (resolve, reject) {
        HTTP(window.ApiToken).post(url, formData, config).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          console.error(err);
          reject(err);
        });
      });
    },
    processFile: function processFile(file) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var fileReader, base64;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileReader = new FileReader();
                base64 = void 0;
                _context.next = 4;
                return new promise_default.a(function (resolve, reject) {
                  fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    file.dataURL = base64;

                    var contentType = file.type;
                    var b64Data = file.dataURL;
                    var replaceString = 'data:' + contentType + ';base64,';

                    resolve(b64toBlob_default()(b64Data.replace(replaceString, ''), contentType));
                  };
                  fileReader.readAsDataURL(file);
                });

              case 4:
                return _context.abrupt('return', _context.sent);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    appendProgressCircle: function appendProgressCircle(params) {
      var progressEl = document.querySelector('#' + params.id + ' .dz-upload-progress-wrapper');
      if (progressEl) {
        return;
      }
      var progressValue = 0;
      var progressCirlcleEl = document.createElement('div');
      progressCirlcleEl.className = 'dz-upload-progress-wrapper';
      progressCirlcleEl.innerHTML = '<div class="c100 blue p' + progressValue + '">\n                              <span>' + progressValue + '%</span>\n                              <div class="slice">\n                                <div class="bar"></div>\n                                <div class="fill"></div>\n                              </div>\n                            </div>';
      document.getElementById(params.id).appendChild(progressCirlcleEl);
    },
    updateProgressCircle: function updateProgressCircle(params, progressValue) {
      var progressEl = document.querySelector('#' + params.id + ' .dz-upload-progress-wrapper');
      progressEl.classList.add('visible');
      var circleEl = progressEl.querySelector('.c100');
      circleEl.className = 'c100 blue p' + progressValue;
      circleEl.querySelector('span').innerHTML = progressValue + '%';
    },
    removeProgressCircle: function removeProgressCircle(params) {
      var wrapperEl = document.getElementById(params.id);
      var progressEl = document.querySelector('#' + params.id + ' .dz-upload-progress-wrapper');
      progressEl.classList.remove('visible');
      setTimeout(function () {
        wrapperEl.removeChild(progressEl);
      }, 500);
    },
    downloadURI: function downloadURI(uri, name) {
      var urlLink = document.createElement('a');
      urlLink.download = name;
      urlLink.href = uri;
      document.body.appendChild(urlLink);
      urlLink.click();
      document.body.removeChild(urlLink);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/ThumbnailCropper.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var ThumbnailCropper = ({
  name: 'ThumbnailCropper',
  mixins: [UploadMixin],
  components: {
    VueCropper: VueCropper_default.a
  },
  data: function data() {
    return {
      b64Img: '',
      imgUrl: '',
      isDefault: false,
      isEditingThumbnail: false,
      confirmClicked: false
    };
  },

  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  props: {
    cropImg: {
      type: String,
      default: ''
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    defaultThumbnail: 'common/getDefaultThumbnail'
  }), {
    thumbnail: function thumbnail() {
      var defaultTumbnail = "/" + "liste-lives/static/vignette/vignette_purple.jpg";
      if (this.hasISFM) {
        defaultTumbnail = "/" + "liste-lives/static/vignette/vignette_green.jpeg";
      }
      if (this.defaultThumbnail && this.defaultThumbnail !== null && this.defaultThumbnail !== '' && this.defaultThumbnail !== undefined) {
        defaultTumbnail = "/" + "liste-lives/static/vignette/" + this.defaultThumbnail;
      }
      return this.imgUrl || defaultTumbnail;
    },
    hasSkin: function hasSkin() {
      if (window.process.env.HAS_SKIN === 'true') {
        return true;
      } else {
        return false;
      }
    },
    hasISFM: function hasISFM() {
      if (window.process.env.ISFM && window.process.env.ISFM !== "false") {
        return true;
      } else {
        return false;
      }
    },
    getClientName1: function getClientName1() {
      return window.process.env.CLIENT_NAME1;
    },
    getClientName2: function getClientName2() {
      return window.process.env.CLIENT_NAME2;
    }
  }),
  watch: {
    cropImg: function cropImg() {
      if (!this.imgUrl) {
        this.imgUrl = this.cropImg;
      }
    }
  },
  methods: {
    toDataURL: function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    },
    b64toBlob: function b64toBlob(b64Data) {
      var _this = this;

      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var byteCharacters, byteArrays, offset, slice, byteNumbers, i, byteArray, blob;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                byteCharacters = atob(b64Data);
                byteArrays = [];


                for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                  slice = byteCharacters.slice(offset, offset + sliceSize);
                  byteNumbers = new Array(slice.length);

                  for (i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                  }

                  byteArray = new Uint8Array(byteNumbers);

                  byteArrays.push(byteArray);
                }

                blob = new Blob(byteArrays, { type: contentType });
                return _context.abrupt('return', blob);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    isEmpty: function isEmpty(img) {
      if (!img) {
        return true;
      }
      if ((typeof img === 'undefined' ? 'undefined' : typeof_default()(img)) === 'object') {
        return keys_default()(img).length === 0;
      }
      return img === '';
    },
    setImage: function setImage(e) {
      var _this2 = this;

      var file = e.target.files[0];
      if (!file) return;
      if (!file.type.includes('image/')) {
        alert('Veuillez sélectionner un fichier image');
        return;
      }

      var reader = new FileReader();
      reader.onload = function (event) {
        _this2.b64Img = event.target.result;
        _this2.$refs.cropper.replace(event.target.result);
        _this2.$refs.thumbnailFileInput.value = '';

        _this2.isEditingThumbnail = true;
        _this2.$emit('pickedImage', file); // ⭐ emit raw file if needed
      };
      reader.readAsDataURL(file);
    },
    cropImage: function cropImage() {
      var _this3 = this;

      nprogress_nprogress_default.a.start();
      var width = 1280;
      var height = Math.round(width * 9 / 16);

      var canvas = this.$refs.cropper.getCroppedCanvas({ width: width, height: height });

      // Keep base64 for preview
      this.imgUrl = canvas.toDataURL();

      // Convert canvas to Blob and File
      canvas.toBlob(function (blob) {
        if (!blob) return;

        var file = new File([blob], 'thumbnail.jpg', { type: 'image/jpeg' });

        // Emit file to parent
        _this3.$emit('thumbnailUpdated', file);

        _this3.isEditingThumbnail = false;
        _this3.$emit('thumbnailConfirmed', _this3.confirmClicked);

        nprogress_nprogress_default.a.done();
      }, 'image/jpeg', 0.9);

      this.b64Img = '';
    },
    updateThumbnail: function updateThumbnail() {
      this.$refs.thumbnailFileInput.click();
    },
    removeThumbnail: function removeThumbnail() {
      nprogress_nprogress_default.a.start();
      this.imgUrl = '';
      this.$refs.thumbnailFileInput.value = '';
      this.$emit('thumbnailUpdated', '');
    }
  },
  mounted: function mounted() {
    if (this.cropImg) {
      this.imgUrl = this.cropImg;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ec2ae6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/ThumbnailCropper.vue
var ThumbnailCropper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail-cropper-wrapper"},[_c('div',{staticClass:"thumbnail-cropper-container",attrs:{"hidden":_vm.isEmpty(_vm.b64Img)}},[_c('input',{ref:"thumbnailFileInput",staticStyle:{"display":"none"},attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.setImage}}),_vm._v(" "),_c('vue-cropper',{ref:"cropper",staticClass:"img-fluid brad-3",attrs:{"viewMode":2,"dragMode":"crop","background":true,"src":_vm.thumbnail,"alt":"Source Image","aspectRatio":16 / 9,"img-style":{ width: '100%', height: 'auto' }}}),_vm._v(" "),_c('b-button',{staticClass:"float-right mt-2",attrs:{"variant":"primary","type":"button"},on:{"click":_vm.cropImage}},[_vm._v(_vm._s(_vm.$t('vignette.confirm')))])],1),_vm._v(" "),_c('div',{staticClass:"thumbnail-container",attrs:{"hidden":_vm.thumbnail === '' || _vm.b64Img !== ''}},[_c('img',{staticClass:"img-fluid brad-3",attrs:{"src":_vm.thumbnail,"alt":"Cropped Image","fill-width":""}}),_vm._v(" "),_c('div',{staticClass:"more-btn-container"},[_c('b-dropdown',{attrs:{"variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[(!_vm.hasSkin)?_c('span',{staticClass:"icon-more"}):_vm._e(),_vm._v(" "),(_vm.hasSkin)?_c('div',{staticClass:"settings-button"},[_c('span',{staticClass:"icon-settings"})]):_vm._e()]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.updateThumbnail()}}},[_c('span',{staticClass:"icon-edit"}),_vm._v("\n          "+_vm._s(_vm.$t('vignette.edit'))+"\n        ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"disabled":_vm.isEmpty(_vm.imgUrl)},on:{"click":function($event){return _vm.removeThumbnail()}}},[_c('span',{staticClass:"icon-trash"}),_vm._v("\n          "+_vm._s(_vm.$t('vignette.delete'))+"\n        ")])],2)],1)])])}
var ThumbnailCropper_staticRenderFns = []
var ThumbnailCropper_esExports = { render: ThumbnailCropper_render, staticRenderFns: ThumbnailCropper_staticRenderFns }
/* harmony default export */ var components_ThumbnailCropper = (ThumbnailCropper_esExports);
// CONCATENATED MODULE: ./src/components/components/ThumbnailCropper.vue
function ThumbnailCropper_injectStyle (ssrContext) {
  __webpack_require__("7Qie")
}
var ThumbnailCropper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ThumbnailCropper___vue_template_functional__ = false
/* styles */
var ThumbnailCropper___vue_styles__ = ThumbnailCropper_injectStyle
/* scopeId */
var ThumbnailCropper___vue_scopeId__ = "data-v-77ec2ae6"
/* moduleIdentifier (server only) */
var ThumbnailCropper___vue_module_identifier__ = null
var ThumbnailCropper_Component = ThumbnailCropper_normalizeComponent(
  ThumbnailCropper,
  components_ThumbnailCropper,
  ThumbnailCropper___vue_template_functional__,
  ThumbnailCropper___vue_styles__,
  ThumbnailCropper___vue_scopeId__,
  ThumbnailCropper___vue_module_identifier__
)

/* harmony default export */ var components_components_ThumbnailCropper = (ThumbnailCropper_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/mixins/UtilsMixin.js




//var moment = require('moment');




var UtilsMixin_TOAST_DURATION = 5000;

/* harmony default export */ var UtilsMixin = ({
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('setFormLang', function (lang) {
      _this.$i18n.locale = lang;
      i18n.locale = lang;
    });
  },

  methods: {
    watchUndoRemoveItem: function watchUndoRemoveItem(array) {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.$toasted.clear();
        var toast = _this2.$toasted.show(i18n.t('toast.success_delete'), {
          theme: 'bubble',
          position: 'bottom-right',
          duration: UtilsMixin_TOAST_DURATION,
          icon: {
            name: 'icon-warning mr-2'
          },
          action: {
            text: i18n.t('button.cancel'),
            onClick: function onClick(e, toastObject) {
              resolve(array);
              toastObject.goAway(0);
            }
          }
        });
        setTimeout(function () {
          reject();
        }, UtilsMixin_TOAST_DURATION + 1);
      });
    },
    showToast: function showToast(type, message, icon) {
      var toast = this.$toasted.show(message, {
        type: type,
        theme: 'bubble',
        position: 'bottom-right',
        duration: UtilsMixin_TOAST_DURATION,
        icon: {
          name: 'mr-2 ' + icon
        }
      });
    },
    mapFormData: function mapFormData(form) {
      var empLivesForm = JSON.parse(stringify_default()(form));
      var startDate = moment_default.a.utc(empLivesForm.startDate);
      var endDate = moment_default.a.utc(empLivesForm.startDate);
      // convert startTime from local to utc time
      var localDate = moment_default()(form.startDate);

      var utcDateTime = moment_default()(empLivesForm.startTime, 'HH:mm');
      var localDateTime = localDate.hours(utcDateTime.hours()).minutes(utcDateTime.minutes());
      var startTimeDate = localDateTime.utc();
      var startTime = moment_default()(startTimeDate, 'HH:mm');
      empLivesForm.startDate = moment_default()(startTimeDate).format('HH:mm');
      empLivesForm.startTime = moment_default()(startTimeDate).format('HH:mm');
      // convert endTime from local to utc time
      var utcEndTime = moment_default()(empLivesForm.endTime, 'HH:mm');
      var endTimeDate = utcEndTime.utc();
      var endTimeOneHour = moment_default()(endTimeDate, 'HH:mm');
      empLivesForm.endTime = moment_default()(endTimeDate).format('HH:mm');
      empLivesForm.canCommentBeforeLive = empLivesForm.foComment ? empLivesForm.canCommentBeforeLive : false;
      empLivesForm.canReplyToComments = empLivesForm.foComment ? empLivesForm.canReplyToComments : false;
      empLivesForm.isCommentValidation = empLivesForm.foComment ? empLivesForm.isCommentValidation : false;
      empLivesForm.active = empLivesForm.active ? true : false;

      startDate.set({
        hour: startTime.get('hour'),
        minute: startTime.get('minute'),
        second: 0
      });

      empLivesForm.dateStart = startDate.format();
      var endTimeWithDuration = startDate;
      var endTimeWithOneHour = startDate;

      if (empLivesForm.duration) {
        var duration = moment_default()(empLivesForm.duration, 'HH:mm');
        endTimeWithDuration.add(duration.get('hour'), 'hours').add(duration.get('minute'), 'minutes').format('LT');
        empLivesForm.dateEnd = endTimeWithDuration.format();
      } else if (window.process.env.ISFM && window.process.env.ISFM !== "false") {
        endTimeWithOneHour.add(endTimeOneHour.get('hour'), 'hours').add(endTimeOneHour.get('minute'), 'minutes').format('LT');

        endDate.set({
          hour: endTimeOneHour.get('hour'),
          minute: endTimeOneHour.get('minute'),
          second: 0
        });
        empLivesForm.dateEnd = endDate.format();
      } else {
        endDate.set({
          hour: endTimeOneHour.get('hour'),
          minute: endTimeOneHour.get('minute'),
          second: 0
        });
        empLivesForm.dateEnd = endDate.format();
      }

      empLivesForm.isCdn = empLivesForm.isCdn ? '1' : '0';

      // if (empLivesForm.contributors) {
      //   empLivesForm.contributors = empLivesForm.contributors.map(c => c.id);
      // }

      if (empLivesForm.themes) {
        empLivesForm.themes = empLivesForm.themes.map(function (c) {
          return c.id;
        });
      }

      if (empLivesForm.types) {
        if (Array.isArray(empLivesForm.types)) {
          empLivesForm.types = empLivesForm.types.length && empLivesForm.types[0].id !== 0 ? [empLivesForm.types[0].id] : [];
        } else if (typeof_default()(empLivesForm.types) === 'object' && empLivesForm.types.id !== 0) {
          empLivesForm.types = [empLivesForm.types.id];
        } else {
          empLivesForm.types = [];
        }
      }
      if (empLivesForm.slides) {
        empLivesForm.slides = empLivesForm.slides.map(function (s) {
          return {
            slide: s.slide,
            slideType: s.slideType
          };
        });
      }

      if (empLivesForm.tags) empLivesForm.tags = empLivesForm.tags.join(' ');

      empLivesForm.isProtected = !!empLivesForm.pwd;
      empLivesForm.thumbnail = form.thumbnail;
      if (empLivesForm.thumbnailPath && !empLivesForm.thumbnail) {
        empLivesForm.thumbnail = empLivesForm.thumbnailPath;
      }
      delete empLivesForm.thumbnailPath;
      if (!empLivesForm.pwd) {
        delete empLivesForm.pwd;
      }

      delete empLivesForm.confAfter;
      delete empLivesForm.created_at;
      delete empLivesForm.live;
      //delete empLivesForm.screenType;
      delete empLivesForm.server_infos;
      delete empLivesForm.updated_at;
      delete empLivesForm.urlDiffusion;
      delete empLivesForm.urlPlayer;

      return { id: empLivesForm.id, empLivesForm: empLivesForm };
    },
    mapThemes: function mapThemes(channels) {
      var _channels = keys_default()(channels).map(function (k) {
        return channels[k];
      });
      return this.flatten(_channels, 0);
    },
    flatten: function flatten(arr, index) {
      var newArr = [];
      for (var i = 0; i < arr.length; i++) {
        var item = {
          title: arr[i].title,
          id: arr[i].id,
          $isDisabled: index === 0,
          index: index > 1 ? index - 1 : 0
        };
        newArr.push(item);
        if (arr[i].themes.length > 0) {
          newArr = newArr.concat(this.flatten(arr[i].themes, index + 1));
        }
      }
      return newArr;
    },
    generatePassword: function generatePassword() {
      var length = 8,
          charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
          retVal = '';
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/QuestionForm.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var QuestionForm = ({
  name: 'QuestionForm',
  mixins: [UtilsMixin],
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  data: function data() {
    return {
      newChoice: '',
      localQuestion: {}
    };
  },

  props: {
    question: {
      type: Object,
      default: function _default() {
        return { question: '', nsp: 0, choices: [] };
      }
    },
    buttonLabel: {
      type: String,
      default: i18n.t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.button_add')
    }
  },
  computed: {
    isValid: function isValid() {
      if (!this.localQuestion.question) {
        return false;
      }
      if (this.localQuestion.nsp > 1) {
        return !(this.localQuestion.choices.length === 0 || this.newChoice);
      }
      return true;
    },
    isEmpty: function isEmpty() {
      return !this.localQuestion.question && this.localQuestion.choices && this.localQuestion.choices.length > 0;
    }
  },
  methods: {
    addQuestion: function addQuestion() {
      var question = assign_default()({}, this.localQuestion);
      this.localQuestion = { question: '', nsp: 0, choices: [] };
      this.$emit('addQuestion', question);
    },
    addChoice: function addChoice() {
      if (!this.newChoice) {
        return;
      }
      var choice = {
        response: this.newChoice
      };
      this.localQuestion.choices.push(choice);
      this.newChoice = '';
    },
    removeChoice: function removeChoice(index) {
      var _this = this;

      this.watchUndoRemoveItem(this.localQuestion.choices, index).then(function (val) {
        _this.localQuestion.choices = val;
      });
      this.localQuestion.choices = this.localQuestion.choices.filter(function (c, i) {
        return i !== index;
      });
    },
    handleUpdateQuestionType: function handleUpdateQuestionType() {
      if (this.localQuestion.nsp < 2) {
        this.localQuestion.type = 'question';
      } else {
        this.localQuestion.type = 'quiz';
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.localQuestion = assign_default()({}, this.question);
    this.$nextTick(function () {
      _this2.$refs.questionInput.$el.focus();

      var questionsWrapper = document.querySelector('.scroll-questions');

      var _questionsWrapper$get = questionsWrapper.getBoundingClientRect(),
          top = _questionsWrapper$get.top;

      window.scrollTo(0, top + window.scrollY);
      var editChapterEl = document.querySelector('.chapter-container.question.is-open');
      if (editChapterEl) {
        questionsWrapper.scrollTop = editChapterEl.getBoundingClientRect().top;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ff9bbd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/QuestionForm.vue
var QuestionForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-form-wrapper"},[_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-input',{ref:"questionInput",class:{ invalid: _vm.isEmpty },attrs:{"type":"text","placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.form.title')},model:{value:(_vm.localQuestion.question),callback:function ($$v) {_vm.$set(_vm.localQuestion, "question", $$v)},expression:"localQuestion.question"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-form-radio-group',{attrs:{"name":"radio-options"},on:{"input":_vm.handleUpdateQuestionType},model:{value:(_vm.localQuestion.nsp),callback:function ($$v) {_vm.$set(_vm.localQuestion, "nsp", _vm._n($$v))},expression:"localQuestion.nsp"}},[_c('b-form-radio',{attrs:{"value":0}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.yes_no')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":1}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.yes_no_nsp')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":2}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.simple_choice')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":3}},[_vm._v(_vm._s(_vm.$t(
          'form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.multiple_choice'
        )))])],1)],1),_vm._v(" "),(_vm.localQuestion.nsp > 1)?_c('div',{staticClass:"answers-wrapper"},[_vm._l((_vm.localQuestion.choices),function(choice,index){return _c('div',{staticClass:"form-group answer-wrapper"},[_c('b-input',{attrs:{"type":"text","placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.response')},model:{value:(choice.response),callback:function ($$v) {_vm.$set(choice, "response", $$v)},expression:"choice.response"}}),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeChoice(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)}),_vm._v(" "),_c('div',{staticClass:"form-group position-relative"},[_c('b-input',{attrs:{"type":"text","placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.response')},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addChoice.apply(null, arguments)}},model:{value:(_vm.newChoice),callback:function ($$v) {_vm.newChoice=$$v},expression:"newChoice"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.newChoice),expression:"newChoice"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.addChoice}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}})],1)],1)],2):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"secondary","type":"button"},on:{"click":function($event){return _vm.$emit('closeForm')}}},[_vm._v(_vm._s(_vm.$t('button.cancel'))+"\n        ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","type":"button","disabled":!_vm.isValid},on:{"click":_vm.addQuestion}},[_vm._v("\n          "+_vm._s(_vm.buttonLabel)+"\n        ")])],1)])],1)],2)}
var QuestionForm_staticRenderFns = []
var QuestionForm_esExports = { render: QuestionForm_render, staticRenderFns: QuestionForm_staticRenderFns }
/* harmony default export */ var components_QuestionForm = (QuestionForm_esExports);
// CONCATENATED MODULE: ./src/components/components/QuestionForm.vue
function QuestionForm_injectStyle (ssrContext) {
  __webpack_require__("qqS2")
}
var QuestionForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var QuestionForm___vue_template_functional__ = false
/* styles */
var QuestionForm___vue_styles__ = QuestionForm_injectStyle
/* scopeId */
var QuestionForm___vue_scopeId__ = "data-v-78ff9bbd"
/* moduleIdentifier (server only) */
var QuestionForm___vue_module_identifier__ = null
var QuestionForm_Component = QuestionForm_normalizeComponent(
  QuestionForm,
  components_QuestionForm,
  QuestionForm___vue_template_functional__,
  QuestionForm___vue_styles__,
  QuestionForm___vue_scopeId__,
  QuestionForm___vue_module_identifier__
)

/* harmony default export */ var components_components_QuestionForm = (QuestionForm_Component.exports);

// CONCATENATED MODULE: ./src/core/http/http-common.js

var http_common_HTTP = axios_default.a.create({
  baseURL: window.process.env.API_HOST_GLOBAL,
  headers: {
    Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
  }
});

function getHttp() {
  axios_default.a.create({
    baseURL: window.process.env.API_HOST_GLOBAL,
    headers: {
      Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
    }
  });
}
// CONCATENATED MODULE: ./src/store/modules/common-data.js






var common_data_state = {
  clientName: '',
  authToken: '',
  isSuperAdmin: false,
  permissions: {},
  useJitsi: false,
  showExportBtnArchived: false,
  idUser: '',
  diffusion: "all",
  defaultThumbnail: '',
  showModal: false
};

var mutations = {
  setAuthToken: function setAuthToken(state, authToken) {
    state.authToken = authToken;
  },
  setIsSuperAdmin: function setIsSuperAdmin(state, isSuperAdmin) {
    state.isSuperAdmin = isSuperAdmin;
  },
  setPermissions: function setPermissions(state, modules) {
    state.permissions = modules;
  },
  setIdUser: function setIdUser(state, idUser) {
    state.idUser = idUser;
  },
  setClientName: function setClientName(state, clientName) {
    state.clientName = clientName;
  },
  setUseJitsi: function setUseJitsi(state, useJitsi) {
    state.useJitsi = useJitsi;
  },
  setShowExportBtnArchived: function setShowExportBtnArchived(state, showExportBtnArchived) {
    state.showExportBtnArchived = showExportBtnArchived;
  },
  setDiffusion: function setDiffusion(state, diffusion) {
    state.diffusion = diffusion;
  },
  setDefaultThumbnail: function setDefaultThumbnail(state, defaultTumbnail) {
    state.defaultThumbnail = defaultTumbnail;
  },
  setShowModal: function setShowModal(state, showModal) {
    state.showModal = showModal;
  }
};

var actions = {
  getUserParams: function getUserParams(_ref, cryptext) {
    var _this = this;

    var commit = _ref.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var url, _ref2, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = router_router.generate('api_live_get_user_params', { cryptext: cryptext });
              _context.next = 3;
              return new promise_default.a(function (resolve, reject) {
                http_common_HTTP.get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;

              commit('setAuthToken', data.userData.auth_token);
              commit('setIsSuperAdmin', data.userData.isSuperAdmin);
              commit('setPermissions', data.userData.modules);
              commit('setIdUser', data.userData.idUser);
              commit('setClientName', data.client);
              commit('setDefaultThumbnail', data.defaultTumbnail);
              commit('setUseJitsi', data.use_jitsi);
              commit('setShowExportBtnArchived', data.show_export_btn_archived);
              commit('setDiffusion', data.diffusion);
              window.ApiToken = data.userData.auth_token;
              window.client = data.client;

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setDiffusionLive: function setDiffusionLive(_ref3, val) {
    var commit = _ref3.commit;

    commit('setDiffusion', val);
  },
  setShowModal: function setShowModal(_ref4, val) {
    var commit = _ref4.commit;

    commit('setShowModal', val);
  }
};

var common_data_getters = {
  getPermission: function getPermission(state) {
    return state.permissions;
  },
  getSuperAdmin: function getSuperAdmin(state) {
    return state.isSuperAdmin;
  },
  /* getSelected: state => state.selected,*/
  getUseJitsi: function getUseJitsi(state) {
    return state.useJitsi;
  },
  getShowExportBtnArchived: function getShowExportBtnArchived(state) {
    return state.showExportBtnArchived;
  },
  getDiffusion: function getDiffusion(state) {
    return state.diffusion;
  },
  getUserName: function getUserName(state) {
    return state.clientName;
  },
  getDefaultThumbnail: function getDefaultThumbnail(state) {
    return state.defaultThumbnail;
  },
  hasPermission: function hasPermission(state) {
    return function (permissions) {
      return permissions.split(',').some(function (v) {
        return state.permissions[v];
      }) || state.isSuperAdmin;
    };
  },
  getShowModal: function getShowModal(state) {
    return state.showModal;
  },
  getUserId: function getUserId(state) {
    return state.idUser;
  }

};

/* harmony default export */ var common_data = ({
  namespaced: true,
  state: common_data_state,
  getters: common_data_getters,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/directives/HasPermission.js


/* harmony default export */ var HasPermission = ({
  inserted: function inserted(el, binding, vnode) {
    if (binding.value !== undefined) {
      setTimeout(function () {
        var permissions = common_data.state.permissions;
        var isSuperAdmin = common_data.state.isSuperAdmin;
        var values = binding.value.split(',');
        var hasPermission = values.some(function (v) {
          return permissions[v];
        }) || isSuperAdmin;

        if (!hasPermission) {
          vnode.elm.parentElement.removeChild(vnode.elm);
          // OR
          // el.parentNode.removeChild(el);
        }
      }, 100);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/YoutubeLinks.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var YoutubeLinks = ({
  name: "YouTubeLinks",

  props: {
    initialYoutubeEnabled: Boolean,
    initialYoutubeLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isYoutubeEnabled: !!this.initialYoutubeEnabled,
      openMenu: !!this.initialYoutubeEnabled,
      listLang: this.initialYoutubeLinks.map(function (l) {
        return extends_default()({}, l);
      }),
      inputYoutube: "",
      languageUrl: null,
      isEnabled: false,
      duplicateError: "",
      errorMessage: "",
      options: [{ value: "fr", text: "Fr" }, { value: "en", text: "En" }, { value: "ar", text: "Ar" }, { value: "fl", text: "FL" }, { value: "sp", text: "SP" }, { value: "ch", text: "Ch" }, { value: "ru", text: "Ru" }, { value: "zh", text: "Zh" }],
      copiedIndex: null
    };
  },


  computed: {
    filteredSelectOptions: function filteredSelectOptions() {
      var _this = this;

      return this.options.map(function (opt) {
        return extends_default()({}, opt, {
          disabled: _this.listLang.some(function (l) {
            return l.lang === opt.value;
          })
        });
      });
    },
    canAddNew: function canAddNew() {
      var url = this.inputYoutube.trim();
      return this.isEnabled && this.languageUrl && url && this.isValidUrl(url) && !this.listLang.some(function (l) {
        return l.link === url;
      });
    }
  },

  methods: {
    isValidUrl: function isValidUrl(url) {
      var urlRegex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      return urlRegex.test(url);
    },
    validateNewRow: function validateNewRow(e) {
      var value = e;
      var link = value.trim();

      if (!link) {
        this.errorMessage = this.$t('form_live.tabs.advanced.diffusion.emptyInput');
        return;
      }

      if (this.listLang.some(function (l) {
        return l.link === link;
      })) {
        this.duplicateError = this.$t('form_live.tabs.advanced.diffusion.duplicateUrl');
        this.errorMessage = "";
        return;
      }

      if (!this.isValidUrl(link)) {
        this.errorMessage = this.$t('form_live.tabs.advanced.diffusion.validUrl');
        this.duplicateError = "";
        return;
      }

      this.errorMessage = "";
      this.duplicateError = "";
    },
    handleYoutubeChange: function handleYoutubeChange(val) {
      this.isYoutubeEnabled = val;
      this.openMenu = val;

      if (!val) {
        this.listLang = [];
        this.$emit('update:youtubeLinks', []);
      }

      this.$emit('update:youtubeEnabled', val);
    },
    removeLanguage: function removeLanguage(index) {
      this.listLang.splice(index, 1);
      this.$emit('update:youtubeLinks', this.listLang);
    },
    validateEditRow: function validateEditRow(i) {
      var link = this.listLang[i].link.trim();

      if (!link) {
        this.errorMessage = this.$t('Translate.emptyInput');
        return;
      }

      if (this.listLang.some(function (l, idx) {
        return idx !== i && l.link === link;
      })) {
        this.duplicateError = this.$t('Translate.Input');
        this.errorMessage = "";
        return;
      }

      if (!this.isValidUrl(link)) {
        this.errorMessage = this.$t('Translate.validUrl');
        return;
      }

      this.errorMessage = "";
      this.duplicateError = "";
      this.$emit('update:youtubeLinks', this.listLang);
    },
    copyLink: function copyLink(lang, index, e) {
      var _this2 = this;

      e.preventDefault();

      if (!lang || !lang.link) return;

      navigator.clipboard.writeText(lang.link);
      this.copiedIndex = index;
      setTimeout(function () {
        _this2.copiedIndex = null;
      }, 400);
    },
    copyNewRowLink: function copyNewRowLink(e) {
      var _this3 = this;

      e.preventDefault();

      if (!this.inputYoutube) return;
      navigator.clipboard.writeText(this.inputYoutube);
      this.copiedIndex = 'new';
      setTimeout(function () {
        _this3.copiedIndex = null;
      }, 400);
    },
    handleAjouter: function handleAjouter() {
      var link = this.inputYoutube.trim();
      this.listLang.push({ lang: this.languageUrl, link: link });
      this.inputYoutube = "";
      this.languageUrl = null;
      this.isEnabled = false;
      this.$emit('update:youtubeLinks', this.listLang);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f9564e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YoutubeLinks.vue
var YoutubeLinks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youtube-section"},[_c('b-row',[_c('b-col',{attrs:{"span":24}},[_c('b-form-checkbox',{attrs:{"checked":_vm.isYoutubeEnabled,"name":"isYoutube"},on:{"change":_vm.handleYoutubeChange}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('Youtube')))])])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"12px"}},_vm._l((_vm.listLang),function(lang,index){return _c('div',{key:index,staticStyle:{"display":"flex","gap":"10px","align-items":"center","position":"relative"}},[_c('input',{staticClass:"custom-input",attrs:{"type":"checkbox","checked":""},on:{"click":function($event){return _vm.removeLanguage(index)}}}),_vm._v(" "),_c('b-form-select',{staticStyle:{"width":"80px"},attrs:{"options":_vm.filteredSelectOptions},model:{value:(lang.lang),callback:function ($$v) {_vm.$set(lang, "lang", $$v)},expression:"lang.lang"}}),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","flex":"1"}},[_c('b-form-input',{staticStyle:{"padding-right":"40px"},attrs:{"placeholder":"https://youtube..."},model:{value:(lang.link),callback:function ($$v) {_vm.$set(lang, "link", $$v)},expression:"lang.link"}}),_vm._v(" "),_c('span',{staticClass:"copy-icon copy-icon-inside",class:{ copied: _vm.copiedIndex === index },attrs:{"title":"Copy link"},on:{"click":function($event){return _vm.copyLink(lang, index, $event)}}},[_c('font-awesome-icon',{attrs:{"icon":"copy"}})],1)],1)],1)}),0),_vm._v(" "),(_vm.openMenu && _vm.listLang.length < 7)?_c('div',{staticStyle:{"display":"flex","gap":"10px","align-items":"center","margin-top":"6px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isEnabled),expression:"isEnabled"}],staticClass:"custom-input",staticStyle:{"flex-shrink":"0"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isEnabled)?_vm._i(_vm.isEnabled,null)>-1:(_vm.isEnabled)},on:{"change":function($event){var $$a=_vm.isEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isEnabled=$$c}}}}),_vm._v(" "),_c('b-form-select',{staticStyle:{"width":"80px","flex-shrink":"0"},attrs:{"options":_vm.filteredSelectOptions,"disabled":!_vm.isEnabled},model:{value:(_vm.languageUrl),callback:function ($$v) {_vm.languageUrl=$$v},expression:"languageUrl"}}),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","flex":"1"}},[_c('b-form-input',{staticStyle:{"padding-right":"40px"},attrs:{"disabled":!_vm.isEnabled,"placeholder":"https://youtube..."},on:{"input":_vm.validateNewRow},model:{value:(_vm.inputYoutube),callback:function ($$v) {_vm.inputYoutube=$$v},expression:"inputYoutube"}}),_vm._v(" "),_c('span',{staticClass:"copy-icon copy-icon-inside",class:{ disabled: !_vm.inputYoutube },attrs:{"title":"Copy link"},on:{"click":function($event){return _vm.copyNewRowLink($event)}}},[_c('font-awesome-icon',{attrs:{"icon":"copy"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"8px"}},[(_vm.errorMessage)?_c('b-col',{attrs:{"span":24}},[_c('span',{staticClass:"errorUrl"},[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),(_vm.duplicateError)?_c('b-col',{attrs:{"span":24}},[_c('span',{staticClass:"errorUrl"},[_vm._v(_vm._s(_vm.duplicateError))])]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('b-col',{attrs:{"span":24}},[(_vm.openMenu && _vm.listLang.length < 7)?_c('b-button',{attrs:{"disabled":!_vm.canAddNew},on:{"click":_vm.handleAjouter}},[_vm._v("\n        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.addyoutubeLanguage'))+"\n      ")]):_vm._e()],1)],1)],1)}
var YoutubeLinks_staticRenderFns = []
var YoutubeLinks_esExports = { render: YoutubeLinks_render, staticRenderFns: YoutubeLinks_staticRenderFns }
/* harmony default export */ var components_YoutubeLinks = (YoutubeLinks_esExports);
// CONCATENATED MODULE: ./src/components/YoutubeLinks.vue
function YoutubeLinks_injectStyle (ssrContext) {
  __webpack_require__("2azS")
}
var YoutubeLinks_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var YoutubeLinks___vue_template_functional__ = false
/* styles */
var YoutubeLinks___vue_styles__ = YoutubeLinks_injectStyle
/* scopeId */
var YoutubeLinks___vue_scopeId__ = "data-v-c9f9564e"
/* moduleIdentifier (server only) */
var YoutubeLinks___vue_module_identifier__ = null
var YoutubeLinks_Component = YoutubeLinks_normalizeComponent(
  YoutubeLinks,
  components_YoutubeLinks,
  YoutubeLinks___vue_template_functional__,
  YoutubeLinks___vue_styles__,
  YoutubeLinks___vue_scopeId__,
  YoutubeLinks___vue_module_identifier__
)

/* harmony default export */ var src_components_YoutubeLinks = (YoutubeLinks_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("+6Bu");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ./src/store/modules/lives-socket.js









var WS_LIVE_URL = window.process.env.WS_LIVE_URL || "";

// Map to store live sockets
// socketsMap = { [liveId]: WebSocket }
var socketsMap = {};

var generateSignedUrl = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(url) {
    var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var encoder, secretKeyData, key, expiry, dataToAuthenticate, mac, base64Mac;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            encoder = new TextEncoder();
            secretKeyData = encoder.encode("2qySfsbI5akSqHmj_empreinte_bNLt1pnS4I");
            _context.next = 4;
            return crypto.subtle.importKey("raw", secretKeyData, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);

          case 4:
            key = _context.sent;
            expiry = Date.now() + 3 * 60 * 1000; // 3min

            dataToAuthenticate = url.pathname + "@" + expiry;
            _context.next = 9;
            return crypto.subtle.sign("HMAC", key, encoder.encode(dataToAuthenticate));

          case 9:
            mac = _context.sent;
            base64Mac = btoa(String.fromCharCode.apply(String, toConsumableArray_default()(new Uint8Array(mac))));


            url.searchParams.set("mac", base64Mac);
            url.searchParams.set("expiry", expiry.toString());

            return _context.abrupt("return", url.toString());

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function generateSignedUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();

var lives_socket_state = function state() {
  return {
    currentLive: null,
    socketsMap: {}, // keep multiple sockets here
    reloadListFlag: false // flag to trigger list reload
  };
};

var lives_socket_getters = {
  getCurrentLive: function getCurrentLive(state) {
    return state.currentLive;
  },
  getSocketsMap: function getSocketsMap(state) {
    return state.socketsMap;
  },
  getSocketById: function getSocketById(state) {
    return function (id) {
      return state.socketsMap[id] || null;
    };
  },
  getReloadListFlag: function getReloadListFlag(state) {
    return state.reloadListFlag;
  }
};

var lives_socket_mutations = {
  SET_SOCKET: function SET_SOCKET(state, _ref2) {
    var id = _ref2.id,
        socket = _ref2.socket;

    state.socketsMap = extends_default()({}, state.socketsMap, defineProperty_default()({}, id, socket));
    socketsMap[id] = socket; // keep global reference
  },
  REMOVE_SOCKET: function REMOVE_SOCKET(state, id) {
    var _state$socketsMap = state.socketsMap,
        removed = _state$socketsMap[id],
        rest = objectWithoutProperties_default()(_state$socketsMap, [id]);

    state.socketsMap = rest;
    delete socketsMap[id];
  },
  UPDATE_LIVE_STATUS: function UPDATE_LIVE_STATUS(state, _ref3) {
    var id = _ref3.id,
        status = _ref3.status;

    if (state.currentLive.id === id) {
      state.currentLive.status = status;
    }
  },
  TRIGGER_RELOAD_LIST: function TRIGGER_RELOAD_LIST(state) {
    state.reloadListFlag = !state.reloadListFlag; // toggle to trigger watchers
  }
};

var lives_socket_actions = {
  initSocketLive: function initSocketLive(_ref4, id) {
    var _this = this;

    var commit = _ref4.commit,
        getters = _ref4.getters;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var connectWebSocket;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!getters.getSocketById(id)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              connectWebSocket = function () {
                var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                  var wsUrl, signedWsUrl, socket, rejoined, startTime, rejoin;
                  return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          wsUrl = WS_LIVE_URL;

                          if (!wsUrl.includes("wss://")) wsUrl = "wss:" + wsUrl;
                          wsUrl += "/?room=" + id + "&role=participant";

                          _context3.next = 5;
                          return generateSignedUrl(new URL(wsUrl));

                        case 5:
                          signedWsUrl = _context3.sent;
                          socket = new WebSocket(signedWsUrl);
                          rejoined = false;
                          startTime = Date.now();

                          rejoin = function () {
                            var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                              var elapsed;
                              return regenerator_default.a.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      if (rejoined) {
                                        _context2.next = 7;
                                        break;
                                      }

                                      rejoined = true;
                                      elapsed = Date.now() - startTime;

                                      if (!(elapsed < 1000)) {
                                        _context2.next = 6;
                                        break;
                                      }

                                      _context2.next = 6;
                                      return new promise_default.a(function (resolve) {
                                        return setTimeout(resolve, 1000 - elapsed);
                                      });

                                    case 6:
                                      connectWebSocket();

                                    case 7:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2, _this);
                            }));

                            return function rejoin() {
                              return _ref6.apply(this, arguments);
                            };
                          }();

                          socket.onopen = function () {
                            commit("SET_SOCKET", { id: id, socket: socket });
                          };

                          socket.onmessage = function (event) {
                            var data = JSON.parse(event.data);
                            if (data.type === "live_ended" || data.type === "live_started") {
                              commit("TRIGGER_RELOAD_LIST");
                            }
                          };

                          socket.onerror = function () {
                            socket.close();
                            rejoin();
                          };

                          socket.onclose = function () {
                            rejoin();
                          };

                        case 14:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this);
                }));

                return function connectWebSocket() {
                  return _ref5.apply(this, arguments);
                };
              }();

              connectWebSocket();

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }))();
  },
  closeSocket: function closeSocket(_ref7, id) {
    var commit = _ref7.commit,
        getters = _ref7.getters;

    var socket = getters.getSocketById(id);
    if (socket) {
      socket.close();
      commit("REMOVE_SOCKET", id);
    }
  },
  closeAllSockets: function closeAllSockets(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit;

    keys_default()(state.socketsMap).forEach(function (id) {
      state.socketsMap[id].close();
      commit("REMOVE_SOCKET", id);
    });
  },
  syncLivesSockets: function syncLivesSockets(_ref9, _ref10) {
    var _this2 = this;

    var dispatch = _ref9.dispatch,
        getters = _ref9.getters;
    var lives = _ref10.lives,
        diffusionType = _ref10.diffusionType;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var liveIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, live;

      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!lives.length || diffusionType !== "endless")) {
                _context5.next = 3;
                break;
              }

              dispatch("closeAllSockets");
              return _context5.abrupt("return");

            case 3:
              liveIds = lives.map(function (l) {
                return l.id;
              });

              // Close sockets for removed lives

              keys_default()(getters.getSocketsMap).forEach(function (id) {
                if (!liveIds.includes(Number(id))) {
                  dispatch("closeSocket", Number(id));
                }
              });

              // Create sockets for new lives
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context5.prev = 8;
              for (_iterator = get_iterator_default()(lives); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                live = _step.value;

                if (!getters.getSocketById(live.id)) {
                  dispatch("initSocketLive", live.id);
                }
              }
              _context5.next = 16;
              break;

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context5.t0;

            case 16:
              _context5.prev = 16;
              _context5.prev = 17;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 19:
              _context5.prev = 19;

              if (!_didIteratorError) {
                _context5.next = 22;
                break;
              }

              throw _iteratorError;

            case 22:
              return _context5.finish(19);

            case 23:
              return _context5.finish(16);

            case 24:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this2, [[8, 12, 16, 24], [17,, 19, 23]]);
    }))();
  }
};

/* harmony default export */ var lives_socket = ({
  namespaced: true,
  state: lives_socket_state,
  getters: lives_socket_getters,
  mutations: lives_socket_mutations,
  actions: lives_socket_actions
});
// CONCATENATED MODULE: ./src/helpers/live-documents.js




function getLiveDocumentsHeaders() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var headers = {
    Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
  };

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  return { headers: headers };
}

var getSignedLiveDocumentsUrl = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(path) {
    var base, normalized;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            base = '' + window.process.env.API_HOST_LIVE + path;
            normalized = base.startsWith('http') ? base : 'https:' + base;
            return _context.abrupt('return', generateSignedUrl(new URL(normalized)));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSignedLiveDocumentsUrl(_x2) {
    return _ref.apply(this, arguments);
  };
}();

function normalizeLiveDocumentsResponse(payload) {
  var candidates = [payload && payload.data, payload && payload.data && payload.data.data, payload && payload.data && payload.data.documents, payload && payload.data && payload.data.files, payload && payload.data && payload.data.items, payload && payload.data && payload.data.data && payload.data.data.documents, payload && payload.data && payload.data.data && payload.data.data.files, payload && payload.data && payload.data.data && payload.data.data.items];

  var matchedCandidate = candidates.find(function (candidate) {
    return Array.isArray(candidate);
  });
  if (matchedCandidate) {
    return matchedCandidate;
  }

  var singleDocument = payload && payload.data && payload.data.document || payload && payload.data && payload.data.file || (payload && payload.data && payload.data.id ? payload.data : null);

  return singleDocument ? [singleDocument] : [];
}

function getLiveDocumentId(item) {
  return item && (item.id || item.documentId || item.fileId || item.key);
}

function getLiveDocumentName(item) {
  return item && (item.file_name || item.fileName || item.originalName || item.documentName || item.title) || 'Document';
}

function getLiveDocumentUrl(item) {
  return item && (item.url || item.fileUrl || item.documentUrl || item.downloadUrl || item.path) || '';
}

function isLiveDocumentPublic(item) {
  return !!(item && (item.public || item.isPublic));
}
// EXTERNAL MODULE: ./node_modules/vue-infinite-loading/dist/vue-infinite-loading.js
var vue_infinite_loading = __webpack_require__("qK+J");
var vue_infinite_loading_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_loading);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LiveForm.vue












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























var XLSX = __webpack_require__("N393");




var LiveForm_moment = __webpack_require__("PJh5");

var createPollOptionDraft = function createPollOptionDraft(option) {
  return {
    id: option && option.id ? option.id : null,
    poll_option: option && option.poll_option ? option.poll_option : '',
    dirty: false
  };
};

var createPollDraft = function createPollDraft(poll) {
  var options = poll && Array.isArray(poll.options) && poll.options.length > 0 ? poll.options.map(createPollOptionDraft) : [createPollOptionDraft(), createPollOptionDraft()];

  return {
    id: poll && poll.id ? poll.id : null,
    question: poll && poll.question ? poll.question : '',
    isPublished: !!(poll && poll.isPublished),
    options: options,
    dirty: false
  };
};

/* harmony default export */ var LiveForm = ({
  name: 'LiveForm',
  mixins: [UploadMixin, UtilsMixin],
  components: {
    Datepicker: vue2_datepicker_lib_default.a,
    YoutubeLinks: src_components_YoutubeLinks,
    VueClockPicker: vue2_clock_picker_es_default.a,
    InputTag: vueInputTag_common_default.a,
    QuestionForm: components_components_QuestionForm,
    VuePerfectScrollbar: dist_default.a,
    Carousel: vue_carousel_min["Carousel"],
    Slide: vue_carousel_min["Slide"],
    Multiselect: vue_multiselect_min_default.a,
    draggable: vuedraggable_umd_default.a,
    ThumbnailCropper: components_components_ThumbnailCropper,
    vueDropzone: vue2Dropzone_default.a,
    InfiniteLoading: vue_infinite_loading_default.a
  },
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  directives: {
    HasPermission: HasPermission
  },
  validations: {
    form: {
      title: { required: lib_validators["required"] },
      description: { required: lib_validators["required"] },
      startDate: {
        required: lib_validators["required"]
        // minValue: value => {
        //   const today = new Date();
        //   let yesterday = new Date();
        //   yesterday.setDate(today.getDate() - 1);
        //   return new Date(value) > yesterday;
        // },
      },
      startTime: {
        required: lib_validators["required"]
        // minValue(value) {
        //   if (moment().isSame(this.form.startDate, 'day')) {
        //     const beginningTime = moment(this.form.startTime, 'HH:mm');
        //     return moment().isBefore(beginningTime);
        //   }
        //   return true;
        // },
      },
      endTime: {
        required: lib_validators["required"],
        minValue: function minValue(value) {
          var endTime = LiveForm_moment(value, 'HH:mm', true);
          var startTime = LiveForm_moment(this.form.startTime, 'HH:mm', true);
          return endTime > startTime;
        }
      },
      conf: {
        message: {
          required: Object(lib_validators["requiredIf"])(function (nestedModel) {
            return this.form.conf.type === 'Message';
          })
        },
        video: {
          required: Object(lib_validators["requiredIf"])(function (nestedModel) {
            return this.form.conf.type === 'Video';
          })
        }
      },
      survey: {
        required: Object(lib_validators["requiredIf"])(function (nestedModel) {
          return this.form.foSondage;
        })
      },
      stationId: {
        required: Object(lib_validators["requiredIf"])(function (nestedModel) {
          return this.form.isAuto;
        }),
        minValue: function minValue(value) {
          if (!this.form.isAuto) return true; // ⬅ ignore validation
          return value > 0;
        }
      }
    }
  },
  data: function data() {
    var _this = this,
        _ref;

    return _ref = {
      sourceTypeTouched: false,
      bulkEmailListenerCleanup: [],
      localParticipantOptions: [],
      uploading: {
        logo: false,
        before: false,
        after: false
      },
      showFilesPanel: false,
      sections: {
        consent: true,
        typeLive: true,
        connexionEmpreinte: true,
        social_media: true,
        diffusion: true,
        sources: true,
        options: true,
        languages: true,
        socialMedia: true,
        contributors: true,
        richMedia: true,
        video: true,
        access_direct: true,
        program: true,
        questions: true,
        sous_titrage: true,
        presentation: true,
        polls: true,
        tools: true,
        LiveProgram: true,
        general: true,
        skin: true,
        chapitres: true
      },
      TypesSources: [],
      TypesToShow: [],
      skinIsEditMode: false,
      currentSkin: null,
      skinConfirmed: null,
      skinOptions: [],
      skinForm: {
        selectedSkin: null,

        skin: {
          primary_color: "#00a6d9",
          secondary_color: "#ecf6fa",
          text_primary_color: "#ffffff",
          text_secondary_color: "#000000",
          title: "",
          logo: null,
          before: {
            info_text: "",
            show_date: false,
            show_hour: false,
            background: null,
            background_blur: false
          },
          after: {
            info_text: "",
            show_date: false,
            show_hour: false,
            background: null,
            background_blur: false
          }

        }
      },

      btnDisabled: false,
      PendingUpload: false,
      uploadImage: Upload_default.a,
      errorOccurred: false,
      errorOccurredInUpdate: false,
      errorOccurredInAdd: false,
      uploadError: false,
      EditOption: false,
      moderators: [],
      languages: [],
      countries: [],
      languagesOptions: [{ label: 'fl', lang: i18n.t('form_live.tabs.advanced.diffusion.language.FL1') }, { label: 'en', lang: i18n.t('form_live.tabs.advanced.diffusion.language.Anglais') }, { label: 'sp', lang: i18n.t('form_live.tabs.advanced.diffusion.language.ES') }, { label: 'fr', lang: i18n.t('form_live.tabs.advanced.diffusion.language.Français') }, { label: 'ru', lang: i18n.t('form_live.tabs.advanced.diffusion.language.RU') }, { label: 'ar', lang: i18n.t('form_live.tabs.advanced.diffusion.language.AR') }, { label: 'zh', lang: i18n.t('form_live.tabs.advanced.diffusion.language.ZH') }],

      manualStations: [],
      automaticStations: [],
      loadingManualStations: false,
      loadingAutomaticStations: false,
      countriesOptions: [],
      isLoadingCountries: false,
      openTimeModal: false,
      update: false,
      checked: false,
      checkedSwitch: false,
      headerBgVariant: 'custom-secondary',
      status: false,
      currentLive: {},
      imgSrc: '',
      cropImg: '',
      isEditingThumbnail: false,
      imageIsPicked: false,
      confirmClicked: false,
      form: {
        sourceTypeId: 2,
        isYoutube: false,
        selectedManualStation: null,
        stationId: null,
        youtubeLinks: [],
        isRecorded: true,
        autoPublish: true,
        nom: '',
        lastName: '',
        fonction: '',
        structure: '',
        mail: '',
        live_plan: true,
        role: '',
        Description: '',
        max_online_guests: null,
        max_onsite_guests: null,
        title: '',
        description: '',
        types: null,
        startDate: LiveForm_moment().format('YYYY-MM-DD'),
        startTime: LiveForm_moment().format('HH:mm'),
        endTime: LiveForm_moment().add(1, 'hours').format('HH:mm'),
        tags: [],
        isCdn: true,
        screenShare: false,
        externalHls: false,
        linkHls: "",
        webinar: true,
        isPearl: false,
        screenType: 'pip',
        chapters: [],
        questions: [],
        files: [],
        slides: [],
        defaultConf: true,
        conf: {
          type: 'Counter'
        },
        diffusion: 'webinar',
        isAuto: false,
        videoPortIndex: 0,
        audioPortIndex: 0,
        protocolType: 'RTMP',
        videoBeforeLive: null,
        connexionType: "auto",
        accessType: "public",
        thumbnail: '',
        thumbnailPath: '',
        emailError: null,
        encoderType: "manual",
        contributors: [],
        participants: [],
        record_with_permission: false,
        foFilesShare: false,
        doc_public: false,
        doc_publish_default: false,
        doc_public_mail: false,
        doc_private: false,
        autoSip: false

      },
      protocolOptions: [{ value: 'RTMP', text: 'RTMP' }, { value: 'SRT', text: 'SRT' }],
      accessWebinar: "",
      connexionWebinar: "",
      searchVideoKeyword: '',
      submitButtonClicked: false,
      requiredMessage: i18n.t('form_live.tabs.required_message'),
      screenTypeOptions: [{ value: 'pip', text: 'Picture in Picture PIP' }, { value: 'sbs', text: 'Side by Side' }],
      newChapter: '',
      currentPageQuestion: 1,
      addQuestionMode: false,
      showAllSlides: false,
      joinFile: false,
      socialNetwork: false,
      password: false,
      //languages: lang,
      initialLocaleCode: 'fr',
      isEditMode: false,
      slideIndex: -1,
      showCarousel: false,
      ready: false,
      pastDates: {},
      isBeforeLiveVideoPickerVisible: true,
      initInfinitScrollVideos: false,
      chapterTitle: '',
      shortcuts: [{
        text: 'Today',
        onClick: function onClick() {
          _this.time3 = [new Date(), new Date()];
        }
      }],
      permissions: [{ name: "webinar", permission: "lives_webinar_no_api" }, { name: "isPearl", permission: "lives_encoder_no_api" }, { name: "screenShare", permission: "lives_screen_share_no_api" }],
      disabledConfigFO: false,
      showErrorMessage: false,
      MaxParticipantsDistance: '',
      MaxInvited: '',
      file: null,
      url: null,
      intervenants: [],
      intervenantsToUpdate: [],
      intervenantsToAdd: [],
      checkedLimit: false,
      idUpdate: '',
      showDelete: false,
      intervenantsTodelete: [],
      forUpdate: false,
      updateModal: false,
      indexToupdate: '',
      updateIdParticipant: '',
      udpateInIntervenants: ''
    }, defineProperty_default()(_ref, 'checkedLimit', true), defineProperty_default()(_ref, 'livePolls', []), defineProperty_default()(_ref, 'activePollIndex', 0), defineProperty_default()(_ref, 'deletedPollIds', []), defineProperty_default()(_ref, 'deletedPollOptionIds', []), defineProperty_default()(_ref, 'pollsLoading', false), defineProperty_default()(_ref, 'pollsSyncing', false), defineProperty_default()(_ref, 'pollsLoaded', false), defineProperty_default()(_ref, 'pendingPollDelete', null), defineProperty_default()(_ref, 'presentationSlides', []), defineProperty_default()(_ref, 'pendingPresentationFiles', []), defineProperty_default()(_ref, 'presentationLoading', false), defineProperty_default()(_ref, 'presentationUploading', false), defineProperty_default()(_ref, 'presentationDeletingId', null), defineProperty_default()(_ref, 'liveDocuments', []), defineProperty_default()(_ref, 'pendingLiveDocuments', []), defineProperty_default()(_ref, 'documentsLoading', false), defineProperty_default()(_ref, 'documentsUploading', false), defineProperty_default()(_ref, 'documentsDeletingId', null), _ref;
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    getWebtvUsers: 'lives/getWebtvUsers',
    live: 'lives/getSelected',
    contributorsOptions: 'lives/getWebtvUsers',
    channelsOptions: 'lives/getChannels',
    typesOptions: 'lives/getTypes',
    surveyOptions: 'form/getSurveys',
    slidesChips: 'form/getVideos',
    isEndReached: 'form/getEndReached',
    isLoading: 'form/getLoading',
    hasPermission: 'common/hasPermission',
    getDiffusion: 'common/getDiffusion',
    getDiffusionObject: 'lives/getDiffusionObject',
    defaultThumbnail: 'common/getDefaultThumbnail',
    linkHls: 'lives/getHlsValue',
    isPermission: 'common/getPermission',
    isSuperAdmin: 'common/getSuperAdmin',
    lang: 'lives/getCurrentLang',
    liveSkinsOptions: 'lives/getLiveSkins',
    getUserId: 'common/getUserId'

  }), {
    isUnescoClient: function isUnescoClient() {
      // return window.process.env.CLIENT_NAME === 'test';
      return true;
    },
    isEmpreinteClient: function isEmpreinteClient() {
      return ['empreinte', 'cnam', 'gers', 'test'].includes(window.process.env.CLIENT_NAME);
    },
    isEmpreintePollClient: function isEmpreintePollClient() {
      return window.process.env.CLIENT_NAME === 'empreinte';
    },
    cleanedAvatarUrl: function cleanedAvatarUrl() {
      return function (avatarUrl) {
        var parts = avatarUrl.split("https://");
        var correctUrl = "https://" + parts[parts.length - 1];
        return correctUrl;
      };
    },
    filteredTypesToShow: function filteredTypesToShow() {
      var _this2 = this;

      return this.TypesToShow.filter(function (option) {
        return _this2.hasPermission(option.permission);
      });
    },
    getThumbnail: function getThumbnail() {
      return "/" + 'liste-lives/static/vignette/' + this.defaultThumbnail;
    },
    getPermissions: function getPermissions() {
      var _this3 = this;

      var permissionsArray = [];
      this.permissions.forEach(function (p) {
        if (_this3.hasPermission(p.permission)) {
          permissionsArray.push(p);
        }
      });
      return permissionsArray;
    },
    getDifferentDiffusionPermission: function getDifferentDiffusionPermission() {
      var permissionsArray = this.getPermissions;
      if (permissionsArray.length > 0 && permissionsArray.length === 1) {
        this.getDefaultDiffusion();
      }
    },
    getDiffusionPermission: function getDiffusionPermission() {
      if (this.currentLive.isPearl) {
        return "lives_pearl_diffuser_no_api";
      } else {
        return "lives_diffuser_no_api";
      }
    },
    isChapterEditMode: function isChapterEditMode() {
      return this.form.chapters.some(function (c) {
        return c.isEditMode;
      });
    },
    isQuestionEditMode: function isQuestionEditMode() {
      return this.form.questions.some(function (c) {
        return c.isEditMode;
      });
    },
    activePoll: function activePoll() {
      return this.livePolls[this.activePollIndex] || null;
    },
    canAddPoll: function canAddPoll() {
      if (this.livePolls.length === 0) {
        return true;
      }

      var lastPoll = this.livePolls[this.livePolls.length - 1];
      return !this.getPollValidationError(lastPoll);
    },
    canManagePresentation: function canManagePresentation() {
      return true;
    },
    presentationItems: function presentationItems() {
      return this.$route.params.id ? this.presentationSlides : this.pendingPresentationFiles;
    },
    managedLiveDocuments: function managedLiveDocuments() {
      return this.$route.params.id ? this.liveDocuments : this.pendingLiveDocuments;
    },
    hasAnyPublishedLiveDocuments: function hasAnyPublishedLiveDocuments() {
      var _this4 = this;

      return this.managedLiveDocuments.some(function (document) {
        return document.public || _this4.isManagedDocumentPublic(document);
      });
    },
    getActiveColor: function getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    },
    liveTypesOptions: function liveTypesOptions() {
      var defaultType = {
        id: 0,
        title: i18n.t('form_live.tabs.general.form.type_default')
      };
      if (this.form.types === null || this.form.types.length === 0) {
        this.form.types = defaultType;
      }
      var types = this.typesOptions || [];

      types = [defaultType].concat(toConsumableArray_default()(types));

      return types;
    },
    themesOptions: function themesOptions() {
      return this.mapThemes(this.channelsOptions);
    },
    closeOnOverlay: function closeOnOverlay() {
      return true;
    }
  }, Object(vuex_esm["d" /* mapState */])({
    confirmationClicked: function confirmationClicked(state) {
      return state.confirmation.clicked;
    }
  })),
  watch: {
    '$route.params.id': function $routeParamsId() {
      this.fetchPresentationSlides();
      this.fetchLivePolls();
      this.fetchLiveDocuments();
    },
    getWebtvUsers: {
      immediate: true,
      handler: function handler(users) {
        var customParticipants = this.localParticipantOptions.filter(function (option) {
          return option.isCustom;
        });
        this.localParticipantOptions = [].concat(toConsumableArray_default()(users), toConsumableArray_default()(customParticipants));
        this.setupParticipantBulkListener();
      }
    },

    'form.diffusion': function formDiffusion(newValue) {
      this.getTypesSources(newValue);
    },
    'skinConfirmed': function skinConfirmed(newV) {
      if (newV && newV.id) {
        var selected = newV;
        this.skinForm.selectedSkin = newV.id;
        this.skinIsEditMode = true;
        this.currentSkin = selected;
        this.skinForm.skin = {
          primary_color: selected.primaryColor || "#00a6d9",
          secondary_color: selected.secondaryColor || "#ecf6fa",
          text_primary_color: selected.primaryTextColor || "#ffffff",
          text_secondary_color: selected.secondaryTextColor || "#000000",
          name: selected.name || "",

          logo: selected.logo || null,
          logoPreview: selected.logo || null, // <-- set preview URL

          before: {
            info_text: selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.title || "",
            show_date: selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.date || false,
            show_hour: selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.duration || false,
            background: selected.beforeBackground || null,
            backgroundPreview: selected.beforeBackground || null, // <-- set preview URL
            background_blur: selected.bluredBeforeBackground || false
          },

          after: {
            info_text: selected.afterLiveTextOptions && selected.afterLiveTextOptions.title || "",
            show_date: selected.afterLiveTextOptions && selected.afterLiveTextOptions.date || false,
            show_hour: selected.afterLiveTextOptions && selected.afterLiveTextOptions.duration || false,
            background: selected.afterBackground || null,
            backgroundPreview: selected.afterBackground || null, // <-- set preview URL
            background_blur: selected.bluredAfterBackground || false
          }
        };
      }
    },

    liveSkinsOptions: {
      handler: function handler(newSkins) {
        this.buildSkinOptions(Array.isArray(newSkins) ? newSkins : []);
        this.selectSkinIfReady();
      },

      immediate: true
    },
    live: function live() {
      var _this5 = this;

      this.ready = true;
      // Object.assign(this.form, JSON.parse(JSON.stringify(this.live)));
      var liveData = JSON.parse(stringify_default()(this.live));
      keys_default()(liveData).forEach(function (key) {
        _this5.$set(_this5.form, key, liveData[key]);
      });
      this.socialNetwork = this.form.foFacebook || this.form.foYoutube || this.form.foX || this.form.foLinkedin;
      this.joinFile = this.form.files.length > 0;
      this.form.doc_public = !!this.form.doc_public;
      this.form.doc_publish_default = !!this.form.doc_publish_default;
      this.form.doc_public_mail = !!this.form.doc_public_mail;
      this.form.doc_private = !!this.form.doc_private;
      this.password = !!this.form.pwd;
      this.connexionWebinar = this.form.connexionType;
      this.accessWebinar = this.form.accessType;
      this.isBeforeLiveVideoPickerVisible = !this.form.videoBeforeLive;
      if (this.defaultThumbnail && this.defaultThumbnail !== null && this.defaultThumbnail !== '' && this.defaultThumbnail !== undefined) {
        this.getDefaultThumb();
      }
      this.selectSkinIfReady();
      if (this.isEmpreinteClient) {
        if (this.form.questions && this.form.questions.length > 0 || this.form.slides && this.form.slides.length > 0) {
          this.form.isRm = true;
        } else {
          this.form.isRm = false;
        }
      }
    },
    file: function file() {
      if (this.file == '' || this.file == null) {
        this.showDelete = false;
      } else {
        this.showDelete = true;
      }
    },
    'form.mail': function formMail(newVal) {
      if (newVal) {
        this.validateEmail(newVal);
      } else {
        this.emailError = null;
      }
    },
    checkedLimit: function checkedLimit(newVal) {
      if (!newVal) {
        this.resetMaxOnlineGuests();
      }
    },

    'form.isRecorded': function formIsRecorded(newVal) {
      if (!newVal) {
        this.form.autoPublish = false;
      }
    }
  },
  methods: extends_default()({
    getPollRequestConfig: function getPollRequestConfig() {
      return {
        headers: {
          Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA",
          'Content-Type': 'application/json',
          'client-name': window.process.env.CLIENT_NAME
        }
      };
    },
    getPresentationRequestConfig: function getPresentationRequestConfig() {
      var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'application/json';

      var headers = {
        Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA",
        'client-name': window.process.env.CLIENT_NAME || 'test'
      };

      if (contentType) {
        headers['Content-Type'] = contentType;
      }

      return {
        headers: headers
      };
    },
    normalizePresentationSlidesResponse: function normalizePresentationSlidesResponse(payload) {
      var candidates = [payload && payload.data, payload && payload.data && payload.data.data, payload && payload.data && payload.data.documents, payload && payload.data && payload.data.slides, payload && payload.data && payload.data.data && payload.data.data.documents, payload && payload.data && payload.data.data && payload.data.data.slides];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(candidates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var candidate = _step.value;

          if (Array.isArray(candidate)) {
            return candidate;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [];
    },
    getPresentationTitle: function getPresentationTitle(item) {
      return item.doc_name || this.$t('form_live.tabs.advanced.presentation.untitled');
    },
    getPresentationExtension: function getPresentationExtension(item) {
      var title = this.getPresentationTitle(item);
      if (!title || title.indexOf('.') === -1) {
        return this.$t('form_live.tabs.advanced.presentation.file');
      }

      return title.split('.').pop().toUpperCase();
    },
    getPresentationFileType: function getPresentationFileType(item) {
      var extension = this.getPresentationExtension(item).toLowerCase();

      if (extension === 'pdf') {
        return 'pdf';
      }

      if (extension === 'ppt' || extension === 'pptx') {
        return 'ppt';
      }

      if (extension === 'doc' || extension === 'docx') {
        return 'doc';
      }

      return 'file';
    },
    getPresentationSlidesCount: function getPresentationSlidesCount(item) {
      if (Array.isArray(item.slides)) {
        return item.slides.length;
      }

      if (Array.isArray(item.images)) {
        return item.images.length;
      }

      if (typeof item.slidesCount === 'number') {
        return item.slidesCount;
      }

      if (typeof item.slideCount === 'number') {
        return item.slideCount;
      }

      return 0;
    },
    getPresentationPreview: function getPresentationPreview(item) {
      if (item.preview) {
        return item.preview;
      }

      if (item.thumbnail) {
        return item.thumbnail;
      }

      if (Array.isArray(item.slides) && item.slides.length > 0) {
        var firstSlide = item.slides[0];
        return firstSlide.url || firstSlide.src || firstSlide.image || firstSlide;
      }

      if (Array.isArray(item.images) && item.images.length > 0) {
        var firstImage = item.images[0];
        return firstImage.url || firstImage.src || firstImage.image || firstImage;
      }

      return '';
    },
    getPresentationSourceUrl: function getPresentationSourceUrl(item) {
      return item.url || item.fileUrl || item.sourceUrl || item.documentUrl || '';
    },
    getPresentationDeleteId: function getPresentationDeleteId(item) {
      return item.localId || item.doc_index || item.docId || item.doc_id || item.id || item.documentId || item.fileId || item.key || '';
    },
    triggerPresentationUpload: function triggerPresentationUpload() {
      if (!this.$refs.presentationInput) {
        return;
      }

      this.$refs.presentationInput.click();
    },
    handlePresentationFileChange: function handlePresentationFileChange(event) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var input, selectedFile, extension, formData;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = event && event.target ? event.target : null;
                selectedFile = input && input.files && input.files[0] ? input.files[0] : null;

                if (selectedFile) {
                  _context.next = 5;
                  break;
                }

                if (input) {
                  input.value = '';
                }
                return _context.abrupt('return');

              case 5:
                if (_this6.$route.params.id) {
                  _context.next = 10;
                  break;
                }

                _this6.pendingPresentationFiles.push({
                  localId: 'pending-presentation-' + Date.now() + '-' + _this6.pendingPresentationFiles.length,
                  name: selectedFile.name,
                  file: selectedFile,
                  isPending: true
                });
                _this6.showToast('success', _this6.$t('form_live.tabs.advanced.presentation.queued_success'), 'icon-success');
                if (input) {
                  input.value = '';
                }
                return _context.abrupt('return');

              case 10:
                extension = selectedFile.name.includes('.') ? selectedFile.name.split('.').pop().toLowerCase() : '';
                formData = new FormData();

                formData.append('file', selectedFile);
                formData.append('extension', extension);

                _this6.presentationUploading = true;

                _context.prev = 15;
                _context.next = 18;
                return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/convert-document/' + _this6.$route.params.id, formData, _this6.getPresentationRequestConfig(null));

              case 18:

                _this6.showToast('success', _this6.$t('form_live.tabs.advanced.presentation.upload_success'), 'icon-success');
                _context.next = 21;
                return _this6.fetchPresentationSlides();

              case 21:
                _context.next = 27;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](15);

                console.log('error while uploading presentation document : ', _context.t0);
                _this6.showToast('error', _this6.$t('form_live.tabs.advanced.presentation.upload_error'), 'icon-warning');

              case 27:
                _context.prev = 27;

                _this6.presentationUploading = false;
                if (input) {
                  input.value = '';
                }
                return _context.finish(27);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6, [[15, 23, 27, 31]]);
      }))();
    },
    fetchPresentationSlides: function fetchPresentationSlides() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this7.$route.params.id) {
                  _context2.next = 3;
                  break;
                }

                _this7.presentationSlides = [];
                return _context2.abrupt('return');

              case 3:

                _this7.presentationLoading = true;

                _context2.prev = 4;
                _context2.next = 7;
                return axios_default.a.get(window.process.env.API_HOST_LIVE + '/live/doc-slides/' + _this7.$route.params.id, _this7.getPresentationRequestConfig());

              case 7:
                response = _context2.sent;

                _this7.presentationSlides = _this7.normalizePresentationSlidesResponse(response);
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](4);

                console.log('error while fetching presentation slides for this live : ', _context2.t0);
                _this7.presentationSlides = [];
                _this7.showToast('error', _this7.$t('form_live.tabs.advanced.presentation.fetch_error'), 'icon-warning');

              case 16:
                _context2.prev = 16;

                _this7.presentationLoading = false;
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[4, 11, 16, 19]]);
      }))();
    },
    deletePresentation: function deletePresentation(documentId) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var pendingIndex, signedUrl;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (documentId) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                pendingIndex = _this8.pendingPresentationFiles.findIndex(function (item) {
                  return item.localId === documentId;
                });

                if (!(pendingIndex > -1)) {
                  _context3.next = 6;
                  break;
                }

                _this8.pendingPresentationFiles.splice(pendingIndex, 1);
                return _context3.abrupt('return');

              case 6:

                _this8.presentationDeletingId = documentId;

                _context3.prev = 7;
                _context3.next = 10;
                return getSignedLiveDocumentsUrl('/live/doc-slides/' + documentId);

              case 10:
                signedUrl = _context3.sent;
                _context3.next = 13;
                return axios_default.a.delete(signedUrl, _this8.getPresentationRequestConfig());

              case 13:
                _this8.showToast('success', _this8.$t('form_live.tabs.advanced.presentation.delete_success'), 'icon-success');
                _context3.next = 16;
                return _this8.fetchPresentationSlides();

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](7);

                console.log('error while deleting presentation document : ', _context3.t0);
                _this8.showToast('error', _this8.$t('form_live.tabs.advanced.presentation.delete_error'), 'icon-warning');

              case 22:
                _context3.prev = 22;

                _this8.presentationDeletingId = null;
                return _context3.finish(22);

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[7, 18, 22, 25]]);
      }))();
    },
    uploadPresentationFile: function uploadPresentationFile(file, liveId) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var extension, formData;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                extension = file.name && file.name.includes('.') ? file.name.split('.').pop().toLowerCase() : '';
                formData = new FormData();

                formData.append('file', file);
                formData.append('extension', extension);

                _context4.next = 6;
                return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/convert-document/' + liveId, formData, _this9.getPresentationRequestConfig(null));

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    uploadPendingPresentations: function uploadPendingPresentations(liveId) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, pendingFile;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!liveId || _this10.pendingPresentationFiles.length === 0)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:

                _this10.presentationUploading = true;

                _context5.prev = 3;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 7;
                _iterator2 = get_iterator_default()(_this10.pendingPresentationFiles);

              case 9:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context5.next = 16;
                  break;
                }

                pendingFile = _step2.value;
                _context5.next = 13;
                return _this10.uploadPresentationFile(pendingFile.file, liveId);

              case 13:
                _iteratorNormalCompletion2 = true;
                _context5.next = 9;
                break;

              case 16:
                _context5.next = 22;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5['catch'](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 22:
                _context5.prev = 22;
                _context5.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context5.prev = 25;

                if (!_didIteratorError2) {
                  _context5.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context5.finish(25);

              case 29:
                return _context5.finish(22);

              case 30:

                _this10.pendingPresentationFiles = [];
                _this10.showToast('success', _this10.$t('form_live.tabs.advanced.presentation.upload_success'), 'icon-success');
                _context5.next = 34;
                return _this10.fetchPresentationSlides();

              case 34:
                _context5.next = 40;
                break;

              case 36:
                _context5.prev = 36;
                _context5.t1 = _context5['catch'](3);

                console.log('error while uploading pending presentation documents : ', _context5.t1);
                _this10.showToast('error', _this10.$t('form_live.tabs.advanced.presentation.upload_error'), 'icon-warning');

              case 40:
                _context5.prev = 40;

                _this10.presentationUploading = false;
                return _context5.finish(40);

              case 43:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this10, [[3, 36, 40, 43], [7, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    getManagedDocumentName: function getManagedDocumentName(item) {
      return getLiveDocumentName(item);
    },
    getManagedDocumentExtension: function getManagedDocumentExtension(item) {
      var name = this.getManagedDocumentName(item);
      if (!name || name.indexOf('.') === -1) {
        return '';
      }

      return name.split('.').pop().toLowerCase();
    },
    getManagedDocumentIcon: function getManagedDocumentIcon(item) {
      var extension = this.getManagedDocumentExtension(item);

      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(extension)) {
        return 'file-image';
      }

      if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
        return 'file-video';
      }

      if (['mp3', 'wav', 'ogg', 'm4a'].includes(extension)) {
        return 'file-audio';
      }

      if (extension === 'pdf') {
        return 'file-pdf';
      }

      if (['doc', 'docx'].includes(extension)) {
        return 'file-word';
      }

      if (['ppt', 'pptx'].includes(extension)) {
        return 'file-powerpoint';
      }

      if (['xls', 'xlsx', 'csv'].includes(extension)) {
        return 'file-excel';
      }

      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
        return 'file-archive';
      }

      return 'file';
    },
    getManagedDocumentIconClass: function getManagedDocumentIconClass(item) {
      var extension = this.getManagedDocumentExtension(item);

      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp'].includes(extension)) {
        return 'is-image';
      }

      if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
        return 'is-video';
      }

      if (['mp3', 'wav', 'ogg', 'm4a'].includes(extension)) {
        return 'is-audio';
      }

      if (extension === 'pdf') {
        return 'is-pdf';
      }

      if (['doc', 'docx'].includes(extension)) {
        return 'is-word';
      }

      if (['ppt', 'pptx'].includes(extension)) {
        return 'is-powerpoint';
      }

      if (['xls', 'xlsx', 'csv'].includes(extension)) {
        return 'is-excel';
      }

      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
        return 'is-archive';
      }

      return 'is-default';
    },
    getManagedDocumentUrl: function getManagedDocumentUrl(item) {
      var url = getLiveDocumentUrl(item);
      if (url) return url;
      if (item.file_path) {
        return item.file_path;
      }
      if (item.doc_index) {
        return '' + window.process.env.API_HOST_DOWNLOAD + item.doc_index;
      }
      return '';
    },
    getManagedDocumentOwner: function getManagedDocumentOwner(item) {
      var owner = item && item.owner ? String(item.owner).trim() : '';
      return owner ? owner.toUpperCase() : '';
    },
    isManagedDocumentPublic: function isManagedDocumentPublic(item) {
      return isLiveDocumentPublic(item);
    },
    getManagedDocumentId: function getManagedDocumentId(item) {
      return getLiveDocumentId(item);
    },
    triggerLiveDocumentUpload: function triggerLiveDocumentUpload() {
      if (this.$refs.liveDocumentsInput) {
        this.$refs.liveDocumentsInput.click();
      }
    },
    syncSharedFilesPanelState: function syncSharedFilesPanelState() {
      var hasDocuments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.managedLiveDocuments.length > 0;

      if (!hasDocuments) {
        return;
      }

      this.showFilesPanel = true;
    },
    unpublishAllLiveDocuments: function unpublishAllLiveDocuments() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var hasPublishedPending, publishedIds;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!_this11.documentsUploading) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                hasPublishedPending = false;

                _this11.pendingLiveDocuments = _this11.pendingLiveDocuments.map(function (doc) {
                  if (doc.public) {
                    hasPublishedPending = true;
                    return extends_default()({}, doc, { public: false });
                  }
                  return doc;
                });

                publishedIds = _this11.liveDocuments.filter(function (doc) {
                  return _this11.isManagedDocumentPublic(doc);
                }).map(function (doc) {
                  return _this11.getManagedDocumentId(doc);
                }).filter(Boolean);

                if (!(publishedIds.length === 0 && !hasPublishedPending)) {
                  _context6.next = 8;
                  break;
                }

                _this11.showToast('info', _this11.$t('form_live.tabs.advanced.documents.unpublish_all_nothing'), 'icon-info');
                return _context6.abrupt('return');

              case 8:
                if (!(publishedIds.length > 0)) {
                  _context6.next = 26;
                  break;
                }

                _this11.documentsUploading = true;
                _context6.prev = 10;
                _context6.next = 13;
                return _this11.setLiveDocumentsPublish(publishedIds, false);

              case 13:
                _this11.liveDocuments = _this11.liveDocuments.map(function (item) {
                  return extends_default()({}, item, {
                    public: false
                  });
                });
                _context6.next = 16;
                return _this11.fetchLiveDocuments();

              case 16:
                _context6.next = 23;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6['catch'](10);

                console.log('error while unpublishing all live documents : ', _context6.t0);
                _this11.showToast('error', _this11.$t('form_live.tabs.advanced.documents.unpublish_all_error'), 'icon-warning');
                return _context6.abrupt('return');

              case 23:
                _context6.prev = 23;

                _this11.documentsUploading = false;
                return _context6.finish(23);

              case 26:

                _this11.showToast('success', _this11.$t('form_live.tabs.advanced.documents.unpublish_all_success'), 'icon-success');

              case 27:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this11, [[10, 18, 23, 26]]);
      }))();
    },
    fetchLiveDocuments: function fetchLiveDocuments() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var signedUrl, response;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this12.$route.params.id) {
                  _context7.next = 3;
                  break;
                }

                _this12.liveDocuments = [];
                return _context7.abrupt('return');

              case 3:

                _this12.documentsLoading = true;

                _context7.prev = 4;
                _context7.next = 7;
                return getSignedLiveDocumentsUrl('/live/file-live/' + _this12.$route.params.id);

              case 7:
                signedUrl = _context7.sent;
                _context7.next = 10;
                return axios_default.a.get(signedUrl, getLiveDocumentsHeaders());

              case 10:
                response = _context7.sent;

                _this12.liveDocuments = normalizeLiveDocumentsResponse(response);
                _this12.syncSharedFilesPanelState();
                _context7.next = 20;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](4);

                console.log('error while fetching live documents : ', _context7.t0);
                _this12.liveDocuments = [];
                _this12.showToast('error', _this12.$t('form_live.tabs.advanced.documents.fetch_error'), 'icon-warning');

              case 20:
                _context7.prev = 20;

                _this12.documentsLoading = false;
                return _context7.finish(20);

              case 23:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this12, [[4, 15, 20, 23]]);
      }))();
    },
    handleLiveDocumentFileChange: function handleLiveDocumentFileChange(event) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var input, files, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, file;

        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                input = event && event.target ? event.target : null;
                files = input && input.files ? from_default()(input.files) : [];

                if (files.length) {
                  _context8.next = 5;
                  break;
                }

                if (input) {
                  input.value = '';
                }
                return _context8.abrupt('return');

              case 5:

                _this13.syncSharedFilesPanelState(true);

                if (_this13.$route.params.id) {
                  _context8.next = 11;
                  break;
                }

                files.forEach(function (file, index) {
                  _this13.pendingLiveDocuments.push({
                    localId: 'pending-document-' + Date.now() + '-' + index,
                    name: file.name,
                    file: file,
                    isPending: true,
                    public: !!_this13.form.doc_publish_default
                  });
                });
                _this13.showToast('success', _this13.$t('form_live.tabs.advanced.documents.queued_success'), 'icon-success');
                if (input) {
                  input.value = '';
                }
                return _context8.abrupt('return');

              case 11:

                _this13.documentsUploading = true;

                _context8.prev = 12;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context8.prev = 16;
                _iterator3 = get_iterator_default()(files);

              case 18:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context8.next = 25;
                  break;
                }

                file = _step3.value;
                _context8.next = 22;
                return _this13.uploadLiveDocument(file, _this13.$route.params.id, !!_this13.form.doc_publish_default);

              case 22:
                _iteratorNormalCompletion3 = true;
                _context8.next = 18;
                break;

              case 25:
                _context8.next = 31;
                break;

              case 27:
                _context8.prev = 27;
                _context8.t0 = _context8['catch'](16);
                _didIteratorError3 = true;
                _iteratorError3 = _context8.t0;

              case 31:
                _context8.prev = 31;
                _context8.prev = 32;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 34:
                _context8.prev = 34;

                if (!_didIteratorError3) {
                  _context8.next = 37;
                  break;
                }

                throw _iteratorError3;

              case 37:
                return _context8.finish(34);

              case 38:
                return _context8.finish(31);

              case 39:

                _this13.showToast('success', _this13.$t('form_live.tabs.advanced.documents.upload_success'), 'icon-success');
                _context8.next = 42;
                return _this13.fetchLiveDocuments();

              case 42:
                _context8.next = 48;
                break;

              case 44:
                _context8.prev = 44;
                _context8.t1 = _context8['catch'](12);

                console.log('error while uploading live documents : ', _context8.t1);
                _this13.showToast('error', _this13.$t('form_live.tabs.advanced.documents.upload_error'), 'icon-warning');

              case 48:
                _context8.prev = 48;

                _this13.documentsUploading = false;
                if (input) {
                  input.value = '';
                }
                return _context8.finish(48);

              case 52:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this13, [[12, 44, 48, 52], [16, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    uploadLiveDocument: function uploadLiveDocument(file, liveId) {
      var _this14 = this;

      var publishAfterUpload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var signedUrl, formData, response, uploadedDocuments, ids;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return getSignedLiveDocumentsUrl('/live/files-live/' + liveId);

              case 2:
                signedUrl = _context9.sent;
                formData = new FormData();

                formData.append('files', file);
                formData.append('owner', window.client || window.process.env.CLIENT_NAME || 'empadmin');

                _context9.next = 8;
                return axios_default.a.post(signedUrl, formData, getLiveDocumentsHeaders(null));

              case 8:
                response = _context9.sent;
                uploadedDocuments = normalizeLiveDocumentsResponse(response);

                if (!publishAfterUpload) {
                  _context9.next = 15;
                  break;
                }

                ids = uploadedDocuments.map(function (item) {
                  return getLiveDocumentId(item);
                }).filter(Boolean);

                if (!(ids.length > 0)) {
                  _context9.next = 15;
                  break;
                }

                _context9.next = 15;
                return _this14.setLiveDocumentsPublish(ids, true);

              case 15:
                return _context9.abrupt('return', response);

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this14);
      }))();
    },
    uploadPendingLiveDocuments: function uploadPendingLiveDocuments(liveId) {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, pendingDocument;

        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(!liveId || _this15.pendingLiveDocuments.length === 0)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return');

              case 2:

                _this15.documentsUploading = true;

                _context10.prev = 3;
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context10.prev = 7;
                _iterator4 = get_iterator_default()(_this15.pendingLiveDocuments);

              case 9:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context10.next = 16;
                  break;
                }

                pendingDocument = _step4.value;
                _context10.next = 13;
                return _this15.uploadLiveDocument(pendingDocument.file, liveId, !!pendingDocument.public);

              case 13:
                _iteratorNormalCompletion4 = true;
                _context10.next = 9;
                break;

              case 16:
                _context10.next = 22;
                break;

              case 18:
                _context10.prev = 18;
                _context10.t0 = _context10['catch'](7);
                _didIteratorError4 = true;
                _iteratorError4 = _context10.t0;

              case 22:
                _context10.prev = 22;
                _context10.prev = 23;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 25:
                _context10.prev = 25;

                if (!_didIteratorError4) {
                  _context10.next = 28;
                  break;
                }

                throw _iteratorError4;

              case 28:
                return _context10.finish(25);

              case 29:
                return _context10.finish(22);

              case 30:

                _this15.pendingLiveDocuments = [];
                _context10.next = 33;
                return _this15.fetchLiveDocuments();

              case 33:
                _context10.prev = 33;

                _this15.documentsUploading = false;
                return _context10.finish(33);

              case 36:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this15, [[3,, 33, 36], [7, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    setLiveDocumentsPublish: function setLiveDocumentsPublish(ids, value) {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var signedUrl;
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(!Array.isArray(ids) || ids.length === 0)) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return');

              case 2:
                _context11.next = 4;
                return getSignedLiveDocumentsUrl('/live/files-live/publish');

              case 4:
                signedUrl = _context11.sent;
                _context11.next = 7;
                return axios_default.a.post(signedUrl, [{ ids: ids, public: !!value }], getLiveDocumentsHeaders('application/json'));

              case 7:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this16);
      }))();
    },
    toggleLiveDocumentPublish: function toggleLiveDocumentPublish(document, value) {
      var _this17 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        var documentId;
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                documentId = _this17.getManagedDocumentId(document);

                if (documentId) {
                  _context12.next = 3;
                  break;
                }

                return _context12.abrupt('return');

              case 3:
                _context12.prev = 3;
                _context12.next = 6;
                return _this17.setLiveDocumentsPublish([documentId], value);

              case 6:
                _this17.liveDocuments = _this17.liveDocuments.map(function (item) {
                  return _this17.getManagedDocumentId(item) === documentId ? extends_default()({}, item, { public: !!value }) : item;
                });
                _context12.next = 13;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12['catch'](3);

                console.log('error while updating live document visibility : ', _context12.t0);
                _this17.showToast('error', _this17.$t('form_live.tabs.advanced.documents.publish_error'), 'icon-warning');

              case 13:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this17, [[3, 9]]);
      }))();
    },
    deleteLiveDocument: function deleteLiveDocument(document) {
      var _this18 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var documentId, signedUrl;
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                documentId = document.isPending ? document.localId : _this18.getManagedDocumentId(document);

                if (documentId) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt('return');

              case 3:
                if (!document.isPending) {
                  _context13.next = 6;
                  break;
                }

                _this18.pendingLiveDocuments = _this18.pendingLiveDocuments.filter(function (item) {
                  return item.localId !== documentId;
                });
                return _context13.abrupt('return');

              case 6:

                _this18.documentsDeletingId = documentId;

                _context13.prev = 7;
                _context13.next = 10;
                return getSignedLiveDocumentsUrl('/live/file-live/' + documentId);

              case 10:
                signedUrl = _context13.sent;
                _context13.next = 13;
                return axios_default.a.delete(signedUrl, getLiveDocumentsHeaders());

              case 13:
                _this18.liveDocuments = _this18.liveDocuments.filter(function (item) {
                  return _this18.getManagedDocumentId(item) !== documentId;
                });
                _this18.showToast('success', _this18.$t('form_live.tabs.advanced.documents.delete_success'), 'icon-success');
                _context13.next = 21;
                break;

              case 17:
                _context13.prev = 17;
                _context13.t0 = _context13['catch'](7);

                console.log('error while deleting live document : ', _context13.t0);
                _this18.showToast('error', _this18.$t('form_live.tabs.advanced.documents.delete_error'), 'icon-warning');

              case 21:
                _context13.prev = 21;

                _this18.documentsDeletingId = null;
                return _context13.finish(21);

              case 24:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this18, [[7, 17, 21, 24]]);
      }))();
    },
    copyLiveDocumentLink: function copyLiveDocumentLink(document) {
      var _this19 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
        var url;
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                url = _this19.getManagedDocumentUrl(document);

                if (url) {
                  _context14.next = 3;
                  break;
                }

                return _context14.abrupt('return');

              case 3:
                _context14.prev = 3;
                _context14.next = 6;
                return navigator.clipboard.writeText(url);

              case 6:
                _this19.showToast('success', _this19.$t('form_live.tabs.advanced.documents.link_copied'), 'icon-success');
                _context14.next = 12;
                break;

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14['catch'](3);

                console.log('error while copying live document link : ', _context14.t0);

              case 12:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this19, [[3, 9]]);
      }))();
    },
    normalizePollsResponse: function normalizePollsResponse(payload) {
      var candidates = [payload && payload.data, payload && payload.data && payload.data.data, payload && payload.data && payload.data.polls, payload && payload.data && payload.data.data && payload.data.data.polls];

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(candidates), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var candidate = _step5.value;

          if (Array.isArray(candidate)) {
            return candidate;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var singlePoll = payload && payload.data && payload.data.poll || payload && payload.data && payload.data.data && payload.data.data.poll || (payload && payload.data && payload.data.id ? payload.data : null);

      return singlePoll ? [singlePoll] : [];
    },
    addPollDraft: function addPollDraft() {
      if (!this.canAddPoll) {
        this.showToast('warning', this.$t('form_live.tabs.advanced.polls.complete_current_first'), 'icon-warning');
        this.activePollIndex = this.livePolls.length - 1;
        return;
      }
      this.livePolls.push(createPollDraft());
      this.activePollIndex = this.livePolls.length - 1;
    },
    setActivePoll: function setActivePoll(index) {
      if (index < 0 || index >= this.livePolls.length) {
        return;
      }

      this.activePollIndex = index;
    },
    ensureActivePollIndex: function ensureActivePollIndex() {
      var preferredIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.livePolls.length === 0) {
        this.activePollIndex = 0;
        return;
      }

      this.activePollIndex = Math.min(Math.max(preferredIndex, 0), this.livePolls.length - 1);
    },
    getPollTabTitle: function getPollTabTitle(poll) {
      if (poll && poll.question && poll.question.trim()) {
        return poll.question;
      }

      return this.$t('form_live.tabs.advanced.polls.untitled');
    },
    isDeletePollPending: function isDeletePollPending(pollIndex) {
      return this.pendingPollDelete && this.pendingPollDelete.type === 'poll' && this.pendingPollDelete.pollIndex === pollIndex;
    },
    isDeleteOptionPending: function isDeleteOptionPending(pollIndex, optionIndex) {
      return this.pendingPollDelete && this.pendingPollDelete.type === 'option' && this.pendingPollDelete.pollIndex === pollIndex && this.pendingPollDelete.optionIndex === optionIndex;
    },
    requestPollDelete: function requestPollDelete(pollIndex) {
      this.pendingPollDelete = {
        type: 'poll',
        pollIndex: pollIndex
      };
    },
    requestPollOptionDelete: function requestPollOptionDelete(pollIndex, optionIndex) {
      this.pendingPollDelete = {
        type: 'option',
        pollIndex: pollIndex,
        optionIndex: optionIndex
      };
    },
    cancelPendingDelete: function cancelPendingDelete() {
      this.pendingPollDelete = null;
    },
    confirmPollDelete: function confirmPollDelete(pollIndex) {
      this.cancelPendingDelete();
      this.removePoll(pollIndex);
    },
    confirmPollOptionDelete: function confirmPollOptionDelete(pollIndex, optionIndex) {
      var _this20 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this20.cancelPendingDelete();
                _context15.next = 3;
                return _this20.removePollOption(pollIndex, optionIndex);

              case 3:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this20);
      }))();
    },
    addPollOption: function addPollOption(pollIndex) {
      var poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      poll.options.push(createPollOptionDraft());
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, extends_default()({}, poll));
    },
    updatePollQuestion: function updatePollQuestion(pollIndex, value) {
      var poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      poll.question = value;
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, extends_default()({}, poll));
    },
    updatePollPublished: function updatePollPublished(pollIndex, value) {
      var _this21 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var poll, nextValue, previousValue;
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                poll = _this21.livePolls[pollIndex];

                if (poll) {
                  _context16.next = 3;
                  break;
                }

                return _context16.abrupt('return');

              case 3:
                nextValue = !!value;
                previousValue = !!poll.isPublished;

                poll.isPublished = nextValue;
                poll.dirty = true;
                _this21.livePolls.splice(pollIndex, 1, extends_default()({}, poll));

                if (!(!poll.id || !_this21.isEmpreintePollClient)) {
                  _context16.next = 10;
                  break;
                }

                return _context16.abrupt('return');

              case 10:
                _context16.prev = 10;
                _context16.next = 13;
                return axios_default.a.patch(window.process.env.API_HOST_LIVE + '/live/polls/publish/' + poll.id, {
                  isPublished: nextValue
                }, _this21.getPollRequestConfig());

              case 13:
                _context16.next = 20;
                break;

              case 15:
                _context16.prev = 15;
                _context16.t0 = _context16['catch'](10);

                poll.isPublished = previousValue;
                _this21.livePolls.splice(pollIndex, 1, extends_default()({}, poll));
                _this21.showToast('error', _this21.$t('form_live.tabs.advanced.polls.publish_error'), 'icon-warning');

              case 20:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this21, [[10, 15]]);
      }))();
    },
    updatePollOption: function updatePollOption(pollIndex, optionIndex, value) {
      var poll = this.livePolls[pollIndex];
      if (!poll || !poll.options[optionIndex]) {
        return;
      }

      poll.options[optionIndex].poll_option = value;
      poll.options[optionIndex].dirty = true;
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, extends_default()({}, poll));
    },
    removePollOptionLocally: function removePollOptionLocally(pollIndex, optionIndex) {
      var poll = this.livePolls[pollIndex];
      if (!poll) {
        return false;
      }

      if (poll.options.length <= 2) {
        this.showToast('warning', this.$t('form_live.tabs.advanced.polls.min_options_warning'), 'icon-warning');
        return false;
      }

      poll.options.splice(optionIndex, 1);
      poll.dirty = true;
      this.livePolls.splice(pollIndex, 1, extends_default()({}, poll));
      return true;
    },
    removePollOption: function removePollOption(pollIndex, optionIndex) {
      var _this22 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var poll, option, removed;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                poll = _this22.livePolls[pollIndex];

                if (!(!poll || !poll.options[optionIndex])) {
                  _context17.next = 3;
                  break;
                }

                return _context17.abrupt('return');

              case 3:
                option = poll.options[optionIndex];
                removed = _this22.removePollOptionLocally(pollIndex, optionIndex);

                if (removed) {
                  _context17.next = 7;
                  break;
                }

                return _context17.abrupt('return');

              case 7:
                if (option.id) {
                  _context17.next = 9;
                  break;
                }

                return _context17.abrupt('return');

              case 9:

                if (poll.id && !_this22.deletedPollOptionIds.some(function (deletedOption) {
                  return deletedOption.pollId === poll.id && deletedOption.optionId === option.id;
                })) {
                  _this22.deletedPollOptionIds.push({
                    pollId: poll.id,
                    optionId: option.id
                  });
                }

              case 10:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this22);
      }))();
    },
    removePoll: function removePoll(pollIndex) {
      var poll = this.livePolls[pollIndex];
      if (!poll) {
        return;
      }

      if (poll.id) {
        if (!this.deletedPollIds.includes(poll.id)) {
          this.deletedPollIds.push(poll.id);
        }
        this.deletedPollOptionIds = this.deletedPollOptionIds.filter(function (deletedOption) {
          return deletedOption.pollId !== poll.id;
        });
      }

      this.livePolls.splice(pollIndex, 1);
      if (this.livePolls.length === 0) {
        this.form.poll = false;
        this.activePollIndex = 0;
        return;
      }

      this.ensureActivePollIndex(Math.min(pollIndex, this.livePolls.length - 1));
    },
    getPollValidationError: function getPollValidationError(poll) {
      if (!poll || !poll.question || !poll.question.trim()) {
        return this.$t('form_live.tabs.advanced.polls.validation_question_required');
      }

      if (!Array.isArray(poll.options) || poll.options.length < 2) {
        return this.$t('form_live.tabs.advanced.polls.validation_min_options');
      }

      var invalidOption = poll.options.find(function (option) {
        return !option.poll_option || !option.poll_option.trim();
      });
      if (invalidOption) {
        return this.$t('form_live.tabs.advanced.polls.validation_options_required');
      }

      return '';
    },
    buildCreatePollsPayload: function buildCreatePollsPayload(liveId) {
      return this.livePolls.filter(function (poll) {
        return !poll.id;
      }).map(function (poll) {
        return {
          question: poll.question.trim(),
          liveId: liveId,
          isPublished: !!poll.isPublished,
          options: poll.options.map(function (option) {
            return {
              poll_option: option.poll_option.trim()
            };
          })
        };
      });
    },
    buildUpdatePollsPayload: function buildUpdatePollsPayload() {
      var _this23 = this;

      return this.livePolls.filter(function (poll) {
        return poll.id;
      }).map(function (poll) {
        return {
          pollId: poll.id,
          question: poll.question.trim(),
          options: [].concat(toConsumableArray_default()(poll.options.map(function (option) {
            return option.id ? {
              id: option.id,
              action: 'update',
              text: option.poll_option.trim()
            } : {
              action: 'add',
              text: option.poll_option.trim()
            };
          })), toConsumableArray_default()(_this23.deletedPollOptionIds.filter(function (deletedOption) {
            return deletedOption.pollId === poll.id;
          }).map(function (deletedOption) {
            return {
              id: deletedOption.optionId,
              action: 'delete'
            };
          })))
        };
      });
    },
    fetchLivePolls: function fetchLivePolls() {
      var _this24 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
        var response, polls;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (_this24.isEmpreintePollClient) {
                  _context18.next = 7;
                  break;
                }

                _this24.livePolls = [];
                _this24.activePollIndex = 0;
                _this24.deletedPollIds = [];
                _this24.deletedPollOptionIds = [];
                _this24.pollsLoaded = true;
                return _context18.abrupt('return');

              case 7:
                if (_this24.$route.params.id) {
                  _context18.next = 12;
                  break;
                }

                _this24.livePolls = [];
                _this24.activePollIndex = 0;
                _this24.pollsLoaded = true;
                return _context18.abrupt('return');

              case 12:

                _this24.pollsLoading = true;

                _context18.prev = 13;
                _context18.next = 16;
                return axios_default.a.get(window.process.env.API_HOST_LIVE + '/live/polls/' + _this24.$route.params.id, _this24.getPollRequestConfig());

              case 16:
                response = _context18.sent;
                polls = _this24.normalizePollsResponse(response);

                _this24.livePolls = polls.map(createPollDraft);
                _this24.ensureActivePollIndex();
                _this24.deletedPollIds = [];
                _this24.deletedPollOptionIds = [];
                _this24.pollsLoaded = true;
                _context18.next = 31;
                break;

              case 25:
                _context18.prev = 25;
                _context18.t0 = _context18['catch'](13);

                console.log('error while fetching polls for this live : ', _context18.t0);
                _this24.livePolls = [];
                _this24.activePollIndex = 0;
                _this24.pollsLoaded = true;

              case 31:
                _context18.prev = 31;

                _this24.pollsLoading = false;
                return _context18.finish(31);

              case 34:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this24, [[13, 25, 31, 34]]);
      }))();
    },
    syncLivePolls: function syncLivePolls(liveId) {
      var _this25 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19() {
        var pollErrors, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, pollId, pollsToCreate, pollsToUpdate;

        return regenerator_default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(!_this25.isEmpreintePollClient || !liveId)) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt('return');

              case 2:
                pollErrors = _this25.livePolls.map(_this25.getPollValidationError).filter(Boolean);

                if (!(pollErrors.length > 0)) {
                  _context19.next = 5;
                  break;
                }

                throw new Error(pollErrors[0]);

              case 5:

                _this25.pollsSyncing = true;

                _context19.prev = 6;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context19.prev = 10;
                _iterator6 = get_iterator_default()(_this25.deletedPollIds);

              case 12:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context19.next = 19;
                  break;
                }

                pollId = _step6.value;
                _context19.next = 16;
                return axios_default.a.delete(window.process.env.API_HOST_LIVE + '/live/polls/' + pollId, _this25.getPollRequestConfig());

              case 16:
                _iteratorNormalCompletion6 = true;
                _context19.next = 12;
                break;

              case 19:
                _context19.next = 25;
                break;

              case 21:
                _context19.prev = 21;
                _context19.t0 = _context19['catch'](10);
                _didIteratorError6 = true;
                _iteratorError6 = _context19.t0;

              case 25:
                _context19.prev = 25;
                _context19.prev = 26;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 28:
                _context19.prev = 28;

                if (!_didIteratorError6) {
                  _context19.next = 31;
                  break;
                }

                throw _iteratorError6;

              case 31:
                return _context19.finish(28);

              case 32:
                return _context19.finish(25);

              case 33:
                pollsToCreate = _this25.buildCreatePollsPayload(liveId);

                if (!(pollsToCreate.length > 0)) {
                  _context19.next = 37;
                  break;
                }

                _context19.next = 37;
                return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/polls/multiple', pollsToCreate, _this25.getPollRequestConfig());

              case 37:
                pollsToUpdate = _this25.buildUpdatePollsPayload();

                if (!(pollsToUpdate.length > 0)) {
                  _context19.next = 41;
                  break;
                }

                _context19.next = 41;
                return axios_default.a.patch(window.process.env.API_HOST_LIVE + '/live/polls/multiple', pollsToUpdate, _this25.getPollRequestConfig());

              case 41:

                _this25.deletedPollIds = [];
                _this25.deletedPollOptionIds = [];
                _context19.next = 45;
                return _this25.fetchLivePolls();

              case 45:
                _context19.prev = 45;

                _this25.pollsSyncing = false;
                return _context19.finish(45);

              case 48:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this25, [[6,, 45, 48], [10, 21, 25, 33], [26,, 28, 32]]);
      }))();
    },
    handleSourceTypeInput: function handleSourceTypeInput(value) {
      var _this26 = this;

      // Use setTimeout to ensure DOM stability
      setTimeout(function () {
        _this26.form.sourceTypeId = value;
      }, 50);
    },
    addCustomParticipant: function addCustomParticipant(email) {
      // Optional: validate email format
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) return;

      var existingOption = this.localParticipantOptions.find(function (option) {
        return option.email === email;
      });
      if (existingOption) {
        var alreadySelected = this.form.participants.some(function (option) {
          return option.email === email;
        });
        if (!alreadySelected) {
          this.form.participants.push(existingOption);
        }
        return;
      }

      var newParticipant = {
        id: 'custom-' + Date.now(),
        name: email,
        email: email,
        isCustom: true
      };
      // Add to options so it remains selectable
      this.localParticipantOptions.push(newParticipant);

      // Select it immediately
      this.form.participants.push(newParticipant);
    },
    extractEmailsFromText: function extractEmailsFromText(value) {
      if (!value || typeof value !== 'string') return [];

      var matches = value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi) || [];
      var seen = new set_default.a();

      return matches.map(function (email) {
        return email.trim().toLowerCase();
      }).filter(function (email) {
        if (seen.has(email)) return false;
        seen.add(email);
        return true;
      });
    },
    addParticipantEmails: function addParticipantEmails(rawValue) {
      var _this27 = this;

      var emails = this.extractEmailsFromText(rawValue);

      emails.forEach(function (email) {
        _this27.addCustomParticipant(email);
      });

      return emails.length;
    },
    triggerParticipantImport: function triggerParticipantImport() {
      var input = this.$refs.participantsImportInput;
      if (input) {
        input.click();
      }
    },
    handleParticipantFileChange: function handleParticipantFileChange(event) {
      var _this28 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
        var input, file, rawText, importedCount;
        return regenerator_default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                input = event.target;
                file = input && input.files ? input.files[0] : null;

                if (file) {
                  _context20.next = 4;
                  break;
                }

                return _context20.abrupt('return');

              case 4:
                _context20.prev = 4;
                _context20.next = 7;
                return _this28.readEmailsFromInviteFile(file);

              case 7:
                rawText = _context20.sent;
                importedCount = _this28.addParticipantEmails(rawText);


                if (importedCount > 0) {
                  _this28.showToast('success', importedCount + ' e-mail(s) import\xE9(s)', 'icon-success');
                } else {
                  _this28.showToast('error', 'Aucune adresse e-mail valide trouvée dans le fichier', 'icon-error');
                }
                _context20.next = 16;
                break;

              case 12:
                _context20.prev = 12;
                _context20.t0 = _context20['catch'](4);

                console.error('Error while importing participant file:', _context20.t0);
                _this28.showToast('error', 'Impossible de lire ce fichier', 'icon-error');

              case 16:
                _context20.prev = 16;

                if (input) {
                  input.value = '';
                }
                return _context20.finish(16);

              case 19:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this28, [[4, 12, 16, 19]]);
      }))();
    },
    readEmailsFromInviteFile: function readEmailsFromInviteFile(file) {
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        var fileName = (file.name || '').toLowerCase();

        reader.onload = function (event) {
          try {
            if (fileName.endsWith('.csv')) {
              resolve(event.target.result);
              return;
            }

            if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
              var workbook = XLSX.read(event.target.result, { type: 'array' });
              var content = workbook.SheetNames.map(function (sheetName) {
                var sheet = workbook.Sheets[sheetName];
                return XLSX.utils.sheet_to_csv(sheet);
              }).join('\n');

              resolve(content);
              return;
            }

            reject(new Error('Unsupported file type'));
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = function () {
          return reject(reader.error);
        };

        if (fileName.endsWith('.csv')) {
          reader.readAsText(file);
          return;
        }

        reader.readAsArrayBuffer(file);
      });
    },
    setupParticipantBulkListener: function setupParticipantBulkListener() {
      var _this29 = this;

      this.bulkEmailListenerCleanup.forEach(function (cleanup) {
        return cleanup();
      });
      this.bulkEmailListenerCleanup = [];

      this.$nextTick(function () {
        var multiselect = _this29.$refs.participantsMultiselect;
        var input = multiselect && multiselect.$el ? multiselect.$el.querySelector('.multiselect__input') : null;

        if (!input) {
          return;
        }

        var handlePaste = function handlePaste(event) {
          var pastedText = event.clipboardData && event.clipboardData.getData('text');
          if (!pastedText) return;

          if (_this29.extractEmailsFromText(pastedText).length > 1) {
            event.preventDefault();
            _this29.addParticipantEmails(pastedText);
            event.target.value = '';
          }
        };

        var handleKeydown = function handleKeydown(event) {
          var inputValue = event.target && event.target.value;
          if (!inputValue) return;

          var shouldSplit = ['Enter', 'Tab', ',', ';'].includes(event.key) || /[\n\r]/.test(inputValue);

          if (!shouldSplit) return;

          if (_this29.extractEmailsFromText(inputValue).length > 1) {
            event.preventDefault();
            _this29.addParticipantEmails(inputValue);
            event.target.value = '';
          }
        };

        input.addEventListener('paste', handlePaste);
        input.addEventListener('keydown', handleKeydown);

        _this29.bulkEmailListenerCleanup.push(function () {
          input.removeEventListener('paste', handlePaste);
          input.removeEventListener('keydown', handleKeydown);
        });
      });
    },
    toggleSection: function toggleSection(section) {
      var _this30 = this;

      // Force Vue to complete any pending DOM updates BEFORE toggling
      this.$nextTick(function () {
        _this30.$nextTick(function () {
          // Double $nextTick for safety
          _this30.sections[section] = !_this30.sections[section];
        });
      });
    },
    getPermissionByType: function getPermissionByType(type) {
      var permissionMap = {
        'Meeting': 'lives_type_meeting',
        'Webinar': 'lives_type_webinar',
        'Webcast': 'lives_type_webcast'
      };

      return permissionMap[type];
    },
    onStationChange: function onStationChange(stationId) {
      var _this31 = this;

      this.form.stationId = stationId;
      this.$nextTick(function () {
        _this31.updatePortIndexesForUnesco(stationId);
      });
    },
    updatePortIndexesForUnesco: function updatePortIndexesForUnesco(stationId) {
      if (!stationId || !this.isUnescoClient) return;

      var station = this.automaticStations.find(function (s) {
        return s.value === stationId;
      });
      if (!station) return;

      var match = station.text.match(/SDI\s*(\d+)/i);
      if (match && match[1]) {
        var sdiNumber = parseInt(match[1], 10);
        var portIndex = sdiNumber - 1;
        this.$set(this.form, 'videoPortIndex', Math.max(0, portIndex));
        this.$set(this.form, 'audioPortIndex', Math.max(0, portIndex));
      }
    },
    setPortIndexesForVyv: function setPortIndexesForVyv(station) {
      var match = station.text.toLowerCase().match(/sdi\s*(\d+)/);
      if (match && match[1]) {
        var sdiNumber = parseInt(match[1], 10);
        var portIndex = sdiNumber - 1;
        // fixing portVIdeo and portAudio to 0 for now
        // this.form.videoPortIndex = portIndex;
        // this.form.audioPortIndex = portIndex;
      } else {
        this.form.videoPortIndex = 0;
        this.form.audioPortIndex = 0;
      }
    },
    onWebinarChange: function onWebinarChange() {
      if (![1, 2].includes(this.form.sourceTypeId)) {
        this.form.sourceTypeId = 1;
      }
    },
    fetchStations: function fetchStations() {
      var _this32 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21() {
        var response;
        return regenerator_default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _this32.loadingAutomaticStations = true;
                _context21.prev = 1;
                _context21.next = 4;
                return axios_default.a.get(window.process.env.API_HOST_GLOBAL + '/live/station/auto', {
                  headers: {
                    Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
                  }
                });

              case 4:
                response = _context21.sent;

                _this32.automaticStations = response.data.stations || response.data;
                _context21.next = 12;
                break;

              case 8:
                _context21.prev = 8;
                _context21.t0 = _context21['catch'](1);

                console.error('Error fetching manual stations:', _context21.t0);
                _this32.showToast('error', _this32.$t('toast.error_fetching_stations'), 'icon-error');

              case 12:
                _context21.prev = 12;

                _this32.loadingAutomaticStations = false;
                return _context21.finish(12);

              case 15:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this32, [[1, 8, 12, 15]]);
      }))();
    },
    handleEncoderTypeChange: function handleEncoderTypeChange(type) {
      if (!type) {
        this.form.isAuto = false;
        this.form.isPearl = true;
      } else {
        this.form.isAuto = true;
        this.form.isPearl = true;
      }
    },
    fetchEncoderStations: function fetchEncoderStations() {
      var _this33 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
        var response;
        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return axios_default.a.get('/api/encoders/stations');

              case 2:
                response = _context22.sent;


                _this33.manualStations = response.data.manual || [];
                _this33.automaticStations = response.data.automatic || [];

              case 5:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this33);
      }))();
    },
    onYoutubeEnabledChange: function onYoutubeEnabledChange(val) {
      this.form.isYoutube = val;
    },
    onYoutubeLinksChange: function onYoutubeLinksChange(val) {
      this.form.youtubeLinks = val;
    },
    fetchCountries: function fetchCountries() {
      var _this34 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
        var response;
        return regenerator_default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this34.isLoadingCountries = true;
                _context23.prev = 1;
                _context23.next = 4;
                return axios_default.a.get(window.process.env.API_HOST_GLOBAL + '/video-api/video/countries?language=' + _this34.lang, {
                  headers: {
                    Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
                  }
                });

              case 4:
                response = _context23.sent;


                _this34.countriesOptions = response.data.data ? response.data.data.map(function (country) {
                  return {
                    countryCode: country.country_code,
                    countryName: country.country_name,
                    id: country.id
                  };
                }) : [];

                _context23.next = 11;
                break;

              case 8:
                _context23.prev = 8;
                _context23.t0 = _context23['catch'](1);

                console.error('Error fetching countries:', _context23.t0);

              case 11:
                _context23.prev = 11;

                _this34.isLoadingCountries = false;
                return _context23.finish(11);

              case 14:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this34, [[1, 8, 11, 14]]);
      }))();
    },
    showToast: function showToast(variant, message, icon) {
      console.log(variant, message, icon);
      this.$toasted.show(message, {
        type: variant,
        theme: 'bubble',
        position: 'bottom-right',
        duration: 2000,
        icon: {
          name: 'mr-2 ' + icon
        }
      });
    },
    handleAddInputTags: function handleAddInputTags(tags) {
      for (var i = 0; i < tags.length; i++) {
        tags[i] = tags[i].replaceAll(' ', '-');
      }
      return tags;
    },
    handleBeforeOpen: function handleBeforeOpen() {
      this.openTimeModal = true;
    },
    closeModal: function closeModal() {
      this.openTimeModal = false;
    },
    resetMaxOnlineGuests: function resetMaxOnlineGuests() {
      //Reset inputs in case the user toggle off the limit participant checkbox
      this.form.max_online_guests = null;
      this.form.max_onsite_guests = null;
    }
  }, Object(vuex_esm["b" /* mapActions */])('common', ['setDiffusionLive']), Object(vuex_esm["b" /* mapActions */])('lives', ['getLiveById', 'fetchContributors', 'fetchChannels', 'fetchLiveTypes', 'updateLive', 'createLive', 'setDiffusionObject', 'setHlsLinkValue', 'fetchLiveSkins']), {
    setHls: function setHls(e) {
      this.setHlsLinkValue(e);
    }
  }, Object(vuex_esm["b" /* mapActions */])('form', ['fetchVideos', 'fetchSurveys', 'resetPagination']), {
    getDefaultThumb: function getDefaultThumb() {
      var _this35 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24() {
        return regenerator_default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (_this35.form.thumbnail) {
                  _context24.next = 4;
                  break;
                }

                nprogress_nprogress_default.a.start();
                _context24.next = 4;
                return _this35.getDefaultImage(_this35.getThumbnail);

              case 4:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this35);
      }))();
    },
    inputFile: function inputFile() {
      if (!this.url) {
        document.getElementById('file-default').click();
        // Alternatively, you can use the ref approach:
        // this.$refs.File.click();
      }
    },
    changeInput: function changeInput() {
      var _this36 = this;

      setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee25() {
        return regenerator_default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return _this36.handleAvatarUpdated(_this36.file);

              case 2:
                _this36.PendingUpload = false;
                _this36.showDelete = true;

              case 4:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, _this36);
      })), 400);
    },
    toDataURL: function toDataURL(url, callback) {
      var _this37 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee26() {
        var xhr;
        return regenerator_default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                xhr = new XMLHttpRequest();

                xhr.onload = function () {
                  var reader = new FileReader();
                  reader.onloadend = function () {
                    callback(reader.result);
                  };
                  reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();

              case 5:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, _this37);
      }))();
    },
    portKeydown: function portKeydown(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode >= 96 && charCode <= 105 || charCode == 8) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    closeModel: function closeModel() {
      this.uploadError = false;
      this.hideModal();
      this.$refs.formIntervenant.reset();
      this.update = false;
      this.updateModal = false;

      this.form.nom = '';
      this.form.lastName = '';
      this.form.fonction = '';
      this.form.role = '';
      this.form.Description = '';
      this.file = '';
      this.form.mail = '';
      this.form.structure = '';
      this.showDelete = false;
      this.url = '';
    },
    showModal: function showModal() {
      this.$refs['my-modal'].show();
    },
    hideModal: function hideModal() {
      this.$refs['my-modal'].hide();
    },
    toggleModal: function toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn');
    },
    b64toBlob: function b64toBlob(b64Data) {
      var _this38 = this;

      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee27() {
        var byteCharacters, byteArrays, offset, slice, byteNumbers, i, byteArray, blob;
        return regenerator_default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                byteCharacters = atob(b64Data);
                byteArrays = [];


                for (offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                  slice = byteCharacters.slice(offset, offset + sliceSize);
                  byteNumbers = new Array(slice.length);

                  for (i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                  }

                  byteArray = new Uint8Array(byteNumbers);

                  byteArrays.push(byteArray);
                }

                blob = new Blob(byteArrays, { type: contentType });
                return _context27.abrupt('return', blob);

              case 5:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, _this38);
      }))();
    },
    getDefaultImage: function getDefaultImage(defaultTumbnail) {
      var _this39 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee29() {
        var self, img;
        return regenerator_default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                self = _this39;
                img = defaultTumbnail;
                _context29.next = 4;
                return _this39.toDataURL(img, function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee28(dataUrl) {
                    var contentType, replaceString, blob;
                    return regenerator_default.a.wrap(function _callee28$(_context28) {
                      while (1) {
                        switch (_context28.prev = _context28.next) {
                          case 0:
                            _context28.next = 2;
                            return dataUrl;

                          case 2:
                            img = _context28.sent;
                            contentType = 'image/jpeg';
                            replaceString = 'data:' + contentType + ';base64,';

                            if (!(img.indexOf(contentType) > -1)) {
                              _context28.next = 11;
                              break;
                            }

                            _context28.next = 8;
                            return self.b64toBlob(img.replace(replaceString, ''), contentType);

                          case 8:
                            blob = _context28.sent;
                            _context28.next = 11;
                            return self.uploadThumbnail(blob).then(function (result) {
                              var data = result.data;


                              if (img.indexOf('base64') > -1) {
                                self.form.thumbnailPath = data.location.path;
                                nprogress_nprogress_default.a.done();
                              }
                            });

                          case 11:
                          case 'end':
                            return _context28.stop();
                        }
                      }
                    }, _callee28, this);
                  }));

                  return function (_x7) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, _this39);
      }))();
    },
    redirectTo: function redirectTo(start) {
      if (start) {
        parent.postMessage({
          info: 'goToDiffusionLive',
          live: this.currentLive
        }, '*');
        this.$root.$emit('bv::hide::modal', 'modal-start-direct-v2');
      } else {
        this.goToListLive();
      }

      if (this.status && start) {
        localStorage.setItem('redirectToStartDirect', true);
      } else if (this.status && !start) {
        localStorage.setItem('redirectToList', true);
      }
    },
    redirectToLives: function redirectToLives() {
      this.goToListLive();
    },
    removeError: function removeError(event) {
      if (event.target.value.length >= 255) {
        this.showErrorMessage = true;
      } else {
        this.showErrorMessage = false;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this40 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee30() {
        var dataToSubmit, ids, message, data, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, intervenant, dd, deletee, obj, startdate, currentdate, choix;

        return regenerator_default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                if (!(_this40.openTimeModal || _this40.btnDisabled)) {
                  _context30.next = 2;
                  break;
                }

                return _context30.abrupt('return');

              case 2:

                _this40.resetHighlightErrors();
                _this40.$v.form.$touch();

                if (!_this40.$v.form.$error) {
                  _context30.next = 7;
                  break;
                }

                _this40.highlightFormErrors();
                return _context30.abrupt('return');

              case 7:

                nprogress_nprogress_default.a.start();

                if (!_this40.skinForm.selectedSkin) {
                  _context30.next = 13;
                  break;
                }

                _context30.next = 11;
                return _this40.saveAndApplySkin().then(function (res) {
                  if (res.liveSkin.liveSkin.id) {
                    _this40.form.liveSkinId = res.liveSkin.liveSkin.id;
                  } else {
                    _this40.form.liveSkinId = null;
                  }
                }).catch(function (err) {
                  console.log("error", err);
                });

              case 11:
                _context30.next = 14;
                break;

              case 13:
                _this40.form.liveSkinId = null;

              case 14:
                // set isRm to true if chapters are not empty
                if (_this40.form.chapters && _this40.form.chapters.length > 0) {
                  _this40.form.isRm = true;
                }

                dataToSubmit = _this40.mapFormData(_this40.form);

                dataToSubmit.empLivesForm.record_with_permission = _this40.form.record_with_permission;
                if (_this40.getUserId) {
                  if (_this40.form && Array.isArray(_this40.form.contributors) && _this40.form.contributors.length > 0) {
                    ids = _this40.form.contributors.map(function (admin) {
                      return admin.id;
                    });

                    dataToSubmit.empLivesForm.contributorID = ids.includes(_this40.getUserId) ? ids : [_this40.getUserId].concat(toConsumableArray_default()(ids));
                  } else {
                    dataToSubmit.empLivesForm.contributorID = [_this40.getUserId];
                  }
                }
                message = void 0;
                data = void 0;
                _context30.prev = 20;

                if (!_this40.isEditMode) {
                  _context30.next = 66;
                  break;
                }

                if (!_this40.EditOption) {
                  _context30.next = 49;
                  break;
                }

                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context30.prev = 26;
                _iterator7 = get_iterator_default()(_this40.intervenantsToUpdate);

              case 28:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  _context30.next = 35;
                  break;
                }

                intervenant = _step7.value;
                _context30.next = 32;
                return _this40.submitUpdateForm(intervenant);

              case 32:
                _iteratorNormalCompletion7 = true;
                _context30.next = 28;
                break;

              case 35:
                _context30.next = 41;
                break;

              case 37:
                _context30.prev = 37;
                _context30.t0 = _context30['catch'](26);
                _didIteratorError7 = true;
                _iteratorError7 = _context30.t0;

              case 41:
                _context30.prev = 41;
                _context30.prev = 42;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 44:
                _context30.prev = 44;

                if (!_didIteratorError7) {
                  _context30.next = 47;
                  break;
                }

                throw _iteratorError7;

              case 47:
                return _context30.finish(44);

              case 48:
                return _context30.finish(41);

              case 49:
                if (!(_this40.intervenantsTodelete.length > 0)) {
                  _context30.next = 52;
                  break;
                }

                _context30.next = 52;
                return _this40.deleteIntervenant();

              case 52:
                if (!(_this40.intervenantsToAdd.length > 0)) {
                  _context30.next = 55;
                  break;
                }

                _context30.next = 55;
                return _this40.submitFormIntervenant();

              case 55:
                if (!(!_this40.errorOccurred && !_this40.errorOccurredInUpdate && !_this40.errorOccurredInAdd)) {
                  _context30.next = 64;
                  break;
                }

                dataToSubmit.moderators = _this40.moderators;
                _context30.next = 59;
                return _this40.updateLive(dataToSubmit);

              case 59:
                data = _context30.sent;

                if (!(data.code == 200)) {
                  _context30.next = 64;
                  break;
                }

                _context30.next = 63;
                return _this40.syncLivePolls(_this40.$route.params.id);

              case 63:
                message = i18n.t('toast.success_edit');

              case 64:
                _context30.next = 88;
                break;

              case 66:
                dataToSubmit.moderators = _this40.moderators;
                _context30.next = 69;
                return _this40.createLive(dataToSubmit);

              case 69:
                data = _context30.sent;

                if (!(data.code == 200)) {
                  _context30.next = 87;
                  break;
                }

                _context30.next = 73;
                return _this40.intervenantsToAdd.map(function (el) {
                  el.liveId = data.Lives.id;
                });

              case 73:
                if (!(_this40.intervenantsToAdd.length > 0)) {
                  _context30.next = 77;
                  break;
                }

                _context30.next = 76;
                return _this40.submitFormIntervenant();

              case 76:
                dd = _context30.sent;

              case 77:
                if (!(_this40.intervenantsTodelete.length > 0)) {
                  _context30.next = 81;
                  break;
                }

                _context30.next = 80;
                return _this40.deleteIntervenant();

              case 80:
                deletee = _context30.sent;

              case 81:
                _context30.next = 83;
                return _this40.uploadPendingPresentations(data.Lives.id);

              case 83:
                _context30.next = 85;
                return _this40.uploadPendingLiveDocuments(data.Lives.id);

              case 85:
                _context30.next = 87;
                return _this40.syncLivePolls(data.Lives.id);

              case 87:
                message = i18n.t('toast.success_add');

              case 88:
                _this40.showToast('success', message, 'icon-success');
                _this40.$v.form.$reset();
                obj = _this40.getDiffusionObject;

                obj.type = _this40.getDiffusion;
                _this40.setDiffusionObject(obj);
                _this40.setDiffusionLive(_this40.getDiffusion);
                _context30.next = 100;
                break;

              case 96:
                _context30.prev = 96;
                _context30.t1 = _context30['catch'](20);

                message = i18n.t('toast.error');
                _this40.showToast('error', message, 'icon-warning');

              case 100:
                nprogress_nprogress_default.a.done();
                startdate = LiveForm_moment(new Date(dataToSubmit.empLivesForm.dateStart)).format('YYYY-MM-DD');
                currentdate = LiveForm_moment(new Date()).format('YYYY-MM-DD');
                choix = localStorage.getItem('redirectToStartDirect');

                if (startdate === currentdate && !choix) {
                  _this40.currentLive = data.Lives;
                  if (_this40.currentLive.webinar && _this40.hasPermission(_this40.getDiffusionPermission)) {
                    _this40.$root.$emit('bv::show::modal', 'modal-start-direct');
                  } else {
                    _this40.goToListLive();
                  }
                } else {
                  _this40.goToListLive();
                }

              case 105:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, _this40, [[20, 96], [26, 37, 41, 49], [42,, 44, 48]]);
      }))();
    },
    onReset: function onReset() {},
    handleToggleSecured: function handleToggleSecured() {
      if (!this.password) {
        this.form.pwd = '';
      }
    },
    toggleBeforeLiveVideoPicker: function toggleBeforeLiveVideoPicker() {
      this.isBeforeLiveVideoPickerVisible = !this.isBeforeLiveVideoPickerVisible;
    },
    focusAddChapter: function focusAddChapter() {
      var _this41 = this;

      this.$nextTick(function () {
        if (_this41.$refs.newChapterInput) {
          _this41.$refs.newChapterInput.$el.focus();
        }
      });
    },
    highlightFormErrors: function highlightFormErrors() {
      var _this42 = this;

      var validators = [['description', 'endTime', 'startDate', 'startTime', 'title'], ['conf'], ['title'], ['title']];
      var tabs = document.querySelectorAll('.nav-item');
      var index = void 0;

      if (validators[0].some(function (item) {
        return _this42.$v.form[item].$invalid;
      })) {
        nprogress_nprogress_default.a.done();
        index = 0;
      } else if (this.$v.form["stationId"].$invalid) {
        index = 1;
      } else {
        index = 2;
      }
      tabs[index].classList.add('has-error');
      tabs[index].querySelector('.nav-link').click();
    },
    resetHighlightErrors: function resetHighlightErrors() {
      var tabs = document.querySelectorAll('.nav-item');
      for (var i = 0; i < tabs.length; ++i) {
        tabs[i].classList.remove('has-error');
      }
    },
    submitForm: function submitForm() {
      this.submitButtonClicked = true;
    },
    openModelForUpdate: function openModelForUpdate(id) {
      var _this43 = this;

      this.uploadError = false;
      this.update = true;
      this.showModal();
      this.form.nom = this.intervenants[id].name;
      this.form.lastName = this.intervenants[id].lastName;
      this.form.fonction = this.intervenants[id].function;
      this.form.structure = this.intervenants[id].structure;
      this.form.role = this.intervenants[id].role;
      this.form.Description = this.intervenants[id].description;
      this.form.mail = this.intervenants[id].mail;
      this.file = this.intervenants[id].avatar;

      var cleanedUrl = this.cleanedAvatarUrl(this.intervenants[id].avatar);
      this.url = cleanedUrl === "https://" ? "" : cleanedUrl;

      this.idUpdate = this.intervenants[id].id;
      if (this.intervenants[id].id == undefined) {
        this.update = false;
        this.updateModal = true;
        this.forUpdate = true;
        this.indexToupdate = id;
        var existingIntervenantIndex = this.intervenantsToAdd.findIndex(function (intervenant) {
          return intervenant.name === _this43.form.nom && intervenant.lastName === _this43.form.lastName;
        });
        var existingIndex = this.intervenants.findIndex(function (intervenant) {
          return intervenant.name === _this43.form.nom && intervenant.lastName === _this43.form.lastName;
        });

        if (existingIntervenantIndex > -1) {
          this.updateIdParticipant = existingIntervenantIndex;
        }
        if (existingIndex > -1) {
          this.udpateInIntervenants = existingIndex;
        }
      } else {
        this.update = true;
      }
    },
    deleteImageIntervenant: function deleteImageIntervenant() {
      this.file = '';
      this.url = '';
    },
    fetchAllintervenant: function fetchAllintervenant() {
      var _this44 = this;

      if (this.$route.params.id) {
        axios_default.a.get(window.process.env.API_HOST_GLOBAL + '/live/get-live-speakers/' + this.$route.params.id, {
          headers: {
            Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
          }
        }).then(function (res) {
          _this44.intervenants = res.data.data;
        });
      }
    },
    validateEmail: function validateEmail(email) {
      var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (email) {
        this.emailError = emailRegex.test(email) ? null : this.$t("modal.errorEmail");
        // console.log("emailRegex", emailRegex.test(email))
        return emailRegex.test(email);
      } else {
        return true;
      }
    },
    submitUpdateForm: function submitUpdateForm(intervenant) {
      var _this45 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee31() {
        var res;
        return regenerator_default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (!(!intervenant || !intervenant.name || !intervenant.lastName)) {
                  _context31.next = 2;
                  break;
                }

                return _context31.abrupt('return');

              case 2:
                if (!_this45.validateEmail(intervenant.mail)) {
                  _context31.next = 14;
                  break;
                }

                _context31.prev = 3;
                _context31.next = 6;
                return axios_default.a.post(window.process.env.API_HOST_GLOBAL + '/live/update-speakers', {
                  Speakers: [{
                    id: intervenant.id,
                    name: intervenant.name,
                    lastName: intervenant.lastName,
                    function: intervenant.fonction,
                    role: intervenant.role,
                    description: intervenant.Description,
                    avatar: intervenant.avatar,
                    liveId: Number(_this45.$route.params.id),
                    mail: intervenant.mail,
                    structure: intervenant.structure
                  }]
                }, {
                  headers: {
                    Authorization: 'Bearer ' + window.process.env.API_TOKEN
                  }
                });

              case 6:
                res = _context31.sent;

                if (res.status === 200) {
                  _this45.errorOccurredInUpdate = false;
                }

                _context31.next = 14;
                break;

              case 10:
                _context31.prev = 10;
                _context31.t0 = _context31['catch'](3);

                _this45.errorOccurredInUpdate = true;
                _this45.showToast('error', _this45.$t("toast.UpdateError"), 'icon-error');

              case 14:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, _this45, [[3, 10]]);
      }))();
    },
    resetModal: function resetModal() {
      this.form.nom = '';
      this.form.lastName = '';
      this.form.fonction = '';
      this.form.structure = '';
      this.form.role = '';
      this.form.Description = '';
      this.form.mail = '';
      this.update = true;
    },
    handleeForm: function handleeForm() {
      this.submitButtonClicked = true;
    },
    ManageIntervenant: function ManageIntervenant() {
      var _this46 = this;

      var intervenantEmails = this.intervenants.map(function (intervenant) {
        return intervenant.mail;
      }).filter(function (email) {
        return email && email.trim() !== '';
      });
      if (!this.form.nom || !this.form.lastName) {

        this.showToast('error', this.$t("modal.error"), 'icon-error');
      } else if (intervenantEmails.includes(this.form.mail) && !this.updateModal && !this.update) {
        this.showToast('error', this.$t("modal.errorEmailDuplicated"), 'icon-error');
      } else if (this.uploadError) {
        this.showToast('error', this.$t("modal.errorUpload"), 'icon-error');
      } else {
        if (this.validateEmail(this.form.mail)) {

          var data = {
            name: this.form.nom,
            lastName: this.form.lastName,
            function: this.form.fonction,
            role: this.form.role,
            description: this.form.Description,
            avatar: this.url ? this.url : "",
            liveId: Number(this.$route.params.id),
            mail: this.form.mail,
            structure: this.form.structure
          };
          var dataSend = {
            name: this.form.nom,
            lastName: this.form.lastName,
            function: this.form.fonction,
            role: this.form.role,
            description: this.form.Description,
            avatar: this.file ? this.file : "",
            liveId: Number(this.$route.params.id),
            mail: this.form.mail,
            structure: this.form.structure
          };
          if (this.updateModal) {
            this.showToast('success', this.$t("modal.successUpdate"), 'icon-success');
            this.intervenants[this.udpateInIntervenants] = data;
            this.intervenantsToAdd[this.updateIdParticipant] = data;
          } else if (this.update) {
            this.EditOption = true;
            var updatedIntervenant = {
              id: this.idUpdate,
              name: this.form.nom,
              lastName: this.form.lastName,
              function: this.form.fonction,
              role: this.form.role,
              description: this.form.Description,
              avatar: this.url,
              liveId: Number(this.$route.params.id),
              mail: this.form.mail,
              structure: this.form.structure
            };

            var intervenantsIndex = this.intervenants.findIndex(function (i) {
              return i.id === _this46.idUpdate;
            });
            var existingIndex = this.intervenantsToUpdate.findIndex(function (i) {
              return i.id === _this46.idUpdate;
            });

            if (intervenantsIndex > -1) {
              this.intervenants[intervenantsIndex] = updatedIntervenant;
            }
            if (existingIndex > -1) {
              this.intervenantsToUpdate[existingIndex] = updatedIntervenant;
            } else {
              this.intervenantsToUpdate.push(updatedIntervenant);
            }
          } else {
            this.intervenantsToAdd.push(dataSend);
            this.intervenants.push(data);
            this.showToast('success', this.$t("modal.success"), 'icon-success');
          }
          this.closeModel();
        } else {
          // this.showToast('error', this.$t("modal.errorEmail"), 'icon-error');
        }
      }
    },
    submitFormIntervenant: function submitFormIntervenant() {
      var _this47 = this;

      var data = {
        speakers: this.intervenantsToAdd
      };

      var config = {
        method: 'post',
        url: window.process.env.API_HOST_GLOBAL + '/live/add-speakers',
        headers: {
          Authorization: 'Bearer ' + window.process.env.API_TOKEN,
          'Content-Type': 'application/json',
          'Content-Length': stringify_default()(data).length
        },
        data: data
      };

      axios_default()(config).then(function (response) {
        _this47.errorOccurredInAdd = false;
        if (response.data && response.data.status === 200) {
          _this47.$v.form.$reset();
        }
      }).catch(function (error) {
        _this47.errorOccurredInAdd = true;

        _this47.$v.form.$reset();
        console.error(error);
        _this47.showToast('error', _this47.$t("toast.AddError"), 'icon-error');
      });
    },
    deleteInter: function deleteInter(index) {
      this.PendingUpload = false;
      var deletedIntervenantId = this.intervenants[index].id;
      if (deletedIntervenantId === undefined) {
        var nomToDelete = this.intervenants[index].name;
        var prenomToDelete = this.intervenants[index].lastName;
        var intervenantIndexToDelete = this.intervenants.findIndex(function (intervenant) {
          return intervenant.name === nomToDelete && intervenant.lastName === prenomToDelete;
        });
        var intervenanIndexAdd = this.intervenantsToAdd.findIndex(function (intervenant) {
          return intervenant.name === nomToDelete && intervenant.lastName === prenomToDelete;
        });

        if (intervenantIndexToDelete > -1) {
          this.intervenantsTodelete.push(intervenantIndexToDelete);
          this.intervenants = this.intervenants.filter(function (el, i) {
            return i !== intervenantIndexToDelete;
          });
          if (intervenanIndexAdd > -1) {
            this.intervenantsToAdd = this.intervenantsToAdd.filter(function (el, i) {
              return i !== intervenanIndexAdd;
            });
          }
        }
      } else {
        this.intervenantsTodelete.push(deletedIntervenantId);
        this.intervenants = this.intervenants.filter(function (el) {
          return el.id !== deletedIntervenantId;
        });
        this.intervenantsToAdd = this.intervenantsToAdd.filter(function (el) {
          return el.id !== deletedIntervenantId;
        });
        if (this.intervenantsToUpdate) {
          this.intervenantsToUpdate = this.intervenantsToUpdate.filter(function (el) {
            return el.id !== deletedIntervenantId;
          });
        }
      }
    },
    deleteIntervenant: function deleteIntervenant() {
      var _this48 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee32() {
        var res;
        return regenerator_default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                _context32.next = 3;
                return axios_default.a.delete(window.process.env.API_HOST_GLOBAL + '/live/delete-speakers', {
                  headers: {
                    Authorization: 'Bearer ' + window.process.env.API_TOKEN
                  },
                  data: {
                    list_to_delete_speakers: _this48.intervenantsTodelete
                  }
                });

              case 3:
                res = _context32.sent;


                if (res.status === 200) {
                  _this48.errorOccurred = false;
                } else {
                  _this48.errorOccurred = true;
                  _this48.showToast('error', _this48.$t("toast.DeleteError"), 'icon-error');
                }
                _context32.next = 12;
                break;

              case 7:
                _context32.prev = 7;
                _context32.t0 = _context32['catch'](0);

                console.error("Error deleting intervenants:", _context32.t0);
                _this48.errorOccurred = true;
                _this48.showToast('error', _this48.$t("toast.DeleteError"), 'icon-error');

              case 12:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, _this48, [[0, 7]]);
      }))();
    },
    handleDiffusionTypeChanged: function handleDiffusionTypeChanged(type) {
      var _this49 = this;

      setTimeout(function () {
        var types = [];
        switch (type) {
          case 'accessType':
            types = ['by_link', 'private', 'public'];
            types.forEach(function (t) {
              _this49.connexionWebinar = t === _this49.form[type];
            });
            break;
          case 'connexionType':
            types = ['auto', 'by_authorization'];
            types.forEach(function (t) {
              _this49.accessWebinar = t === _this49.form[type];
            });
            break;
          case 'diffusion':
            types = ['webinar', 'isPearl', 'screenShare', 'externalHls'];
            _this49.form.accessType = "public";
            _this49.form.connexionType = "auto";
            types.forEach(function (t) {
              _this49.form[t] = t === _this49.form[type];
            });

            break;
        }
      }, 100);
    },
    addChapter: function addChapter() {
      if (!this.newChapter) {
        return;
      }
      var chapter = {
        title: this.newChapter,
        chapterOrder: this.form.chapters.length,
        timeCode: null
      };
      this.form.chapters.push(chapter);
      this.newChapter = '';
      // const chapresEl = this.$refs['ps-chapters'].$el;
      // setTimeout(() => {
      //   chapresEl.scrollTop = chapresEl.scrollHeight;
      // }, 100);
    },
    toggleEditChapter: function toggleEditChapter(index) {
      var _this50 = this;

      var dismiss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!(this.form.chapters[index] || this.chapterTitle)) {
        return;
      }
      this.form.chapters = this.form.chapters.map(function (c, i) {
        if (i === index) {
          if (_this50.chapterTitle) {
            c.title = _this50.chapterTitle;
          } else {
            _this50.chapterTitle = c.title;
          }
          c.isEditMode = !c.isEditMode;
        }
        return c;
      });
      if (dismiss) {
        this.chapterTitle = '';
      }
    },
    removeChapter: function removeChapter(index) {
      var _this51 = this;

      this.watchUndoRemoveItem(this.form.chapters, index).then(function (val) {
        _this51.form.chapters = val;
      });
      this.form.chapters = this.form.chapters.filter(function (c, i) {
        return i !== index;
      });
    },
    setAddQuestionMode: function setAddQuestionMode(addQuestionMode) {
      this.addQuestionMode = addQuestionMode;
      this.form.questions = this.form.questions.map(function (q) {
        q.isEditMode = false;
        return q;
      });
    },
    addQuestion: function addQuestion(question) {
      this.form.questions.push(question);
      this.addQuestionMode = false;

      // const questionsEl = this.$refs['ps-questions'].$el;
      // setTimeout(() => {
      //   questionsEl.scrollTop = questionsEl.scrollHeight;
      // }, 100);
    },
    updateQuestion: function updateQuestion(question, index) {
      this.form.questions = this.form.questions.map(function (q, i) {
        return i === index ? extends_default()({}, question, { isEditMode: false }) : q;
      });
    },
    toggleEditQuestion: function toggleEditQuestion(index) {
      this.form.questions = this.form.questions.map(function (q, i) {
        if (i === index) {
          q.isEditMode = !q.isEditMode;
        }
        return q;
      });
      this.addQuestionMode = false;
    },
    removeQuestion: function removeQuestion(index) {
      var _this52 = this;

      this.watchUndoRemoveItem(this.form.questions, index).then(function (val) {
        _this52.form.questions = val;
      });
      this.form.questions = this.form.questions.filter(function (c, i) {
        return i !== index;
      });
    },
    updateScrollbar: function updateScrollbar() {
      var _this53 = this;

      this.$nextTick(function () {
        var ps = _this53.$refs.ps;
        if (ps) {
          ps.update();
        }
      });
    },
    searchVideo: function searchVideo() {
      this.resetPagination('videos');
      this.fetchVideos(this.searchVideoKeyword);
    },
    renderCarousel: function renderCarousel() {
      var _this54 = this;

      this.showCarousel = true;
      this.$nextTick(function () {
        var carousel = _this54.$refs.carousel;
        if (carousel) {
          carousel.render();
          carousel.goToPage(0);
        }
      });
    },
    selectVideo: function selectVideo(slide) {
      this.form.conf.video = slide.id;
      this.form = assign_default()({}, this.form);
      this.form.videoBeforeLive = assign_default()({}, slide, { logo: slide.thumbnail });
      this.toggleBeforeLiveVideoPicker();
    },
    checkEditMode: function checkEditMode() {
      var _this55 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee33() {
        var id;
        return regenerator_default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                id = _this55.$route.params.id;

                _this55.isEditMode = !!id;

                if (!_this55.isEditMode) {
                  _context33.next = 7;
                  break;
                }

                nprogress_nprogress_default.a.start();
                _context33.next = 6;
                return _this55.getLiveById(id);

              case 6:
                nprogress_nprogress_default.a.done();

              case 7:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, _this55);
      }))();
    },
    getDropzoneOptions: function getDropzoneOptions(type) {
      var opts = {
        url: '/',
        thumbnailWidth: 150,
        uploadMultiple: true,
        maxFilesize: 5,
        autoProcessQueue: false,
        dictDefaultMessage: '<span class="icon icon-upload"></span>' + i18n.t('upload_files.title')
      };
      switch (type) {
        case 'media':
          opts.dictDefaultMessage += i18n.t('upload_files.media_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif, video/mp4';
          break;
        case 'file':
          opts.dictDefaultMessage += i18n.t('upload_files.file_type');
          break;
        case 'image':
          opts.dictDefaultMessage += i18n.t('upload_files.image_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
          break;
      }
      opts.dictDefaultMessage += '<br>' + i18n.t('upload_files.or') + '<b><u>' + i18n.t('upload_files.click') + '</u></b>' + i18n.t('upload_files.selected_file');
      return opts;
    },
    replaceSlide: function replaceSlide(index) {
      this.slideIndex = index;
      window.dz = this.$refs.slidesDZ;
      document.getElementById('slides-dz').click();
    },
    handleDzSlideAdded: function handleDzSlideAdded(files) {
      var _this56 = this;

      setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee34() {
        var _loop, i;

        return regenerator_default.a.wrap(function _callee34$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _loop = /*#__PURE__*/regenerator_default.a.mark(function _loop(i) {
                  var params, file, blob;
                  return regenerator_default.a.wrap(function _loop$(_context34) {
                    while (1) {
                      switch (_context34.prev = _context34.next) {
                        case 0:
                          params = {
                            id: 'slides-dz',
                            current: i,
                            total: files.length,
                            type: 'slides'
                          };
                          file = files[i];
                          _context34.next = 4;
                          return _this56.processFile(file);

                        case 4:
                          blob = _context34.sent;
                          _context34.next = 7;
                          return _this56.uploadThumbnail(blob, params).then(function (result) {
                            var data = result.data;

                            var slide = {
                              slideType: file.type.indexOf('image') > -1 ? 'Image' : 'Video',
                              slide: data.location.path,
                              urlSlide: data.location.url
                            };
                            if (_this56.slideIndex > -1) {
                              _this56.form.slides.splice(_this56.slideIndex, 1, slide);
                              _this56.slideIndex = -1;
                            } else {
                              _this56.form.slides.push(slide);
                            }
                            if (i === files.length - 1) {
                              _this56.removeProgressCircle(params);
                            }
                          });

                        case 7:
                        case 'end':
                          return _context34.stop();
                      }
                    }
                  }, _loop, _this56);
                });
                i = 0;

              case 2:
                if (!(i < files.length)) {
                  _context35.next = 7;
                  break;
                }

                return _context35.delegateYield(_loop(i), 't0', 4);

              case 4:
                i++;
                _context35.next = 2;
                break;

              case 7:
                _this56.$refs.slidesDZ.removeAllFiles();
                // const slidesEl = this.$refs['ps-slides'].$el;
                // setTimeout(() => {
                //   slidesEl.scrollTop = slidesEl.scrollHeight;
                // }, 100);

              case 8:
              case 'end':
                return _context35.stop();
            }
          }
        }, _callee34, _this56);
      })), 100);
    },
    handleDzFileAdded: function handleDzFileAdded(files) {
      var _this57 = this;

      setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee35() {
        var _loop2, i;

        return regenerator_default.a.wrap(function _callee35$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _loop2 = /*#__PURE__*/regenerator_default.a.mark(function _loop2(i) {
                  var params, file, blob;
                  return regenerator_default.a.wrap(function _loop2$(_context36) {
                    while (1) {
                      switch (_context36.prev = _context36.next) {
                        case 0:
                          params = {
                            id: 'files-dz',
                            current: i,
                            total: files.length,
                            type: 'attatched_files'
                          };
                          file = files[i];
                          _context36.next = 4;
                          return _this57.processFile(file);

                        case 4:
                          blob = _context36.sent;
                          _context36.next = 7;
                          return _this57.uploadThumbnail(blob, params).then(function (result) {
                            var data = result.data;


                            var f = {
                              fileName: file.name,
                              mimeType: data.location.mimeType,
                              title: data.location.path
                            };
                            _this57.form.files = _this57.form.files.concat(common.buildIcons([f]));
                            if (i === files.length - 1) {
                              _this57.removeProgressCircle(params);
                            }
                          });

                        case 7:
                        case 'end':
                          return _context36.stop();
                      }
                    }
                  }, _loop2, _this57);
                });
                i = 0;

              case 2:
                if (!(i < files.length)) {
                  _context37.next = 7;
                  break;
                }

                return _context37.delegateYield(_loop2(i), 't0', 4);

              case 4:
                i++;
                _context37.next = 2;
                break;

              case 7:

                _this57.$refs.filesDZ.removeAllFiles();

              case 8:
              case 'end':
                return _context37.stop();
            }
          }
        }, _callee35, _this57);
      })), 100);
    },
    handleDzFileCompleted: function handleDzFileCompleted() {
      this.$refs.filesDZ.removeAllFiles();
    },
    handleDzSlideCompleted: function handleDzSlideCompleted() {
      this.$refs.slidesDZ.removeAllFiles();
    },
    removeSlide: function removeSlide(index) {
      var _this58 = this;

      this.watchUndoRemoveItem(this.form.slides, index).then(function (val) {
        _this58.form.slides = val;
      });
      this.form.slides = this.form.slides.filter(function (s, i) {
        return i !== index;
      });
    },
    removeFile: function removeFile(index) {
      var _this59 = this;

      this.watchUndoRemoveItem(this.form.files, index).then(function (val) {
        _this59.form.files = val;
      });
      this.form.files = this.form.files.filter(function (f, i) {
        return i !== index;
      });
    },
    handleAvatarUpdated: function handleAvatarUpdated(files) {
      var _this60 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee36() {
        var blob, result, data, f;
        return regenerator_default.a.wrap(function _callee36$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.prev = 0;

                _this60.PendingUpload = true;
                _context38.next = 4;
                return _this60.processFile(files);

              case 4:
                blob = _context38.sent;
                _context38.next = 7;
                return _this60.uploadThumbnail(blob);

              case 7:
                result = _context38.sent;
                data = result.data;

                if (result.status === 200) {
                  _this60.uploadError = false;
                }
                f = {
                  fileName: files.name,
                  mimeType: data.location.mimeType,
                  title: data.location.path,
                  url: data.location.url
                };


                _this60.form.Avatarfiles = _this60.form.files.concat(common.buildIcons([f]));
                _this60.file = _this60.form.Avatarfiles[0].title;
                _this60.url = _this60.form.Avatarfiles[0].url;
                _context38.next = 22;
                break;

              case 16:
                _context38.prev = 16;
                _context38.t0 = _context38['catch'](0);

                _this60.uploadError = true;
                _this60.PendingUpload = false;

                console.error('Error occurred in handleAvatarUpdated:', _context38.t0);
                throw _context38.t0;

              case 22:
              case 'end':
                return _context38.stop();
            }
          }
        }, _callee36, _this60, [[0, 16]]);
      }))();
    },
    handleThumbnailUpdated: function handleThumbnailUpdated(thumbnail) {
      var _this61 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee37() {
        return regenerator_default.a.wrap(function _callee37$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (_this61.defaultThumbnail && _this61.defaultThumbnail !== null && _this61.defaultThumbnail !== '' && _this61.defaultThumbnail !== undefined) {
                  if (!thumbnail) {
                    nprogress_nprogress_default.a.start();
                  }
                  _this61.confirmClicked = true;
                }
                _this61.form.thumbnail = thumbnail;
                nprogress_nprogress_default.a.done();

              case 3:
              case 'end':
                return _context39.stop();
            }
          }
        }, _callee37, _this61);
      }))();
    },
    handleEditingThumbnail: function handleEditingThumbnail(isEditing) {
      this.imageIsPicked = isEditing;
    },
    thumbnailConfirmed: function thumbnailConfirmed(isConfirmed) {
      this.imageIsPicked = false;
      this.confirmClicked = false;
    },
    handleBeforeLivePosterUpdated: function handleBeforeLivePosterUpdated(thumbnail) {
      this.form.conf.image = thumbnail;
    },
    handlePageChanged: function handlePageChanged() {
      if (this.isEndReached('videos') || this.isLoading('videos') || !(this.form.conf.type === 'Video' && this.initInfinitScrollVideos && this.isBeforeLiveVideoPickerVisible)) {
        return;
      }
      this.fetchVideos(this.searchVideoKeyword);
    },
    goToListLive: function goToListLive() {
      parent.postMessage({
        info: 'goToListLive',
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    },
    disabledDate: function disabledDate(value) {
      var today = new Date();
      var yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      return new Date(value) < yesterday;
    },
    getDefaultDiffusion: function getDefaultDiffusion() {
      var _this62 = this;

      if (this.getPermissions.length > 0) {
        this.form.diffusion = this.getPermissions[0].name;
        this.permissions.forEach(function (t) {
          _this62.form[t.name] = t.name === _this62.form.diffusion;
        });
      }
    },
    verifyCheckLimit: function verifyCheckLimit() {
      var _this63 = this;

      setTimeout(function () {
        if (_this63.form.max_online_guests != null || _this63.form.max_onsite_guests != null) {
          _this63.checkedLimit = true;
        }
      }, 400);
    },
    resetSkinForm: function resetSkinForm() {
      this.skinForm.skin = {

        primary_color: "#00a6d9",
        secondary_color: "#ecf6fa",
        text_primary_color: "#ffffff",
        text_secondary_color: "#000000",
        name: "",
        logo: null,
        before: {
          info_text: "",
          show_date: false,
          show_hour: false,
          background: null,
          background_blur: false
        },
        after: {
          info_text: "",
          show_date: false,
          show_hour: false,
          background: null,
          background_blur: false
        }
      };
    },
    buildSkinOptions: function buildSkinOptions(skins) {

      this.skinOptions = [
      // Placeholder
      { value: null, text: this.$t('form_live.tabs.SkinModel.choose') },
      // Create new, with bold style
      { value: 'new', text: this.$t('form_live.tabs.SkinModel.createNew') }].concat(toConsumableArray_default()(skins.map(function (skin) {
        return {
          value: skin.id,
          text: skin.name || 'Mod\xE8le #' + skin.id // fallback (prevents undefined)
        };
      })));
    },
    selectSkinIfReady: function selectSkinIfReady() {
      var _this64 = this;

      if (!this.form.liveSkinId || !(this.liveSkinsOptions && this.liveSkinsOptions.length)) return;

      var selected = this.liveSkinsOptions.find(function (s) {
        return String(s.id) === String(_this64.form.liveSkinId);
      });
      if (selected) this.skinConfirmed = selected;
    },
    onSelectSkin: function onSelectSkin(value) {
      this.skinConfirmed = null;
      if (value === "new") {
        // Reset the skin form for creation
        this.resetSkinForm();
        this.skinIsEditMode = false;
        return;
      }

      // ----- EXISTING SKIN -----
      var selected = this.liveSkinsOptions.find(function (s) {
        return s.id === value;
      });

      if (!selected) return;
      // commenting this to allow edit skin
      this.skinIsEditMode = true;
      // Populate all fields safely using && and fallbacks
      this.skinConfirmed = selected;
      this.currentSkin = selected;
      this.skinForm.skin = {
        primary_color: selected.primaryColor || "#00a6d9",
        secondary_color: selected.secondaryColor || "#ecf6fa",
        text_primary_color: selected.primaryTextColor || "#ffffff",
        text_secondary_color: selected.secondaryTextColor || "#000000",
        name: selected.name || "",

        logo: selected.logo || null,
        logoPreview: selected.logo || null, // <-- set preview URL

        before: {
          info_text: selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.title || "",
          show_date: selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.date || false,
          show_hour: selected.beforeLiveTextOptions && selected.beforeLiveTextOptions.duration || false,
          background: selected.beforeBackground || null,
          backgroundPreview: selected.beforeBackground || null, // <-- set preview URL
          background_blur: selected.bluredBeforeBackground || false
        },

        after: {
          info_text: selected.afterLiveTextOptions && selected.afterLiveTextOptions.title || "",
          show_date: selected.afterLiveTextOptions && selected.afterLiveTextOptions.date || false,
          show_hour: selected.afterLiveTextOptions && selected.afterLiveTextOptions.duration || false,
          background: selected.afterBackground || null,
          backgroundPreview: selected.afterBackground || null, // <-- set preview URL
          background_blur: selected.bluredAfterBackground || false
        }
      };
    },
    uploadAndPreview: function uploadAndPreview(file, target, localPreview) {
      var _this65 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee38() {
        var formData, _ref6, data, url;

        return regenerator_default.a.wrap(function _callee38$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                formData = new FormData();

                formData.append('file', file);

                _this65.uploading[target] = true;

                _context40.prev = 3;
                _context40.next = 6;
                return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/upload/skin', formData, {
                  headers: {
                    Authorization: 'Bearer ' + window.process.env.API_TOKEN
                  }
                });

              case 6:
                _ref6 = _context40.sent;
                data = _ref6.data;
                url = data.urlSkin;


                if (target === 'before') {
                  _this65.skinForm.skin.before.background = url;
                  _this65.skinForm.skin.before.backgroundPreview = url;
                } else if (target === 'after') {
                  _this65.skinForm.skin.after.background = url;
                  _this65.skinForm.skin.after.backgroundPreview = url;
                }
                _context40.next = 16;
                break;

              case 12:
                _context40.prev = 12;
                _context40.t0 = _context40['catch'](3);

                console.error('Upload failed', _context40.t0);

                // ❌ rollback preview
                if (target === 'before') {
                  _this65.skinForm.skin.before.backgroundPreview = null;
                } else {
                  _this65.skinForm.skin.after.backgroundPreview = null;
                }

              case 16:
                _context40.prev = 16;

                _this65.uploading[target] = false;
                URL.revokeObjectURL(localPreview);
                return _context40.finish(16);

              case 20:
              case 'end':
                return _context40.stop();
            }
          }
        }, _callee38, _this65, [[3, 12, 16, 20]]);
      }))();
    },
    uploadLogo: function uploadLogo(e, target) {
      var file = e.target.files[0];
      if (!file) return;

      // 1️⃣ instant preview
      var localPreview = URL.createObjectURL(file);

      if (target === 'logo') {
        this.skinForm.skin.logoPreview = localPreview;
      } else if (target === 'before') {
        this.skinForm.skin.before.backgroundPreview = localPreview;
      } else if (target === 'after') {
        this.skinForm.skin.after.backgroundPreview = localPreview;
      }

      // 2️⃣ upload async
      this.uploadAndPreview(file, target, localPreview);
    },
    uploadBackground: function uploadBackground(e, target) {
      var file = e.target.files[0];
      if (!file) return;

      // 1️⃣ Instant preview
      var localPreview = URL.createObjectURL(file);

      if (target === 'before') {
        this.skinForm.skin.before.backgroundPreview = localPreview;
      } else {
        this.skinForm.skin.after.backgroundPreview = localPreview;
      }

      // 2️⃣ Upload async
      this.uploadAndPreview(file, target, localPreview);
    },
    saveAndApplySkin: function saveAndApplySkin() {
      var _this66 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee39() {
        var skin, payload, _ref7, data, _skin, _payload, _ref8, _data;

        return regenerator_default.a.wrap(function _callee39$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (!_this66.skinIsEditMode) {
                  _context41.next = 20;
                  break;
                }

                _context41.prev = 1;
                skin = _this66.skinForm.skin;
                payload = {
                  liveSkin: {
                    name: skin.name && skin.name.trim() || 'Mod\xE8le ' + Math.floor(Math.random() * 10000),
                    primaryColor: skin.primary_color,
                    secondaryColor: skin.secondary_color,
                    primaryTextColor: skin.text_primary_color,
                    secondaryTextColor: skin.text_secondary_color,
                    logo: skin.logo,
                    beforeBackground: skin.before.background,
                    afterBackground: skin.after.background,
                    bluredBeforeBackground: skin.before.background_blur,
                    bluredAfterBackground: skin.after.background_blur,
                    beforeLiveTextOptions: {
                      title: skin.before.info_text,
                      date: skin.before.show_date,
                      duration: skin.before.show_hour
                    },
                    afterLiveTextOptions: {
                      title: skin.after.info_text,
                      date: skin.after.show_date,
                      duration: skin.after.show_hour
                    }
                  }
                };

                if (!_this66.currentSkin.id) {
                  _context41.next = 12;
                  break;
                }

                _context41.next = 7;
                return axios_default.a.patch(window.process.env.API_HOST_LIVE + '/live/skin/' + _this66.currentSkin.id, payload, {
                  headers: {
                    Authorization: 'Bearer ' + window.process.env.API_TOKEN,
                    'Content-Type': 'application/json'
                  }
                });

              case 7:
                _ref7 = _context41.sent;
                data = _ref7.data;

                _this66.skinConfirmed = data.liveSkin.liveSkin;
                _this66.fetchLiveSkins();

                return _context41.abrupt('return', data);

              case 12:
                _context41.next = 18;
                break;

              case 14:
                _context41.prev = 14;
                _context41.t0 = _context41['catch'](1);

                console.error('Skin creation failed', _context41.t0);
                return _context41.abrupt('return');

              case 18:
                _context41.next = 36;
                break;

              case 20:
                _context41.prev = 20;
                _skin = _this66.skinForm.skin;
                _payload = {
                  liveSkin: {
                    name: _skin.name && _skin.name.trim() || 'Mod\xE8le ' + Math.floor(Math.random() * 10000),
                    primaryColor: _skin.primary_color,
                    secondaryColor: _skin.secondary_color,
                    primaryTextColor: _skin.text_primary_color,
                    secondaryTextColor: _skin.text_secondary_color,
                    logo: _skin.logo,
                    beforeBackground: _skin.before.background,
                    afterBackground: _skin.after.background,
                    bluredBeforeBackground: _skin.before.background_blur,
                    bluredAfterBackground: _skin.after.background_blur,
                    beforeLiveTextOptions: {
                      title: _skin.before.info_text,
                      date: _skin.before.show_date,
                      duration: _skin.before.show_hour
                    },
                    afterLiveTextOptions: {
                      title: _skin.after.info_text,
                      date: _skin.after.show_date,
                      duration: _skin.after.show_hour
                    }
                  }
                };
                _context41.next = 25;
                return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/skin', _payload, {
                  headers: {
                    Authorization: 'Bearer ' + window.process.env.API_TOKEN,
                    'Content-Type': 'application/json'
                  }
                });

              case 25:
                _ref8 = _context41.sent;
                _data = _ref8.data;


                _this66.skinConfirmed = _data.liveSkin.liveSkin;
                _this66.fetchLiveSkins();

                return _context41.abrupt('return', _data);

              case 32:
                _context41.prev = 32;
                _context41.t1 = _context41['catch'](20);

                console.error('Skin creation failed', _context41.t1);
                return _context41.abrupt('return');

              case 36:
              case 'end':
                return _context41.stop();
            }
          }
        }, _callee39, _this66, [[1, 14], [20, 32]]);
      }))();
    },
    getTypesSources: function getTypesSources(source) {
      switch (source) {
        case 'webinar':
          this.TypesToShow = this.TypesSources.filter(function (row) {
            return row.source == "Empreinte Live";
          });
          break;
        default:
          this.TypesToShow = [];
          break;
      }
    }
  }),
  created: function created() {
    this.checkEditMode();
    this.fetchContributors();
    this.fetchSurveys();
    this.fetchVideos();
    this.fetchChannels();
    this.fetchLiveTypes();
    this.fetchAllintervenant();
    this.verifyCheckLimit();
    this.fetchCountries();
    this.fetchStations();
    this.fetchLiveSkins();
    this.fetchLivePolls();
    this.fetchPresentationSlides();
    this.fetchLiveDocuments();
  },
  mounted: function mounted() {
    var _this67 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee40() {
      var typesLiveData, sources, _form$participants, response, moderators, response1, apiParticpants, existingUsers, normalizedParticipants, response2, apiContributors, contributors, today, yesterday;

      return regenerator_default.a.wrap(function _callee40$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              _context42.prev = 0;

              if (!_this67.isEmpreinteClient) {
                _context42.next = 8;
                break;
              }

              _context42.next = 4;
              return axios_default.a.get(window.process.env.API_HOST_LIVE + '/live/source/type', {
                headers: {
                  Authorization: 'Bearer ' + window.process.env.API_TOKEN
                }
              });

            case 4:
              typesLiveData = _context42.sent;
              sources = typesLiveData && typesLiveData.data && typesLiveData.data.liveSourcesTypes ? typesLiveData.data.liveSourcesTypes : [];

              // Add permission field based on type

              _this67.TypesSources = sources.map(function (source) {
                return extends_default()({}, source, {
                  permission: _this67.getPermissionByType(source.type)
                });
              });
              _this67.getTypesSources(_this67.form.diffusion);

            case 8:
              if (!_this67.isEditMode) {
                _context42.next = 28;
                break;
              }

              _context42.next = 11;
              return axios_default.a.get(window.process.env.API_HOST_LIVE + '/live/get-moderators/' + _this67.$route.params.id, {
                headers: {
                  Authorization: '' + window.ApiToken
                }
              });

            case 11:
              response = _context42.sent;
              moderators = _this67.getWebtvUsers.filter(function (user) {
                return !!response.data.data.find(function (moderator) {
                  return moderator.webtvSubscriptionUser.email === user.email;
                });
              });

              _this67.moderators = moderators;
              _context42.next = 16;
              return axios_default.a.get(window.process.env.API_HOST_LIVE + '/live/get-participants/' + _this67.$route.params.id, {
                headers: {
                  Authorization: '' + window.ApiToken
                }
              });

            case 16:
              response1 = _context42.sent;
              apiParticpants = response1.data.data || [];
              existingUsers = _this67.getWebtvUsers;
              normalizedParticipants = apiParticpants.map(function (c) {
                var user = c.webtvSubscriptionUser;

                var existingUser = existingUsers.find(function (u) {
                  return u.email === user.email;
                });

                if (existingUser) {
                  // ✅ return SAME object reference
                  return existingUser;
                }
                return {
                  id: 'custom-' + c.id,
                  name: user.email,
                  email: user.email,
                  firstName: '',
                  lastName: '',
                  isCustom: true
                };
              });

              (_form$participants = _this67.form.participants).splice.apply(_form$participants, [0, _this67.form.participants.length].concat(toConsumableArray_default()(normalizedParticipants)));
              normalizedParticipants.forEach(function (c) {
                var exists = _this67.localParticipantOptions.some(function (o) {
                  return o.email === c.email;
                });
                if (!exists) _this67.localParticipantOptions.push(c);
              });

              _context42.next = 24;
              return axios_default.a.get(window.process.env.API_HOST_LIVE + '/live/get-contributors/' + _this67.$route.params.id, {
                headers: {
                  Authorization: '' + window.ApiToken
                }
              });

            case 24:
              response2 = _context42.sent;
              apiContributors = response2.data.data || [];
              contributors = _this67.getWebtvUsers.filter(function (user) {
                return !!apiContributors.find(function (c) {
                  return c.webtvSubscriptionUser.email === user.email;
                });
              });

              _this67.form.contributors = contributors;

            case 28:
              _context42.next = 33;
              break;

            case 30:
              _context42.prev = 30;
              _context42.t0 = _context42['catch'](0);

              console.log("error while fetching the moderators for this live : ", _context42.t0);
              // this.showToast("error",this.$t("toast.getModeratorsError") );

            case 33:

              // this.$root.$on('setFormLang', lang => {
              //   this.$i18n.locale = lang;
              //   i18n.locale = lang;
              // });


              if (_this67.defaultThumbnail && _this67.defaultThumbnail !== null && _this67.defaultThumbnail !== '' && _this67.defaultThumbnail !== undefined) {
                if (!_this67.isEditMode) {
                  _this67.getDefaultThumb();
                  _this67.getDefaultDiffusion();
                }
              }
              _this67.$nextTick(function () {
                if (_this67.$i18n.locale === 'fr') {
                  vue2_datepicker_lib_default.a.fecha.i18n.monthNamesShort = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'];
                }
              });
              today = new Date();
              yesterday = new Date();

              yesterday.setDate(today.getDate() - 1);
              _this67.pastDates = {
                to: yesterday
              };
              _this67.setupParticipantBulkListener();

            case 40:
            case 'end':
              return _context42.stop();
          }
        }
      }, _callee40, _this67, [[0, 30]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.bulkEmailListenerCleanup.forEach(function (cleanup) {
      return cleanup();
    });
    this.bulkEmailListenerCleanup = [];
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aee163f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveForm.vue
var LiveForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-live-wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-form',{ref:"form",staticClass:"needs-validation",class:{ 'was-validated': _vm.$v.form.$anyDirty, 'not-ready': _vm.isEditMode && !_vm.ready },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)},"reset":_vm.onReset}},[_c('div',{staticClass:"text-right mb-2 d-lg-none"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"light","type":"button"},on:{"click":_vm.goToListLive}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","type":"submit","disabled":_vm.$v.form.$error || _vm.btnDisabled || (!_vm.confirmClicked && _vm.imageIsPicked)},on:{"mousedown":_vm.submitForm}},[_vm._v(_vm._s(_vm.$t('button.save')))])],1),_vm._v(" "),_c('div',{staticClass:"tabs-wrapper"},[(_vm.isEmpreinteClient)?_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},[_c('b-tab',{attrs:{"active":""}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"pen"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.title')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('general')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('button.infos')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.general ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.general,"id":"collapse-general"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('b-form-group',{attrs:{"description":_vm.$t('form_live.tabs.general.form.description_image'),"label":_vm.$t('form_live.tabs.general.form.add_image'),"label-for":"live-thumbnail","label-class":"primary"}},[_c('thumbnail-cropper',{attrs:{"crop-img":_vm.form.thumbnail},on:{"thumbnailUpdated":_vm.handleThumbnailUpdated}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('form_live.tabs.general.form.title'),"type":"text","id":"title","name":"title","required":""},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.form.title.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required primary",attrs:{"for":"description"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"id":"description","placeholder":_vm.$t('form_live.tabs.general.form.description'),"required":"","rows":"3"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.form.description.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_type'),expression:"'lives_type'"}],staticClass:"form-group",attrs:{"has-permission":"lives_type"}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.types')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.liveTypesOptions,"multiple":false,"track-by":"id","label":"title","close-on-select":false,"placeholder":"","select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.title))])]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('div',{style:({ 'margin-left': option.index + 'em' })},[_vm._v("\n                          "+_vm._s(option.title)+"\n                        ")])]}}],null,false,1949094140),model:{value:(_vm.form.types),callback:function ($$v) {_vm.$set(_vm.form, "types", $$v)},expression:"form.types"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.startDate.$invalid }},[_c('label',{staticClass:"required primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.start_date')))]),_vm._v(" "),_c('div',{staticClass:"input_css input filter-date",attrs:{"id":"filter-date"}},[_c('datepicker',{attrs:{"id":"start-date","input-class":"form-control selectedDate","wrapper-class":"start-date-picker","bootstrap-styling":true,"calendar-button":true,"required":true,"lang":_vm.$i18n.locale,"disabled-days":_vm.disabledDate,"format":'YYYY-MM-DD',"value-type":"format","active-color":_vm.getActiveColor,"clearable":false,"editable":false},model:{value:(_vm.form.startDate),callback:function ($$v) {_vm.$set(_vm.form, "startDate", $$v)},expression:"form.startDate"}},[_c('template',{slot:"calendar-icon"},[_c('font-awesome-icon',{staticClass:"calendar-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'calendar-alt' }}})],1)],2)],1),_vm._v(" "),(!_vm.$v.form.startDate.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):(!_vm.$v.form.startDate.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_date'))+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","sm":"6"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.startTime.$invalid }},[_c('label',{staticClass:"required primary",attrs:{"for":"start-time"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.start_hour')))]),_vm._v(" "),_c('vue-clock-picker',{attrs:{"id":"start-time","input-class":"form-control","active-color":_vm.getActiveColor,"required":false,"cancel-text":_vm.$t('button.cancel'),"done-text":_vm.$t('button.done'),"close-on-overlay":_vm.closeOnOverlay},on:{"close":_vm.closeModal,"beforeOpen":_vm.handleBeforeOpen},model:{value:(_vm.form.startTime),callback:function ($$v) {_vm.$set(_vm.form, "startTime", $$v)},expression:"form.startTime"}}),_vm._v(" "),(!_vm.$v.form.startTime.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):(!_vm.$v.form.startTime.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_hour'))+"\n                    ")]):_vm._e()],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","sm":"6"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.endTime.$invalid }},[_c('label',{staticClass:"required primary",attrs:{"for":"end-time"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.end_hour')))]),_vm._v(" "),_c('vue-clock-picker',{attrs:{"id":"end-time","input-class":"form-control","active-color":_vm.getActiveColor,"required":false,"cancel-text":_vm.$t('button.cancel'),"done-text":_vm.$t('button.done'),"close-on-overlay":_vm.closeOnOverlay},on:{"close":_vm.closeModal,"beforeOpen":_vm.handleBeforeOpen},model:{value:(_vm.form.endTime),callback:function ($$v) {_vm.$set(_vm.form, "endTime", $$v)},expression:"form.endTime"}}),_vm._v(" "),(!_vm.$v.form.endTime.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):(!_vm.$v.form.endTime.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_hour'))+"\n                    ")]):_vm._e()],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.tags')))]),_vm._v(" "),_c('input-tag',{attrs:{"add-tag-on-keys":[13,32]},on:{"input":_vm.handleAddInputTags},model:{value:(_vm.form.tags),callback:function ($$v) {_vm.$set(_vm.form, "tags", $$v)},expression:"form.tags"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.themes')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.themesOptions,"multiple":true,"track-by":"id","label":"title","close-on-select":true,"placeholder":"","select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.title))])]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('div',{style:({ 'margin-left': option.index + 'em' })},[_vm._v("\n                          "+_vm._s(option.title)+"\n                        ")])]}}],null,false,1949094140),model:{value:(_vm.form.themes),callback:function ($$v) {_vm.$set(_vm.form, "themes", $$v)},expression:"form.themes"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1)],1)])],1)],2),_vm._v(" "),_c('b-tab',[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"cog"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.title')))])]),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_type_no_api'),expression:"'lives_type_no_api'"}],staticClass:"settings-section collapsible-section",attrs:{"has-permission":"lives_type_no_api"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('diffusion')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(_vm.getDifferentDiffusionPermission),expression:"getDifferentDiffusionPermission"}],staticClass:"primary mb-0"},[_vm._v("\n        "+_vm._s(_vm.$t('form_live.tabs.advanced.type.title'))+"\n      ")]),_vm._v(" "),_c('i',{staticClass:"fa",class:_vm.sections.diffusion ? 'fa-chevron-up' : 'fa-chevron-down'}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.diffusion ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.diffusion,"id":"collapse-diffusion"}},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_type_no_api'),expression:"'lives_type_no_api'"}],staticClass:"form-group collapse-content",attrs:{"has-permission":"lives_type_no_api"}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.title')))]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"name":"type"},model:{value:(_vm.form.isCdn),callback:function ($$v) {_vm.$set(_vm.form, "isCdn", $$v)},expression:"form.isCdn"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.intranet')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.internet')))])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(_vm.getDifferentDiffusionPermission),expression:"getDifferentDiffusionPermission"}],staticClass:"form-group settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('sources')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.title_empreinte')))]),_vm._v(" "),_c('i',{staticClass:"fa",class:_vm.sections.sources ? 'fa-chevron-up' : 'fa-chevron-down'}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.sources ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{key:'sources-' + _vm.form.diffusion,attrs:{"visible":_vm.sections.sources,"id":"collapse-source"}},[_c('div',{staticClass:"collapse-content"},[_c('b-form-radio-group',{attrs:{"name":"diffusion"},on:{"input":function($event){return _vm.handleDiffusionTypeChanged('diffusion')}},model:{value:(_vm.form.diffusion),callback:function ($$v) {_vm.$set(_vm.form, "diffusion", $$v)},expression:"form.diffusion"}},[_c('b-row',[[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_no_api'),expression:"'lives_webinar_no_api'"}],staticClass:"order-1 order-md-0",attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}},[_c('b-form-radio',{attrs:{"value":"webinar"},on:{"change":_vm.onWebinarChange}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons video-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'video' }}}),_vm._v("\n\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.webinar_empreinte'))+"\n                      ")],1)],1)],_vm._v(" "),_c('b-col',{attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_no_api'),expression:"'lives_encoder_no_api'"}],staticClass:"radio-check-white",attrs:{"value":'isPearl',"has-permission":"lives_encoder_no_api"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons server-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'server' }}}),_vm._v("\n    "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encodeur_empreinte'))+"\n  ")],1),_vm._v(" "),(_vm.form.diffusion === 'isPearl')?_c('div',{staticClass:"encoder-options mt-3 ml-3"},[_c('b-form-radio-group',{attrs:{"name":"encoder-type-group"},on:{"input":_vm.handleEncoderTypeChange},model:{value:(_vm.form.isAuto),callback:function ($$v) {_vm.$set(_vm.form, "isAuto", $$v)},expression:"form.isAuto"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_no_api'),expression:"'lives_encoder_no_api'"}],attrs:{"value":false,"has-permission":"lives_encoder_no_api"}},[_vm._v("\n\n        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encoding'))+"\n      ")]),_vm._v(" "),(_vm.hasPermission('lives_encoder_external_no_api'))?_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_external_no_api'),expression:"'lives_encoder_external_no_api'"}],attrs:{"value":true,"has-permission":"lives_encoder_external_no_api"}},[_vm._v("\n        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encodeur_automatique'))+"\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.form.isAuto)?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"mb-2"},[_c('label',{staticClass:"required primary",attrs:{"for":"automatic-station-select"}},[_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.select_station'))+"\n        ")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"automatic-station-select","options":_vm.automaticStations,"value-field":"id","text-field":"name","disabled":_vm.loadingAutomaticStations,"required":""},on:{"change":_vm.onStationChange},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("\n      "+_vm._s(_vm.loadingAutomaticStations
        ? _vm.$t('form_live.tabs.advanced.diffusion.loading_stations')
        : _vm.$t('form_live.tabs.advanced.diffusion.select_station'))+"\n    ")])]},proxy:true}],null,false,666957146),model:{value:(_vm.form.stationId),callback:function ($$v) {_vm.$set(_vm.form, "stationId", $$v)},expression:"form.stationId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.isAuto)?_c('div',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',{staticClass:"mb-2",attrs:{"cols":"6"}},[_c('label',{staticClass:"form-label",attrs:{"for":"encoder-input-1"}},[_vm._v("\n            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.index_video_port'))+" :\n          ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"encoder-input-1","type":"number","min":"0","placeholder":"0","readonly":_vm.isUnescoClient},model:{value:(_vm.form.videoPortIndex),callback:function ($$v) {_vm.$set(_vm.form, "videoPortIndex", $$v)},expression:"form.videoPortIndex"}}),_vm._v(" "),(_vm.isUnescoClient)?_c('small',{staticClass:"text-muted"}):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"mb-2",attrs:{"cols":"6"}},[_c('label',{staticClass:"form-label",attrs:{"for":"encoder-input-2"}},[_vm._v("\n            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.index_audio_port'))+" :\n          ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"encoder-input-2","type":"number","min":"0","placeholder":"0","readonly":_vm.isUnescoClient},model:{value:(_vm.form.audioPortIndex),callback:function ($$v) {_vm.$set(_vm.form, "audioPortIndex", $$v)},expression:"form.audioPortIndex"}}),_vm._v(" "),(_vm.isUnescoClient)?_c('small',{staticClass:"text-muted"}):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"form-label",attrs:{"for":"protocol-select"}},[_vm._v("\n            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.protocol'))+"\n          ")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"protocol-select","options":_vm.protocolOptions},model:{value:(_vm.form.protocolType),callback:function ($$v) {_vm.$set(_vm.form, "protocolType", $$v)},expression:"form.protocolType"}})],1)],1)],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}},[(_vm.hasPermission(''))?[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(''),expression:"''"}],staticClass:"radio-check-white",attrs:{"value":"externalHls"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons network-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'network-wired' }}}),_vm._v("\n\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.externalHlst'))+"\n                      ")],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.externalHls),expression:"form.externalHls"}]},[_c('b-form-input',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(''),expression:"''"}],on:{"input":_vm.setHls},model:{value:(_vm.form.linkHls),callback:function ($$v) {_vm.$set(_vm.form, "linkHls", $$v)},expression:"form.linkHls"}})],1)]:_vm._e()],2),_vm._v(" "),_c('b-col',{attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}})],2)],1)],1)])],1),_vm._v(" "),(_vm.form.diffusion==='webinar' && _vm.form.webinar)?_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'),expression:"'lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'"}],staticClass:"form-group settings-section collapsible-section",attrs:{"has-permission":"lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('connexionEmpreinte')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.title_empreinte')))]),_vm._v(" "),_c('i',{staticClass:"fa",class:_vm.sections.connexionEmpreinte ? 'fa-chevron-up' : 'fa-chevron-down'}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.connexionEmpreinte ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{key:'connexion-empreinte-' + _vm.form.connexionType,attrs:{"visible":_vm.sections.connexionEmpreinte,"id":"collapse-connexion-empreinte"}},[_c('div',{staticClass:"collapse-content"},[_c('b-form-radio-group',{on:{"input":function($event){return _vm.handleDiffusionTypeChanged('connexionType')}},model:{value:(_vm.form.connexionType),callback:function ($$v) {_vm.$set(_vm.form, "connexionType", $$v)},expression:"form.connexionType"}},[_c('b-row',{staticClass:"webinar-type__radio"},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_auto_no_api'),expression:"'lives_webinar_connexion_auto_no_api'"}],staticClass:"webinar-type__radio col-12",attrs:{"has-permission":"lives_webinar_connexion_auto_no_api"}},[_c('b-form-radio',{attrs:{"value":"auto"}},[_vm._v("\n\t                            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.auto'))+"\n\t                            "),_c('small',{staticClass:"text-muted ml-1"},[_vm._v("("+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.auto_description'))+")")])])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_by_authorization_no_api'),expression:"'lives_webinar_connexion_by_authorization_no_api'"}],staticClass:"webinar-type__radio col-12",attrs:{"has-permission":"lives_webinar_connexion_by_authorization_no_api"}},[_c('b-form-radio',{attrs:{"value":"by_authorization"}},[_vm._v("\n\t                            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.by_authorization'))+"\n\t                            "),_c('small',{staticClass:"text-muted ml-1"},[_vm._v("("+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.by_authorization_description'))+")")])])],1)])],1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.form.diffusion==='webinar' && _vm.form.webinar)?_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'),expression:"'lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'"}],staticClass:"form-group settings-section collapsible-section",attrs:{"has-permission":"lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('consent')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.consent.title')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.consent ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.consent,"id":"collapse-consent"}},[_c('div',{staticClass:"collapse-content"},[_c('b-form-radio-group',{attrs:{"name":"consent"},model:{value:(_vm.form.record_with_permission),callback:function ($$v) {_vm.$set(_vm.form, "record_with_permission", $$v)},expression:"form.record_with_permission"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v("\n\t\t\t                        "+_vm._s(_vm.$t('form_live.consent.noConsent'))+"\n\t\t\t                      ")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_vm._v("\n\t\t\t                        "+_vm._s(_vm.$t('form_live.consent.withConsent'))+"\n\t\t\t                      ")])],1)],1)])],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredTypesToShow.length>0 && (
	                (_vm.form.diffusion =='webinar'  && _vm.hasPermission('lives_type_meeting,lives_type_webinar')) 
	                || 
	                 (_vm.form.diffusion == 'isPearl' && _vm.hasPermission('lives_type_webcast') ))),expression:"filteredTypesToShow.length>0 && (\n\t                (form.diffusion =='webinar'  && hasPermission('lives_type_meeting,lives_type_webinar')) \n\t                || \n\t                 (form.diffusion == 'isPearl' && hasPermission('lives_type_webcast') ))"}],staticClass:"form-group settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('typeLive')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.type_source')))]),_vm._v(" "),_c('i',{staticClass:"fa",class:_vm.sections.typeLive ? 'fa-chevron-up' : 'fa-chevron-down'}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.typeLive ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{key:'typeLive',attrs:{"visible":_vm.sections.typeLive,"id":"collapse-type"}},[_c('div',{staticClass:"collapse-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredTypesToShow.length > 0),expression:"filteredTypesToShow.length > 0"}]},[_c('b-form-radio-group',{key:'source-type-group',on:{"input":_vm.handleSourceTypeInput},model:{value:(_vm.form.sourceTypeId),callback:function ($$v) {_vm.$set(_vm.form, "sourceTypeId", $$v)},expression:"form.sourceTypeId"}},_vm._l((_vm.filteredTypesToShow),function(option){return _c('b-form-radio',{key:'type-' + option.id,attrs:{"value":option.id}},[_vm._v("\n          "+_vm._s(_vm.$t(option.type))+"\n        ")])}),1)],1)])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.diffusion =='webinar' && _vm.hasPermission('lives_social_media_no_api') ),expression:"form.diffusion =='webinar' && hasPermission('lives_social_media_no_api') "}],staticClass:"form-group settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('social_media')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.diffusion_social_media')))]),_vm._v(" "),_c('i',{staticClass:"fa",class:_vm.sections.social_media ? 'fa-chevron-up' : 'fa-chevron-down'}),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.social_media ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{key:'social_media',attrs:{"visible":_vm.sections.social_media,"id":"collapse-type"}},[_c('div',{staticClass:"collapse-content"},[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.diffusion=='webinar'),expression:"form.diffusion=='webinar'"},{name:"has-permission",rawName:"v-has-permission",value:('lives_social_media_no_api'),expression:"'lives_social_media_no_api'"}],attrs:{"md":"12","sm":"12","has-permission":"lives_social_media_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{attrs:{"inline":true,"aria-label":"ddd"},model:{value:(_vm.form.foFacebook),callback:function ($$v) {_vm.$set(_vm.form, "foFacebook", $$v)},expression:"form.foFacebook"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.fb')))]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"inline":true},model:{value:(_vm.form.foYoutube),callback:function ($$v) {_vm.$set(_vm.form, "foYoutube", $$v)},expression:"form.foYoutube"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.youtube')))]),_vm._v(" "),(_vm.isEmpreinteClient)?_c('b-form-checkbox',{attrs:{"inline":true},model:{value:(_vm.form.foX),callback:function ($$v) {_vm.$set(_vm.form, "foX", $$v)},expression:"form.foX"}},[_vm._v(_vm._s('X'))]):_vm._e(),_vm._v(" "),(_vm.isEmpreinteClient)?_c('b-form-checkbox',{attrs:{"inline":true},model:{value:(_vm.form.foLinkedin),callback:function ($$v) {_vm.$set(_vm.form, "foLinkedin", $$v)},expression:"form.foLinkedin"}},[_vm._v(_vm._s('LinkedIn'))]):_vm._e()],1)])],1)])],1),_vm._v(" "),(_vm.form.diffusion=='webinar' && (_vm.hasPermission('lives_fo_whiteboard_no_api') || _vm.hasPermission('lives_fo_poll_no_api') || _vm.hasPermission('lives_fo_question_no_api') || _vm.hasPermission('lives_fo_excel_no_api')))?_c('div',{staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('tools')}}},[(_vm.hasPermission('lives_fo_whiteboard_no_api') || _vm.hasPermission('lives_fo_poll_no_api') || _vm.hasPermission('lives_fo_question_no_api') || _vm.hasPermission('lives_fo_excel_no_api'))?_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.title')))]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.tools ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.tools,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{attrs:{"md":"12","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('div',[_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_whiteboard_no_api'),expression:"'lives_fo_whiteboard_no_api'"}],attrs:{"has-permission":"lives_fo_whiteboard_no_api","inline":true,"aria-label":"ddd"},model:{value:(_vm.form.whiteboard),callback:function ($$v) {_vm.$set(_vm.form, "whiteboard", $$v)},expression:"form.whiteboard"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.whiteBoard')))]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_poll_no_api'),expression:"'lives_fo_poll_no_api'"}],attrs:{"has-permission":"lives_fo_poll_no_api","inline":true},model:{value:(_vm.form.poll),callback:function ($$v) {_vm.$set(_vm.form, "poll", $$v)},expression:"form.poll"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.survey')))]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_question_no_api'),expression:"'lives_fo_question_no_api'"}],attrs:{"has-permission":"lives_fo_question_no_api","inline":true},model:{value:(_vm.form.qna),callback:function ($$v) {_vm.$set(_vm.form, "qna", $$v)},expression:"form.qna"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.question')))]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_excel_no_api'),expression:"'lives_fo_excel_no_api'"}],attrs:{"has-permission":"lives_fo_excel_no_api","inline":true},model:{value:(_vm.form.spreadsheet_excel),callback:function ($$v) {_vm.$set(_vm.form, "spreadsheet_excel", $$v)},expression:"form.spreadsheet_excel"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.excel')))]),_vm._v(" "),(_vm.isEmpreintePollClient)?_c('b-form-checkbox',{attrs:{"inline":true},model:{value:(_vm.form.autoSip),callback:function ($$v) {_vm.$set(_vm.form, "autoSip", $$v)},expression:"form.autoSip"}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.autoSip'))+"\n                        ")]):_vm._e()],1)])])],1)],1)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'),expression:"'lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'"},{name:"show",rawName:"v-show",value:((![1].includes(_vm.form.sourceTypeId) || _vm.form.diffusion=='isPearl') && _vm.isEmpreinteClient),expression:"(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl') && isEmpreinteClient"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('options')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'),expression:"'lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'"}],staticClass:"primary",attrs:{"has-permission":"lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.title_empreinte')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.options ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.options,"id":"collapse-options"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"form-group",model:{value:(_vm.form.isRecorded),callback:function ($$v) {_vm.$set(_vm.form, "isRecorded", $$v)},expression:"form.isRecorded"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.saveVideo'))+" ")]),_vm._v(" "),(_vm.form.isRecorded)?_c('b-form-group',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_autopub_no_api'),expression:"'lives_autopub_no_api'"}],attrs:{"has-permission":"lives_autopub_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.autoPublish),callback:function ($$v) {_vm.$set(_vm.form, "autoPublish", $$v)},expression:"form.autoPublish"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.automatic_share')))])],1):_vm._e()],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dvr_no_api'),expression:"'lives_dvr_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_dvr_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.isDvr),callback:function ($$v) {_vm.$set(_vm.form, "isDvr", $$v)},expression:"form.isDvr"}},[_vm._v("DVR")])],1)])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"fields-example"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.diffusion == 'isPearl'),expression:"form.diffusion == 'isPearl'"},{name:"has-permission",rawName:"v-has-permission",value:('lives_langues_post_add','lives_countries_post_add'),expression:"'lives_langues_post_add','lives_countries_post_add'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('languages')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_langues_post_add','lives_countries_post_add'),expression:"'lives_langues_post_add','lives_countries_post_add'"}],staticClass:"primary"},[_vm._v(" "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.languages_empreinte')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.languages ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.languages,"id":"collapse-languages"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_langues_post_add'),expression:"'lives_langues_post_add'"}],staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.languages')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.languagesOptions,"multiple":true,"track-by":"label","label":"lang","close-on-select":true,"placeholder":_vm.$t('form_live.tabs.advanced.diffusion.languagesPlaceholder'),"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"option",fn:function(ref){
	                 var option = ref.option;
return [_c('div',[_vm._v(_vm._s(option.lang))])]}}],null,false,3976500575),model:{value:(_vm.form.languages),callback:function ($$v) {_vm.$set(_vm.form, "languages", $$v)},expression:"form.languages"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_countries_post_add'),expression:"'lives_countries_post_add'"}],staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.countries')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.countriesOptions,"multiple":true,"track-by":"id","label":"countryName","close-on-select":true,"placeholder":_vm.$t('form_live.tabs.advanced.diffusion.countriesPlaceholder'),"loading":_vm.isLoadingCountries,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"option",fn:function(ref){
	                 var option = ref.option;
return [_c('div',[_vm._v(_vm._s(option.countryName))])]}}],null,false,4176021620),model:{value:(_vm.form.countries),callback:function ($$v) {_vm.$set(_vm.form, "countries", $$v)},expression:"form.countries"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_youtubelinks_post_add'),expression:"'lives_youtubelinks_post_add'"}],staticClass:"settings-section collapsible-section",staticStyle:{"display":"none"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('socialMedia')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_youtubelinks_post_add'),expression:"'lives_youtubelinks_post_add'"}],staticClass:"primary"},[_vm._v(" "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.title')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.socialMedia ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.socialMedia,"id":"collapse-youtube"}},[_c('youtube-links',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_youtubelinks_post_add'),expression:"'lives_youtubelinks_post_add'"}],staticClass:"collapse-content",attrs:{"initial-youtube-enabled":_vm.form.isYoutube,"initial-youtube-links":_vm.form.youtubeLinks},on:{"update:youtubeEnabled":_vm.onYoutubeEnabledChange,"update:youtubeLinks":_vm.onYoutubeLinksChange}})],1)],1)]),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api','lives_conf_moderators_api'),expression:"'lives_associate_users_no_api','lives_conf_moderators_api'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('contributors')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api','lives_conf_moderators_api'),expression:"'lives_associate_users_no_api','lives_conf_moderators_api'"}],staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.header')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.contributors ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.contributors,"id":"collapse-moderator"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api'),expression:"'lives_associate_users_no_api'"}],attrs:{"has-permission":"lives_associate_users_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.advanced.contributors.title'))+"\n      "),_c('small',{staticClass:"text-muted ml-1"},[_vm._v("("+_vm._s(_vm.$t('form_live.tabs.advanced.contributors.admin_description'))+")")])]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getWebtvUsers,"multiple":true,"track-by":"email","label":"email","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
	                 var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name))])]}}],null,false,2784876651),model:{value:(_vm.form.contributors),callback:function ($$v) {_vm.$set(_vm.form, "contributors", $$v)},expression:"form.contributors"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.diffusion == 'webinar' ),expression:"form.diffusion == 'webinar' "}],attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.contributors.participantTitle'))+"\n                        "),_c('small',{staticClass:"text-muted ml-1"},[_vm._v("("+_vm._s(_vm.$t('form_live.tabs.advanced.contributors.participants_description'))+")")])]),_vm._v(" "),_c('div',{staticClass:"participant-import-card"},[_c('div',{staticClass:"participant-import-card__content"},[_c('div',{staticClass:"participant-import-card__title"},[_vm._v("Inviter plusieurs participants")]),_vm._v(" "),_c('div',{staticClass:"participant-import-card__text"},[_vm._v("\n                         "+_vm._s(_vm.$t('form_live.tabs.advanced.contributors.importMultiParticipants'))+"\n                          ")])]),_vm._v(" "),_c('b-button',{staticClass:"fp-upload-btn",attrs:{"variant":"link","size":"sm","type":"button"},on:{"click":_vm.triggerParticipantImport}},[_vm._v("\n   "+_vm._s(_vm.$t('button.upload'))+" CSV / Excel\n")])],1),_vm._v(" "),_c('input',{ref:"participantsImportInput",staticClass:"d-none",attrs:{"type":"file","accept":".csv,.xls,.xlsx"},on:{"change":_vm.handleParticipantFileChange}}),_vm._v(" "),_c('multiselect',{ref:"participantsMultiselect",attrs:{"options":_vm.localParticipantOptions,"multiple":true,"track-by":"email","label":"email","placeholder":"","taggable":true,"tag-placeholder":_vm.$t('form_live.tabs.advanced.contributors.add_email'),"close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},on:{"tag":_vm.addCustomParticipant},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
	                 var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name))])]}}],null,false,2784876651),model:{value:(_vm.form.participants),callback:function ($$v) {_vm.$set(_vm.form, "participants", $$v)},expression:"form.participants"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api'),expression:"'lives_associate_users_no_api'"}]},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        "+_vm._s(_vm.$t('modal.moderators'))+"\n                        "),_c('small',{staticClass:"text-muted ml-1"},[_vm._v("("+_vm._s(_vm.$t('form_live.tabs.advanced.contributors.moderators_description'))+")")])]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getWebtvUsers,"multiple":true,"track-by":"id","label":"email","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
	                 var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.email))])]}}],null,false,3346479968),model:{value:(_vm.moderators),callback:function ($$v) {_vm.moderators=$$v},expression:"moderators"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((![1].includes(_vm.form.sourceTypeId) || _vm.form.diffusion=='isPearl')),expression:"(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')"},{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api,lives_associate_files_no_api'),expression:"'lives_rich_media_no_api,lives_associate_files_no_api'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('richMedia')}}},[_c('label',{staticClass:"primary"},[_vm._v(" "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.medias'))+"  ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.richMedia ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.richMedia,"id":"collapse-media"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:((![1].includes(_vm.form.sourceTypeId) || _vm.form.diffusion=='isPearl')),expression:"(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')"},{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api'),expression:"'lives_rich_media_no_api'"}],attrs:{"has-permission":"lives_rich_media_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.isRm),callback:function ($$v) {_vm.$set(_vm.form, "isRm", $$v)},expression:"form.isRm"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.title')))])],1)]),_vm._v(" "),(_vm.form.isRm)?_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"rm-tabs-wrapper"},[_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},[(_vm.hasPermission('lives_rich_media_question_no_api'))?_c('b-tab',{attrs:{"has-permission":"lives_rich_media_question_no_api"}},[_c('template',{slot:"title"},[_c('div',[_c('span',{staticClass:"icon-question"})]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                              "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.title'))+"\n                            ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.questions),callback:function ($$v) {_vm.$set(_vm.form, "questions", $$v)},expression:"form.questions"}},_vm._l((_vm.form.questions),function(question,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container question",class:{ 'is-open': question.isEditMode }},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}]},[_vm._v("\n                                          "+_vm._s(question.question)+"\n                                        ")]),_vm._v(" "),(question.isEditMode)?_c('question-form',{attrs:{"question":question,"buttonLabel":_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.edit'
                                            )},on:{"addQuestion":function($event){return _vm.updateQuestion($event, index)},"closeForm":function($event){return _vm.toggleEditQuestion(index)}}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isQuestionEditMode),expression:"!isQuestionEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditQuestion(index)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeQuestion(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.questions.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                    "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.empty'))+"\n                                  ")]):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[(_vm.addQuestionMode)?_c('question-form',{on:{"addQuestion":_vm.addQuestion,"closeForm":function($event){_vm.addQuestionMode = false}}},[_c('label',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.new')))])]):_vm._e(),_vm._v(" "),(!_vm.addQuestionMode)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"link","type":"button"},on:{"click":function($event){return _vm.setAddQuestionMode(true)}}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}}),_vm._v("\n                                    "+_vm._s(_vm.$t(
                                        'form_live.tabs.advanced.rich_media.tabs.questions.add_new'
                                      )))],1)],1)])],1):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('b-tab',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_slides_no_api'),expression:"'lives_rich_media_slides_no_api'"}],attrs:{"has-permission":"lives_rich_media_slides_no_api"},on:{"click":_vm.updateScrollbar}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"th-large"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                              "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.slides.title'))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"slides-wrapper"},[_c('draggable',{staticClass:"row",model:{value:(_vm.form.slides),callback:function ($$v) {_vm.$set(_vm.form, "slides", $$v)},expression:"form.slides"}},_vm._l((_vm.form.slides),function(slide,index){return _c('b-col',{key:index,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('figure',{staticClass:"img-fluid"},[_c('div',{staticClass:"type-tag"},[_c('span',{class:'icon-' +
                                            (slide.slideType === 'Image' ? 'picture' : 'video')})]),_vm._v(" "),(slide.slideType === 'Image')?_c('img',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),(slide.slideType === 'Video')?_c('video',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"more-btn-container"},[_c('b-dropdown',{attrs:{"variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"icon-more"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.replaceSlide(index)}}},[_c('span',{staticClass:"icon-edit"}),_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.edit'
                                            ))+"\n                                        ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.removeSlide(index)}}},[_c('span',{staticClass:"icon-trash"}),_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.delete'
                                            ))+"\n                                        ")])],2)],1)])])}),1)],1),_vm._v(" "),_c('div',{staticClass:"dz-upload-wrapper"},[_c('vue-dropzone',{ref:"slidesDZ",attrs:{"id":"slides-dz","options":_vm.getDropzoneOptions('media'),"auto-process-queue":false},on:{"vdropzone-files-added":_vm.handleDzSlideAdded,"vdropzone-file-added-manually":_vm.handleDzSlideAdded,"vdropzone-complete":_vm.handleDzSlideCompleted}})],1)],2)],1)],1)]):_vm._e()],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:((![1].includes(_vm.form.sourceTypeId) || _vm.form.diffusion=='isPearl')),expression:"(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')"}]},[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_docs_share_no_api'),expression:"'lives_fo_docs_share_no_api'"}],attrs:{"md":"12","sm":"12","has-permission":"lives_fo_docs_share_no_api"}},[_c('div',{staticClass:"form-group fp-files-section"},[_c('b-form-checkbox',{model:{value:(_vm.showFilesPanel),callback:function ($$v) {_vm.showFilesPanel=$$v},expression:"showFilesPanel"}},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.title'))+"\n    ")]),_vm._v(" "),_c('transition',{attrs:{"name":"fp-slide"}},[(_vm.showFilesPanel)?_c('div',{staticClass:"fp-panel"},[_c('div',{staticClass:"fp-header"},[_c('span',{staticClass:"fp-count"},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":{ prefix: 'fas', iconName: 'folder-open' }}}),_vm._v("\n            "+_vm._s(_vm.managedLiveDocuments.length)+" "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.fichier'))+"\n          ")],1),_vm._v(" "),_c('div',{staticClass:"fp-header-actions"},[_c('b-button',{staticClass:"fp-upload-btn",attrs:{"variant":"link","size":"sm","type":"button","disabled":_vm.documentsUploading},on:{"click":_vm.triggerLiveDocumentUpload}},[(_vm.documentsUploading)?_c('b-spinner',{staticClass:"mr-1",attrs:{"small":""}}):_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":{ prefix: 'fas', iconName: 'upload' }}}),_vm._v("\n              "+_vm._s(_vm.documentsUploading ? _vm.$t('form_live.tabs.advanced.documents.refresh') : _vm.$t('form_live.tabs.advanced.documents.upload'))+"\n            ")],1)],1)]),_vm._v(" "),(_vm.documentsLoading)?_c('div',{staticClass:"fp-state"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'spinner' },"spin":""}}),_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.refresh'))+"…\n        ")],1):[(!_vm.$route.params.id && _vm.managedLiveDocuments.length > 0)?_c('div',{staticClass:"fp-save-hint"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'info-circle' }}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.documents.save_first')))])],1):_vm._e(),_vm._v(" "),(_vm.managedLiveDocuments.length === 0)?_c('div',{staticClass:"fp-empty"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'folder-open' }}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.documents.empty')))])],1):_c('div',{staticClass:"fp-list"},_vm._l((_vm.managedLiveDocuments),function(document){return _c('div',{key:document.localId || document.id,staticClass:"fp-item"},[_c('div',{staticClass:"fp-item-icon",class:_vm.getManagedDocumentIconClass(document)},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: _vm.getManagedDocumentIcon(document) }}})],1),_vm._v(" "),_c('div',{staticClass:"fp-item-info"},[_c('div',{staticClass:"fp-item-name"},[(_vm.getManagedDocumentUrl(document))?_c('a',{attrs:{"href":_vm.getManagedDocumentUrl(document),"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n                    "+_vm._s(_vm.getManagedDocumentName(document))+"\n                  ")]):_c('span',[_vm._v(_vm._s(_vm.getManagedDocumentName(document)))])]),_vm._v(" "),(_vm.getManagedDocumentOwner(document))?_c('div',{staticClass:"fp-item-owner"},[_vm._v("\n                  "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.uploaded_by'))+": "+_vm._s(_vm.getManagedDocumentOwner(document))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fp-item-meta"},[(document.isPending)?_c('span',{staticClass:"fp-badge fp-badge-pending"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'clock' }}}),_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.pending'))+"\n                  ")],1):(_vm.isManagedDocumentPublic(document))?_c('span',{staticClass:"fp-badge fp-badge-public"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'globe' }}}),_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.public'))+"\n                  ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"fp-item-actions"},[_c('button',{staticClass:"fp-icon-btn fp-icon-btn--danger",attrs:{"type":"button","disabled":_vm.documentsDeletingId === (document.id || document.localId),"title":"Supprimer le fichier"},on:{"click":function($event){return _vm.deleteLiveDocument(document)}}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'trash' }}})],1)])])}),0)],_vm._v(" "),_c('input',{ref:"liveDocumentsInput",staticClass:"d-none",attrs:{"type":"file","multiple":""},on:{"change":_vm.handleLiveDocumentFileChange}})],2):_vm._e()])],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:((![1].includes(_vm.form.sourceTypeId) || _vm.form.diffusion=='isPearl') && !_vm.isEmpreintePollClient),expression:"(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl') && !isEmpreintePollClient"},{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_files_no_api'),expression:"'lives_associate_files_no_api'"}],attrs:{"has-permission":"lives_associate_files_no_api"}},[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_files_share_no_api'),expression:"'lives_fo_files_share_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_fo_files_share_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.foFilesShare),callback:function ($$v) {_vm.$set(_vm.form, "foFilesShare", $$v)},expression:"form.foFilesShare"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files')))]),_vm._v(" "),(_vm.form.foFilesShare)?_c('b-form-group',{staticStyle:{"margin-left":"1.2em"}},[_c('b-form-checkbox',{model:{value:(_vm.form.doc_public),callback:function ($$v) {_vm.$set(_vm.form, "doc_public", $$v)},expression:"form.doc_public"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files_live_event.text'))+"\n                            "),_c('span',{staticStyle:{"color":"#62626b"}},[_vm._v("\n                              "+_vm._s(_vm.$t(
                                  'form_live.tabs.frontOffice.options.sharing_files_live_event.explanation'
                                ))+"\n                            ")])]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.doc_public_mail),callback:function ($$v) {_vm.$set(_vm.form, "doc_public_mail", $$v)},expression:"form.doc_public_mail"}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files_emails')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.doc_private),callback:function ($$v) {_vm.$set(_vm.form, "doc_private", $$v)},expression:"form.doc_private"}},[_vm._v("\n                            "+_vm._s(_vm.$t(
                                'form_live.tabs.frontOffice.options.sharing_files_studio_live.text'
                              ))+"\n                            "),_c('span',{staticStyle:{"color":"#62626b"}},[_vm._v("\n                              "+_vm._s(_vm.$t(
                                  'form_live.tabs.frontOffice.options.sharing_files_studio_live.explanation'
                                ))+"\n                            ")])])],1):_vm._e()],1)])],1)],1)])],1)])],2),_vm._v(" "),(
                _vm.hasPermission(
                  'lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api'
                )
              )?_c('b-tab',{attrs:{"has-permission":"lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api"},on:{"click":function($event){_vm.initInfinitScrollVideos = true}}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"desktop"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                   Player\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_password_security_no_api','lives_fo_subscript_no_api'),expression:"'lives_password_security_no_api','lives_fo_subscript_no_api'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('access_direct')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_password_security_no_api','lives_fo_subscript_no_api'),expression:"'lives_password_security_no_api','lives_fo_subscript_no_api'"}],staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.access_page_direct')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.access_direct ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.access_direct,"id":"collapse-access"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_password_security_no_api'),expression:"'lives_password_security_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_password_security_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",on:{"input":_vm.handleToggleSecured},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.mdp')))]),_vm._v(" "),(_vm.password)?_c('div',{staticClass:"sub-form-control"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"*****"},model:{value:(_vm.form.pwd),callback:function ($$v) {_vm.$set(_vm.form, "pwd", $$v)},expression:"form.pwd"}})],1):_vm._e()],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subscript_no_api'),expression:"'lives_fo_subscript_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_subscript_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foSubscript),callback:function ($$v) {_vm.$set(_vm.form, "foSubscript", $$v)},expression:"form.foSubscript"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.inscri_abonne')))]),_vm._v(" "),_c('div',{staticClass:"form-group"})],1)])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'),expression:"'lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('video')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'),expression:"'lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'"}],staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.lecteur_video')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.video ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.video,"id":"collapse-player"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api'),expression:"'lives_fo_like_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_like_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foLike),callback:function ($$v) {_vm.$set(_vm.form, "foLike", $$v)},expression:"form.foLike"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.like')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_chat_no_api'),expression:"'lives_fo_chat_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_chat_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.chat),callback:function ($$v) {_vm.$set(_vm.form, "chat", $$v)},expression:"form.chat"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.chat_empreinte')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_chat_no_api'),expression:"'lives_fo_chat_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_chat_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.privateChat),callback:function ($$v) {_vm.$set(_vm.form, "privateChat", $$v)},expression:"form.privateChat"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.privateChat_empreinte')))])],1)])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],staticClass:"settings-section collapsible-section",attrs:{"has-permission":"lives_fo_comment_no_api"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('questions')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],staticClass:"primary"},[_vm._v("Questions")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.questions ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.questions,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_comment_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foComment),callback:function ($$v) {_vm.$set(_vm.form, "foComment", $$v)},expression:"form.foComment"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.title')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.foComment),expression:"form.foComment"},{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_confirmation_no_api'),expression:"'lives_fo_comment_confirmation_no_api'"}],staticClass:"sub-form-control",attrs:{"has-permission":"lives_fo_comment_confirmation_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.canCommentBeforeLive),callback:function ($$v) {_vm.$set(_vm.form, "canCommentBeforeLive", $$v)},expression:"form.canCommentBeforeLive"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.questionsBeforeLive')))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.foComment),expression:"form.foComment"},{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_confirmation_no_api'),expression:"'lives_fo_comment_confirmation_no_api'"}],staticClass:"sub-form-control",attrs:{"has-permission":"lives_fo_comment_confirmation_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.isCommentValidation),callback:function ($$v) {_vm.$set(_vm.form, "isCommentValidation", $$v)},expression:"form.isCommentValidation"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.confirm')))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.foComment),expression:"form.foComment"},{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_confirmation_no_api'),expression:"'lives_fo_comment_confirmation_no_api'"}],staticClass:"sub-form-control",attrs:{"has-permission":"lives_fo_comment_confirmation_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.canReplyToComments),callback:function ($$v) {_vm.$set(_vm.form, "canReplyToComments", $$v)},expression:"form.canReplyToComments"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.replies')))])],1)],1)])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subtitles_no_api'),expression:"'lives_fo_subtitles_no_api'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('sous_titrage')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subtitles_no_api'),expression:"'lives_fo_subtitles_no_api'"}],staticClass:"primary",attrs:{"has-permission":"lives_fo_subtitles_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.sous_titrage')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.sous_titrage ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.sous_titrage,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subtitles_no_api'),expression:"'lives_fo_subtitles_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_subtitles_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foSubtitles),callback:function ($$v) {_vm.$set(_vm.form, "foSubtitles", $$v)},expression:"form.foSubtitles"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.subtitles_empreinte')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_auto_transcription'),expression:"'lives_fo_auto_transcription'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_auto_transcription"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.autoTranscription),callback:function ($$v) {_vm.$set(_vm.form, "autoTranscription", $$v)},expression:"form.autoTranscription"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.autoTranscription_empreinte')))])],1)])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((![1].includes(_vm.form.sourceTypeId) || _vm.form.diffusion=='isPearl')),expression:"(![1].includes(form.sourceTypeId) || form.diffusion=='isPearl')"},{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api'),expression:"'lives_rich_media_no_api'"}],staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('chapitres')}}},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api'),expression:"'lives_rich_media_no_api'"}],staticClass:"primary",attrs:{"has-permission":"lives_rich_media_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.title')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.chapitres ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.chapitres,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"rm-tabs-wrapper"},[_c('div',{attrs:{"content-class":"mt-3","noKeyNav":true}},[(_vm.hasPermission('lives_rich_media_chapter_no_api'))?_c('b-row',{attrs:{"has-permission":"lives_rich_media_chapter_no_api"}},[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.chapters),callback:function ($$v) {_vm.$set(_vm.form, "chapters", $$v)},expression:"form.chapters"}},_vm._l((_vm.form.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container"},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}]},[_vm._v(" "+_vm._s(chapter.title)+"\n                                        ")]),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode),expression:"chapter.isEditMode"}],staticClass:"m-0"},[_c('b-form-input',{attrs:{"placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.title')},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleEditChapter(index)}},model:{value:(_vm.chapterTitle),callback:function ($$v) {_vm.chapterTitle=$$v},expression:"chapterTitle"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode && !!chapter.title),expression:"chapter.isEditMode && !!chapter.title"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.toggleEditChapter(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChapterEditMode),expression:"!isChapterEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditChapter(index, false)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeChapter(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.chapters.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                            "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.empty'))+"\n                             ")]):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[_c('div',{staticClass:"position-relative"},[_c('b-form-input',{ref:"newChapterInput",attrs:{"placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.new')},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addChapter.apply(null, arguments)}},model:{value:(_vm.newChapter),callback:function ($$v) {_vm.newChapter=$$v},expression:"newChapter"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.newChapter),expression:"newChapter"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.addChapter}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}})],1)],1)])],1)])])],1)],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_form_presentation'),expression:"'lives_form_presentation'"}],staticClass:"settings-section collapsible-section",attrs:{"has-permission":"lives_form_presentation"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('presentation')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.presentation.label')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.presentation ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.presentation,"id":"collapse-presentation"}},[_c('div',{staticClass:"collapse-content"},[_c('div',{staticClass:"presentation-upload-panel"},[_c('input',{ref:"presentationInput",staticClass:"d-none",attrs:{"type":"file","accept":".pdf,.ppt,.pptx,.doc,.docx"},on:{"change":_vm.handlePresentationFileChange}}),_vm._v(" "),_c('button',{staticClass:"presentation-upload-box",attrs:{"type":"button","disabled":!_vm.canManagePresentation || _vm.presentationUploading},on:{"click":_vm.triggerPresentationUpload}},[(_vm.presentationUploading)?_c('b-spinner',{attrs:{"small":""}}):_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}})],1),_vm._v(" "),_c('div',{staticClass:"presentation-upload-panel__meta"},[_c('strong',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.presentation.upload')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.presentation.formats_hint')))]),_vm._v(" "),(_vm.presentationLoading)?_c('span',{staticClass:"text-muted"},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.advanced.presentation.loading'))+"\n    ")]):(_vm.presentationUploading)?_c('span',{staticClass:"text-muted"},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.advanced.presentation.uploading'))+"\n    ")]):(_vm.presentationDeletingId)?_c('span',{staticClass:"text-muted"},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.advanced.presentation.deleting'))+"\n    ")]):_vm._e()])]),_vm._v(" "),(_vm.presentationItems.length === 0 && !_vm.presentationLoading)?_c('div',{staticClass:"presentation-empty-state"},[_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.presentation.empty')))])]):_vm._e(),_vm._v(" "),(_vm.presentationItems.length > 0)?_c('div',{staticClass:"presentation-list"},_vm._l((_vm.presentationItems),function(presentationItem,presentationIndex){return _c('div',{key:presentationItem.id || presentationItem.documentId || presentationItem.name || presentationIndex,staticClass:"presentation-list-item"},[_c('div',{staticClass:"presentation-list-item__icon",class:'presentation-list-item__icon--' + _vm.getPresentationFileType(presentationItem)},[_vm._v("\n                          "+_vm._s(_vm.getPresentationExtension(presentationItem))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"presentation-list-item__content"},[_c('strong',{staticClass:"presentation-list-item__title"},[_vm._v("\n                            "+_vm._s(_vm.getPresentationTitle(presentationItem))+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"presentation-list-item__meta"},[_c('span',[_vm._v(_vm._s(_vm.getPresentationExtension(presentationItem)))]),_vm._v(" "),_c('span',[(presentationItem.isPending)?[_vm._v("\n                                "+_vm._s(_vm.$t('form_live.tabs.advanced.presentation.pending'))+"\n                              ")]:[_vm._v("\n                                "+_vm._s(_vm.$t('form_live.tabs.advanced.presentation.slides_count', {
                                    count: _vm.getPresentationSlidesCount(presentationItem),
                                  }))+"\n                              ")]],2)])]),_vm._v(" "),_c('div',{staticClass:"presentation-list-item__actions"},[(!presentationItem.isPending && _vm.getPresentationSourceUrl(presentationItem))?_c('b-button',{staticClass:"presentation-action-button",attrs:{"size":"sm","variant":"outline-success","type":"button","href":_vm.getPresentationSourceUrl(presentationItem),"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":"play"}})],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"presentation-action-button",attrs:{"size":"sm","variant":"outline-danger","type":"button","disabled":!presentationItem.isPending && _vm.presentationDeletingId === _vm.getPresentationDeleteId(presentationItem)},on:{"click":function($event){_vm.deletePresentation(_vm.getPresentationDeleteId(presentationItem))}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1)],1)])}),0):_vm._e()])])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_form_poll'),expression:"'lives_form_poll'"}],staticClass:"settings-section collapsible-section",attrs:{"has-permission":"lives_form_poll"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('polls')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.label')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.polls ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.polls,"id":"collapse-polls"}},[_c('div',{staticClass:"collapse-content"},[(_vm.livePolls.length === 0)?_c('div',{staticClass:"poll-empty-state"},[_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.empty')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"primary","type":"button"},on:{"click":_vm.addPollDraft}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"plus-circle"}}),_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.add_first'))+"\n                      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.livePolls.length > 0)?_c('div',{staticClass:"poll-tabs"},[_vm._l((_vm.livePolls),function(pollItem,pollIndex){return _c('button',{key:pollItem.id || 'poll-tab-' + pollIndex,staticClass:"poll-tab",class:{ 'poll-tab--active': pollIndex === _vm.activePollIndex },attrs:{"type":"button"},on:{"click":function($event){return _vm.setActivePoll(pollIndex)}}},[_c('span',{staticClass:"poll-tab__eyebrow"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.tab_label', { number: pollIndex + 1 })))]),_vm._v(" "),_c('strong',{staticClass:"poll-tab__title"},[_vm._v(_vm._s(_vm.getPollTabTitle(pollItem)))]),_vm._v(" "),_c('span',{staticClass:"poll-tab__meta"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.options_count', {
                              count: pollItem.options.length,
                            }))+"\n                          "),(_vm.getPollValidationError(pollItem))?_c('span',{staticClass:"poll-tab__warning"},[_vm._v("\n                            "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.incomplete'))+"\n                          ")]):_vm._e()])])}),_vm._v(" "),_c('button',{staticClass:"poll-tab poll-tab--add",attrs:{"type":"button","disabled":!_vm.canAddPoll,"title":!_vm.canAddPoll ? _vm.$t('form_live.tabs.advanced.polls.complete_current_first') : ''},on:{"click":_vm.addPollDraft}},[_c('strong',{staticClass:"poll-tab__title"},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"plus-circle"}}),_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.add'))+"\n                        ")],1),_vm._v(" "),_c('span',{staticClass:"poll-tab__meta"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.add_hint'))+"\n                        ")])])],2):_vm._e(),_vm._v(" "),(_vm.activePoll)?_c('div',{key:_vm.activePoll.id || 'poll-draft-' + _vm.activePollIndex,staticClass:"poll-card"},[_c('div',{staticClass:"poll-card__header"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.tab_label', {
                              number: _vm.activePollIndex + 1,
                            })))])]),_vm._v(" "),_c('div',{staticClass:"poll-delete-actions"},[_c('b-button',{staticClass:"poll-delete-button",attrs:{"size":"sm","variant":"light","type":"button","title":_vm.$t('form_live.tabs.advanced.polls.delete_poll')},on:{"click":function($event){return _vm.requestPollDelete(_vm.activePollIndex)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1),_vm._v(" "),(_vm.isDeletePollPending(_vm.activePollIndex))?_c('div',{staticClass:"confirm-tooltip"},[_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.confirm_delete_poll')))]),_vm._v(" "),_c('div',{staticClass:"confirm-tooltip__actions"},[_c('b-button',{attrs:{"size":"sm","variant":"danger","type":"button"},on:{"click":function($event){return _vm.confirmPollDelete(_vm.activePollIndex)}}},[_vm._v("\n                                "+_vm._s(_vm.$t('button.confirm'))+"\n                              ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"light","type":"button"},on:{"click":_vm.cancelPendingDelete}},[_vm._v("\n                                "+_vm._s(_vm.$t('button.cancel'))+"\n                              ")])],1)]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.question_label')))]),_vm._v(" "),_c('b-form-textarea',{attrs:{"value":_vm.activePoll.question,"rows":"2","max-rows":"4","placeholder":_vm.$t('form_live.tabs.advanced.polls.question_placeholder')},on:{"input":function($event){return _vm.updatePollQuestion(_vm.activePollIndex, $event)}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mb-3"},[_c('b-form-checkbox',{attrs:{"checked":!!_vm.activePoll.isPublished},on:{"change":function($event){return _vm.updatePollPublished(_vm.activePollIndex, $event)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.publish_label'))+"\n                        ")])],1),_vm._v(" "),_vm._l((_vm.activePoll.options),function(option,optionIndex){return _c('div',{key:option.id || 'poll-' + _vm.activePollIndex + '-option-' + optionIndex,staticClass:"poll-option-row"},[_c('div',{staticClass:"poll-option-row__input"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.option_label', {
                              number: optionIndex + 1,
                            })))]),_vm._v(" "),_c('b-form-input',{attrs:{"value":option.poll_option,"placeholder":_vm.$t('form_live.tabs.advanced.polls.option_placeholder')},on:{"input":function($event){return _vm.updatePollOption(_vm.activePollIndex, optionIndex, $event)}}})],1),_vm._v(" "),_c('b-button',{staticClass:"poll-option-row__delete poll-delete-button",attrs:{"size":"sm","variant":"light","type":"button","title":_vm.$t('form_live.tabs.advanced.polls.delete_option')},on:{"click":function($event){return _vm.requestPollOptionDelete(_vm.activePollIndex, optionIndex)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1),_vm._v(" "),(_vm.isDeleteOptionPending(_vm.activePollIndex, optionIndex))?_c('div',{staticClass:"confirm-tooltip confirm-tooltip--option"},[_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.polls.confirm_delete_option')))]),_vm._v(" "),_c('div',{staticClass:"confirm-tooltip__actions"},[_c('b-button',{attrs:{"size":"sm","variant":"danger","type":"button"},on:{"click":function($event){return _vm.confirmPollOptionDelete(_vm.activePollIndex, optionIndex)}}},[_vm._v("\n                              "+_vm._s(_vm.$t('button.confirm'))+"\n                            ")]),_vm._v(" "),_c('b-button',{attrs:{"size":"sm","variant":"light","type":"button"},on:{"click":_vm.cancelPendingDelete}},[_vm._v("\n                              "+_vm._s(_vm.$t('button.cancel'))+"\n                            ")])],1)]):_vm._e()],1)}),_vm._v(" "),_c('div',{staticClass:"poll-card__actions"},[_c('b-button',{attrs:{"size":"sm","variant":"outline-primary","type":"button"},on:{"click":function($event){return _vm.addPollOption(_vm.activePollIndex)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.polls.add_option'))+"\n                        ")])],1)],2):_vm._e()])])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_post_add'),expression:"'lives_conf_post_add'"}],staticClass:"form-group settings-section collapsible-section",attrs:{"has-permission":"lives_conf_post_add"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('program')}}},[_c('label',{staticClass:"primary conf-label"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.title')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.program ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.program,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('b-form-group',[_c('b-form-radio-group',{model:{value:(_vm.form.defaultConf),callback:function ($$v) {_vm.$set(_vm.form, "defaultConf", $$v)},expression:"form.defaultConf"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.default')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.title')))])],1)],1),_vm._v(" "),(!_vm.form.defaultConf)?_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_post_add'),expression:"'lives_conf_post_add'"}],staticClass:"custom-configuration",attrs:{"has-permission":"lives_conf_post_add"}},[_c('div',{staticClass:"form-group"},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_message_option'),expression:"'lives_conf_message_option'"}],attrs:{"value":"Message","has-permission":"lives_conf_message_option"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.message.title')))]),_vm._v(" "),_c('textarea',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.conf.type === 'Message'),expression:"form.conf.type === 'Message'"},{name:"model",rawName:"v-model",value:(_vm.form.conf.message),expression:"form.conf.message"}],staticClass:"form-control",attrs:{"rows":"5","maxlength":"255","placeholder":_vm.$t(
                        'form_live.tabs.frontOffice.configuration.personalized.message.description'
                      ),"required":""},domProps:{"value":(_vm.form.conf.message)},on:{"keyup":function($event){return _vm.removeError($event)},"focus":function($event){return _vm.removeError($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "message", $event.target.value)}}}),_vm._v(" "),(this.showErrorMessage)?_c('div',{staticClass:"error_message"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.error_long_message'))+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.conf.message.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                  ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_video_option'),expression:"'lives_conf_video_option'"}],attrs:{"value":"Video","has-permission":"lives_conf_video_option"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.video.title')))]),_vm._v(" "),(!_vm.isBeforeLiveVideoPickerVisible && _vm.form.conf.type === 'Video')?_c('div',[_c('div',{staticClass:"before-live-video-container"},[_c('figure',[_c('div',{staticClass:"before-live-video-container__overlay"},[_c('font-awesome-icon',{attrs:{"icon":"play-circle"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-sm before-live-video-container__btn",on:{"click":_vm.toggleBeforeLiveVideoPicker}},[_c('font-awesome-icon',{attrs:{"icon":"pencil-alt"}}),_vm._v("\n                          Changer la source\n                        ")],1),_vm._v(" "),_c('b-img',{attrs:{"src":_vm.form.videoBeforeLive.logo,"fluid":"","alt":_vm.form.videoBeforeLive.title}})],1),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.form.videoBeforeLive.title))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.conf.video),expression:"form.conf.video"}],staticClass:"form-control",attrs:{"type":"text","required":"","hidden":""},domProps:{"value":(_vm.form.conf.video)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "video", $event.target.value)}}}),_vm._v(" "),(
                        _vm.form.conf.type === 'Video' &&
                          _vm.initInfinitScrollVideos &&
                          _vm.isBeforeLiveVideoPickerVisible
                      )?_c('div',{staticClass:"video-picker-wrapper"},[_c('div',{staticClass:"search-wrapper position-relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchVideoKeyword),expression:"searchVideoKeyword"}],staticClass:"form-control mb-15",attrs:{"placeholder":_vm.$t(
                              'form_live.tabs.frontOffice.configuration.personalized.video.description'
                            ),"type":"text"},domProps:{"value":(_vm.searchVideoKeyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchVideo.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchVideoKeyword=$event.target.value}}}),_vm._v(" "),_c('b-button',{staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.searchVideo}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"video-slides-wrapper"},[_c('VuePerfectScrollbar',{ref:"ps",staticClass:"scroll-area",on:{"ps-y-reach-end":_vm.handlePageChanged}},[_c('b-row',_vm._l((_vm.slidesChips),function(slide,index){return _c('b-col',{key:slide.id,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('div',{staticClass:"mb-3"},[_c('figure',[_c('div',{staticClass:"video-overlay",class:{ in: slide.id === _vm.form.conf.video }},[_c('button',{staticClass:"btn",class:slide.id === _vm.form.conf.video
                                          ? 'btn-light'
                                          : 'btn-outline-light',on:{"click":function($event){return _vm.selectVideo(slide)}}},[_vm._v("\n                                      "+_vm._s(_vm.$t('parameters.select.selectOption'))+"\n                                    ")])]),_vm._v(" "),_c('b-img',{attrs:{"src":slide.thumbnail,"fluid":"","alt":slide.title}})],1),_vm._v(" "),_c('div',{staticClass:"video-name",class:{ selected: slide.id === _vm.form.conf.video },attrs:{"title":slide.title}},[_vm._v("\n                                  "+_vm._s(slide.title)+"\n                                ")])])])}),1),_vm._v(" "),(_vm.isLoading('videos'))?_c('div',[_c('div',{staticClass:"sk-circle"},[_c('div',{staticClass:"sk-circle1 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-child"})])]):_vm._e(),_vm._v(" "),(_vm.isEndReached('videos') && _vm.slidesChips.length === 0)?_c('h5',{staticClass:"c-grey-700 font-weight-bolder m-3 text-center"},[_vm._v("\n                            Pas de vidéos\n                          ")]):_vm._e()],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.$v.form.conf.video.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.pick_video'))+"\n                    ")]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_image_option'),expression:"'lives_conf_image_option'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_image_option"}},[_c('b-form-radio',{attrs:{"value":"Image"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.image')))])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.conf.type === 'Image'),expression:"form.conf.type === 'Image'"}]},[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('b-form-group',{attrs:{"description":_vm.$t('form_live.tabs.general.form.description_image'),"label-for":"before-live-thumbnail"}},[_c('thumbnail-cropper',{attrs:{"crop-img":_vm.form.conf.image},on:{"thumbnailUpdated":_vm.handleBeforeLivePosterUpdated}})],1),_vm._v(" "),_c('div',[_c('b-form-checkbox',{attrs:{"name":"check-button","switch":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("\n                       Switch Checkbox "),_c('b',[_vm._v("(Checked: "+_vm._s(_vm.checkedSwitch)+")")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"before-live-image-description"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.text_before_live')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.conf.imageText),expression:"form.conf.imageText"}],staticClass:"form-control",attrs:{"id":"before-live-image-description","placeholder":_vm.$t('form_live.tabs.frontOffice.configuration.personalized.text'),"rows":"5"},domProps:{"value":(_vm.form.conf.imageText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "imageText", $event.target.value)}}})])])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_counter_option'),expression:"'lives_conf_counter_option'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_counter_option"}},[_c('b-form-radio',{attrs:{"value":"Counter"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.countdown')))])],1)],1):_vm._e()],1)])],1)],2):_vm._e(),_vm._v(" "),(this.isPermission.lives_conf_program || this.isSuperAdmin)?_c('b-tab',{attrs:{"has-permission":"lives_conf_program"}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"users"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2",attrs:{"has-permission":"lives_conf_program"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.new_title')))])]),_vm._v(" "),_c('div',{staticClass:"form-group settings-section collapsible-section",attrs:{"has-permission":"lives_conf_program"}},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('LiveProgram')}}},[_c('label',{staticClass:"primary",attrs:{"for":"LiveProgram"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.LiveProgram')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.LiveProgram ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.LiveProgram,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"LiveProgram"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.LiveProgram')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.live_program),expression:"form.live_program"}],staticClass:"form-control",staticStyle:{"width":"45%"},attrs:{"id":"LiveProgram","placeholder":_vm.$t('form_live.tabs.Program.LiveProgramDescription'),"rows":"3"},domProps:{"value":(_vm.form.live_program)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "live_program", $event.target.value)}}})]),_vm._v(" "),_c('b-row',{staticClass:"mt-5 ml-0"},[_c('b-col',{attrs:{"md":"6","sm":"12"}},[(this.isPermission.lives_conf_add_participant_limit || this.isSuperAdmin)?_c('div',{staticStyle:{"width":"40%"},attrs:{"has-permission":"lives_conf_add_participant_limit"}},[_c('b-row',{staticClass:"d-flex"},[_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.ParticpantsLimit'))+" ")]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"ml-2",attrs:{"name":"check-button","switch":""},model:{value:(_vm.checkedLimit),callback:function ($$v) {_vm.checkedLimit=$$v},expression:"checkedLimit"}})],1),_vm._v(" "),(_vm.checkedLimit)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",staticStyle:{"font-size":"12px","color":"gray"},attrs:{"for":"nameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.MaxParticipantsDistance')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"type":"number","min":"0","id":"inline-form-input-MaxParticipantsDistance","placeholder":_vm.$t('form_live.tabs.Program.MaxParticipantsDistance')},on:{"keydown":function($event){return _vm.portKeydown($event)}},model:{value:(_vm.form.max_online_guests),callback:function ($$v) {_vm.$set(_vm.form, "max_online_guests", _vm._n($$v))},expression:"form.max_online_guests"}})],1)],1):_vm._e(),(_vm.checkedLimit)?_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",staticStyle:{"font-size":"12px","color":"gray"},attrs:{"for":"nameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.MaxInvited')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0"},[_c('b-form-input',{attrs:{"type":"number","min":"0","id":"inline-form-input-MaxInvited","placeholder":_vm.$t('form_live.tabs.Program.MaxInvited')},on:{"keydown":function($event){return _vm.portKeydown($event)}},model:{value:(_vm.form.max_onsite_guests),callback:function ($$v) {_vm.$set(_vm.form, "max_onsite_guests", _vm._n($$v))},expression:"form.max_onsite_guests"}})],1)],1)],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{staticClass:"form-group"},[(!_vm.$v.form.description.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('label',{staticClass:"primary",attrs:{"for":"Participants"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Intervenants')))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"ml-2",attrs:{"name":"check-button","switch":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1),_vm._v(" "),(_vm.checked)?_c('b-button',{staticClass:"mt-2",attrs:{"id":"show-btn"},on:{"click":_vm.showModal}},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.Program.AddParticipant'))+"\n                    ")]):_vm._e()],1),_vm._v(" "),_c('b-list-group',{staticClass:"mb-2"},_vm._l((_vm.intervenants),function(intervenant,index){return _c('b-list-group-item',{key:index,staticClass:"d-flex justify-content-between",staticStyle:{"margin-bottom":"12px"}},[(intervenant.avatar.length > 1)?_c('img',{staticStyle:{"width":"75px","border-radius":"50%"},attrs:{"src":_vm.cleanedAvatarUrl(intervenant.avatar)}}):_c('b-avatar',{staticStyle:{"width":"85px","background-color":"#007bff","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","font-size":"26px","padding":"15px","font-weight":"bold","color":"white"},attrs:{"variant":"primary","text":"BV"}},[_vm._v(_vm._s(intervenant.name[0].toUpperCase())+_vm._s(intervenant.lastName[0].toUpperCase()))]),_vm._v(" "),_c('div',{staticClass:"intervenant",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"mb-1"},[_vm._v(_vm._s(intervenant.name)+" "+_vm._s(intervenant.lastName))])]),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('small',[_vm._v(_vm._s(intervenant.mail))])])]),_vm._v(" "),_c('div',{staticClass:"speaker-btns"},[_c('b-button',{attrs:{"variant":"light","pill":""},on:{"click":function($event){return _vm.deleteInter(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"light","pill":""},on:{"click":function($event){return _vm.openModelForUpdate(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"edit"}})],1)],1)],1)}),1),_vm._v(" "),_c('b-modal',{ref:"my-modal",attrs:{"hide-footer":"","title":_vm.update || _vm.updateModal ? _vm.$t('form_live.tabs.Program.editParticipant') : _vm.$t('form_live.tabs.Program.AddParticipant')},on:{"hidden":_vm.closeModel}},[_c('b-form',{ref:"formIntervenant"},[_c('label',{staticClass:"required primary",attrs:{"for":"LiveProgram"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Photo')))]),_vm._v(" "),_c('div',{staticClass:"Image-upload-container"},[_c('div',{staticClass:"image-container",on:{"click":_vm.inputFile}},[_c('b-form-file',{ref:"File",attrs:{"id":"file-default","hidden":"","accept":"image/*"},on:{"change":_vm.changeInput},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_vm._v(" "),(!_vm.url && !_vm.showDelete)?_c('div',{staticClass:"upload-button"},[_c('span',[_c('img',{attrs:{"src":_vm.uploadImage,"alt":"upload Icon"}})]),_vm._v(" "),_c('span',{staticClass:"clickable-text"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Cliquez')))])]):_vm._e(),_vm._v(" "),(_vm.PendingUpload)?_c('font-awesome-icon',{staticClass:"loading-icon",attrs:{"icon":"spinner","spin":""}}):_vm._e(),_vm._v(" "),(_vm.url)?_c('img',{staticClass:"uploaded-image",attrs:{"src":_vm.url,"alt":"Downloaded Image"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"image-info"},[(_vm.showDelete)?_c('font-awesome-icon',{staticClass:"trash-icon",attrs:{"icon":"trash"},on:{"click":_vm.deleteImageIntervenant}}):_vm._e()],1)]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"nameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Nom'))+"\n                          "),_c('span',{staticClass:"required-star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-name","placeholder":_vm.$t('form_live.tabs.Program.Nom'),"required":""},model:{value:(_vm.form.nom),callback:function ($$v) {_vm.$set(_vm.form, "nom", $$v)},expression:"form.nom"}})],1),_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"lastnameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Prenom'))+"\n                         "),_c('span',{staticClass:"required-star"},[_vm._v("*")])]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0"},[_c('b-form-input',{attrs:{"id":"inline-form-input-username","placeholder":_vm.$t('form_live.tabs.Program.Prenom'),"required":""},model:{value:(_vm.form.lastName),callback:function ($$v) {_vm.$set(_vm.form, "lastName", $$v)},expression:"form.lastName"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"fonctionIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Fonction')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-name","placeholder":_vm.$t('form_live.tabs.Program.Fonction')},model:{value:(_vm.form.fonction),callback:function ($$v) {_vm.$set(_vm.form, "fonction", $$v)},expression:"form.fonction"}})],1),_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"StructureIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Structure')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0"},[_c('b-form-input',{attrs:{"id":"inline-form-input-username","placeholder":_vm.$t('form_live.tabs.Program.Structure')},model:{value:(_vm.form.structure),callback:function ($$v) {_vm.$set(_vm.form, "structure", $$v)},expression:"form.structure"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",attrs:{"for":"roleIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Role')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-name","placeholder":_vm.$t('form_live.tabs.Program.Role')},model:{value:(_vm.form.role),callback:function ($$v) {_vm.$set(_vm.form, "role", $$v)},expression:"form.role"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",attrs:{"for":"descriptionIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Description),expression:"form.Description"}],staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"id":"inline-form-input-name","rows":"3","placeholder":_vm.$t('form_live.tabs.Program.Description')},domProps:{"value":(_vm.form.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "Description", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",attrs:{"for":"EmailIntervenant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Email')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-email","placeholder":_vm.$t('form_live.tabs.Program.Email')},model:{value:(_vm.form.mail),callback:function ($$v) {_vm.$set(_vm.form, "mail", $$v)},expression:"form.mail"}}),_vm._v(" "),(_vm.form.mail && _vm.emailError)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-divider'),_vm._v(" "),_c('b-button',{staticClass:"mr-2",attrs:{"variant":"light","type":"button"},on:{"click":_vm.closeModel}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),(_vm.updateModal)?_c('b-button',{staticClass:"outlined-black",attrs:{"variant":"primary","color":"gray","disabled":_vm.PendingUpload || _vm.$v.form.$error},on:{"mousedown":_vm.ManageIntervenant}},[_vm._v(_vm._s(_vm.$t('button.edit')))]):_vm._e(),_vm._v(" "),(!_vm.update && !_vm.updateModal)?_c('b-button',{staticClass:"outlined-black",attrs:{"variant":"primary","color":"gray","disabled":_vm.PendingUpload || _vm.$v.form.$error},on:{"mousedown":_vm.ManageIntervenant}},[_vm._v(_vm._s(_vm.$t('button.save')))]):_vm._e(),_vm._v(" "),(_vm.update)?_c('b-button',{staticClass:"outlined-black",attrs:{"variant":"primary","disabled":_vm.PendingUpload || _vm.$v.form.$error},on:{"mousedown":_vm.ManageIntervenant}},[_vm._v(_vm._s(_vm.$t('button.edit')))]):_vm._e()],1)],1)],1)],1)],1)])],1)],2):_vm._e(),_vm._v(" "),(this.isPermission.lives_skin || this.isSuperAdmin)?_c('b-tab',{attrs:{"has-permission":"lives_skin"}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"palette"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.new_title')))])]),_vm._v(" "),_c('div',{staticClass:"settings-section collapsible-section"},[_c('div',{staticClass:"section-header",on:{"click":function($event){return _vm.toggleSection('skin')}}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.title')))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":_vm.sections.skin ? 'chevron-up' : 'chevron-down'}})],1),_vm._v(" "),_c('b-collapse',{attrs:{"visible":_vm.sections.skin,"id":"collapse-diffusion"}},[_c('div',{staticClass:"collapse-content"},[_c('div',{staticClass:"form-group mt-3"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.selectOrCreate')))]),_vm._v(" "),_c('b-form-select',{staticClass:"w-50",attrs:{"options":_vm.skinOptions},on:{"change":_vm.onSelectSkin},model:{value:(_vm.skinForm.selectedSkin),callback:function ($$v) {_vm.$set(_vm.skinForm, "selectedSkin", $$v)},expression:"skinForm.selectedSkin"}}),_vm._v(" "),_c('small',{staticClass:"text-muted d-block mt-1"},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.explanation'))+"\n    ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.skinForm.selectedSkin)?_c('div',[(!_vm.skinIsEditMode)?_c('h5',{staticClass:"mt-4 mb-3"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.newSkin')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.primaryColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.primary_color),expression:"skinForm.skin.primary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.primary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "primary_color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.secondaryColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.secondary_color),expression:"skinForm.skin.secondary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.secondary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "secondary_color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.primaryTextColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.text_primary_color),expression:"skinForm.skin.text_primary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.text_primary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "text_primary_color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.secondaryTextColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.text_secondary_color),expression:"skinForm.skin.text_secondary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.text_secondary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "text_secondary_color", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('div',{staticClass:"custom-file-wrapper"},[_c('button',{staticClass:"btn-upload",attrs:{"type":"button","disabled":_vm.uploading.logo},on:{"click":function($event){return _vm.$refs.logoInput.click()}}},[(_vm.uploading.logo)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.logo'))+"\n    ")],1),_vm._v(" "),_c('input',{ref:"logoInput",staticClass:"hidden-file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":function (e) { return _vm.uploadLogo(e, 'logo'); }}})]),_vm._v(" "),(_vm.skinForm.skin.logoPreview)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"image-preview-wrapper position-relative d-inline-block"},[_c('img',{staticClass:"logo-preview",class:{ 'is-loading': _vm.uploading.logo },attrs:{"src":_vm.skinForm.skin.logoPreview,"alt":"Logo preview"}}),_vm._v(" "),(_vm.uploading.logo)?_c('div',{staticClass:"preview-overlay"},[_c('b-spinner')],1):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-6 pr-md-4 mb-4"},[_c('h6',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.beforeLiveInfo')))]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.infoText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.before.info_text),expression:"skinForm.skin.before.info_text"}],staticClass:"form-control w-100",attrs:{"rows":"2"},domProps:{"value":(_vm.skinForm.skin.before.info_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin.before, "info_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-flex mb-2"},[_c('div',{staticClass:"mr-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.showDate')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.before.show_date),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.before, "show_date", $$v)},expression:"skinForm.skin.before.show_date"}})],1),_vm._v(" "),_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.showHour')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.before.show_hour),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.before, "show_hour", $$v)},expression:"skinForm.skin.before.show_hour"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"custom-file-wrapper"},[_c('button',{staticClass:"btn-upload",attrs:{"type":"button","disabled":_vm.uploading.before},on:{"click":function($event){return _vm.$refs.beforeInput.click()}}},[(_vm.uploading.before)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.backgroundImage'))+"\n    ")],1),_vm._v(" "),_c('input',{ref:"beforeInput",staticClass:"hidden-file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":function (e) { return _vm.uploadBackground(e, 'before'); }}})]),_vm._v(" "),(_vm.skinForm.skin.before.backgroundPreview)?_c('div',{staticClass:"mt-2 position-relative"},[_c('div',{staticClass:"image-preview-wrapper position-relative d-inline-block"},[_c('img',{staticClass:"bg-preview",class:{ 'is-loading': _vm.uploading.before },attrs:{"src":_vm.skinForm.skin.before.backgroundPreview,"alt":"Before background"}}),_vm._v(" "),(_vm.uploading.before)?_c('div',{staticClass:"preview-overlay"},[_c('b-spinner')],1):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.before.background_blur),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.before, "background_blur", $$v)},expression:"skinForm.skin.before.background_blur"}},[_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.SkinModel.blurred'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 pl-md-4"},[_c('h6',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.afterLiveInfo')))]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.infoText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.after.info_text),expression:"skinForm.skin.after.info_text"}],staticClass:"form-control w-100",attrs:{"rows":"2"},domProps:{"value":(_vm.skinForm.skin.after.info_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin.after, "info_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"custom-file-wrapper"},[_c('button',{staticClass:"btn-upload",attrs:{"type":"button","disabled":_vm.uploading.after},on:{"click":function($event){return _vm.$refs.afterInput.click()}}},[(_vm.uploading.after)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.backgroundImage'))+"\n    ")],1),_vm._v(" "),_c('input',{ref:"afterInput",staticClass:"hidden-file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":function (e) { return _vm.uploadBackground(e, 'after'); }}})]),_vm._v(" "),(_vm.skinForm.skin.after.backgroundPreview)?_c('div',{staticClass:"mt-2 position-relative"},[_c('div',{staticClass:"image-preview-wrapper position-relative d-inline-block"},[_c('img',{staticClass:"bg-preview",class:{ 'is-loading': _vm.uploading.after },attrs:{"src":_vm.skinForm.skin.after.backgroundPreview,"alt":"After background"}}),_vm._v(" "),(_vm.uploading.after)?_c('div',{staticClass:"preview-overlay"},[_c('b-spinner')],1):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.after.background_blur),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.after, "background_blur", $$v)},expression:"skinForm.skin.after.background_blur"}},[_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.SkinModel.blurred'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"mt-4 row d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"col-md-8 applied-skin-message"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.skinIsEditMode),expression:"skinIsEditMode"}]},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.editNote'))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 d-flex justify-content-end align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.name),expression:"skinForm.skin.name"}],staticClass:"form-control mr-2",staticStyle:{"width":"220px"},attrs:{"type":"text","placeholder":_vm.$t('form_live.tabs.SkinModel.skinName')},domProps:{"value":(_vm.skinForm.skin.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "name", $event.target.value)}}})])])]):_vm._e()])])],1)],2):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isEmpreinteClient)?_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},[_c('b-tab',{attrs:{"active":""}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"pen"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.title')))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('b-form-group',{attrs:{"description":_vm.$t('form_live.tabs.general.form.description_image'),"label":_vm.$t('form_live.tabs.general.form.add_image'),"label-for":"live-thumbnail","label-class":"primary"}},[_c('thumbnail-cropper',{attrs:{"crop-img":_vm.form.thumbnail},on:{"thumbnailUpdated":_vm.handleThumbnailUpdated}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('form_live.tabs.general.form.title'),"type":"text","id":"title","name":"title","required":""},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.form.title.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required primary",attrs:{"for":"description"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"id":"description","placeholder":_vm.$t('form_live.tabs.general.form.description'),"required":"","rows":"3"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.form.description.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_type'),expression:"'lives_type'"}],staticClass:"form-group",attrs:{"has-permission":"lives_type"}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.types')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.liveTypesOptions,"multiple":false,"track-by":"id","label":"title","close-on-select":false,"placeholder":"","select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
                                          var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.title))])]}},{key:"option",fn:function(ref){
                                          var option = ref.option;
return [_c('div',{style:({ 'margin-left': option.index + 'em' })},[_vm._v("\n                          "+_vm._s(option.title)+"\n                        ")])]}}],null,false,1949094140),model:{value:(_vm.form.types),callback:function ($$v) {_vm.$set(_vm.form, "types", $$v)},expression:"form.types"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.startDate.$invalid }},[_c('label',{staticClass:"required primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.start_date')))]),_vm._v(" "),_c('div',{staticClass:"input_css input filter-date",attrs:{"id":"filter-date"}},[_c('datepicker',{attrs:{"id":"start-date","input-class":"form-control selectedDate","wrapper-class":"start-date-picker","bootstrap-styling":true,"calendar-button":true,"required":true,"lang":_vm.$i18n.locale,"disabled-days":_vm.disabledDate,"format":'YYYY-MM-DD',"value-type":"format","active-color":_vm.getActiveColor,"clearable":false,"editable":false},model:{value:(_vm.form.startDate),callback:function ($$v) {_vm.$set(_vm.form, "startDate", $$v)},expression:"form.startDate"}},[_c('template',{slot:"calendar-icon"},[_c('font-awesome-icon',{staticClass:"calendar-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'calendar-alt' }}})],1)],2)],1),_vm._v(" "),(!_vm.$v.form.startDate.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):(!_vm.$v.form.startDate.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_date'))+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","sm":"6"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.startTime.$invalid }},[_c('label',{staticClass:"required primary",attrs:{"for":"start-time"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.start_hour')))]),_vm._v(" "),_c('vue-clock-picker',{attrs:{"id":"start-time","input-class":"form-control","active-color":_vm.getActiveColor,"required":false,"cancel-text":_vm.$t('button.cancel'),"done-text":_vm.$t('button.done'),"close-on-overlay":_vm.closeOnOverlay},on:{"close":_vm.closeModal,"beforeOpen":_vm.handleBeforeOpen},model:{value:(_vm.form.startTime),callback:function ($$v) {_vm.$set(_vm.form, "startTime", $$v)},expression:"form.startTime"}}),_vm._v(" "),(!_vm.$v.form.startTime.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):(!_vm.$v.form.startTime.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_hour'))+"\n                    ")]):_vm._e()],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"3","sm":"6"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.endTime.$invalid }},[_c('label',{staticClass:"required primary",attrs:{"for":"end-time"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.end_hour')))]),_vm._v(" "),_c('vue-clock-picker',{attrs:{"id":"end-time","input-class":"form-control","active-color":_vm.getActiveColor,"required":false,"cancel-text":_vm.$t('button.cancel'),"done-text":_vm.$t('button.done'),"close-on-overlay":_vm.closeOnOverlay},on:{"close":_vm.closeModal,"beforeOpen":_vm.handleBeforeOpen},model:{value:(_vm.form.endTime),callback:function ($$v) {_vm.$set(_vm.form, "endTime", $$v)},expression:"form.endTime"}}),_vm._v(" "),(!_vm.$v.form.endTime.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):(!_vm.$v.form.endTime.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_hour'))+"\n                    ")]):_vm._e()],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.tags')))]),_vm._v(" "),_c('input-tag',{attrs:{"add-tag-on-keys":[13,32]},on:{"input":_vm.handleAddInputTags},model:{value:(_vm.form.tags),callback:function ($$v) {_vm.$set(_vm.form, "tags", $$v)},expression:"form.tags"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.themes')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.themesOptions,"multiple":true,"track-by":"id","label":"title","close-on-select":true,"placeholder":"","select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
                                          var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.title))])]}},{key:"option",fn:function(ref){
                                          var option = ref.option;
return [_c('div',{style:({ 'margin-left': option.index + 'em' })},[_vm._v("\n                          "+_vm._s(option.title)+"\n                        ")])]}}],null,false,1949094140),model:{value:(_vm.form.themes),callback:function ($$v) {_vm.$set(_vm.form, "themes", $$v)},expression:"form.themes"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1)],2),_vm._v(" "),_c('b-tab',[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"cog"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.title')))])]),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_type_no_api'),expression:"'lives_type_no_api'"}],staticClass:"form-group",attrs:{"has-permission":"lives_type_no_api"}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.title')))]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"name":"type"},model:{value:(_vm.form.isCdn),callback:function ($$v) {_vm.$set(_vm.form, "isCdn", $$v)},expression:"form.isCdn"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.intranet')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.internet')))])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(_vm.getDifferentDiffusionPermission),expression:"getDifferentDiffusionPermission"}],staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.title_empreinte')))]),_vm._v(" "),_c('b-form-radio-group',{on:{"input":function($event){return _vm.handleDiffusionTypeChanged('diffusion')}},model:{value:(_vm.form.diffusion),callback:function ($$v) {_vm.$set(_vm.form, "diffusion", $$v)},expression:"form.diffusion"}},[_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_no_api'),expression:"'lives_webinar_no_api'"}],staticClass:"order-1 order-md-0",attrs:{"xl":"4","lg":"4","md":"4","sm":"12","has-permission":"lives_webinar_no_api"}},[_c('b-form-radio',{attrs:{"value":"webinar"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons video-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'video' }}}),_vm._v("\n\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.webinar_empreinte'))+"\n                      ")],1),_vm._v(" "),(_vm.form.diffusion==='webinar' && _vm.form.webinar)?_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_type_by_link_no_api,lives_webinar_type_private_no_api,lives_webinar_type_public_no_api'),expression:"'lives_webinar_type_by_link_no_api,lives_webinar_type_private_no_api,lives_webinar_type_public_no_api'"}],staticClass:"webinar-type",attrs:{"has-permission":"lives_webinar_type_by_link_no_api,lives_webinar_type_private_no_api,lives_webinar_type_public_no_api"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.type.title_empreinte')))]),_vm._v(" "),_c('b-form-radio-group',{on:{"input":function($event){return _vm.handleDiffusionTypeChanged('accessType')}},model:{value:(_vm.form.accessType),callback:function ($$v) {_vm.$set(_vm.form, "accessType", $$v)},expression:"form.accessType"}},[_c('b-row',[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_type_by_link_no_api'),expression:"'lives_webinar_type_by_link_no_api'"}],staticClass:"webinar-type__radio col-xl-6 col-lg-12",attrs:{"has-permission":"lives_webinar_type_by_link_no_api"}},[_c('b-form-radio',{attrs:{"value":"by_link"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.type.by_link_empreinte')))])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_type_private_no_api'),expression:"'lives_webinar_type_private_no_api'"}],staticClass:"webinar-type__radio col-xl-3 col-lg-12",attrs:{"has-permission":"lives_webinar_type_private_no_api"}},[_c('b-form-radio',{attrs:{"value":"private"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.type.private_empreinte')))])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_type_public_no_api'),expression:"'lives_webinar_type_public_no_api'"}],staticClass:"webinar-type__radio col-xl-3 col-lg-12",attrs:{"has-permission":"lives_webinar_type_public_no_api"}},[_c('b-form-radio',{attrs:{"value":"public"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.type.public_empreinte'))+"\n                                  ")])],1)])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'),expression:"'lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api'"}],staticClass:"form-group",attrs:{"has-permission":"lives_webinar_connexion_auto_no_api,lives_webinar_connexion_by_authorization_no_api"}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.title_empreinte')))]),_vm._v(" "),_c('b-form-radio-group',{on:{"input":function($event){return _vm.handleDiffusionTypeChanged('connexionType')}},model:{value:(_vm.form.connexionType),callback:function ($$v) {_vm.$set(_vm.form, "connexionType", $$v)},expression:"form.connexionType"}},[_c('b-row',{staticClass:"webinar-type__radio"},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_auto_no_api'),expression:"'lives_webinar_connexion_auto_no_api'"}],staticClass:"webinar-type__radio col-xl-6",attrs:{"has-permission":"lives_webinar_connexion_auto_no_api"}},[_c('b-form-radio',{attrs:{"value":"auto"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.auto')))])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_connexion_by_authorization_no_api'),expression:"'lives_webinar_connexion_by_authorization_no_api'"}],staticClass:"webinar-type__radio col-xl-6",attrs:{"has-permission":"lives_webinar_connexion_by_authorization_no_api"}},[_c('b-form-radio',{attrs:{"value":"by_authorization"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.connexion.by_authorization')))])],1)])],1)],1)]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_no_api'),expression:"'lives_encoder_no_api'"}],attrs:{"value":'isPearl',"has-permission":"lives_encoder_no_api"},on:{"change":function($event){_vm.form.diffusion = 'isPearl'}}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons server-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'server' }}}),_vm._v("\n    "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encodeur_empreinte'))+"\n  ")],1),_vm._v(" "),(_vm.form.diffusion === 'isPearl')?_c('div',{staticClass:"encoder-options mt-3 ml-3"},[_c('b-form-radio-group',{attrs:{"name":"encoder-type-group"},on:{"input":_vm.handleEncoderTypeChange},model:{value:(_vm.form.isAuto),callback:function ($$v) {_vm.$set(_vm.form, "isAuto", $$v)},expression:"form.isAuto"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_no_api'),expression:"'lives_encoder_no_api'"}],attrs:{"value":false,"has-permission":"lives_encoder_no_api"}},[_vm._v("\n\n        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encoding'))+"\n      ")]),_vm._v(" "),(_vm.hasPermission('lives_encoder_external_no_api'))?_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_external_no_api'),expression:"'lives_encoder_external_no_api'"}],attrs:{"value":true,"has-permission":"lives_encoder_external_no_api"}},[_vm._v("\n        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encodeur_automatique'))+"\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.form.isAuto)?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"mb-2"},[_c('label',{staticClass:"required primary",attrs:{"for":"automatic-station-select"}},[_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.select_station'))+"\n        ")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"automatic-station-select","options":_vm.automaticStations,"value-field":"id","text-field":"name","disabled":_vm.loadingAutomaticStations,"required":""},on:{"change":_vm.onStationChange},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("\n      "+_vm._s(_vm.loadingAutomaticStations
        ? _vm.$t('form_live.tabs.advanced.diffusion.loading_stations')
        : _vm.$t('form_live.tabs.advanced.diffusion.select_station'))+"\n    ")])]},proxy:true}],null,false,666957146),model:{value:(_vm.form.stationId),callback:function ($$v) {_vm.$set(_vm.form, "stationId", $$v)},expression:"form.stationId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.isAuto)?_c('div',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',{staticClass:"mb-2",attrs:{"cols":"6"}},[_c('label',{staticClass:"form-label",attrs:{"for":"encoder-input-1"}},[_vm._v("\n            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.index_video_port'))+" :\n          ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"encoder-input-1","type":"number","min":"0","placeholder":"0","readonly":_vm.isUnescoClient},model:{value:(_vm.form.videoPortIndex),callback:function ($$v) {_vm.$set(_vm.form, "videoPortIndex", $$v)},expression:"form.videoPortIndex"}}),_vm._v(" "),(_vm.isUnescoClient)?_c('small',{staticClass:"text-muted"}):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"mb-2",attrs:{"cols":"6"}},[_c('label',{staticClass:"form-label",attrs:{"for":"encoder-input-2"}},[_vm._v("\n            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.index_audio_port'))+" :\n          ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"encoder-input-2","type":"number","min":"0","placeholder":"0","readonly":_vm.isUnescoClient},model:{value:(_vm.form.audioPortIndex),callback:function ($$v) {_vm.$set(_vm.form, "audioPortIndex", $$v)},expression:"form.audioPortIndex"}}),_vm._v(" "),(_vm.isUnescoClient)?_c('small',{staticClass:"text-muted"}):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"form-label",attrs:{"for":"protocol-select"}},[_vm._v("\n            "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.protocol'))+"\n          ")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"protocol-select","options":_vm.protocolOptions},model:{value:(_vm.form.protocolType),callback:function ($$v) {_vm.$set(_vm.form, "protocolType", $$v)},expression:"form.protocolType"}})],1)],1)],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(''),expression:"''"}],attrs:{"value":"externalHls"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons network-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'network-wired' }}}),_vm._v("\n\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.externalHlst'))+"\n                      ")],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.externalHls),expression:"form.externalHls"}]},[_c('b-form-input',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(''),expression:"''"}],on:{"input":_vm.setHls},model:{value:(_vm.form.linkHls),callback:function ($$v) {_vm.$set(_vm.form, "linkHls", $$v)},expression:"form.linkHls"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"xl":"4","lg":"4","md":"4","sm":"12"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'),expression:"'lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api'"}],staticClass:"primary",attrs:{"has-permission":"lives_private_no_api,lives_active_no_api,lives_autopub_no_api,lives_dvr_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.title_empreinte')))]),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_active_no_api'),expression:"'lives_active_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_active_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.active_video')))])],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"form-group",model:{value:(_vm.form.isRecorded),callback:function ($$v) {_vm.$set(_vm.form, "isRecorded", $$v)},expression:"form.isRecorded"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.saveVideo'))+" ")]),_vm._v(" "),(_vm.form.isRecorded)?_c('b-form-group',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_autopub_no_api'),expression:"'lives_autopub_no_api'"}],attrs:{"has-permission":"lives_autopub_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.autoPublish),callback:function ($$v) {_vm.$set(_vm.form, "autoPublish", $$v)},expression:"form.autoPublish"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.automatic_share')))])],1):_vm._e()],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dvr_no_api'),expression:"'lives_dvr_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_dvr_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.isDvr),callback:function ($$v) {_vm.$set(_vm.form, "isDvr", $$v)},expression:"form.isDvr"}},[_vm._v("DVR")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"fields-example"},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_langues_post_add','lives_countries_post_add'),expression:"'lives_langues_post_add','lives_countries_post_add'"}],staticClass:"primary"},[_vm._v(" "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.languages_empreinte')))]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_langues_post_add'),expression:"'lives_langues_post_add'"}],staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.languages')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.languagesOptions,"multiple":true,"track-by":"label","label":"lang","close-on-select":true,"placeholder":_vm.$t('form_live.tabs.advanced.diffusion.languagesPlaceholder'),"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"option",fn:function(ref){
        var option = ref.option;
return [_c('div',[_vm._v(_vm._s(option.lang))])]}}],null,false,3976500575),model:{value:(_vm.form.languages),callback:function ($$v) {_vm.$set(_vm.form, "languages", $$v)},expression:"form.languages"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_countries_post_add'),expression:"'lives_countries_post_add'"}],staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.countries')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.countriesOptions,"multiple":true,"track-by":"id","label":"countryName","close-on-select":true,"placeholder":_vm.$t('form_live.tabs.advanced.diffusion.countriesPlaceholder'),"loading":_vm.isLoadingCountries,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"option",fn:function(ref){
        var option = ref.option;
return [_c('div',[_vm._v(_vm._s(option.countryName))])]}}],null,false,4176021620),model:{value:(_vm.form.countries),callback:function ($$v) {_vm.$set(_vm.form, "countries", $$v)},expression:"form.countries"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_youtubelinks_post_add'),expression:"'lives_youtubelinks_post_add'"}],staticClass:"primary"},[_vm._v(" "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.title')))]),_vm._v(" "),_c('youtube-links',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_youtubelinks_post_add'),expression:"'lives_youtubelinks_post_add'"}],attrs:{"initial-youtube-enabled":_vm.form.isYoutube,"initial-youtube-links":_vm.form.youtubeLinks},on:{"update:youtubeEnabled":_vm.onYoutubeEnabledChange,"update:youtubeLinks":_vm.onYoutubeLinksChange}})],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api'),expression:"'lives_associate_users_no_api'"}],attrs:{"has-permission":"lives_associate_users_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.title')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getWebtvUsers,"multiple":true,"track-by":"email","label":"email","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
        var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name))])]}}],null,false,2784876651),model:{value:(_vm.form.contributors),callback:function ($$v) {_vm.$set(_vm.form, "contributors", $$v)},expression:"form.contributors"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('div',[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.header')))])]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.participantTitle')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.localParticipantOptions,"multiple":true,"track-by":"email","label":"email","placeholder":"","taggable":true,"tag-placeholder":_vm.$t('form_live.tabs.advanced.contributors.add_email'),"close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},on:{"tag":_vm.addCustomParticipant},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
        var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name))])]}}],null,false,2784876651),model:{value:(_vm.form.participants),callback:function ($$v) {_vm.$set(_vm.form, "participants", $$v)},expression:"form.participants"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api'),expression:"'lives_associate_users_no_api'"}]},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('modal.moderators')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getWebtvUsers,"multiple":true,"track-by":"id","label":"email","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
        var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.email))])]}}],null,false,3346479968),model:{value:(_vm.moderators),callback:function ($$v) {_vm.moderators=$$v},expression:"moderators"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api'),expression:"'lives_rich_media_no_api'"}],attrs:{"has-permission":"lives_rich_media_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(" "+_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.medias'))+"  ")]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.isRm),callback:function ($$v) {_vm.$set(_vm.form, "isRm", $$v)},expression:"form.isRm"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.title')))])],1)]),_vm._v(" "),(_vm.form.isRm)?_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"rm-tabs-wrapper"},[_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},[(_vm.hasPermission('lives_rich_media_chapter_no_api'))?_c('b-tab',{attrs:{"has-permission":"lives_rich_media_chapter_no_api","active":""},on:{"click":_vm.focusAddChapter}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                              "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.title'))+"\n                            ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.chapters),callback:function ($$v) {_vm.$set(_vm.form, "chapters", $$v)},expression:"form.chapters"}},_vm._l((_vm.form.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container"},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}]},[_vm._v("\n                                          "+_vm._s(chapter.title)+"\n                                        ")]),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode),expression:"chapter.isEditMode"}],staticClass:"m-0"},[_c('b-form-input',{attrs:{"placeholder":_vm.$t(
                                                'form_live.tabs.advanced.rich_media.tabs.chapters.fields.title'
                                              )},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleEditChapter(index)}},model:{value:(_vm.chapterTitle),callback:function ($$v) {_vm.chapterTitle=$$v},expression:"chapterTitle"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode && !!chapter.title),expression:"chapter.isEditMode && !!chapter.title"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.toggleEditChapter(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChapterEditMode),expression:"!isChapterEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditChapter(index, false)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeChapter(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.chapters.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                    "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.empty'))+"\n                                  ")]):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[_c('div',{staticClass:"position-relative"},[_c('b-form-input',{ref:"newChapterInput",attrs:{"placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.new')},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addChapter.apply(null, arguments)}},model:{value:(_vm.newChapter),callback:function ($$v) {_vm.newChapter=$$v},expression:"newChapter"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.newChapter),expression:"newChapter"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.addChapter}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}})],1)],1)])],2):_vm._e(),_vm._v(" "),(_vm.hasPermission('lives_rich_media_question_no_api'))?_c('b-tab',{attrs:{"has-permission":"lives_rich_media_question_no_api"}},[_c('template',{slot:"title"},[_c('div',[_c('span',{staticClass:"icon-question"})]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                              "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.title'))+"\n                            ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.questions),callback:function ($$v) {_vm.$set(_vm.form, "questions", $$v)},expression:"form.questions"}},_vm._l((_vm.form.questions),function(question,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container question",class:{ 'is-open': question.isEditMode }},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}]},[_vm._v("\n                                          "+_vm._s(question.question)+"\n                                        ")]),_vm._v(" "),(question.isEditMode)?_c('question-form',{attrs:{"question":question,"buttonLabel":_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.edit'
                                            )},on:{"addQuestion":function($event){return _vm.updateQuestion($event, index)},"closeForm":function($event){return _vm.toggleEditQuestion(index)}}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isQuestionEditMode),expression:"!isQuestionEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditQuestion(index)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeQuestion(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.questions.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                    "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.empty'))+"\n                                  ")]):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[(_vm.addQuestionMode)?_c('question-form',{on:{"addQuestion":_vm.addQuestion,"closeForm":function($event){_vm.addQuestionMode = false}}},[_c('label',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.new')))])]):_vm._e(),_vm._v(" "),(!_vm.addQuestionMode)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"link","type":"button"},on:{"click":function($event){return _vm.setAddQuestionMode(true)}}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}}),_vm._v("\n                                    "+_vm._s(_vm.$t(
                                        'form_live.tabs.advanced.rich_media.tabs.questions.add_new'
                                      )))],1)],1)])],1):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('b-tab',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_slides_no_api'),expression:"'lives_rich_media_slides_no_api'"}],attrs:{"has-permission":"lives_rich_media_slides_no_api"},on:{"click":_vm.updateScrollbar}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"th-large"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                              "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.slides.title'))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"slides-wrapper"},[_c('draggable',{staticClass:"row",model:{value:(_vm.form.slides),callback:function ($$v) {_vm.$set(_vm.form, "slides", $$v)},expression:"form.slides"}},_vm._l((_vm.form.slides),function(slide,index){return _c('b-col',{key:index,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('figure',{staticClass:"img-fluid"},[_c('div',{staticClass:"type-tag"},[_c('span',{class:'icon-' +
                                            (slide.slideType === 'Image' ? 'picture' : 'video')})]),_vm._v(" "),(slide.slideType === 'Image')?_c('img',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),(slide.slideType === 'Video')?_c('video',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"more-btn-container"},[_c('b-dropdown',{attrs:{"variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"icon-more"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.replaceSlide(index)}}},[_c('span',{staticClass:"icon-edit"}),_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.edit'
                                            ))+"\n                                        ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.removeSlide(index)}}},[_c('span',{staticClass:"icon-trash"}),_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.slides.delete'
                                            ))+"\n                                        ")])],2)],1)])])}),1)],1),_vm._v(" "),_c('div',{staticClass:"dz-upload-wrapper"},[_c('vue-dropzone',{ref:"slidesDZ",attrs:{"id":"slides-dz","options":_vm.getDropzoneOptions('media'),"auto-process-queue":false},on:{"vdropzone-files-added":_vm.handleDzSlideAdded,"vdropzone-file-added-manually":_vm.handleDzSlideAdded,"vdropzone-complete":_vm.handleDzSlideCompleted}})],1)],2)],1)],1)]):_vm._e()],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_files_no_api'),expression:"'lives_associate_files_no_api'"}],attrs:{"has-permission":"lives_associate_files_no_api"}},[_c('b-col',{attrs:{"md":"3","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.joinFile),callback:function ($$v) {_vm.joinFile=$$v},expression:"joinFile"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.attaching_files_empreinte')))])],1),_vm._v(" "),(_vm.joinFile)?_c('div',{staticClass:"attached-files-wrapper"},_vm._l((_vm.form.files),function(file,index){return _c('div',{staticClass:"attached-file"},[_c('b-button',{staticClass:"attached-file__btn-remove",attrs:{"variant":"link"},on:{"click":function($event){return _vm.removeFile(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"times-circle"}})],1),_vm._v(" "),_c('div',{staticClass:"attached-file__icon"},[_c('font-awesome-icon',{attrs:{"icon":file.icon}})],1),_vm._v(" "),_c('div',{staticClass:"attached-file__name"},[_vm._v("\n                          "+_vm._s(file.fileName)+"\n                        ")])],1)}),0):_vm._e(),_vm._v(" "),(_vm.joinFile)?_c('vue-dropzone',{ref:"filesDZ",attrs:{"id":"files-dz","options":_vm.getDropzoneOptions('file'),"auto-process-queue":false},on:{"vdropzone-files-added":_vm.handleDzFileAdded,"vdropzone-file-added-manually":_vm.handleDzFileAdded,"vdropzone-complete":_vm.handleDzFileCompleted}}):_vm._e()],1),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_files_share_no_api'),expression:"'lives_fo_files_share_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_fo_files_share_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foFilesShare),callback:function ($$v) {_vm.$set(_vm.form, "foFilesShare", $$v)},expression:"form.foFilesShare"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files')))]),_vm._v(" "),(_vm.form.foFilesShare)?_c('b-form-group',[_c('b-form-checkbox',{model:{value:(_vm.form.doc_public),callback:function ($$v) {_vm.$set(_vm.form, "doc_public", $$v)},expression:"form.doc_public"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files_live_event.text'))+"\n                            "),_c('span',{staticStyle:{"color":"#62626b"}},[_vm._v("\n                              "+_vm._s(_vm.$t(
                                  'form_live.tabs.frontOffice.options.sharing_files_live_event.explanation'
                                ))+"\n                            ")])]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.doc_public_mail),callback:function ($$v) {_vm.$set(_vm.form, "doc_public_mail", $$v)},expression:"form.doc_public_mail"}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files_emails')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.form.doc_private),callback:function ($$v) {_vm.$set(_vm.form, "doc_private", $$v)},expression:"form.doc_private"}},[_vm._v("\n                            "+_vm._s(_vm.$t(
                                'form_live.tabs.frontOffice.options.sharing_files_studio_live.text'
                              ))+"\n                            "),_c('span',{staticStyle:{"color":"#62626b"}},[_vm._v("\n                              "+_vm._s(_vm.$t(
                                  'form_live.tabs.frontOffice.options.sharing_files_studio_live.explanation'
                                ))+"\n                            ")])])],1):_vm._e()],1)])],1)],1)],2),_vm._v(" "),(
                _vm.hasPermission(
                  'lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api'
                )
              )?_c('b-tab',{attrs:{"has-permission":"lives_fo_like_no_api,lives_fo_chat_no_api,lives_fo_subscript_no_api,lives_fo_comment_no_api,lives_fo_files_share_no_api,lives_social_media_no_api"},on:{"click":function($event){_vm.initInfinitScrollVideos = true}}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"desktop"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                   Player\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_password_security_no_api','lives_fo_subscript_no_api'),expression:"'lives_password_security_no_api','lives_fo_subscript_no_api'"}],staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.access_page_direct')))]),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_password_security_no_api'),expression:"'lives_password_security_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_password_security_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",on:{"input":_vm.handleToggleSecured},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.mdp')))]),_vm._v(" "),(_vm.password)?_c('div',{staticClass:"sub-form-control"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"*****"},model:{value:(_vm.form.pwd),callback:function ($$v) {_vm.$set(_vm.form, "pwd", $$v)},expression:"form.pwd"}})],1):_vm._e()],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subscript_no_api'),expression:"'lives_fo_subscript_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_subscript_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foSubscript),callback:function ($$v) {_vm.$set(_vm.form, "foSubscript", $$v)},expression:"form.foSubscript"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.inscri_abonne')))]),_vm._v(" "),_c('div',{staticClass:"form-group"})],1)])],1),_vm._v(" "),_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'),expression:"'lives_fo_like_no_api','lives_fo_chat_no_api','lives_social_media_no_api'"}],staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.lecteur_video')))]),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api'),expression:"'lives_fo_like_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_like_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foLike),callback:function ($$v) {_vm.$set(_vm.form, "foLike", $$v)},expression:"form.foLike"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.like')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_chat_no_api'),expression:"'lives_fo_chat_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_chat_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.chat),callback:function ($$v) {_vm.$set(_vm.form, "chat", $$v)},expression:"form.chat"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.chat_empreinte')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_chat_no_api'),expression:"'lives_fo_chat_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_chat_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.privateChat),callback:function ($$v) {_vm.$set(_vm.form, "privateChat", $$v)},expression:"form.privateChat"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.privateChat_empreinte')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_social_media_no_api'),expression:"'lives_social_media_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_social_media_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.socialNetwork),callback:function ($$v) {_vm.socialNetwork=$$v},expression:"socialNetwork"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.title')))]),_vm._v(" "),(_vm.socialNetwork)?_c('div',{staticClass:"sub-form-control"},[_c('b-form-checkbox',{attrs:{"inline":true,"aria-label":"ddd"},model:{value:(_vm.form.foFacebook),callback:function ($$v) {_vm.$set(_vm.form, "foFacebook", $$v)},expression:"form.foFacebook"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.fb')))]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"inline":true},model:{value:(_vm.form.foYoutube),callback:function ($$v) {_vm.$set(_vm.form, "foYoutube", $$v)},expression:"form.foYoutube"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.social_media.youtube')))])],1):_vm._e()],1)])],1),_vm._v(" "),_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],staticClass:"primary"},[_vm._v("Questions")]),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_comment_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foComment),callback:function ($$v) {_vm.$set(_vm.form, "foComment", $$v)},expression:"form.foComment"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.title')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.foComment),expression:"form.foComment"},{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_confirmation_no_api'),expression:"'lives_fo_comment_confirmation_no_api'"}],staticClass:"sub-form-control",attrs:{"has-permission":"lives_fo_comment_confirmation_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.canCommentBeforeLive),callback:function ($$v) {_vm.$set(_vm.form, "canCommentBeforeLive", $$v)},expression:"form.canCommentBeforeLive"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.questionsBeforeLive')))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.foComment),expression:"form.foComment"},{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_confirmation_no_api'),expression:"'lives_fo_comment_confirmation_no_api'"}],staticClass:"sub-form-control",attrs:{"has-permission":"lives_fo_comment_confirmation_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.isCommentValidation),callback:function ($$v) {_vm.$set(_vm.form, "isCommentValidation", $$v)},expression:"form.isCommentValidation"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.confirm')))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.foComment),expression:"form.foComment"},{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_confirmation_no_api'),expression:"'lives_fo_comment_confirmation_no_api'"}],staticClass:"sub-form-control",attrs:{"has-permission":"lives_fo_comment_confirmation_no_api"}},[_c('b-form-checkbox',{model:{value:(_vm.form.canReplyToComments),callback:function ($$v) {_vm.$set(_vm.form, "canReplyToComments", $$v)},expression:"form.canReplyToComments"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.replies')))])],1)],1)])],1),_vm._v(" "),_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subtitles_no_api'),expression:"'lives_fo_subtitles_no_api'"}],staticClass:"primary",attrs:{"has-permission":"lives_fo_subtitles_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.sous_titrage')))]),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subtitles_no_api','lives_fo_auto_transcription'),expression:"'lives_fo_subtitles_no_api','lives_fo_auto_transcription'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_subtitles_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foSubtitles),callback:function ($$v) {_vm.$set(_vm.form, "foSubtitles", $$v)},expression:"form.foSubtitles"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.subtitles_empreinte')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_auto_transcription'),expression:"'lives_fo_auto_transcription'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_fo_auto_transcription"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.autoTranscription),callback:function ($$v) {_vm.$set(_vm.form, "autoTranscription", $$v)},expression:"form.autoTranscription"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.autoTranscription_empreinte')))])],1)])],1),_vm._v(" "),(_vm.hasPermission('lives_fo_whiteboard_no_api') || _vm.hasPermission('lives_fo_poll_no_api') || _vm.hasPermission('lives_fo_question_no_api') || _vm.hasPermission('lives_fo_excel_no_api'))?_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.title')))]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('div',[_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_whiteboard_no_api'),expression:"'lives_fo_whiteboard_no_api'"}],attrs:{"has-permission":"lives_fo_whiteboard_no_api","inline":true,"aria-label":"ddd"},model:{value:(_vm.form.whiteboard),callback:function ($$v) {_vm.$set(_vm.form, "whiteboard", $$v)},expression:"form.whiteboard"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.whiteBoard')))]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_poll_no_api'),expression:"'lives_fo_poll_no_api'"}],attrs:{"has-permission":"lives_fo_poll_no_api","inline":true},model:{value:(_vm.form.poll),callback:function ($$v) {_vm.$set(_vm.form, "poll", $$v)},expression:"form.poll"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.survey')))]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_question_no_api'),expression:"'lives_fo_question_no_api'"}],attrs:{"has-permission":"lives_fo_question_no_api","inline":true},model:{value:(_vm.form.qna),callback:function ($$v) {_vm.$set(_vm.form, "qna", $$v)},expression:"form.qna"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.question')))]),_vm._v(" "),_c('b-form-checkbox',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_excel_no_api'),expression:"'lives_fo_excel_no_api'"}],attrs:{"has-permission":"lives_fo_excel_no_api","inline":true},model:{value:(_vm.form.spreadsheet_excel),callback:function ($$v) {_vm.$set(_vm.form, "spreadsheet_excel", $$v)},expression:"form.spreadsheet_excel"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.excel')))]),_vm._v(" "),(_vm.isEmpreintePollClient)?_c('b-form-checkbox',{attrs:{"inline":true},model:{value:(_vm.form.autoSip),callback:function ($$v) {_vm.$set(_vm.form, "autoSip", $$v)},expression:"form.autoSip"}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.autoSip'))+"\n                        ")]):_vm._e()],1)])])],1)],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_post_add'),expression:"'lives_conf_post_add'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_post_add"}},[_c('label',{staticClass:"primary conf-label"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.title')))]),_vm._v(" "),_c('b-form-group',[_c('b-form-radio-group',{model:{value:(_vm.form.defaultConf),callback:function ($$v) {_vm.$set(_vm.form, "defaultConf", $$v)},expression:"form.defaultConf"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.default')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.title')))])],1)],1)],1),_vm._v(" "),(!_vm.form.defaultConf)?_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_post_add'),expression:"'lives_conf_post_add'"}],staticClass:"custom-configuration",attrs:{"has-permission":"lives_conf_post_add"}},[_c('div',{staticClass:"form-group"},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_message_option'),expression:"'lives_conf_message_option'"}],attrs:{"value":"Message","has-permission":"lives_conf_message_option"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.message.title')))]),_vm._v(" "),_c('textarea',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.conf.type === 'Message'),expression:"form.conf.type === 'Message'"},{name:"model",rawName:"v-model",value:(_vm.form.conf.message),expression:"form.conf.message"}],staticClass:"form-control",attrs:{"rows":"5","maxlength":"255","placeholder":_vm.$t(
                        'form_live.tabs.frontOffice.configuration.personalized.message.description'
                      ),"required":""},domProps:{"value":(_vm.form.conf.message)},on:{"keyup":function($event){return _vm.removeError($event)},"focus":function($event){return _vm.removeError($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "message", $event.target.value)}}}),_vm._v(" "),(this.showErrorMessage)?_c('div',{staticClass:"error_message"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.error_long_message'))+"\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.conf.message.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                  ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_video_option'),expression:"'lives_conf_video_option'"}],attrs:{"value":"Video","has-permission":"lives_conf_video_option"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.video.title')))]),_vm._v(" "),(!_vm.isBeforeLiveVideoPickerVisible && _vm.form.conf.type === 'Video')?_c('div',[_c('div',{staticClass:"before-live-video-container"},[_c('figure',[_c('div',{staticClass:"before-live-video-container__overlay"},[_c('font-awesome-icon',{attrs:{"icon":"play-circle"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-sm before-live-video-container__btn",on:{"click":_vm.toggleBeforeLiveVideoPicker}},[_c('font-awesome-icon',{attrs:{"icon":"pencil-alt"}}),_vm._v("\n                          Changer la source\n                        ")],1),_vm._v(" "),_c('b-img',{attrs:{"src":_vm.form.videoBeforeLive.logo,"fluid":"","alt":_vm.form.videoBeforeLive.title}})],1),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.form.videoBeforeLive.title))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.conf.video),expression:"form.conf.video"}],staticClass:"form-control",attrs:{"type":"text","required":"","hidden":""},domProps:{"value":(_vm.form.conf.video)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "video", $event.target.value)}}}),_vm._v(" "),(
                        _vm.form.conf.type === 'Video' &&
                          _vm.initInfinitScrollVideos &&
                          _vm.isBeforeLiveVideoPickerVisible
                      )?_c('div',{staticClass:"video-picker-wrapper"},[_c('div',{staticClass:"search-wrapper position-relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchVideoKeyword),expression:"searchVideoKeyword"}],staticClass:"form-control mb-15",attrs:{"placeholder":_vm.$t(
                              'form_live.tabs.frontOffice.configuration.personalized.video.description'
                            ),"type":"text"},domProps:{"value":(_vm.searchVideoKeyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchVideo.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchVideoKeyword=$event.target.value}}}),_vm._v(" "),_c('b-button',{staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.searchVideo}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"video-slides-wrapper"},[_c('VuePerfectScrollbar',{ref:"ps",staticClass:"scroll-area",on:{"ps-y-reach-end":_vm.handlePageChanged}},[_c('b-row',_vm._l((_vm.slidesChips),function(slide,index){return _c('b-col',{key:slide.id,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('div',{staticClass:"mb-3"},[_c('figure',[_c('div',{staticClass:"video-overlay",class:{ in: slide.id === _vm.form.conf.video }},[_c('button',{staticClass:"btn",class:slide.id === _vm.form.conf.video
                                          ? 'btn-light'
                                          : 'btn-outline-light',on:{"click":function($event){return _vm.selectVideo(slide)}}},[_vm._v("\n                                      "+_vm._s(_vm.$t('parameters.select.selectOption'))+"\n                                    ")])]),_vm._v(" "),_c('b-img',{attrs:{"src":slide.thumbnail,"fluid":"","alt":slide.title}})],1),_vm._v(" "),_c('div',{staticClass:"video-name",class:{ selected: slide.id === _vm.form.conf.video },attrs:{"title":slide.title}},[_vm._v("\n                                  "+_vm._s(slide.title)+"\n                                ")])])])}),1),_vm._v(" "),(_vm.isLoading('videos'))?_c('div',[_c('div',{staticClass:"sk-circle"},[_c('div',{staticClass:"sk-circle1 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-child"})])]):_vm._e(),_vm._v(" "),(_vm.isEndReached('videos') && _vm.slidesChips.length === 0)?_c('h5',{staticClass:"c-grey-700 font-weight-bolder m-3 text-center"},[_vm._v("\n                            Pas de vidéos\n                          ")]):_vm._e()],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.$v.form.conf.video.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.pick_video'))+"\n                    ")]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_image_option'),expression:"'lives_conf_image_option'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_image_option"}},[_c('b-form-radio',{attrs:{"value":"Image"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.image')))])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.conf.type === 'Image'),expression:"form.conf.type === 'Image'"}]},[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('b-form-group',{attrs:{"description":_vm.$t('form_live.tabs.general.form.description_image'),"label-for":"before-live-thumbnail"}},[_c('thumbnail-cropper',{attrs:{"crop-img":_vm.form.conf.image},on:{"thumbnailUpdated":_vm.handleBeforeLivePosterUpdated}})],1),_vm._v(" "),_c('div',[_c('b-form-checkbox',{attrs:{"name":"check-button","switch":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("\n                       Switch Checkbox "),_c('b',[_vm._v("(Checked: "+_vm._s(_vm.checkedSwitch)+")")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"before-live-image-description"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.text_before_live')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.conf.imageText),expression:"form.conf.imageText"}],staticClass:"form-control",attrs:{"id":"before-live-image-description","placeholder":_vm.$t('form_live.tabs.frontOffice.configuration.personalized.text'),"rows":"5"},domProps:{"value":(_vm.form.conf.imageText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "imageText", $event.target.value)}}})])])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_counter_option'),expression:"'lives_conf_counter_option'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_counter_option"}},[_c('b-form-radio',{attrs:{"value":"Counter"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.configuration.personalized.countdown')))])],1)],1):_vm._e()],2):_vm._e(),_vm._v(" "),(this.isPermission.lives_conf_program || this.isSuperAdmin)?_c('b-tab',{attrs:{"has-permission":"lives_conf_program"}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"users"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2",attrs:{"has-permission":"lives_conf_program"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.new_title')))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"LiveProgram"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.LiveProgram')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.live_program),expression:"form.live_program"}],staticClass:"form-control",staticStyle:{"width":"45%"},attrs:{"id":"LiveProgram","placeholder":_vm.$t('form_live.tabs.Program.LiveProgramDescription'),"rows":"3"},domProps:{"value":(_vm.form.live_program)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "live_program", $event.target.value)}}})]),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"md":"6","sm":"12"}},[(this.isPermission.lives_conf_add_participant_limit || this.isSuperAdmin)?_c('div',{staticStyle:{"width":"40%"},attrs:{"has-permission":"lives_conf_add_participant_limit"}},[_c('b-row',{staticClass:"d-flex"},[_c('span',[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.ParticpantsLimit'))+" ")]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"ml-2",attrs:{"name":"check-button","switch":""},model:{value:(_vm.checkedLimit),callback:function ($$v) {_vm.checkedLimit=$$v},expression:"checkedLimit"}})],1),_vm._v(" "),(_vm.checkedLimit)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",staticStyle:{"font-size":"12px","color":"gray"},attrs:{"for":"nameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.MaxParticipantsDistance')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"type":"number","min":"0","id":"inline-form-input-MaxParticipantsDistance","placeholder":_vm.$t('form_live.tabs.Program.MaxParticipantsDistance')},on:{"keydown":function($event){return _vm.portKeydown($event)}},model:{value:(_vm.form.max_online_guests),callback:function ($$v) {_vm.$set(_vm.form, "max_online_guests", _vm._n($$v))},expression:"form.max_online_guests"}})],1)],1):_vm._e(),(_vm.checkedLimit)?_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",staticStyle:{"font-size":"12px","color":"gray"},attrs:{"for":"nameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.MaxInvited')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0"},[_c('b-form-input',{attrs:{"type":"number","min":"0","id":"inline-form-input-MaxInvited","placeholder":_vm.$t('form_live.tabs.Program.MaxInvited')},on:{"keydown":function($event){return _vm.portKeydown($event)}},model:{value:(_vm.form.max_onsite_guests),callback:function ($$v) {_vm.$set(_vm.form, "max_onsite_guests", _vm._n($$v))},expression:"form.max_onsite_guests"}})],1)],1)],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('div',{staticClass:"form-group"},[(!_vm.$v.form.description.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('label',{staticClass:"primary",attrs:{"for":"Participants"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Intervenants')))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"ml-2",attrs:{"name":"check-button","switch":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1),_vm._v(" "),(_vm.checked)?_c('b-button',{staticClass:"mt-2",attrs:{"id":"show-btn"},on:{"click":_vm.showModal}},[_vm._v("\n                      "+_vm._s(_vm.$t('form_live.tabs.Program.AddParticipant'))+"\n                    ")]):_vm._e()],1),_vm._v(" "),_c('b-list-group',{staticClass:"mb-2"},_vm._l((_vm.intervenants),function(intervenant,index){return _c('b-list-group-item',{key:index,staticClass:"d-flex justify-content-between",staticStyle:{"margin-bottom":"12px"}},[(intervenant.avatar.length > 1)?_c('img',{staticStyle:{"width":"75px","border-radius":"50%"},attrs:{"src":_vm.cleanedAvatarUrl(intervenant.avatar)}}):_c('b-avatar',{staticStyle:{"width":"85px","background-color":"#007bff","border-radius":"50%","display":"flex","justify-content":"center","align-items":"center","font-size":"26px","padding":"15px","font-weight":"bold","color":"white"},attrs:{"variant":"primary","text":"BV"}},[_vm._v(_vm._s(intervenant.name[0].toUpperCase())+_vm._s(intervenant.lastName[0].toUpperCase()))]),_vm._v(" "),_c('div',{staticClass:"intervenant",staticStyle:{"width":"85%"}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"mb-1"},[_vm._v(_vm._s(intervenant.name)+" "+_vm._s(intervenant.lastName))])]),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('small',[_vm._v(_vm._s(intervenant.mail))])])]),_vm._v(" "),_c('div',{staticClass:"speaker-btns"},[_c('b-button',{attrs:{"variant":"light","pill":""},on:{"click":function($event){return _vm.deleteInter(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"light","pill":""},on:{"click":function($event){return _vm.openModelForUpdate(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"edit"}})],1)],1)],1)}),1),_vm._v(" "),_c('b-modal',{ref:"my-modal",attrs:{"hide-footer":"","title":_vm.update || _vm.updateModal ? _vm.$t('form_live.tabs.Program.editParticipant') : _vm.$t('form_live.tabs.Program.AddParticipant')},on:{"hidden":_vm.closeModel}},[_c('b-form',{ref:"formIntervenant"},[_c('label',{staticClass:"required primary",attrs:{"for":"LiveProgram"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Photo')))]),_vm._v(" "),_c('div',{staticClass:"Image-upload-container"},[_c('div',{staticClass:"image-container",on:{"click":_vm.inputFile}},[_c('b-form-file',{ref:"File",attrs:{"id":"file-default","hidden":"","accept":"image/*"},on:{"change":_vm.changeInput},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_vm._v(" "),(!_vm.url && !_vm.showDelete)?_c('div',{staticClass:"upload-button"},[_c('span',[_c('img',{attrs:{"src":_vm.uploadImage,"alt":"upload Icon"}})]),_vm._v(" "),_c('span',{staticClass:"clickable-text"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Cliquez')))])]):_vm._e(),_vm._v(" "),(_vm.PendingUpload)?_c('font-awesome-icon',{staticClass:"loading-icon",attrs:{"icon":"spinner","spin":""}}):_vm._e(),_vm._v(" "),(_vm.url)?_c('img',{staticClass:"uploaded-image",attrs:{"src":_vm.url,"alt":"Downloaded Image"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"image-info"},[(_vm.showDelete)?_c('font-awesome-icon',{staticClass:"trash-icon",attrs:{"icon":"trash"},on:{"click":_vm.deleteImageIntervenant}}):_vm._e()],1)]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"nameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Nom'))+"\n                          "),_c('span',{staticClass:"required-star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-name","placeholder":_vm.$t('form_live.tabs.Program.Nom'),"required":""},model:{value:(_vm.form.nom),callback:function ($$v) {_vm.$set(_vm.form, "nom", $$v)},expression:"form.nom"}})],1),_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"lastnameIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Prenom'))+"\n                         "),_c('span',{staticClass:"required-star"},[_vm._v("*")])]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0"},[_c('b-form-input',{attrs:{"id":"inline-form-input-username","placeholder":_vm.$t('form_live.tabs.Program.Prenom'),"required":""},model:{value:(_vm.form.lastName),callback:function ($$v) {_vm.$set(_vm.form, "lastName", $$v)},expression:"form.lastName"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"fonctionIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Fonction')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-name","placeholder":_vm.$t('form_live.tabs.Program.Fonction')},model:{value:(_vm.form.fonction),callback:function ($$v) {_vm.$set(_vm.form, "fonction", $$v)},expression:"form.fonction"}})],1),_c('b-col',{attrs:{"cols":"6"}},[_c('label',{staticClass:"required primary",attrs:{"for":"StructureIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Structure')))]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2 mr-sm-2 mb-sm-0"},[_c('b-form-input',{attrs:{"id":"inline-form-input-username","placeholder":_vm.$t('form_live.tabs.Program.Structure')},model:{value:(_vm.form.structure),callback:function ($$v) {_vm.$set(_vm.form, "structure", $$v)},expression:"form.structure"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",attrs:{"for":"roleIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Role')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-name","placeholder":_vm.$t('form_live.tabs.Program.Role')},model:{value:(_vm.form.role),callback:function ($$v) {_vm.$set(_vm.form, "role", $$v)},expression:"form.role"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",attrs:{"for":"descriptionIntervernant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.Description),expression:"form.Description"}],staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"id":"inline-form-input-name","rows":"3","placeholder":_vm.$t('form_live.tabs.Program.Description')},domProps:{"value":(_vm.form.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "Description", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('label',{staticClass:"required primary",attrs:{"for":"EmailIntervenant"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.Program.Email')))]),_vm._v(" "),_c('b-form-input',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"inline-form-input-email","placeholder":_vm.$t('form_live.tabs.Program.Email')},model:{value:(_vm.form.mail),callback:function ($$v) {_vm.$set(_vm.form, "mail", $$v)},expression:"form.mail"}}),_vm._v(" "),(_vm.form.mail && _vm.emailError)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.emailError))]):_vm._e()],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-divider'),_vm._v(" "),_c('b-button',{staticClass:"mr-2",attrs:{"variant":"light","type":"button"},on:{"click":_vm.closeModel}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),(_vm.updateModal)?_c('b-button',{staticClass:"outlined-black",attrs:{"variant":"primary","color":"gray","disabled":_vm.PendingUpload || _vm.$v.form.$error},on:{"mousedown":_vm.ManageIntervenant}},[_vm._v(_vm._s(_vm.$t('button.edit')))]):_vm._e(),_vm._v(" "),(!_vm.update && !_vm.updateModal)?_c('b-button',{staticClass:"outlined-black",attrs:{"variant":"primary","color":"gray","disabled":_vm.PendingUpload || _vm.$v.form.$error},on:{"mousedown":_vm.ManageIntervenant}},[_vm._v(_vm._s(_vm.$t('button.save')))]):_vm._e(),_vm._v(" "),(_vm.update)?_c('b-button',{staticClass:"outlined-black",attrs:{"variant":"primary","disabled":_vm.PendingUpload || _vm.$v.form.$error},on:{"mousedown":_vm.ManageIntervenant}},[_vm._v(_vm._s(_vm.$t('button.edit')))]):_vm._e()],1)],1)],1)],1)],2):_vm._e(),_vm._v(" "),(this.isPermission.lives_skin || this.isSuperAdmin)?_c('b-tab',{attrs:{"has-permission":"lives_skin"}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"palette"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.new_title')))])]),_vm._v(" "),_c('div',{staticClass:"form-group mt-3"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.selectOrCreate')))]),_vm._v(" "),_c('b-form-select',{staticClass:"w-50",attrs:{"options":_vm.skinOptions},on:{"change":_vm.onSelectSkin},model:{value:(_vm.skinForm.selectedSkin),callback:function ($$v) {_vm.$set(_vm.skinForm, "selectedSkin", $$v)},expression:"skinForm.selectedSkin"}}),_vm._v(" "),_c('small',{staticClass:"text-muted d-block mt-1"},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.explanation'))+"\n    ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.skinForm.selectedSkin)?_c('div',[(!_vm.skinIsEditMode)?_c('h5',{staticClass:"mt-4 mb-3"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.newSkin')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.primaryColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.primary_color),expression:"skinForm.skin.primary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.primary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "primary_color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.secondaryColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.secondary_color),expression:"skinForm.skin.secondary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.secondary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "secondary_color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.primaryTextColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.text_primary_color),expression:"skinForm.skin.text_primary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.text_primary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "text_primary_color", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-6 mb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.secondaryTextColor')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.text_secondary_color),expression:"skinForm.skin.text_secondary_color"}],staticClass:"form-control p-1",staticStyle:{"height":"38px"},attrs:{"type":"color"},domProps:{"value":(_vm.skinForm.skin.text_secondary_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "text_secondary_color", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-6"},[_c('div',{staticClass:"custom-file-wrapper"},[_c('button',{staticClass:"btn-upload",attrs:{"type":"button","disabled":_vm.uploading.logo},on:{"click":function($event){return _vm.$refs.logoInput.click()}}},[(_vm.uploading.logo)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.logo'))+"\n    ")],1),_vm._v(" "),_c('input',{ref:"logoInput",staticClass:"hidden-file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":function (e) { return _vm.uploadLogo(e, 'logo'); }}})]),_vm._v(" "),(_vm.skinForm.skin.logoPreview)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"image-preview-wrapper position-relative d-inline-block"},[_c('img',{staticClass:"logo-preview",class:{ 'is-loading': _vm.uploading.logo },attrs:{"src":_vm.skinForm.skin.logoPreview,"alt":"Logo preview"}}),_vm._v(" "),(_vm.uploading.logo)?_c('div',{staticClass:"preview-overlay"},[_c('b-spinner')],1):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-6 pr-md-4 mb-4"},[_c('h6',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.beforeLiveInfo')))]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.infoText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.before.info_text),expression:"skinForm.skin.before.info_text"}],staticClass:"form-control w-100",attrs:{"rows":"2"},domProps:{"value":(_vm.skinForm.skin.before.info_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin.before, "info_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-flex mb-2"},[_c('div',{staticClass:"mr-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.showDate')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.before.show_date),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.before, "show_date", $$v)},expression:"skinForm.skin.before.show_date"}})],1),_vm._v(" "),_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.showHour')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.before.show_hour),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.before, "show_hour", $$v)},expression:"skinForm.skin.before.show_hour"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"custom-file-wrapper"},[_c('button',{staticClass:"btn-upload",attrs:{"type":"button","disabled":_vm.uploading.before},on:{"click":function($event){return _vm.$refs.beforeInput.click()}}},[(_vm.uploading.before)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.backgroundImage'))+"\n    ")],1),_vm._v(" "),_c('input',{ref:"beforeInput",staticClass:"hidden-file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":function (e) { return _vm.uploadBackground(e, 'before'); }}})]),_vm._v(" "),(_vm.skinForm.skin.before.backgroundPreview)?_c('div',{staticClass:"mt-2 position-relative"},[_c('div',{staticClass:"image-preview-wrapper position-relative d-inline-block"},[_c('img',{staticClass:"bg-preview",class:{ 'is-loading': _vm.uploading.before },attrs:{"src":_vm.skinForm.skin.before.backgroundPreview,"alt":"Before background"}}),_vm._v(" "),(_vm.uploading.before)?_c('div',{staticClass:"preview-overlay"},[_c('b-spinner')],1):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.before.background_blur),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.before, "background_blur", $$v)},expression:"skinForm.skin.before.background_blur"}},[_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.SkinModel.blurred'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 pl-md-4"},[_c('h6',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.afterLiveInfo')))]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.SkinModel.infoText')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.after.info_text),expression:"skinForm.skin.after.info_text"}],staticClass:"form-control w-100",attrs:{"rows":"2"},domProps:{"value":(_vm.skinForm.skin.after.info_text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin.after, "info_text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"custom-file-wrapper"},[_c('button',{staticClass:"btn-upload",attrs:{"type":"button","disabled":_vm.uploading.after},on:{"click":function($event){return _vm.$refs.afterInput.click()}}},[(_vm.uploading.after)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.backgroundImage'))+"\n    ")],1),_vm._v(" "),_c('input',{ref:"afterInput",staticClass:"hidden-file-input",attrs:{"type":"file","accept":"image/*"},on:{"change":function (e) { return _vm.uploadBackground(e, 'after'); }}})]),_vm._v(" "),(_vm.skinForm.skin.after.backgroundPreview)?_c('div',{staticClass:"mt-2 position-relative"},[_c('div',{staticClass:"image-preview-wrapper position-relative d-inline-block"},[_c('img',{staticClass:"bg-preview",class:{ 'is-loading': _vm.uploading.after },attrs:{"src":_vm.skinForm.skin.after.backgroundPreview,"alt":"After background"}}),_vm._v(" "),(_vm.uploading.after)?_c('div',{staticClass:"preview-overlay"},[_c('b-spinner')],1):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.skinForm.skin.after.background_blur),callback:function ($$v) {_vm.$set(_vm.skinForm.skin.after, "background_blur", $$v)},expression:"skinForm.skin.after.background_blur"}},[_vm._v("\n          "+_vm._s(_vm.$t('form_live.tabs.SkinModel.blurred'))+"\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"mt-4 row d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"col-md-8 applied-skin-message"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.skinIsEditMode),expression:"skinIsEditMode"}]},[_vm._v("\n      "+_vm._s(_vm.$t('form_live.tabs.SkinModel.editNote'))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 d-flex justify-content-end align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skinForm.skin.name),expression:"skinForm.skin.name"}],staticClass:"form-control mr-2",staticStyle:{"width":"220px"},attrs:{"type":"text","placeholder":_vm.$t('form_live.tabs.SkinModel.skinName')},domProps:{"value":(_vm.skinForm.skin.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.skinForm.skin, "name", $event.target.value)}}})])])]):_vm._e()],2):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buttons-wrapper d-none d-lg-block"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"light","type":"button"},on:{"click":_vm.goToListLive}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","type":"submit","has-permission":"lives_post_edit","disabled":_vm.$v.form.$error  ||_vm.btnDisabled || (!_vm.confirmClicked && _vm.imageIsPicked) || _vm.openTimeModal},on:{"mousedown":_vm.submitForm}},[_vm._v(_vm._s(_vm.$t('button.save')))])],1)],1)])],1),_vm._v(" "),_c('b-modal',{ref:"modal-start-direct",attrs:{"title":_vm.$t('startDirect.title'),"id":"modal-start-direct","header-bg-variant":_vm.headerBgVariant,"hide-footer":"","size":"lg"},on:{"hide":function($event){return _vm.redirectTo()}}},[_c('div',{staticClass:"subTitle"},[_vm._v(" "+_vm._s(_vm.$t('startDirect.subtitle'))+" ")]),_vm._v(" "),_c('div',{staticClass:"action-start-direct"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary","type":"button"},on:{"click":function($event){return _vm.redirectTo(true)}}},[_vm._v(_vm._s(_vm.$t('startDirect.btn.YES')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"light","type":"button"},on:{"click":function($event){return _vm.redirectToLives()}}},[_vm._v(_vm._s(_vm.$t('startDirect.btn.NO')))])],1),_vm._v(" "),_c('div',{staticClass:"action-choix"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_vm._v("\n            "+_vm._s(_vm.$t('startDirect.choix'))+"\n          ")])],1)])])],1)}
var LiveForm_staticRenderFns = []
var LiveForm_esExports = { render: LiveForm_render, staticRenderFns: LiveForm_staticRenderFns }
/* harmony default export */ var components_LiveForm = (LiveForm_esExports);
// CONCATENATED MODULE: ./src/components/LiveForm.vue
function LiveForm_injectStyle (ssrContext) {
  __webpack_require__("SWQt")
}
var LiveForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LiveForm___vue_template_functional__ = false
/* styles */
var LiveForm___vue_styles__ = LiveForm_injectStyle
/* scopeId */
var LiveForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LiveForm___vue_module_identifier__ = null
var LiveForm_Component = LiveForm_normalizeComponent(
  LiveForm,
  components_LiveForm,
  LiveForm___vue_template_functional__,
  LiveForm___vue_styles__,
  LiveForm___vue_scopeId__,
  LiveForm___vue_module_identifier__
)

/* harmony default export */ var src_components_LiveForm = (LiveForm_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-timepicker/dist/VueTimepicker.common.js
var VueTimepicker_common = __webpack_require__("B2B0");
var VueTimepicker_common_default = /*#__PURE__*/__webpack_require__.n(VueTimepicker_common);

// EXTERNAL MODULE: ./node_modules/@ckeditor/ckeditor5-build-decoupled-document/build/ckeditor.js
var build_ckeditor = __webpack_require__("YV2/");
var build_ckeditor_default = /*#__PURE__*/__webpack_require__.n(build_ckeditor);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LiveFormV2.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import * as lang from 'vuejs-datepicker/src/locale';





























//import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
//import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';




var LiveFormV2_moment = __webpack_require__("PJh5");
/* harmony default export */ var LiveFormV2 = ({
  name: 'LiveForm',
  mixins: [UploadMixin, UtilsMixin],
  components: {
    Datepicker: vue2_datepicker_lib_default.a,
    VueClockPicker: vue2_clock_picker_es_default.a,
    InputTag: vueInputTag_common_default.a,
    QuestionForm: components_components_QuestionForm,
    VuePerfectScrollbar: dist_default.a,
    Carousel: vue_carousel_min["Carousel"],
    Slide: vue_carousel_min["Slide"],
    Multiselect: vue_multiselect_min_default.a,
    draggable: vuedraggable_umd_default.a,
    ThumbnailCropper: components_components_ThumbnailCropper,
    vueDropzone: vue2Dropzone_default.a,
    InfiniteLoading: vue_infinite_loading_default.a,
    ckeditor: ckeditor_default.a.component,
    VueTimepicker: VueTimepicker_common_default.a
  },
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  directives: {
    HasPermission: HasPermission
  },
  validations: {
    form: {
      title: { required: lib_validators["required"] },
      description: { required: lib_validators["required"] },
      /*duration: {
        required: requiredIf(function(nestedModel) {
          return this.show_start_date;
        })
      },*/
      startDate: {
        required: Object(lib_validators["requiredIf"])(function (nestedModel) {
          return this.show_start_date;
        })
        // minValue: value => {
        //   const today = new Date();
        //   let yesterday = new Date();
        //   yesterday.setDate(today.getDate() - 1);
        //
        //   if(!this.show_start_date){
        //     return true
        //   }else{
        //   return new Date(value) > yesterday;
        //   }
        // },
      },
      startTime: {
        required: Object(lib_validators["requiredIf"])(function (nestedModel) {
          return this.show_start_date;
        })
        // minValue(value) {
        //   if(!this.show_start_date){
        //     return true
        //   }else{
        //     if (moment().isSame(this.form.startDate, 'day')) {
        //       const beginningTime = moment(this.form.startTime, 'HH:mm');
        //       return moment().isBefore(beginningTime);
        //     }
        //     return true;
        //   }
        // },

        /* beforeHour: {
           required: requiredIf(function(nestedModel) {
             return this.show_start_date;
           }),
           minValue(value) {
             if (moment().isSame(this.form.beforeHour, 'day')) {
               const beginningTime = moment(this.form.beforeHour, 'HH:mm');
               return moment().isBefore(beginningTime);
             }
             return true;
           },
         }*/
      }, /* endTime: {
            required: requiredIf(function(nestedModel) {
              return this.show_start_date;
            }),
            minValue(value) {
              const endTime = moment(value, 'HH:mm', true);
              const startTime = moment(this.form.startTime, 'HH:mm', true);
               if(!this.show_start_date){
                return true
              }else{
              return endTime > startTime;}
            },
          },*/
      conf: {
        message: {
          required: Object(lib_validators["requiredIf"])(function (nestedModel) {
            return this.form.conf.type === 'Message';
          })
        },
        video: {
          required: Object(lib_validators["requiredIf"])(function (nestedModel) {
            return this.form.conf.type === 'Video';
          })
        }
      },
      survey: {
        required: Object(lib_validators["requiredIf"])(function (nestedModel) {
          return this.form.foSondage;
        })
      }
    },
    intervenant: {
      lastName: { required: lib_validators["required"] },
      firstName: { required: lib_validators["required"] }
    }
  },
  data: function data() {
    var _this = this;

    return {
      currentNameGroup: null,
      currentIdGroup: null,
      oneMail: null,
      show_list_mail: false,
      show_start_date: true,
      show_automatic_archiving: false,
      customheaderBgVariant: 'custom-secondary',
      status: false,
      currentLive: {},
      imgSrc: '',
      cropImg: '',
      form: {
        duration: null,
        title: '',
        description: '',
        startDate: new Date(),
        startTime: LiveFormV2_moment().format('HH:mm'),
        endTime: LiveFormV2_moment().add(1, 'hours').format('HH:mm'),
        tags: [],
        isCdn: true,
        screenShare: false,
        webinar: true,
        screenType: 'pip',
        chapters: [],
        questions: [],
        files: [],
        foFilesShare: false,
        slides: [],
        defaultConf: true,
        secureAccess: false,
        conf: {
          type: null
        },
        diffusion: 'webinar',
        videoBeforeLive: null,
        autoPub: false,
        shareLive: '',
        contact: {
          email: '',
          phone: '',
          address: ''
        },

        allIntervenants: [],
        editor: {
          dataAbout: ''
        },
        idTemplate: 0,
        encodingUrl: 'test',
        encodingName: 'test',
        encodingKey: 'test',
        nbDays: 1,
        beforeHour: LiveFormV2_moment().format('HH:mm'),
        emails: [],
        groupEmails: [],
        doc_public: false,
        autoSip: false,
        rules: [{
          nbDays: 1,
          beforeHour: LiveFormV2_moment().format('HH:mm')
        }]
      },
      intervenant: {
        lastName: '',
        firstName: '',
        fonction: '',
        bibliography: '',
        email: ''
      },
      searchVideoKeyword: '',
      submitButtonClicked: false,
      requiredMessage: i18n.t('form_live.tabs.required_message'),
      screenTypeOptions: [{ value: 'pip', text: 'Picture in Picture PIP' }, { value: 'sbs', text: 'Side by Side' }],
      newChapter: '',
      currentPageQuestion: 1,
      addQuestionMode: false,
      showAllSlides: false,
      joinFile: false,
      socialNetwork: false,
      password: false,
      //languages: lang,
      initialLocaleCode: 'fr',
      isEditMode: false,
      slideIndex: -1,
      showCarousel: false,
      ready: false,
      pastDates: {},
      isBeforeLiveVideoPickerVisible: true,
      initInfinitScrollVideos: false,
      chapterTitle: '',
      shortcuts: [{
        text: 'Today',
        onClick: function onClick() {
          _this.time3 = [new Date(), new Date()];
        }
      }],
      disabledConfigFO: false,
      tabs: ['general', 'configuration'],
      activeTab: 'general',
      allTemplates: [],
      isSelectedTheme: false,
      showMoreTemplates: false,
      showLessTemplates: false,
      showText: 'more',
      nb_rest: 0,
      nameState: null,
      headerBgVariant: 'header-secondary',
      okButtonBgVariant: 'primary',
      editor: build_ckeditor_default.a,
      editorConfig: {},
      showLiveToolip: false,
      showErrorMessage: false,
      liveDocuments: [],
      pendingLiveDocuments: [],
      documentsLoading: false,
      documentsUploading: false,
      documentsDeletingId: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    live: 'lives/getSelected',
    contributorsOptions: 'lives/getContributors',
    channelsOptions: 'lives/getChannels',
    surveyOptions: 'form/getSurveys',
    slidesChips: 'form/getVideos',
    isEndReached: 'form/getEndReached',
    isLoading: 'form/getLoading',
    hasPermission: 'common/hasPermission',
    getDiffusion: 'common/getDiffusion',
    getDiffusionObject: 'lives/getDiffusionObject',
    getAllSkinTemplates: 'lives/getAllSkinTemplates',
    getSubscriptionUser: 'lives/getSubscriptionUser',
    getSubscriptionGroupUsers: 'lives/getSubscriptionGroupUsers',
    isGroupExist: 'lives/isGroupExist',
    getlistMail: 'lives/getlistMail',
    getGroupById: 'lives/getGroupById'
  }), {
    isEmpreinteClient: function isEmpreinteClient() {
      return window.process.env.CLIENT_NAME === 'empreinte';
    },
    getDifferentDiffusionPermission: function getDifferentDiffusionPermission() {
      var _this2 = this;

      var permissions = [{ name: "webinar", permission: "lives_webinar_no_api" }, { name: "isPearl", permission: "lives_encoder_no_api" }, { name: "screenShare", permission: "lives_screen_share_no_api" }];
      var permissionsArray = [];
      permissions.forEach(function (p) {
        if (_this2.hasPermission(p.permission)) {
          permissionsArray.push(p);
        }
        _this2.form[p.name] = false;
        return p.permission;
      });
      if (permissionsArray.length > 0 && permissionsArray.length === 1) {
        this.form.diffusion = permissionsArray[0].name;
        this.form[permissionsArray[0].name] = true;
      } else {
        this.form[permissions[0].name] = true;
      }
    },
    getDiffusionPermission: function getDiffusionPermission() {
      if (this.currentLive.isPearl) {
        return "lives_pearl_diffuser_no_api";
      } else {
        return "lives_diffuser_no_api";
      }
    },

    listMailInStor: {
      get: function get() {
        return this.getlistMail;
      },
      set: function set(value) {
        //add and edit ListMail from TagInput in same Store
        this.setListMail(value);
      }
    },

    templates: function templates() {
      var _this3 = this;

      if (this.getAllSkinTemplates && keys_default()(this.getAllSkinTemplates).length > 0) {
        this.allTemplates = this.getAllSkinTemplates.filter(function (theme) {
          return theme.type === 'live';
        });
      }
      var allThemes = [];
      this.allTemplates.forEach(function (template, index) {
        if (index > 2 && !_this3.showMoreTemplates) {
          return;
        } else {
          if (allThemes.indexOf(template) === -1) {
            allThemes.push(template);
          }
        }
      });
      this.nb_rest = this.allTemplates.length - 3;
      return allThemes;
    },
    isChapterEditMode: function isChapterEditMode() {
      return this.form.chapters.some(function (c) {
        return c.isEditMode;
      });
    },
    isQuestionEditMode: function isQuestionEditMode() {
      return this.form.questions.some(function (c) {
        return c.isEditMode;
      });
    },
    getActiveColor: function getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    },
    themesOptions: function themesOptions() {
      return this.mapThemes(this.channelsOptions);
    },
    closeOnOverlay: function closeOnOverlay() {
      return true;
    },
    managedLiveDocuments: function managedLiveDocuments() {
      return this.$route.params.id ? this.liveDocuments : this.pendingLiveDocuments;
    }
  }),
  watch: {
    live: function live() {
      this.ready = true;
      this.form = JSON.parse(stringify_default()(this.live));
      this.form.doc_public = !!this.form.doc_public;
      this.socialNetwork = this.form.foFacebook || this.form.foTwitter || this.form.foWisembly;
      this.joinFile = this.form.files.length > 0;
      this.password = !!this.form.pwd;
      this.isBeforeLiveVideoPickerVisible = !this.form.videoBeforeLive;
      console.log("back api live :", this.form);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('lives', ['addIntoListGroup']), Object(vuex_esm["b" /* mapActions */])('common', ['setDiffusionLive']), Object(vuex_esm["b" /* mapActions */])('lives', ['getLiveById', 'fetchContributors', 'fetchChannels', 'fetchLiveTypes', 'updateLive', 'createLive', 'setDiffusionObject', 'fetchAllSkinTemplates', 'resetAllSkinTemplates', 'getSubscriptionUserList', 'getSubscriptionGroupUsersList', 'deleteOneMailIntoListMail', 'addOneMailIntoGroup', 'addIntoListMail', 'deleteOneMailIntoGroup', 'deleteGroupMailFromListMail', 'setListMail']), Object(vuex_esm["b" /* mapActions */])('form', ['fetchVideos', 'fetchSurveys', 'resetPagination']), {
    // addGroupUser(group) {
    //   console.log('event*****', group);
    //   this.form.groupMails.push(group.name);
    // },

    format: function format(value, event) {
      return LiveFormV2_moment(value).format('YYYY-MM-DDThh:mm:ss').tz('Europe/Rome');
    },
    deselectOneGroup: function deselectOneGroup() {
      this.deleteGroupMailFromListMail(this.currentIdGroup);
      this.show_list_mail = false;
    },
    removeError: function removeError(event) {
      if (event.target.value.length >= 255) {
        this.showErrorMessage = true;
      } else {
        this.showErrorMessage = false;
      }
    },
    selectOneGroup: function selectOneGroup(Obj) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.isGroupExist(Obj.id)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this4.addIntoListGroup(Obj.id);

              case 3:
                _this4.currentNameGroup = Obj.name;
                _this4.currentIdGroup = Obj.id;
                _this4.listGroup = _this4.getGroupById(Obj.id).users;
                _this4.listGroup.forEach(function (e) {
                  _this4.addIntoListMail(e.email);
                });

                _this4.show_list_mail = true;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    deleteMailInGroup: function deleteMailInGroup(email) {
      var data = { id: this.currentIdGroup, email: email };
      this.deleteOneMailIntoGroup(data);
      this.deleteOneMailIntoListMail(email);
      this.listGroup = this.getGroupById(this.currentIdGroup).users;
    },
    addOneMail: function addOneMail() {
      if (this.oneMail) {
        var data = { id: this.currentIdGroup, email: this.oneMail };
        this.addOneMailIntoGroup(data);
        this.addIntoListMail(this.oneMail);
      }
      this.oneMail = null;
    },
    redirectTo: function redirectTo(start) {
      if (start) {
        parent.postMessage({
          info: 'goToDiffusionLive',
          live: this.currentLive
        }, '*');
        this.$root.$emit('bv::hide::modal', 'modal-start-direct-v2');
      } else {
        this.goToListLive();
      }

      if (this.status && start) {
        localStorage.setItem('redirectToStartDirect', true);
      } else if (this.status && !start) {
        localStorage.setItem('redirectToList', true);
      }
    },
    setNbDays: function setNbDays(event, index) {
      console.log('event****', event);
      console.log('index****', index);
      console.log('his.rules[index]****', this.form.rules[index]);
      this.form.rules[index].nbDays = event.target.value;
    },
    getClockValue: function getClockValue(event, index) {
      console.log('event****', event);
      this.form.rules[index].beforeHour = event.target.value;
    },
    onReady: function onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    onAboutEditorInput: function onAboutEditorInput(event) {
      this.form.editor.dataAbout = event;
    },

    // onIntervenantEditorInput(event) {
    //   this.form.editor.dataIntervenant = event;
    // },
    checkFormValidity: function checkFormValidity() {
      var _this5 = this;

      var valid = this.$refs['intervenant-form'].checkValidity();
      console.log('valid*****', valid);
      var validators = ['lastName', 'firstName'];
      if (validators.some(function (item) {
        return _this5.$v.intervenant[item].$invalid;
      })) {
        valid = false;
      }
      this.nameState = valid;
      return valid;
    },
    resetModal: function resetModal() {
      this.intervenant = {
        lastName: '',
        firstName: '',
        fonction: '',
        bibliography: '',
        email: ''
      };
      this.nameState = true;
    },
    openModalIntervenant: function openModalIntervenant() {
      this.nameState = true;
    },
    editIntervenant: function editIntervenant(intervenant) {
      this.intervenant = intervenant;
      console.log(' this.intervenant**', this.intervenant);
      this.$bvModal.show('modal-intervenants');
    },
    removeIntervenant: function removeIntervenant(intervenant) {
      var _this6 = this;

      var message_confirm = i18n.t('toast.success_delete');
      var message_reset = i18n.t('modal.delete.selection.btn_cancel');
      var TOAST_DURATION = 5000;
      var TOAST_DURATION_DELETE = TOAST_DURATION + 1;
      var deleteLive = true;
      var index = this.form.allIntervenants.indexOf(intervenant);
      this.form.allIntervenants.splice(index, 1);
      this.$toasted.show(message_confirm, {
        theme: 'bubble',
        position: 'bottom-right',
        icon: {
          name: 'icon-warning mr-2'
        },
        duration: TOAST_DURATION,
        action: {
          text: message_reset,
          onClick: function onClick(e, toastObject) {
            deleteLive = false;
            _this6.form.allIntervenants.push(intervenant);
            toastObject.goAway(0);
          }
        }
      });
      setTimeout(function () {}, TOAST_DURATION_DELETE);
    },
    handleOk: function handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      console.log("this.$v.form.$error", this.$v.form);
      this.$v.intervenant.$touch();
      if (this.$v.intervenant.$error) {
        this.highlightFormErrors();
        return;
      }
      this.handleSubmitModal();
    },
    handleSubmitModal: function handleSubmitModal() {
      var _this7 = this;

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      console.log('this.form.allIntervenants.indexOf(this.intervenant) ***', this.form.allIntervenants.indexOf(this.intervenant));
      if (this.form.allIntervenants.indexOf(this.intervenant) === -1) this.form.allIntervenants.push(this.intervenant);
      // Hide the modal manually
      this.$nextTick(function () {
        _this7.$bvModal.hide('modal-intervenants');
      });
    },
    addSendRule: function addSendRule() {
      var rule = {
        nbDays: 1,
        beforeHour: LiveFormV2_moment().format('HH:mm')
      };

      this.form.rules.push(rule);
      console.log('this.form.rules***', this.form.rules);
    },
    copyButton: function copyButton(event, selector) {
      console.log('event', event);
      var copyText = document.getElementById(selector);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
    },
    changeTab: function changeTab(tab) {
      this.activeTab = tab;
    },
    selectTheme: function selectTheme(theme) {
      this.isSelectedTheme = true;
      this.form.idTemplate = theme.id;
    },
    showMore: function showMore() {
      this.showMoreTemplates = !this.showMoreTemplates;
      if (this.showMoreTemplates) {
        this.showText = 'less';
      } else {
        this.showText = 'more';
      }

      // this.showLessTemplates = true;
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var dataToSubmit, message, data, startdate, currentdate, choixOUI, choixNON, obj;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('handleSubmit', _this8.submitButtonClicked);

                if (_this8.submitButtonClicked) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _this8.submitButtonClicked = false;
                _this8.resetHighlightErrors();

                console.log("this.$v.form.$error", _this8.$v.form);
                _this8.$v.form.$touch();

                if (!_this8.$v.form.$error) {
                  _context2.next = 10;
                  break;
                }

                _this8.highlightFormErrors();
                return _context2.abrupt('return');

              case 10:
                nprogress_nprogress_default.a.start();
                console.log('this.form', _this8.form);
                if (!_this8.form.duration || _this8.form.duration === null) {
                  _this8.form.endTime = "01:00";
                }

                if (_this8.form.duration != null && _this8.form.duration) {
                  if (_this8.form.duration.HH == "" && _this8.form.duration.mm != "") {
                    _this8.form.duration = "00:" + _this8.form.duration.mm;
                  }
                  if (_this8.form.duration.mm == "" && _this8.form.duration.HH != "") {
                    _this8.form.duration = _this8.form.duration.HH + ":00";
                  }
                }

                _this8.form.emails = _this8.listMailInStor;

                dataToSubmit = _this8.mapFormData(_this8.form);

                console.log('dataToSubmit', dataToSubmit);
                message = void 0;
                data = void 0;
                _context2.prev = 19;

                if (!_this8.isEditMode) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 23;
                return _this8.updateLive(dataToSubmit);

              case 23:
                data = _context2.sent;

                message = i18n.t('toast.success_edit');
                _context2.next = 33;
                break;

              case 27:
                _context2.next = 29;
                return _this8.createLive(dataToSubmit);

              case 29:
                data = _context2.sent;
                _context2.next = 32;
                return _this8.uploadPendingLiveDocuments(data.Lives.id);

              case 32:
                message = i18n.t('toast.success_add');

              case 33:
                _this8.showToast('success', message, 'icon-success');
                _context2.next = 40;
                break;

              case 36:
                _context2.prev = 36;
                _context2.t0 = _context2['catch'](19);

                message = i18n.t('toast.error');
                _this8.showToast('error', message, 'icon-warning');

              case 40:
                startdate = LiveFormV2_moment(new Date(dataToSubmit.empLivesForm.dateStart)).format('YYYY-MM-DD');
                currentdate = LiveFormV2_moment(new Date()).format('YYYY-MM-DD');
                choixOUI = localStorage.getItem('redirectToStartDirect');
                choixNON = localStorage.getItem('redirectToList');

                if (startdate === currentdate && !choixOUI && !choixNON) {
                  console.log("data", data);
                  _this8.currentLive = data.Lives;
                  if (_this8.hasPermission(_this8.getDiffusionPermission)) {
                    _this8.$root.$emit('bv::show::modal', 'modal-start-direct-v2');
                  } else {
                    _this8.goToListLive();
                  }
                } else {
                  _this8.$v.form.$reset();
                  obj = _this8.getDiffusionObject;

                  obj.type = _this8.getDiffusion;
                  _this8.setDiffusionObject(obj);
                  _this8.setDiffusionLive(_this8.getDiffusion);
                  _this8.goToListLive();
                }

                nprogress_nprogress_default.a.done();

              case 46:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[19, 36]]);
      }))();
    },
    getManagedDocumentName: function getManagedDocumentName(item) {
      return getLiveDocumentName(item);
    },
    getManagedDocumentUrl: function getManagedDocumentUrl(item) {
      return getLiveDocumentUrl(item);
    },
    isManagedDocumentPublic: function isManagedDocumentPublic(item) {
      return isLiveDocumentPublic(item);
    },
    getManagedDocumentId: function getManagedDocumentId(item) {
      return getLiveDocumentId(item);
    },
    triggerLiveDocumentUpload: function triggerLiveDocumentUpload() {
      if (this.$refs.liveDocumentsInput) {
        this.$refs.liveDocumentsInput.click();
      }
    },
    fetchLiveDocuments: function fetchLiveDocuments() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var signedUrl, response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this9.$route.params.id) {
                  _context3.next = 3;
                  break;
                }

                _this9.liveDocuments = [];
                return _context3.abrupt('return');

              case 3:

                _this9.documentsLoading = true;

                _context3.prev = 4;
                _context3.next = 7;
                return getSignedLiveDocumentsUrl('/live/file-live/' + _this9.$route.params.id);

              case 7:
                signedUrl = _context3.sent;
                _context3.next = 10;
                return axios_default.a.get(signedUrl, getLiveDocumentsHeaders());

              case 10:
                response = _context3.sent;

                _this9.liveDocuments = normalizeLiveDocumentsResponse(response);
                _context3.next = 19;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](4);

                console.log('error while fetching live documents : ', _context3.t0);
                _this9.liveDocuments = [];
                _this9.showToast('error', _this9.$t('form_live.tabs.advanced.documents.fetch_error'), 'icon-warning');

              case 19:
                _context3.prev = 19;

                _this9.documentsLoading = false;
                return _context3.finish(19);

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9, [[4, 14, 19, 22]]);
      }))();
    },
    handleLiveDocumentFileChange: function handleLiveDocumentFileChange(event) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var input, files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = event && event.target ? event.target : null;
                files = input && input.files ? from_default()(input.files) : [];

                if (files.length) {
                  _context4.next = 5;
                  break;
                }

                if (input) {
                  input.value = '';
                }
                return _context4.abrupt('return');

              case 5:
                if (_this10.$route.params.id) {
                  _context4.next = 10;
                  break;
                }

                files.forEach(function (file, index) {
                  _this10.pendingLiveDocuments.push({
                    localId: 'pending-document-' + Date.now() + '-' + index,
                    name: file.name,
                    file: file,
                    isPending: true,
                    public: !!_this10.form.doc_public
                  });
                });
                _this10.showToast('success', _this10.$t('form_live.tabs.advanced.documents.queued_success'), 'icon-success');
                if (input) {
                  input.value = '';
                }
                return _context4.abrupt('return');

              case 10:

                _this10.documentsUploading = true;

                _context4.prev = 11;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 15;
                _iterator = get_iterator_default()(files);

              case 17:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 24;
                  break;
                }

                file = _step.value;
                _context4.next = 21;
                return _this10.uploadLiveDocument(file, _this10.$route.params.id, !!_this10.form.doc_public);

              case 21:
                _iteratorNormalCompletion = true;
                _context4.next = 17;
                break;

              case 24:
                _context4.next = 30;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](15);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 30:
                _context4.prev = 30;
                _context4.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 33:
                _context4.prev = 33;

                if (!_didIteratorError) {
                  _context4.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context4.finish(33);

              case 37:
                return _context4.finish(30);

              case 38:

                _this10.showToast('success', _this10.$t('form_live.tabs.advanced.documents.upload_success'), 'icon-success');
                _context4.next = 41;
                return _this10.fetchLiveDocuments();

              case 41:
                _context4.next = 47;
                break;

              case 43:
                _context4.prev = 43;
                _context4.t1 = _context4['catch'](11);

                console.log('error while uploading live documents : ', _context4.t1);
                _this10.showToast('error', _this10.$t('form_live.tabs.advanced.documents.upload_error'), 'icon-warning');

              case 47:
                _context4.prev = 47;

                _this10.documentsUploading = false;
                if (input) {
                  input.value = '';
                }
                return _context4.finish(47);

              case 51:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10, [[11, 43, 47, 51], [15, 26, 30, 38], [31,, 33, 37]]);
      }))();
    },
    uploadLiveDocument: function uploadLiveDocument(file, liveId) {
      var _this11 = this;

      var publishAfterUpload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var signedUrl, formData, response, uploadedDocuments, ids;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return getSignedLiveDocumentsUrl('/live/files-live/' + liveId);

              case 2:
                signedUrl = _context5.sent;
                formData = new FormData();

                formData.append('file', file);
                formData.append('owner', window.client || window.process.env.CLIENT_NAME || 'empadmin');

                _context5.next = 8;
                return axios_default.a.post(signedUrl, formData, getLiveDocumentsHeaders(null));

              case 8:
                response = _context5.sent;
                uploadedDocuments = normalizeLiveDocumentsResponse(response);

                if (!publishAfterUpload) {
                  _context5.next = 15;
                  break;
                }

                ids = uploadedDocuments.map(function (item) {
                  return getLiveDocumentId(item);
                }).filter(Boolean);

                if (!(ids.length > 0)) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 15;
                return _this11.setLiveDocumentsPublish(ids, true);

              case 15:
                return _context5.abrupt('return', response);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    uploadPendingLiveDocuments: function uploadPendingLiveDocuments(liveId) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, pendingDocument;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!liveId || _this12.pendingLiveDocuments.length === 0)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:

                _this12.documentsUploading = true;

                _context6.prev = 3;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 7;
                _iterator2 = get_iterator_default()(_this12.pendingLiveDocuments);

              case 9:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 16;
                  break;
                }

                pendingDocument = _step2.value;
                _context6.next = 13;
                return _this12.uploadLiveDocument(pendingDocument.file, liveId, !!pendingDocument.public);

              case 13:
                _iteratorNormalCompletion2 = true;
                _context6.next = 9;
                break;

              case 16:
                _context6.next = 22;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6['catch'](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 22:
                _context6.prev = 22;
                _context6.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context6.prev = 25;

                if (!_didIteratorError2) {
                  _context6.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context6.finish(25);

              case 29:
                return _context6.finish(22);

              case 30:

                _this12.pendingLiveDocuments = [];
                _context6.next = 33;
                return _this12.fetchLiveDocuments();

              case 33:
                _context6.prev = 33;

                _this12.documentsUploading = false;
                return _context6.finish(33);

              case 36:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this12, [[3,, 33, 36], [7, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    setLiveDocumentsPublish: function setLiveDocumentsPublish(ids, value) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var signedUrl;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!Array.isArray(ids) || ids.length === 0)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt('return');

              case 2:
                _context7.next = 4;
                return getSignedLiveDocumentsUrl('/live/files-live/publish');

              case 4:
                signedUrl = _context7.sent;
                _context7.next = 7;
                return axios_default.a.post(signedUrl, [{ ids: ids, public: !!value }], getLiveDocumentsHeaders('application/json'));

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this13);
      }))();
    },
    toggleLiveDocumentPublish: function toggleLiveDocumentPublish(document, value) {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var documentId;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                documentId = _this14.getManagedDocumentId(document);

                if (documentId) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt('return');

              case 3:
                _context8.prev = 3;
                _context8.next = 6;
                return _this14.setLiveDocumentsPublish([documentId], value);

              case 6:
                _this14.liveDocuments = _this14.liveDocuments.map(function (item) {
                  return _this14.getManagedDocumentId(item) === documentId ? extends_default()({}, item, { public: !!value }) : item;
                });
                _context8.next = 13;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](3);

                console.log('error while updating live document visibility : ', _context8.t0);
                _this14.showToast('error', _this14.$t('form_live.tabs.advanced.documents.publish_error'), 'icon-warning');

              case 13:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this14, [[3, 9]]);
      }))();
    },
    deleteLiveDocument: function deleteLiveDocument(document) {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var documentId, signedUrl;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                documentId = document.isPending ? document.localId : _this15.getManagedDocumentId(document);

                if (documentId) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt('return');

              case 3:
                if (!document.isPending) {
                  _context9.next = 6;
                  break;
                }

                _this15.pendingLiveDocuments = _this15.pendingLiveDocuments.filter(function (item) {
                  return item.localId !== documentId;
                });
                return _context9.abrupt('return');

              case 6:

                _this15.documentsDeletingId = documentId;

                _context9.prev = 7;
                _context9.next = 10;
                return getSignedLiveDocumentsUrl('/live/file-live/' + documentId);

              case 10:
                signedUrl = _context9.sent;
                _context9.next = 13;
                return axios_default.a.delete(signedUrl, getLiveDocumentsHeaders());

              case 13:
                _this15.liveDocuments = _this15.liveDocuments.filter(function (item) {
                  return _this15.getManagedDocumentId(item) !== documentId;
                });
                _this15.showToast('success', _this15.$t('form_live.tabs.advanced.documents.delete_success'), 'icon-success');
                _context9.next = 21;
                break;

              case 17:
                _context9.prev = 17;
                _context9.t0 = _context9['catch'](7);

                console.log('error while deleting live document : ', _context9.t0);
                _this15.showToast('error', _this15.$t('form_live.tabs.advanced.documents.delete_error'), 'icon-warning');

              case 21:
                _context9.prev = 21;

                _this15.documentsDeletingId = null;
                return _context9.finish(21);

              case 24:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this15, [[7, 17, 21, 24]]);
      }))();
    },
    copyLiveDocumentLink: function copyLiveDocumentLink(document) {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var url;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                url = _this16.getManagedDocumentUrl(document);

                if (url) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt('return');

              case 3:
                _context10.prev = 3;
                _context10.next = 6;
                return navigator.clipboard.writeText(url);

              case 6:
                _this16.showToast('success', _this16.$t('form_live.tabs.advanced.documents.link_copied'), 'icon-success');
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10['catch'](3);

                console.log('error while copying live document link : ', _context10.t0);

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this16, [[3, 9]]);
      }))();
    },
    onReset: function onReset() {},
    handleToggleSecured: function handleToggleSecured() {
      if (!this.password) {
        this.form.pwd = '';
      } else {
        this.form.pwd = this.generatePassword();
      }
    },
    toggleBeforeLiveVideoPicker: function toggleBeforeLiveVideoPicker() {
      this.isBeforeLiveVideoPickerVisible = !this.isBeforeLiveVideoPickerVisible;
    },
    focusAddChapter: function focusAddChapter() {
      var _this17 = this;

      this.$nextTick(function () {
        if (_this17.$refs.newChapterInput) {
          _this17.$refs.newChapterInput.$el.focus();
        }
      });
    },
    highlightFormErrors: function highlightFormErrors() {
      var _this18 = this;

      var validators = [['description', 'title'], ['conf']];
      var tabs = document.querySelectorAll('.nav-item');
      var index = void 0;

      try {
        if (this.show_start_date) {
          validators = [['description', 'duration', 'startDate', 'startTime', 'title'], ['conf']];
          if (validators[0].some(function (item) {
            return _this18.$v.form[item].$invalid;
          })) {

            console.log("item,", item);

            index = 0;
          } else {
            index = 2;
          }
          tabs[index].classList.add('has-error');
          tabs[index].querySelector('.nav-link').click();
        }
      } catch (e) {
        console.log("highlight Form Errors");
      }
    },
    resetHighlightErrors: function resetHighlightErrors() {

      var tabs = document.querySelectorAll('.nav-item');
      for (var i = 0; i < tabs.length; ++i) {
        tabs[i].classList.remove('has-error');
      }
    },
    submitForm: function submitForm() {
      this.submitButtonClicked = true;
      this.handleSubmit();
    },
    handleDiffusionTypeChanged: function handleDiffusionTypeChanged() {
      var _this19 = this;

      setTimeout(function () {
        var types = ['webinar', 'isPearl', 'screenShare'];
        types.forEach(function (t) {
          _this19.form[t] = t === _this19.form.diffusion;
        });
      }, 100);
    },
    addChapter: function addChapter() {
      if (!this.newChapter) {
        return;
      }
      var chapter = {
        title: this.newChapter,
        chapterOrder: this.form.chapters.length,
        timeCode: null
      };
      this.form.chapters.push(chapter);
      this.newChapter = '';
      // const chapresEl = this.$refs['ps-chapters'].$el;
      // setTimeout(() => {
      //   chapresEl.scrollTop = chapresEl.scrollHeight;
      // }, 100);
    },
    toggleEditChapter: function toggleEditChapter(index) {
      var _this20 = this;

      var dismiss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!(this.form.chapters[index] || this.chapterTitle)) {
        return;
      }
      this.form.chapters = this.form.chapters.map(function (c, i) {
        if (i === index) {
          if (_this20.chapterTitle) {
            c.title = _this20.chapterTitle;
          } else {
            _this20.chapterTitle = c.title;
          }
          c.isEditMode = !c.isEditMode;
        }
        return c;
      });
      if (dismiss) {
        this.chapterTitle = '';
      }
    },
    removeChapter: function removeChapter(index) {
      var _this21 = this;

      this.watchUndoRemoveItem(this.form.chapters, index).then(function (val) {
        _this21.form.chapters = val;
      });
      this.form.chapters = this.form.chapters.filter(function (c, i) {
        return i !== index;
      });
    },
    setAddQuestionMode: function setAddQuestionMode(addQuestionMode) {
      this.addQuestionMode = addQuestionMode;
      this.form.questions = this.form.questions.map(function (q) {
        q.isEditMode = false;
        return q;
      });
    },
    addQuestion: function addQuestion(question) {
      this.form.questions.push(question);
      this.addQuestionMode = false;

      // const questionsEl = this.$refs['ps-questions'].$el;
      // setTimeout(() => {
      //   questionsEl.scrollTop = questionsEl.scrollHeight;
      // }, 100);
    },
    updateQuestion: function updateQuestion(question, index) {
      this.form.questions = this.form.questions.map(function (q, i) {
        return i === index ? extends_default()({}, question, { isEditMode: false }) : q;
      });
    },
    toggleEditQuestion: function toggleEditQuestion(index) {
      this.form.questions = this.form.questions.map(function (q, i) {
        if (i === index) {
          q.isEditMode = !q.isEditMode;
        }
        return q;
      });
      this.addQuestionMode = false;
    },
    removeQuestion: function removeQuestion(index) {
      var _this22 = this;

      this.watchUndoRemoveItem(this.form.questions, index).then(function (val) {
        _this22.form.questions = val;
      });
      this.form.questions = this.form.questions.filter(function (c, i) {
        return i !== index;
      });
    },
    updateScrollbar: function updateScrollbar() {
      var _this23 = this;

      this.$nextTick(function () {
        var ps = _this23.$refs.ps;
        if (ps) {
          ps.update();
        }
      });
    },
    searchVideo: function searchVideo() {
      this.resetPagination('videos');
      this.fetchVideos(this.searchVideoKeyword);
    },
    renderCarousel: function renderCarousel() {
      var _this24 = this;

      this.showCarousel = true;
      this.$nextTick(function () {
        var carousel = _this24.$refs.carousel;
        if (carousel) {
          carousel.render();
          carousel.goToPage(0);
        }
      });
    },
    selectVideo: function selectVideo(slide) {
      this.form.conf.video = slide.id;
      this.form = assign_default()({}, this.form);
      this.form.videoBeforeLive = assign_default()({}, slide, { logo: slide.thumbnail });
      this.toggleBeforeLiveVideoPicker();
    },
    checkEditMode: function checkEditMode() {
      var _this25 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var id;
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                id = _this25.$route.params.id;

                _this25.isEditMode = !!id;

                if (!_this25.isEditMode) {
                  _context11.next = 7;
                  break;
                }

                nprogress_nprogress_default.a.start();
                _context11.next = 6;
                return _this25.getLiveById(id);

              case 6:
                nprogress_nprogress_default.a.done();

              case 7:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this25);
      }))();
    },
    getDropzoneOptions: function getDropzoneOptions(type) {
      var opts = {
        url: '/',
        thumbnailWidth: 150,
        uploadMultiple: true,
        maxFilesize: 5,
        autoProcessQueue: false,
        dictDefaultMessage: '<span class="icon icon-upload"></span>' + i18n.t('upload_files.title')
      };
      switch (type) {
        case 'media':
          opts.dictDefaultMessage += i18n.t('upload_files.media_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif, video/mp4';
          break;
        case 'file':
          opts.dictDefaultMessage += i18n.t('upload_files.file_type');
          break;
        case 'image':
          opts.dictDefaultMessage += i18n.t('upload_files.image_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
          break;
      }
      opts.dictDefaultMessage += '<br>' + i18n.t('upload_files.or') + '<b><u>' + i18n.t('upload_files.click') + '</u></b>' + i18n.t('upload_files.selected_file');
      return opts;
    },
    replaceSlide: function replaceSlide(index) {
      this.slideIndex = index;
      window.dz = this.$refs.slidesDZ;
      document.getElementById('slides-dz').click();
    },
    handleDzSlideAdded: function handleDzSlideAdded(files) {
      var _this26 = this;

      setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        var _loop, i;

        return regenerator_default.a.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _loop = /*#__PURE__*/regenerator_default.a.mark(function _loop(i) {
                  var params, file, blob;
                  return regenerator_default.a.wrap(function _loop$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          params = {
                            id: 'slides-dz',
                            current: i,
                            total: files.length,
                            type: 'slides'
                          };
                          file = files[i];
                          _context12.next = 4;
                          return _this26.processFile(file);

                        case 4:
                          blob = _context12.sent;
                          _context12.next = 7;
                          return _this26.uploadThumbnail(blob, params).then(function (result) {
                            var data = result.data;

                            var slide = {
                              slideType: file.type.indexOf('image') > -1 ? 'Image' : 'Video',
                              slide: data.location.path,
                              urlSlide: data.location.url
                            };
                            if (_this26.slideIndex > -1) {
                              _this26.form.slides.splice(_this26.slideIndex, 1, slide);
                              _this26.slideIndex = -1;
                            } else {
                              _this26.form.slides.push(slide);
                            }
                            if (i === files.length - 1) {
                              _this26.removeProgressCircle(params);
                            }
                          });

                        case 7:
                        case 'end':
                          return _context12.stop();
                      }
                    }
                  }, _loop, _this26);
                });
                i = 0;

              case 2:
                if (!(i < files.length)) {
                  _context13.next = 7;
                  break;
                }

                return _context13.delegateYield(_loop(i), 't0', 4);

              case 4:
                i++;
                _context13.next = 2;
                break;

              case 7:
                _this26.$refs.slidesDZ.removeAllFiles();
                // const slidesEl = this.$refs['ps-slides'].$el;
                // setTimeout(() => {
                //   slidesEl.scrollTop = slidesEl.scrollHeight;
                // }, 100);

              case 8:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee12, _this26);
      })), 100);
    },
    handleDzFileAdded: function handleDzFileAdded(files) {
      var _this27 = this;

      setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var _loop2, i;

        return regenerator_default.a.wrap(function _callee13$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _loop2 = /*#__PURE__*/regenerator_default.a.mark(function _loop2(i) {
                  var params, file, blob;
                  return regenerator_default.a.wrap(function _loop2$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          params = {
                            id: 'files-dz',
                            current: i,
                            total: files.length,
                            type: 'attatched_files'
                          };
                          file = files[i];
                          _context14.next = 4;
                          return _this27.processFile(file);

                        case 4:
                          blob = _context14.sent;
                          _context14.next = 7;
                          return _this27.uploadThumbnail(blob, params).then(function (result) {
                            var data = result.data;


                            var f = {
                              fileName: file.name,
                              mimeType: data.location.mimeType,
                              title: data.location.path
                            };
                            _this27.form.files = _this27.form.files.concat(common.buildIcons([f]));
                            if (i === files.length - 1) {
                              _this27.removeProgressCircle(params);
                            }
                          });

                        case 7:
                        case 'end':
                          return _context14.stop();
                      }
                    }
                  }, _loop2, _this27);
                });
                i = 0;

              case 2:
                if (!(i < files.length)) {
                  _context15.next = 7;
                  break;
                }

                return _context15.delegateYield(_loop2(i), 't0', 4);

              case 4:
                i++;
                _context15.next = 2;
                break;

              case 7:

                _this27.$refs.filesDZ.removeAllFiles();

              case 8:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee13, _this27);
      })), 100);
    },
    handleDzFileCompleted: function handleDzFileCompleted() {
      this.$refs.filesDZ.removeAllFiles();
    },
    handleDzSlideCompleted: function handleDzSlideCompleted() {
      this.$refs.slidesDZ.removeAllFiles();
    },
    removeSlide: function removeSlide(index) {
      var _this28 = this;

      this.watchUndoRemoveItem(this.form.slides, index).then(function (val) {
        _this28.form.slides = val;
      });
      this.form.slides = this.form.slides.filter(function (s, i) {
        return i !== index;
      });
    },
    removeFile: function removeFile(index) {
      var _this29 = this;

      this.watchUndoRemoveItem(this.form.files, index).then(function (val) {
        _this29.form.files = val;
      });
      this.form.files = this.form.files.filter(function (f, i) {
        return i !== index;
      });
    },
    handleThumbnailUpdated: function handleThumbnailUpdated(thumbnail) {
      this.form.thumbnail = thumbnail;
    },
    handleBeforeLivePosterUpdated: function handleBeforeLivePosterUpdated(thumbnail) {
      this.form.conf.image = thumbnail;
    },
    handlePageChanged: function handlePageChanged() {
      if (this.isEndReached('videos') || this.isLoading('videos') || !(this.form.conf.type === 'Video' && this.initInfinitScrollVideos && this.isBeforeLiveVideoPickerVisible)) {
        return;
      }
      this.fetchVideos(this.searchVideoKeyword);
    },
    goToListLive: function goToListLive() {
      parent.postMessage({
        info: 'goToListLive',
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    },
    disabledDate: function disabledDate(value) {
      var today = new Date();
      var yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      return new Date(value) < yesterday;
    }
  }),
  created: function created() {
    this.checkEditMode();
    this.fetchContributors();
    this.fetchSurveys();
    this.fetchVideos();
    this.fetchChannels();
    this.fetchLiveTypes();
    this.fetchAllSkinTemplates();
    this.fetchLiveDocuments();
  },
  mounted: function mounted() {
    var _this30 = this;

    // this.$root.$on('setFormLang', lang => {
    //   this.$i18n.locale = lang;
    //   i18n.locale = lang;
    // });


    //todo click outside

    this.$nextTick(function () {
      if (_this30.$i18n.locale === 'fr') {
        vue2_datepicker_lib_default.a.fecha.i18n.monthNamesShort = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'];
      }
    });
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    this.pastDates = {
      to: yesterday
    };
    this.getSubscriptionUserList();
    this.getSubscriptionGroupUsersList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ce6574","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveFormV2.vue
var LiveFormV2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-live-wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"action-BTN-mobile"},[_c('b-button',{staticClass:"mr-2 Annuler",attrs:{"variant":"light","type":"button"},on:{"click":_vm.goToListLive}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),_c('b-button',{class:{'DifuserBtn':!_vm.show_start_date,'SaveBTN':_vm.show_start_date},attrs:{"type":"submit","disabled":_vm.$v.form.$error},on:{"mousedown":_vm.submitForm}},[_c('i',{staticClass:"icon-dotv"}),_vm._v(" "+_vm._s(_vm.$t('button.save')))])],1),_vm._v(" "),_c('div',{staticClass:"tabs-wrapper"},[_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},_vm._l((_vm.tabs),function(tab,index){return _c('b-tab',{key:index,attrs:{"title":_vm.$t('form_live.tabs.' + tab + '.title'),"active":tab === _vm.activeTab},on:{"click":function($event){return _vm.changeTab(tab)}}})}),1),_vm._v(" "),_c('div',{staticClass:"action-BTN"},[_c('b-button',{staticClass:"mr-2 Annuler",attrs:{"type":"button","variant":"light"},on:{"click":_vm.goToListLive}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),_c('b-button',{class:{'DifuserBtn':!_vm.show_start_date,'SaveBTN':_vm.show_start_date},attrs:{"type":"submit","disabled":_vm.$v.form.$error},on:{"mousedown":_vm.submitForm}},[_c('i',{staticClass:"icon-dotv"}),_vm._v(" "+_vm._s(_vm.$t('button.save')))])],1)],1),_vm._v(" "),_c('b-form',{ref:"form",staticClass:"needs-validation",class:{ 'was-validated': _vm.$v.form.$anyDirty, 'not-ready': _vm.isEditMode && !_vm.ready },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)},"reset":_vm.onReset}},[(_vm.activeTab === 'general')?_c('div',{staticClass:"general-tab"},[_c('b-row',[_c('b-col',{staticClass:"col-12 col-sm-12 col-xl-6"},[_c('div',{staticClass:"tabs-wrapper"},[_c('b-row',[_c('b-col',{attrs:{"md":"12","sm":"12"}},[_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('b-form-group',{attrs:{"description":_vm.$t('form_live.tabs.general.form.description_image'),"label":_vm.$t('form_live.tabs.general.form.add_image'),"label-for":"live-thumbnail","label-class":"primary"}},[_c('div',{staticClass:"vignette-infos"},[_c('thumbnail-cropper',{attrs:{"crop-img":_vm.form.thumbnail},on:{"thumbnailUpdated":_vm.handleThumbnailUpdated}}),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.vignette')}})],1)])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.title),expression:"form.title"}],staticClass:"form-control",attrs:{"placeholder":_vm.$t('form_live.tabs.general.form.title'),"type":"text","id":"title","name":"title","required":""},domProps:{"value":(_vm.form.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "title", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.form.title.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                      ")]):_vm._e()])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required primary",attrs:{"for":"description"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.description')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"id":"description","placeholder":_vm.$t('form_live.tabs.general.form.description'),"required":"","rows":"3"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}}),_vm._v(" "),(!_vm.$v.form.description.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                      ")]):_vm._e()])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_password_security_no_api'),expression:"'lives_password_security_no_api'"}],attrs:{"has-permission":"lives_password_security_no_api"}},[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.access_live')))]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"name":"type_access"},model:{value:(_vm.form.secureAccess),callback:function ($$v) {_vm.$set(_vm.form, "secureAccess", $$v)},expression:"form.secureAccess"}},[_c('b-row',[_c('b-col',{staticStyle:{"min-width":"190px!important"},attrs:{"md":"3","sm":"12"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.access_free'))+"\n                              "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottomleft",modifiers:{"hover":true,"bottomleft":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.access_free')}})])],1),_vm._v(" "),_c('b-col',{staticStyle:{"min-width":"225px!important"},attrs:{"md":"3","sm":"12"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.access_secure'))+"\n                              "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.access_secure')}})])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3","sm":"12"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"9","sm":"12"}},[(_vm.form.secureAccess)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"sub-form-control"},[_c('b-form-input',{attrs:{"type":"text","placeholder":_vm.$t('form_live.tabs.general.form.placeholder_pass')},model:{value:(_vm.form.pwd),callback:function ($$v) {_vm.$set(_vm.form, "pwd", $$v)},expression:"form.pwd"}})],1),_vm._v(" "),_c('div',{staticClass:"sub-form-control align-infos-live"},[_c('b-form-checkbox',{staticClass:"primary generer-pwd",on:{"input":_vm.handleToggleSecured,"change":_vm.handleToggleSecured},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.secure_pass'))+"\n                                "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottomleft",modifiers:{"hover":true,"bottomleft":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.secure_pass')}})])],1)]):_vm._e()])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group align-infos-live"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.schedule_live')))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"no-p-r",attrs:{"switch":"","size":"lg"},model:{value:(_vm.show_start_date),callback:function ($$v) {_vm.show_start_date=$$v},expression:"show_start_date"}}),_vm._v(" "),_c('span',{staticClass:"position-icon icon-infos"})],1)])],1),_vm._v(" "),(_vm.show_start_date)?_c('b-row',[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.startDate.$invalid }},[_c('label',{staticClass:"required primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.start_date')))]),_vm._v(" "),_c('div',{staticClass:"input_css input filter-date",attrs:{"id":"filter-date"}},[_c('datepicker',{attrs:{"id":"start-date","input-class":"form-control selectedDate","wrapper-class":"start-date-picker","bootstrap-styling":true,"calendar-button":true,"required":true,"lang":_vm.$i18n.locale,"disabled-days":_vm.disabledDate,"format":'DD MMM YYYY',"active-color":_vm.getActiveColor,"clearable":false,"editable":false},model:{value:(_vm.form.startDate),callback:function ($$v) {_vm.$set(_vm.form, "startDate", $$v)},expression:"form.startDate"}},[_c('template',{slot:"calendar-icon"},[_c('font-awesome-icon',{staticClass:"calendar-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'calendar-alt' }}})],1)],2)],1),_vm._v(" "),(!_vm.$v.form.startDate.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                      ")]):(!_vm.$v.form.startDate.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_date'))+"\n                      ")]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4","sm":"6"}},[_c('div',{staticClass:"form-group",class:{ 'is-invalid__custom': _vm.$v.form.startTime.$invalid }},[_c('label',{staticClass:"required primary",attrs:{"for":"start-time"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.start_hour')))]),_vm._v(" "),_c('vue-clock-picker',{attrs:{"id":"start-time","input-class":"form-control","active-color":_vm.getActiveColor,"required":false,"cancel-text":_vm.$t('button.cancel'),"done-text":_vm.$t('button.done'),"close-on-overlay":_vm.closeOnOverlay},model:{value:(_vm.form.startTime),callback:function ($$v) {_vm.$set(_vm.form, "startTime", $$v)},expression:"form.startTime"}}),_vm._v(" "),(!_vm.$v.form.startTime.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                      ")]):(!_vm.$v.form.startTime.minValue)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.general.form.invalid_hour'))+"\n                      ")]):_vm._e()],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"4","sm":"6"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"duration"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.duration')))]),_vm._v(" "),_c('div',{staticClass:"duration-live"},[_c('vue-timepicker',{attrs:{"format":"HH:mm","placeholder":_vm.$t('form_live.tabs.general.form.duration'),"id":"duration","name":"duration"},model:{value:(_vm.form.duration),callback:function ($$v) {_vm.$set(_vm.form, "duration", $$v)},expression:"form.duration"}})],1)])])],1):_vm._e()],1)]),_vm._v(" "),_c('b-col',{staticClass:"col-12 col-sm-12 col-xl-6"},[_c('div',{staticClass:"tabs-wrapper"},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"align-infos-live"},[_c('label',{staticClass:"share-live primary",attrs:{"for":"share_live"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.share_live.title'))+"\n                        ")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.share_live')}})]),_vm._v(" "),_c('div',{staticClass:"share-live"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.shareLive),expression:"form.shareLive"}],staticClass:"form-control input-share",attrs:{"type":"text","id":"share_live","name":"share live","readonly":"","disabled":""},domProps:{"value":(_vm.form.shareLive)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "shareLive", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary copy-button",attrs:{"disabled":""},on:{"click":function($event){return _vm.copyButton($event, 'share_live')}}},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.general.form.share_live.copy'))+"\n                        ")])])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group align-infos-live"},[_c('label',{staticClass:"primary align-infos-live--size"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.archived_live')))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"no-p-r",attrs:{"switch":"","size":"lg"},model:{value:(_vm.form.autoPub),callback:function ($$v) {_vm.$set(_vm.form, "autoPub", $$v)},expression:"form.autoPub"}}),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottomright",modifiers:{"hover":true,"bottomright":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.archived_live')}})],1)])],1),_vm._v(" "),(_vm.show_automatic_archiving)?_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_autopub_no_api'),expression:"'lives_autopub_no_api'"}],attrs:{"has-permission":"lives_autopub_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-radio-group',{staticClass:"videos-visibility",attrs:{"name":"type_video","disabled":""},model:{value:(_vm.form.autoPub),callback:function ($$v) {_vm.$set(_vm.form, "autoPub", $$v)},expression:"form.autoPub"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.video.invisible'))+"\n                          "),_c('span',{staticClass:"position-icon icon-infos"})]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.video.visible'))+"\n                          "),_c('span',{staticClass:"position-icon icon-infos"})])],1),_vm._v(" "),(_vm.form.autoPub)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"align-infos-live"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.themes'))+"\n                          ")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.themes')}})]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.themesOptions,"multiple":true,"track-by":"id","label":"title","close-on-select":false,"placeholder":"","select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.title))])]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('div',{style:({ 'margin-left': option.index + 'em' })},[_vm._v("\n                              "+_vm._s(option.title)+"\n                            ")])]}}],null,false,3319115772),model:{value:(_vm.form.themes),callback:function ($$v) {_vm.$set(_vm.form, "themes", $$v)},expression:"form.themes"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.interactives_options.title')))]),_vm._v(" "),(_vm.isEmpreinteClient)?_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.autoSip),callback:function ($$v) {_vm.$set(_vm.form, "autoSip", $$v)},expression:"form.autoSip"}},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.frontOffice.options.interactive_tools.autoSip'))+"\n                      ")]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api'),expression:"'lives_fo_like_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_fo_like_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foLike),callback:function ($$v) {_vm.$set(_vm.form, "foLike", $$v)},expression:"form.foLike"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.like')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_chat_no_api'),expression:"'lives_fo_chat_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_fo_chat_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.chat),callback:function ($$v) {_vm.$set(_vm.form, "chat", $$v)},expression:"form.chat"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.chat')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],attrs:{"md":"4","sm":"12","has-permission":"lives_fo_comment_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foComment),callback:function ($$v) {_vm.$set(_vm.form, "foComment", $$v)},expression:"form.foComment"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.active_comment.title')))])],1)])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.multimedia_options')))]),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api'),expression:"'lives_rich_media_no_api'"}],attrs:{"has-permission":"lives_rich_media_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group align-infos-live"},[_c('b-form-checkbox',{model:{value:(_vm.form.isRm),callback:function ($$v) {_vm.$set(_vm.form, "isRm", $$v)},expression:"form.isRm"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.title'))+"\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.rich_media')}})],1)]),_vm._v(" "),(_vm.form.isRm)?_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"rm-tabs-wrapper"},[_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},[(_vm.hasPermission('lives_rich_media_chapter_no_api'))?_c('b-tab',{attrs:{"active":""},on:{"click":_vm.focusAddChapter}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                                    "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.title'))+"\n                                  ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.chapters),callback:function ($$v) {_vm.$set(_vm.form, "chapters", $$v)},expression:"form.chapters"}},_vm._l((_vm.form.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container"},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}],staticClass:"text"},[_vm._v("\n                                                "+_vm._s(chapter.title)+"\n                                              ")]),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode),expression:"chapter.isEditMode"}],staticClass:"m-0"},[_c('b-form-input',{attrs:{"placeholder":_vm.$t(
                                                      'form_live.tabs.advanced.rich_media.tabs.chapters.fields.title'
                                                    )},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleEditChapter(index)}},model:{value:(_vm.chapterTitle),callback:function ($$v) {_vm.chapterTitle=$$v},expression:"chapterTitle"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode && !!chapter.title),expression:"chapter.isEditMode && !!chapter.title"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.toggleEditChapter(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChapterEditMode),expression:"!isChapterEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditChapter(index, false)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeChapter(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.chapters.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.chapters.empty'
                                            ))+"\n                                        ")]):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[_c('div',{staticClass:"position-relative"},[_c('b-form-input',{ref:"newChapterInput",attrs:{"placeholder":_vm.$t(
                                          'form_live.tabs.advanced.rich_media.tabs.chapters.fields.new'
                                        )},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addChapter.apply(null, arguments)}},model:{value:(_vm.newChapter),callback:function ($$v) {_vm.newChapter=$$v},expression:"newChapter"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.newChapter),expression:"newChapter"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.addChapter}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}})],1)],1)])],2):_vm._e(),_vm._v(" "),(_vm.hasPermission('lives_rich_media_question_no_api'))?_c('b-tab',[_c('template',{slot:"title"},[_c('div',[_c('span',{staticClass:"icon-question"})]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                                    "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.title'))+"\n                                  ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.questions),callback:function ($$v) {_vm.$set(_vm.form, "questions", $$v)},expression:"form.questions"}},_vm._l((_vm.form.questions),function(question,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container question",class:{ 'is-open': question.isEditMode }},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}],staticClass:"text"},[_vm._v("\n                                                "+_vm._s(question.question)+"\n                                              ")]),_vm._v(" "),(question.isEditMode)?_c('question-form',{attrs:{"question":question,"buttonLabel":_vm.$t(
                                                    'form_live.tabs.advanced.rich_media.tabs.questions.edit'
                                                  )},on:{"addQuestion":function($event){return _vm.updateQuestion($event, index)},"closeForm":function($event){return _vm.toggleEditQuestion(index)}}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isQuestionEditMode),expression:"!isQuestionEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditQuestion(index)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeQuestion(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.questions.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.empty'
                                            ))+"\n                                        ")]):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[(_vm.addQuestionMode)?_c('question-form',{on:{"addQuestion":_vm.addQuestion,"closeForm":function($event){_vm.addQuestionMode = false}}},[_c('label',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.new')))])]):_vm._e(),_vm._v(" "),(!_vm.addQuestionMode)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"link","type":"button"},on:{"click":function($event){return _vm.setAddQuestionMode(true)}}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}}),_vm._v("\n                                          "+_vm._s(_vm.$t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.add_new'
                                            )))],1)],1)])],1):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('b-tab',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_slides_no_api'),expression:"'lives_rich_media_slides_no_api'"}],attrs:{"has-permission":"lives_rich_media_slides_no_api"},on:{"click":_vm.updateScrollbar}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"th-large"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                                    "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.slides.title'))+"\n                                  ")])]),_vm._v(" "),_c('div',{staticClass:"slides-wrapper"},[_c('draggable',{staticClass:"row",model:{value:(_vm.form.slides),callback:function ($$v) {_vm.$set(_vm.form, "slides", $$v)},expression:"form.slides"}},_vm._l((_vm.form.slides),function(slide,index){return _c('b-col',{key:index,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('figure',{staticClass:"img-fluid"},[_c('div',{staticClass:"type-tag"},[_c('span',{class:'icon-' +
                                                  (slide.slideType === 'Image'
                                                    ? 'picture'
                                                    : 'video')})]),_vm._v(" "),(slide.slideType === 'Image')?_c('img',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),(slide.slideType === 'Video')?_c('video',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"more-btn-container"},[_c('b-dropdown',{attrs:{"variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"icon-more"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.replaceSlide(index)}}},[_c('span',{staticClass:"icon-edit"}),_vm._v("\n                                                "+_vm._s(_vm.$t(
                                                    'form_live.tabs.advanced.rich_media.tabs.slides.edit'
                                                  ))+"\n                                              ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.removeSlide(index)}}},[_c('span',{staticClass:"icon-trash"}),_vm._v("\n                                                "+_vm._s(_vm.$t(
                                                    'form_live.tabs.advanced.rich_media.tabs.slides.delete'
                                                  ))+"\n                                              ")])],2)],1)])])}),1)],1),_vm._v(" "),_c('div',{staticClass:"dz-upload-wrapper"},[_c('vue-dropzone',{ref:"slidesDZ",attrs:{"id":"slides-dz","options":_vm.getDropzoneOptions('media'),"auto-process-queue":false},on:{"vdropzone-files-added":_vm.handleDzSlideAdded,"vdropzone-file-added-manually":_vm.handleDzSlideAdded,"vdropzone-complete":_vm.handleDzSlideCompleted}})],1)],2)],1)],1)]):_vm._e()],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_files_no_api'),expression:"'lives_associate_files_no_api'"}],attrs:{"has-permission":"lives_associate_files_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group align-infos-live"},[_c('b-form-checkbox',{model:{value:(_vm.joinFile),callback:function ($$v) {_vm.joinFile=$$v},expression:"joinFile"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.attaching_files'))+"\n                            ")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.attaching_files')}})],1),_vm._v(" "),(_vm.joinFile)?_c('div',{staticClass:"attached-files-wrapper"},_vm._l((_vm.form.files),function(file,index){return _c('div',{staticClass:"attached-file"},[_c('b-button',{staticClass:"attached-file__btn-remove",attrs:{"variant":"link"},on:{"click":function($event){return _vm.removeFile(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"times-circle"}})],1),_vm._v(" "),_c('div',{staticClass:"attached-file__icon"},[_c('font-awesome-icon',{attrs:{"icon":file.icon}})],1),_vm._v(" "),_c('div',{staticClass:"attached-file__name"},[_vm._v("\n                                "+_vm._s(file.fileName)+"\n                              ")])],1)}),0):_vm._e(),_vm._v(" "),(_vm.joinFile)?_c('vue-dropzone',{ref:"filesDZ",attrs:{"id":"files-dz","options":_vm.getDropzoneOptions('file'),"auto-process-queue":false},on:{"vdropzone-files-added":_vm.handleDzFileAdded,"vdropzone-file-added-manually":_vm.handleDzFileAdded,"vdropzone-complete":_vm.handleDzFileCompleted}}):_vm._e()],1)],1)],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api'),expression:"'lives_associate_users_no_api'"}],attrs:{"has-permission":"lives_associate_users_no_api"}},[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.publish'))+"\n                      ")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.contributorsOptions,"multiple":true,"track-by":"id","label":"name","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
                                                  var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name))])]}}],null,false,2784876651),model:{value:(_vm.form.contributors),callback:function ($$v) {_vm.$set(_vm.form, "contributors", $$v)},expression:"form.contributors"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"align-infos-live"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.tags'))+" ")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.general.form.infos.tags')}})]),_vm._v(" "),_c('input-tag',{model:{value:(_vm.form.tags),callback:function ($$v) {_vm.$set(_vm.form, "tags", $$v)},expression:"form.tags"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary conf-label",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.interactives_options.title'))+"\n                        "),_c('span',{staticClass:"position-icon icon-infos"})]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"form-group interactive-options"},[_c('b-form-checkbox',{staticClass:"primary",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.general.form.interactives_options.social_media.fb'))+"\n                            "),_c('span',{staticClass:"tm"},[_vm._v("TM")])])],1)]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"form-group interactive-options"},[_c('b-form-checkbox',{staticClass:"primary",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t(
                                'form_live.tabs.general.form.interactives_options.social_media.youtube'
                              ))+"\n                            "),_c('span',{staticClass:"tm"},[_vm._v("TM")])])],1)])],1)])],1)],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'advanced')?_c('div',{staticClass:"advanced-tab"},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_type_no_api'),expression:"'lives_type_no_api'"}],staticClass:"form-group",attrs:{"has-permission":"lives_type_no_api"}},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.title')))]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"name":"type"},model:{value:(_vm.form.isCdn),callback:function ($$v) {_vm.$set(_vm.form, "isCdn", $$v)},expression:"form.isCdn"}},[_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.intranet')))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.type.internet')))])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(_vm.getDifferentDiffusionPermission),expression:"getDifferentDiffusionPermission"}],staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.title')))]),_vm._v(" "),_c('b-form-radio-group',{on:{"input":function($event){return _vm.handleDiffusionTypeChanged()}},model:{value:(_vm.form.diffusion),callback:function ($$v) {_vm.$set(_vm.form, "diffusion", $$v)},expression:"form.diffusion"}},[_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_webinar_no_api'),expression:"'lives_webinar_no_api'"}],attrs:{"md":"3","sm":"6","has-permission":"lives_webinar_no_api"}},[_c('b-form-radio',{attrs:{"value":"webinar"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.webinar')))])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3","sm":"6"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_encoder_no_api'),expression:"'lives_encoder_no_api'"}],attrs:{"value":"isPearl","has-permission":"lives_encoder_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.encoding')))])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_screen_share_no_api'),expression:"'lives_screen_share_no_api'"}],attrs:{"value":"screenShare","has-permission":"lives_screen_share_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.diffusion.sharing')))]),_vm._v(" "),(_vm.form.screenShare)?_c('div',[_c('b-form-select',{staticClass:"screen-share-select",attrs:{"options":_vm.screenTypeOptions},model:{value:(_vm.form.screenType),callback:function ($$v) {_vm.$set(_vm.form, "screenType", $$v)},expression:"form.screenType"}})],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_private_no_api,lives_active_no_api,lives_autopub_no_api'),expression:"'lives_private_no_api,lives_active_no_api,lives_autopub_no_api'"}],staticClass:"primary",attrs:{"has-permission":"lives_private_no_api,lives_active_no_api,lives_autopub_no_api"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.title')))]),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_private_no_api'),expression:"'lives_private_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_private_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.private),callback:function ($$v) {_vm.$set(_vm.form, "private", $$v)},expression:"form.private"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.private_video')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_active_no_api'),expression:"'lives_active_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_active_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.active),callback:function ($$v) {_vm.$set(_vm.form, "active", $$v)},expression:"form.active"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.active_video')))])],1)]),_vm._v(" "),_c('b-col',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_autopub_no_api'),expression:"'lives_autopub_no_api'"}],attrs:{"md":"3","sm":"12","has-permission":"lives_autopub_no_api"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.autoPub),callback:function ($$v) {_vm.$set(_vm.form, "autoPub", $$v)},expression:"form.autoPub"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.options.automatic_share')))])],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_users_no_api'),expression:"'lives_associate_users_no_api'"}],attrs:{"has-permission":"lives_associate_users_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.title')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.contributorsOptions,"multiple":true,"track-by":"id","label":"name","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
                              var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name))])]}}],null,false,2784876651),model:{value:(_vm.form.contributors),callback:function ($$v) {_vm.$set(_vm.form, "contributors", $$v)},expression:"form.contributors"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_no_api'),expression:"'lives_rich_media_no_api'"}],attrs:{"has-permission":"lives_rich_media_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.form.isRm),callback:function ($$v) {_vm.$set(_vm.form, "isRm", $$v)},expression:"form.isRm"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.title')))])],1)]),_vm._v(" "),(_vm.form.isRm)?_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"rm-tabs-wrapper"},[_c('b-tabs',{attrs:{"content-class":"mt-3","noKeyNav":true}},[(_vm.hasPermission('lives_rich_media_chapter_no_api'))?_c('b-tab',{attrs:{"active":""},on:{"click":_vm.focusAddChapter}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"list"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.title'))+"\n                        ")])]),_vm._v(" "),_c('VuePerfectScrollbar',{ref:"ps-chapters",staticClass:"scroll-area scroll-chapters"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.chapters),callback:function ($$v) {_vm.$set(_vm.form, "chapters", $$v)},expression:"form.chapters"}},_vm._l((_vm.form.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container"},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}],staticClass:"text"},[_vm._v("\n                                      "+_vm._s(chapter.title)+"\n                                    ")]),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode),expression:"chapter.isEditMode"}],staticClass:"m-0"},[_c('b-form-input',{attrs:{"placeholder":_vm.$t(
                                            'form_live.tabs.advanced.rich_media.tabs.chapters.fields.title'
                                          )},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleEditChapter(index)}},model:{value:(_vm.chapterTitle),callback:function ($$v) {_vm.chapterTitle=$$v},expression:"chapterTitle"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(chapter.isEditMode && !!chapter.title),expression:"chapter.isEditMode && !!chapter.title"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.toggleEditChapter(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"check-circle"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!chapter.isEditMode),expression:"!chapter.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isChapterEditMode),expression:"!isChapterEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditChapter(index, false)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeChapter(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.chapters.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.empty'))+"\n                              ")]):_vm._e()],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[_c('div',{staticClass:"position-relative"},[_c('b-form-input',{ref:"newChapterInput",attrs:{"placeholder":_vm.$t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.new')},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addChapter.apply(null, arguments)}},model:{value:(_vm.newChapter),callback:function ($$v) {_vm.newChapter=$$v},expression:"newChapter"}}),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.newChapter),expression:"newChapter"}],staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.addChapter}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}})],1)],1)])],2):_vm._e(),_vm._v(" "),(_vm.hasPermission('lives_rich_media_question_no_api'))?_c('b-tab',[_c('template',{slot:"title"},[_c('div',[_c('span',{staticClass:"icon-question"})]),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.title'))+"\n                        ")])]),_vm._v(" "),_c('VuePerfectScrollbar',{ref:"ps-questions",staticClass:"scroll-area scroll-questions"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"chapters-wrapper"},[_c('draggable',{attrs:{"handle":".sort-handler"},model:{value:(_vm.form.questions),callback:function ($$v) {_vm.$set(_vm.form, "questions", $$v)},expression:"form.questions"}},_vm._l((_vm.form.questions),function(question,index){return _c('div',{key:index,staticClass:"chapter-wrapper",attrs:{"md":"12"}},[_c('div',{staticClass:"chapter-container question",class:{ 'is-open': question.isEditMode }},[_c('div',{staticClass:"sort-handler"},[_c('font-awesome-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"index"},[_vm._v(_vm._s(index + 1)+". ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}],staticClass:"text"},[_vm._v("\n                                      "+_vm._s(question.question)+"\n                                    ")]),_vm._v(" "),(question.isEditMode)?_c('question-form',{attrs:{"question":question,"buttonLabel":_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.edit')},on:{"addQuestion":function($event){return _vm.updateQuestion($event, index)},"closeForm":function($event){return _vm.toggleEditQuestion(index)}}}):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!question.isEditMode),expression:"!question.isEditMode"}],staticClass:"rm-actions-wrapper"},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isQuestionEditMode),expression:"!isQuestionEditMode"}],attrs:{"size":"sm","variant":"light"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditQuestion(index)}}},[_c('span',{staticClass:"icon-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-remove",attrs:{"size":"sm","variant":"light"},on:{"click":function($event){return _vm.removeQuestion(index)}}},[_c('span',{staticClass:"icon-trash"})])],1)])}),0),_vm._v(" "),(_vm.form.questions.length === 0)?_c('h5',{staticClass:"text-center m-3 c-grey-600"},[_vm._v("\n                                "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.empty'))+"\n                              ")]):_vm._e()],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"add-item-wrapper"},[(_vm.addQuestionMode)?_c('question-form',{on:{"addQuestion":_vm.addQuestion,"closeForm":function($event){_vm.addQuestionMode = false}}},[_c('label',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.new')))])]):_vm._e(),_vm._v(" "),(!_vm.addQuestionMode)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"link","type":"button"},on:{"click":function($event){return _vm.setAddQuestionMode(true)}}},[_c('font-awesome-icon',{attrs:{"icon":"plus-circle"}}),_vm._v("\n                                "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.questions.add_new')))],1)],1)])],1):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('b-tab',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_rich_media_slides_no_api'),expression:"'lives_rich_media_slides_no_api'"}],attrs:{"has-permission":"lives_rich_media_slides_no_api"},on:{"click":_vm.updateScrollbar}},[_c('template',{slot:"title"},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"th-large"}})],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block ml-2"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.slides.title'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"slides-wrapper"},[_c('VuePerfectScrollbar',{ref:"ps-slides",staticClass:"scroll-area"},[_c('draggable',{staticClass:"row",model:{value:(_vm.form.slides),callback:function ($$v) {_vm.$set(_vm.form, "slides", $$v)},expression:"form.slides"}},_vm._l((_vm.form.slides),function(slide,index){return _c('b-col',{key:index,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('figure',{staticClass:"img-fluid"},[_c('div',{staticClass:"type-tag"},[_c('span',{class:'icon-' + (slide.slideType === 'Image' ? 'picture' : 'video')})]),_vm._v(" "),(slide.slideType === 'Image')?_c('img',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),(slide.slideType === 'Video')?_c('video',{attrs:{"src":slide.urlSlide,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"more-btn-container"},[_c('b-dropdown',{attrs:{"variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"icon-more"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.replaceSlide(index)}}},[_c('span',{staticClass:"icon-edit"}),_vm._v("\n                                      "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.slides.edit'))+"\n                                    ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.stopPropagation();return _vm.removeSlide(index)}}},[_c('span',{staticClass:"icon-trash"}),_vm._v("\n                                      "+_vm._s(_vm.$t('form_live.tabs.advanced.rich_media.tabs.slides.delete'))+"\n                                    ")])],2)],1)])])}),1)],1)],1)],2)],1)],1)]):_vm._e()],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_associate_files_no_api'),expression:"'lives_associate_files_no_api'"}],attrs:{"has-permission":"lives_associate_files_no_api"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"primary",model:{value:(_vm.form.foFilesShare),callback:function ($$v) {_vm.$set(_vm.form, "foFilesShare", $$v)},expression:"form.foFilesShare"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.frontOffice.options.sharing_files')))]),_vm._v(" "),_c('b-form-checkbox',{model:{value:(_vm.joinFile),callback:function ($$v) {_vm.joinFile=$$v},expression:"joinFile"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.attaching_files')))])],1),_vm._v(" "),(_vm.joinFile)?_c('div',{staticClass:"attached-files-wrapper"},_vm._l((_vm.form.files),function(file,index){return _c('div',{staticClass:"attached-file"},[_c('b-button',{staticClass:"attached-file__btn-remove",attrs:{"variant":"link"},on:{"click":function($event){return _vm.removeFile(index)}}},[_c('font-awesome-icon',{attrs:{"icon":"times-circle"}})],1),_vm._v(" "),_c('div',{staticClass:"attached-file__icon"},[_c('font-awesome-icon',{attrs:{"icon":file.icon}})],1),_vm._v(" "),_c('div',{staticClass:"attached-file__name"},[_vm._v("\n                      "+_vm._s(file.fileName)+"\n                    ")])],1)}),0):_vm._e(),_vm._v(" "),(_vm.form.foFilesShare)?_c('div',{staticClass:"documents-share-panel mt-3"},[_c('div',{staticClass:"documents-share-panel__header"},[_c('div',[_c('label',{staticClass:"primary mb-0"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.documents.title')))])]),_vm._v(" "),_c('div',{staticClass:"documents-share-panel__actions"},[_c('b-button',{attrs:{"variant":"light","size":"sm","type":"button","disabled":!_vm.$route.params.id || _vm.documentsLoading},on:{"click":_vm.fetchLiveDocuments}},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.refresh'))+"\n                      ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","size":"sm","type":"button","disabled":_vm.documentsUploading},on:{"click":_vm.triggerLiveDocumentUpload}},[_vm._v("\n                        "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.upload'))+"\n                      ")])],1)]),_vm._v(" "),(!_vm.$route.params.id)?_c('p',{staticClass:"documents-share-panel__hint"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.save_first'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.form.doc_public),callback:function ($$v) {_vm.$set(_vm.form, "doc_public", $$v)},expression:"form.doc_public"}},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.publish_default'))+"\n                  ")]),_vm._v(" "),(_vm.documentsLoading)?_c('div',{staticClass:"documents-share-panel__state"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.refresh'))+"...\n                  ")]):(_vm.managedLiveDocuments.length === 0)?_c('div',{staticClass:"documents-share-panel__state"},[_vm._v("\n                    "+_vm._s(_vm.$t('form_live.tabs.advanced.documents.empty'))+"\n                  ")]):_c('div',{staticClass:"documents-share-list"},_vm._l((_vm.managedLiveDocuments),function(document){return _c('div',{key:document.localId || document.id,staticClass:"documents-share-item"},[_c('div',{staticClass:"documents-share-item__main"},[_c('div',{staticClass:"documents-share-item__name"},[_vm._v("\n                          "+_vm._s(_vm.getManagedDocumentName(document))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"documents-share-item__meta"},[_c('span',{staticClass:"documents-share-item__badge",class:{
                              'is-public': _vm.isManagedDocumentPublic(document),
                              'is-pending': document.isPending,
                            }},[_vm._v("\n                            "+_vm._s(document.isPending
                                ? _vm.$t('form_live.tabs.advanced.documents.pending')
                                : _vm.isManagedDocumentPublic(document)
                                  ? _vm.$t('form_live.tabs.advanced.documents.public')
                                  : _vm.$t('form_live.tabs.advanced.documents.private'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"documents-share-item__controls"},[_c('b-button',{attrs:{"variant":"outline-warning","size":"sm","type":"button","disabled":document.isPending},on:{"click":function($event){_vm.toggleLiveDocumentPublish(document, !_vm.isManagedDocumentPublic(document))}}},[_c('font-awesome-icon',{attrs:{"icon":"share-alt"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-danger","size":"sm","type":"button","disabled":_vm.documentsDeletingId === (document.id || document.localId)},on:{"click":function($event){return _vm.deleteLiveDocument(document)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1)],1)])}),0)],1):_vm._e(),_vm._v(" "),_c('input',{ref:"liveDocumentsInput",staticClass:"d-none",attrs:{"type":"file","multiple":""},on:{"change":_vm.handleLiveDocumentFileChange}})])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.activeTab === 'configuration')?_c('div',{staticClass:"configuration-tab"},[_c('b-row',[_c('b-col',{staticClass:"col-12 col-sm-12 col-xl-6"},[_c('div',{staticClass:"tabs-wrapper"},[(_vm.templates.length > 0)?_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.skins_live'))+"\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.skins_live')}})]),_vm._v(" "),_c('div',{staticClass:"container-default__themes__container__cards"},[_c('div',{staticClass:"row"},[_vm._l((_vm.templates),function(theme,index){return _c('div',{key:index,staticClass:"col-lg-3 template"},[_c('b-card',{staticClass:"mb-2 template-card",class:{
                                selected: _vm.isSelectedTheme && _vm.form.idTemplate === theme.id,
                              },attrs:{"title":_vm.$t('skin.template.title'),"img-src":theme.image,"img-alt":"Image","img-top":"","tag":"article","id":['template-card-' + index]},on:{"click":function($event){return _vm.selectTheme(theme)}}}),_vm._v(" "),_c('p',{staticClass:"template-title",class:{
                                selected: _vm.isSelectedTheme && _vm.form.idTemplate === theme.id,
                              }},[_vm._v("\n                              "+_vm._s(theme.label)+"\n                            ")])],1)}),_vm._v(" "),(_vm.templates.length > 2)?_c('div',{staticClass:"col-lg-3 template"},[_c('b-card',{staticClass:"mb-2 show-more",attrs:{"title":_vm.$t('skin.template.title'),"img-alt":"Image","img-top":"","tag":"article","id":['template-card'],"overlay":""},on:{"click":_vm.showMore}},[_c('b-card-text',{staticClass:"show-more-templates"},[(!_vm.showMoreTemplates)?_c('p',{staticClass:"nb-rest-templates position-text"},[_vm._v("\n                                  "+_vm._s('(' + _vm.nb_rest + ')')+" "+_vm._s('templates')+"\n                                ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"title-show-more position-text"},[_vm._v("\n                                  "+_vm._s(_vm.$t('form_live.tabs.configuration.form.' + _vm.showText))+"\n                                ")])])],1)],1):_vm._e()],2)])])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_post_add'),expression:"'lives_conf_post_add'"}],staticClass:"custom-configuration",attrs:{"has-permission":"lives_conf_post_add"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.infos_live')))]),_vm._v(" "),_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_message_option'),expression:"'lives_conf_message_option'"}],attrs:{"disabled":"","value":"Message","has-permission":"lives_conf_message_option"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.message.title'))+"\n                          "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.message')}})]),_vm._v(" "),_c('textarea',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.conf.type === 'Message'),expression:"form.conf.type === 'Message'"},{name:"model",rawName:"v-model",value:(_vm.form.conf.message),expression:"form.conf.message"}],staticClass:"form-control",attrs:{"rows":"5","maxlength":"255","placeholder":_vm.$t('form_live.tabs.configuration.form.message.description'),"required":""},domProps:{"value":(_vm.form.conf.message)},on:{"keyup":function($event){return _vm.removeError($event)},"focus":function($event){return _vm.removeError($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "message", $event.target.value)}}}),_vm._v(" "),(this.showErrorMessage)?_c('div',{staticClass:"error_message"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.error_long_message'))+"\n                        ")]):_vm._e(),_vm._v(" "),(!_vm.$v.form.conf.message.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                          "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-form-radio',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_video_option'),expression:"'lives_conf_video_option'"}],attrs:{"disabled":"","value":"Video","has-permission":"lives_conf_video_option"},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.video.title'))+"\n                          "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.video')}})]),_vm._v(" "),(!_vm.isBeforeLiveVideoPickerVisible && _vm.form.conf.type === 'Video')?_c('div',[_c('div',{staticClass:"before-live-video-container"},[_c('figure',[_c('div',{staticClass:"before-live-video-container__overlay"},[_c('font-awesome-icon',{attrs:{"icon":"play-circle"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-sm before-live-video-container__btn",on:{"click":_vm.toggleBeforeLiveVideoPicker}},[_c('font-awesome-icon',{attrs:{"icon":"pencil-alt"}}),_vm._v("\n                                Changer la source\n                              ")],1),_vm._v(" "),_c('b-img',{attrs:{"src":_vm.form.videoBeforeLive.logo,"fluid":"","alt":_vm.form.videoBeforeLive.title}})],1),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.form.videoBeforeLive.title))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.conf.video),expression:"form.conf.video"}],staticClass:"form-control",attrs:{"type":"text","required":"","hidden":""},domProps:{"value":(_vm.form.conf.video)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "video", $event.target.value)}}}),_vm._v(" "),(
                              _vm.form.conf.type === 'Video' &&
                                _vm.initInfinitScrollVideos &&
                                _vm.isBeforeLiveVideoPickerVisible
                            )?_c('div',{staticClass:"video-picker-wrapper"},[_c('div',{staticClass:"search-wrapper position-relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchVideoKeyword),expression:"searchVideoKeyword"}],staticClass:"form-control mb-15",attrs:{"placeholder":_vm.$t('form_live.tabs.configuration.form.video.description'),"type":"text"},domProps:{"value":(_vm.searchVideoKeyword)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchVideo.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchVideoKeyword=$event.target.value}}}),_vm._v(" "),_c('b-button',{staticClass:"inline-submit-btn",attrs:{"size":"sm","variant":"light"},on:{"click":_vm.searchVideo}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"video-slides-wrapper"},[_c('VuePerfectScrollbar',{ref:"ps",staticClass:"scroll-area",on:{"ps-y-reach-end":_vm.handlePageChanged}},[_c('b-row',_vm._l((_vm.slidesChips),function(slide,index){return _c('b-col',{key:slide.id,staticClass:"slide-wrapper",attrs:{"lg":"2","md":"3","sm":"4"}},[_c('div',{staticClass:"mb-3"},[_c('figure',[_c('div',{staticClass:"video-overlay",class:{ in: slide.id === _vm.form.conf.video }},[_c('button',{staticClass:"btn",class:slide.id === _vm.form.conf.video
                                                ? 'btn-light'
                                                : 'btn-outline-light',on:{"click":function($event){return _vm.selectVideo(slide)}}},[_vm._v("\n                                            "+_vm._s(_vm.$t('parameters.select.selectOption'))+"\n                                          ")])]),_vm._v(" "),_c('b-img',{attrs:{"src":slide.thumbnail,"fluid":"","alt":slide.title}})],1),_vm._v(" "),_c('div',{staticClass:"video-name",class:{ selected: slide.id === _vm.form.conf.video },attrs:{"title":slide.title}},[_vm._v("\n                                        "+_vm._s(slide.title)+"\n                                      ")])])])}),1),_vm._v(" "),(_vm.isLoading('videos'))?_c('div',[_c('div',{staticClass:"sk-circle"},[_c('div',{staticClass:"sk-circle1 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-child"})])]):_vm._e(),_vm._v(" "),(_vm.isEndReached('videos') && _vm.slidesChips.length === 0)?_c('h5',{staticClass:"c-grey-700 font-weight-bolder m-3 text-center"},[_vm._v("\n                                  Pas de vidéos\n                                ")]):_vm._e()],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.$v.form.conf.video.required)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                            "+_vm._s(_vm.$t('form_live.tabs.pick_video'))+"\n                          ")]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_image_option'),expression:"'lives_conf_image_option'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_image_option"}},[_c('b-form-radio',{attrs:{"value":"Image","disabled":""},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.image'))+"\n                          "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos secondary",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.image')}})])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.conf.type === 'Image'),expression:"form.conf.type === 'Image'"}]},[_c('b-col',{attrs:{"md":"4","sm":"12"}},[_c('b-form-group',{attrs:{"description":_vm.$t('form_live.tabs.general.form.description_image'),"label-for":"before-live-thumbnail"}},[_c('thumbnail-cropper',{attrs:{"crop-img":_vm.form.conf.image},on:{"thumbnailUpdated":_vm.handleBeforeLivePosterUpdated}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8","sm":"12"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"before-live-image-description"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.text_before_live')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.conf.imageText),expression:"form.conf.imageText"}],staticClass:"form-control",attrs:{"id":"before-live-image-description","placeholder":_vm.$t('form_live.tabs.configuration.form.text'),"rows":"5"},domProps:{"value":(_vm.form.conf.imageText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.conf, "imageText", $event.target.value)}}})])])],1),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_counter_option'),expression:"'lives_conf_counter_option'"}],staticClass:"form-group",attrs:{"has-permission":"lives_conf_counter_option"}},[_c('b-form-radio',{attrs:{"value":"Counter","disabled":""},model:{value:(_vm.form.conf.type),callback:function ($$v) {_vm.$set(_vm.form.conf, "type", $$v)},expression:"form.conf.type"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.countdown')))])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.informations')))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.about'))+"\n                              "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.about')}})]),_vm._v(" "),_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.form.editor.dataAbout,"config":_vm.editorConfig,"isEnabled":'false',"disabled":""},on:{"ready":_vm.onReady,"input":function($event){return _vm.onAboutEditorInput($event)}},model:{value:(_vm.form.editor.dataAbout),callback:function ($$v) {_vm.$set(_vm.form.editor, "dataAbout", $$v)},expression:"form.editor.dataAbout"}})],1)])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.contact'))+"\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.contact')}})]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.contact.address),expression:"form.contact.address"}],staticClass:"form-control input-address",attrs:{"type":"text","id":"address","name":"address","placeholder":_vm.$t('form_live.tabs.configuration.form.address'),"disabled":""},domProps:{"value":(_vm.form.contact.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.contact, "address", $event.target.value)}}})])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.contact.phone),expression:"form.contact.phone"}],staticClass:"form-control input-phone",attrs:{"type":"text","id":"phone","name":"phone","placeholder":_vm.$t('form_live.tabs.configuration.form.phone'),"disabled":""},domProps:{"value":(_vm.form.contact.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.contact, "phone", $event.target.value)}}})])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.contact.email),expression:"form.contact.email"}],staticClass:"form-control input-email",attrs:{"type":"email","id":"email","name":"email","placeholder":_vm.$t('form_live.tabs.configuration.form.email'),"disabled":""},domProps:{"value":(_vm.form.contact.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.contact, "email", $event.target.value)}}})])])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.intervenants.title'))+"\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.intervenants')}})]),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._l((_vm.form.allIntervenants),function(item,index){return (_vm.form.allIntervenants.length > 0)?_c('div',{key:index,staticClass:"form-group"},[_c('div',{staticClass:"form-control intervenants"},[_c('span',{staticClass:"intervenants-text",attrs:{"id":'Intervenant-' + index}},[_vm._v("\n                                "+_vm._s(item.lastName)+" "+_vm._s(item.firstName))]),_vm._v(" "),_c('div',{staticClass:"intervenants-icons"},[_c('span',{staticClass:"icon-edit",on:{"click":function($event){return _vm.editIntervenant(item)}}}),_vm._v(" "),_c('span',{staticClass:"icon-trash",on:{"click":function($event){return _vm.removeIntervenant(item)}}})])])]):_vm._e()}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group add-intervenants-button"},[_c('a',{attrs:{"disabled":""},on:{"click":_vm.openModalIntervenant}},[_c('span',{staticClass:"button-add"},[_vm._v("+")]),_vm._v(" "),_c('span',{staticClass:"add-intervenants"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.intervenants.add')))])])])])],1),_vm._v(" "),_c('b-modal',{ref:"modal",attrs:{"id":"modal-intervenants","title":_vm.$t('form_live.tabs.configuration.form.intervenants.add'),"size":"lg","centered":"","header-bg-variant":_vm.headerBgVariant,"ok-variant":_vm.okButtonBgVariant,"ok-title":_vm.$t('button.add'),"cancel-title":_vm.$t('button.cancel'),"cancel-variant":_vm.headerBgVariant,"footer-border-variant":'transparent',"footer-class":'footer-intervenant',"header-class":'header-intervenant'},on:{"hidden":_vm.resetModal,"ok":_vm.handleOk}},[_c('form',{ref:'intervenant-form',staticClass:"needs-validation",class:{ 'was-validated': _vm.$v.intervenant.$anyDirty, },on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitModal.apply(null, arguments)}}},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"state":_vm.nameState,"label":_vm.$t('form_live.tabs.configuration.form.intervenants.lastName'),"required":"","invalid-feedback":_vm.$t(
                                        'form_live.tabs.required_message'
                                      ),"label-class":"primary required intervenant-modal","label-for":"IntervenantLastName"}},[_c('b-form-input',{staticClass:"intervenant-modal",attrs:{"id":"IntervenantLastName","required":"","state":_vm.nameState,"placeholder":_vm.$t(
                                          'form_live.tabs.configuration.form.intervenants.lastName'
                                        )},model:{value:(_vm.intervenant.lastName),callback:function ($$v) {_vm.$set(_vm.intervenant, "lastName", $$v)},expression:"intervenant.lastName"}}),_vm._v(" "),(!_vm.$v.intervenant.lastName)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                                    ")]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"state":_vm.nameState,"label":_vm.$t('form_live.tabs.configuration.form.intervenants.firstName'),"required":"","invalid-feedback":_vm.$t(
                                        'form_live.tabs.required_message'
                                      ),"label-for":"IntervenantFirstName","label-class":"primary required intervenant-modal"}},[_c('b-form-input',{staticClass:"intervenant-modal",attrs:{"id":"IntervenantFirstName","state":_vm.nameState,"placeholder":_vm.$t(
                                          'form_live.tabs.configuration.form.intervenants.firstName'
                                        ),"required":""},model:{value:(_vm.intervenant.firstName),callback:function ($$v) {_vm.$set(_vm.intervenant, "firstName", $$v)},expression:"intervenant.firstName"}}),_vm._v(" "),(!_vm.$v.intervenant.firstName)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                                      "+_vm._s(_vm.$t('form_live.tabs.required_message'))+"\n                                    ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"state":_vm.nameState,"label":_vm.$t('form_live.tabs.configuration.form.intervenants.fonction'),"label-for":"IntervenantFonction","label-class":"primary intervenant-modal"}},[_c('b-form-input',{staticClass:"intervenant-modal form-control",attrs:{"id":"IntervenantFonction","state":_vm.nameState,"placeholder":_vm.$t(
                                          'form_live.tabs.configuration.form.intervenants.fonction'
                                        )},model:{value:(_vm.intervenant.fonction),callback:function ($$v) {_vm.$set(_vm.intervenant, "fonction", $$v)},expression:"intervenant.fonction"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"state":_vm.nameState,"label":_vm.$t('form_live.tabs.configuration.form.intervenants.email'),"label-for":"IntervenantEmail","label-class":"primary intervenant-modal"}},[_c('b-form-input',{staticClass:"intervenant-modal form-control",attrs:{"id":"IntervenantEmail","state":_vm.nameState,"placeholder":_vm.$t('form_live.tabs.configuration.form.intervenants.email'),"value":_vm.intervenant.email},model:{value:(_vm.intervenant.email),callback:function ($$v) {_vm.$set(_vm.intervenant, "email", $$v)},expression:"intervenant.email"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary intervenant-modal",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.intervenants.biography')))]),_vm._v(" "),_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.intervenant.bibliography,"config":_vm.editorConfig,"isEnabled":'true'},on:{"ready":_vm.onReady},model:{value:(_vm.intervenant.bibliography),callback:function ($$v) {_vm.$set(_vm.intervenant, "bibliography", $$v)},expression:"intervenant.bibliography"}})],1)])],1)],1)])],2)],1)],1)])],1)],1)]),_vm._v(" "),_c('b-col',{staticClass:"col-12 col-sm-12 col-xl-6"},[_c('div',{staticClass:"tabs-wrapper"},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.send_invitations.title')))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t(
                                  'form_live.tabs.configuration.form.send_invitations.group_emails'
                                ))+"\n                              "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.group_emails')}})]),_vm._v(" "),_c('multiselect',{key:"id",attrs:{"options":_vm.getSubscriptionGroupUsers,"multiple":true,"track-by":"id","label":"name","taggable":true,"close-on-select":true,"placeholder":"","selected-label":_vm.$t('form_live.tabs.advanced.contributors.selected_item')},on:{"select":_vm.selectOneGroup,"remove":_vm.deselectOneGroup},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
                                var option = ref.option;
return [_c('strong',[_vm._v(_vm._s(option.name)+" ")])]}},{key:"option",fn:function(ref){
                                var option = ref.option;
return [_c('div',{style:({ 'margin-left': option.index + 'em' })},[_vm._v("\n                                  "+_vm._s(option.name)+"\n                                ")])]}}],null,false,2181789559),model:{value:(_vm.form.groupEmails),callback:function ($$v) {_vm.$set(_vm.form, "groupEmails", $$v)},expression:"form.groupEmails"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1),_vm._v(" "),(_vm.show_list_mail)?_c('div',{staticClass:"ListMail",attrs:{"id":"ListMail"}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"context"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.currentNameGroup))]),_vm._v(" "),_c('button',{staticClass:"fermer",attrs:{"type":"submit"},on:{"click":function($event){_vm.show_list_mail=false}}},[_vm._v(" X  ")])])]),_vm._v(" "),_c('div',{staticClass:"addmail"},[_c('form',{staticClass:"add-mail-form",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addOneMail.apply(null, arguments)}}},[_c('b-form-input',{staticClass:"input-add-mail",attrs:{"id":"input-add-mail","placeholder":" Ajouter un email","type":"email"},model:{value:(_vm.oneMail),callback:function ($$v) {_vm.oneMail=$$v},expression:"oneMail"}}),_vm._v(" "),_c('button',{staticClass:"icon-add",attrs:{"type":"submit"}},[_vm._v(" + ")])],1)]),_vm._v(" "),_c('div',{staticClass:"list-mail-to-add"},_vm._l((_vm.listGroup),function(item,index){return _c('div',{key:index,staticClass:"onemail"},[_c('div',{staticClass:"mail"},[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('div',{staticClass:"delete cursor",on:{"click":function($event){return _vm.deleteMailInGroup(item.email)}}},[_c('i',{staticClass:"icon-trash"})])])}),0)]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.send_invitations.emails'))+"\n                              ")]),_vm._v(" "),_c('input-tag',{staticClass:"input-email",attrs:{"validate":"email"},model:{value:(_vm.listMailInStor),callback:function ($$v) {_vm.listMailInStor=$$v},expression:"listMailInStor"}})],1)])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.send_rule.title'))+"\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.send_rule')}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.form.rules.length > 0)?_c('div',_vm._l((_vm.form.rules),function(rule,index){return _c('b-row',{key:index},[_c('b-col',{attrs:{"cols":"2"}},[_c('input',{staticClass:"form-control input-send",attrs:{"type":"number","id":'send-rule-' + index,"name":"send rule"},domProps:{"value":rule.nbDays},on:{"input":function($event){return _vm.setNbDays($event, index)}}})]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('span',{staticClass:"positions-text"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.send_rule.days_left')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{staticClass:"form-group beforeHour"},[_c('vue-clock-picker',{attrs:{"id":'beforeHour-' + index,"input-class":"form-control before-hour-rule","value":rule.beforeHour,"active-color":_vm.getActiveColor,"required":false,"cancel-text":_vm.$t('button.cancel'),"done-text":_vm.$t('button.done'),"close-on-overlay":_vm.closeOnOverlay},on:{"cancel":function($event){return _vm.getClockValue($event, index)}},model:{value:(rule.beforeHour),callback:function ($$v) {_vm.$set(rule, "beforeHour", $$v)},expression:"rule.beforeHour"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"5","flex":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(index === 0),expression:"index === 0"}],staticClass:"form-group add-rule-button add-rule-button--position",on:{"click":_vm.addSendRule}},[_c('a',[_c('span',{staticClass:"button-add"},[_vm._v("+")]),_vm._v(" "),_c('span',{staticClass:"add-rule"},[_vm._v("\n                                  "+_vm._s(_vm.$t(
                                      'form_live.tabs.configuration.form.send_rule.add_rule_button'
                                    )))])])])])],1)}),1):_vm._e()])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary conf-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.encoding.title'))+"\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"position-icon icon-infos",attrs:{"title":_vm.$t('form_live.tabs.configuration.form.infos.encoding')}})]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary conf-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.encoding.url')))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"encoding-url"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.encodingUrl),expression:"form.encodingUrl"}],staticClass:"form-control conf-label input-encoding-url",attrs:{"disabled":"","type":"text","id":"encoding-url","name":"encoding url"},domProps:{"value":(_vm.form.encodingUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "encodingUrl", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary copy-button",attrs:{"disabled":""},on:{"click":function($event){return _vm.copyButton($event, 'encoding-url')}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('button.copy'))+"\n                                  ")])])])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary conf-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.encoding.name')))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"encoding-url"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.encodingName),expression:"form.encodingName"}],staticClass:"form-control conf-label input-encoding-name",attrs:{"disabled":"","type":"text","id":"encoding-name","name":"encoding url"},domProps:{"value":(_vm.form.encodingName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "encodingName", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary copy-button",attrs:{"disabled":""},on:{"click":function($event){return _vm.copyButton($event, 'encoding-name')}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('button.copy'))+"\n                                  ")])])])],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"secondary conf-label",attrs:{"for":"title"}},[_vm._v(_vm._s(_vm.$t('form_live.tabs.configuration.form.encoding.key')))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"encoding-url"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.encodingKey),expression:"form.encodingKey"}],staticClass:"form-control conf-label input-encoding-key",attrs:{"disabled":"","type":"text","id":"encoding-key","name":"encoding url"},domProps:{"value":(_vm.form.encodingKey)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "encodingKey", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary copy-button",attrs:{"disabled":""},on:{"click":function($event){return _vm.copyButton($event, 'encoding-key')}}},[_vm._v("\n                                    "+_vm._s(_vm.$t('button.copy'))+"\n                                  ")])])])],1)],1)])],1)],1)])],1)],1)])],1)],1):_vm._e()])],1),_vm._v(" "),_c('b-modal',{ref:"modal-start-direct-v2",attrs:{"title":_vm.$t('startDirect.title'),"id":"modal-start-direct-v2","header-bg-variant":_vm.customheaderBgVariant,"hide-footer":"","size":"lg"}},[_c('div',{staticClass:"subTitle"},[_vm._v(" "+_vm._s(_vm.$t('startDirect.subtitle'))+" ")]),_vm._v(" "),_c('div',{staticClass:"action-start-direct"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary","type":"button"},on:{"click":function($event){return _vm.redirectTo(true)}}},[_vm._v(_vm._s(_vm.$t('startDirect.btn.YES')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"light","type":"button"},on:{"click":function($event){return _vm.redirectTo()}}},[_vm._v(_vm._s(_vm.$t('startDirect.btn.NO')))])],1),_vm._v(" "),_c('div',{staticClass:"action-choix"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_vm._v("\n            "+_vm._s(_vm.$t('startDirect.choix'))+"\n          ")])],1)])])],1)}
var LiveFormV2_staticRenderFns = []
var LiveFormV2_esExports = { render: LiveFormV2_render, staticRenderFns: LiveFormV2_staticRenderFns }
/* harmony default export */ var components_LiveFormV2 = (LiveFormV2_esExports);
// CONCATENATED MODULE: ./src/components/LiveFormV2.vue
function LiveFormV2_injectStyle (ssrContext) {
  __webpack_require__("4+Jt")
}
var LiveFormV2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LiveFormV2___vue_template_functional__ = false
/* styles */
var LiveFormV2___vue_styles__ = LiveFormV2_injectStyle
/* scopeId */
var LiveFormV2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LiveFormV2___vue_module_identifier__ = null
var LiveFormV2_Component = LiveFormV2_normalizeComponent(
  LiveFormV2,
  components_LiveFormV2,
  LiveFormV2___vue_template_functional__,
  LiveFormV2___vue_styles__,
  LiveFormV2___vue_scopeId__,
  LiveFormV2___vue_module_identifier__
)

/* harmony default export */ var src_components_LiveFormV2 = (LiveFormV2_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./node_modules/vue-select/src/scss/vue-select.scss
var scss_vue_select = __webpack_require__("4K1A");
var scss_vue_select_default = /*#__PURE__*/__webpack_require__.n(scss_vue_select);

// EXTERNAL MODULE: ./node_modules/vue-moment/dist/vue-moment.js
var vue_moment = __webpack_require__("8AgW");
var vue_moment_default = /*#__PURE__*/__webpack_require__.n(vue_moment);

// EXTERNAL MODULE: ./node_modules/moment/locale/pt-br.js
var pt_br = __webpack_require__("AoDM");
var pt_br_default = /*#__PURE__*/__webpack_require__.n(pt_br);

// EXTERNAL MODULE: ./node_modules/vue-click-outside/index.js
var vue_click_outside = __webpack_require__("dDoS");
var vue_click_outside_default = /*#__PURE__*/__webpack_require__.n(vue_click_outside);

// CONCATENATED MODULE: ./src/service/access_service.js



var access_service__this = this;



var guidGenerator = function guidGenerator() {
  var S4 = function S4() {
    return Math.random().toString(36).substring(2, 11);
  };
  return '_' + S4() + S4() + S4() + S4();
};
var SendAccess = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(sessionId, action) {
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http_common_HTTP.post("/stat/acces_send", { "EmpStatsQuery": { "session_id": sessionId, "action": action } });

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, access_service__this);
  }));

  return function SendAccess(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var access_service_acces_send = function acces_send(action) {
  var currentDate = new Date();
  var expireDate = new Date(currentDate.getTime() + 20 * 60 * 1000);
  var sessionId = vue_cookies_default.a.get('session_acces');
  if (sessionId) {
    SendAccess(sessionId, action);
  } else {
    sessionId = guidGenerator();
    vue_cookies_default.a.set('session_acces', sessionId, { expires: expireDate });
    SendAccess(sessionId, action);
  }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/ActionButtons.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var ActionButtons = ({
  name: 'ActionButtons',
  components: {
    Toasted: vue_toasted_min_default.a,
    VueSelect: vue_select_default.a,
    VueMoment: vue_moment_default.a
  },
  mixins: [UploadMixin, UtilsMixin],
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  props: {
    row: {
      type: Object,
      default: {}
    }
  },
  directives: {
    HasPermission: HasPermission
  },
  data: function data() {
    return {
      fields: [{ key: 'check', label: '', class: 'd-none d-md-table-cell' }, {
        key: 'id',
        id: '0',
        label: i18n.t('table.list.id'),
        sortable: true,
        class: 'd-none d-lg-table-cell'
      }, {
        key: 'thumbnail',
        id: '1',
        label: i18n.t('table.list.preview'),
        class: 'd-none d-lg-table-cell'
      }, {
        key: 'title',
        id: '2',
        label: i18n.t('table.list.title'),
        sortable: true,
        class: 'd-none d-md-table-cell'
      }, {
        key: 'description',
        id: '3',
        label: i18n.t('table.list.description'),
        sortable: true,
        class: 'd-none d-md-table-cell'
      }, {
        key: 'active',
        id: '4',
        label: i18n.t('table.list.active'),
        class: 'd-none d-md-table-cell'
      }, {
        key: 'dateStart',
        id: '5',
        label: i18n.t('table.list.date'),
        sortable: true,
        class: 'd-none d-lg-table-cell'
      }, {
        key: 'actions',
        id: '6',
        label: i18n.t('table.list.actions'),
        class: 'd-none d-md-table-cell'
      }, { key: 'mobile-details', id: '7', class: 'd-table-cell d-md-none' }, { key: 'show_details', id: '8', class: 'd-table-cell d-md-none w-50px' }],
      statusLive: 'start',

      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 20, 30, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      checkedAll: true,
      mdTime: { date: new Date(), time: '', endtime: '' },
      active: false,
      indeterminate: false,
      periods: ['period', 'week', 'month', 'trimester', 'semester', 'year'],
      tableValues: [],
      totalRows: 1,
      allSelected: false,
      type: 'endless',
      obj: {},
      showTrash: false,
      checkedItems: false,
      selected: [],
      selectedAll: [],
      checked: false,
      isActive: true,
      selectedList: [],
      openModalDelete: false,
      selectedContributor: '',
      substitle: '',
      liveId: '',
      live: {},
      showAllSlides: false,
      diffusionSelected: false,
      numColumn: 0,
      selectedRows: [],
      clickedIcon: false,
      selectedUser: false,
      invitations: [],
      headerBgVariant: 'primary',
      headerTextVariant: 'white',
      screenType: 'pip',
      screenTypeOptions: [{ value: 'pip', text: 'Picture in Picture PIP' }, { value: 'sbs', text: 'Side by Side' }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    allLives: 'lives/getAllLives',
    getContributors: 'lives/getContributors',
    getLive: 'lives/getLive',
    getTotalLive: 'lives/getTotalLive',
    getInfoDetailLive: 'lives/getInfoDetailLive',
    getLinkExportLives: 'lives/getLinkExportLives',
    getSubscriptionUser: 'lives/getSubscriptionUser',
    getArchivedLive: 'lives/getArchivedLive',
    downloadFile: 'lives/getUrlDownloadFile',
    getDiffusion: 'common/getDiffusion',
    getShowExportBtnArchived: 'common/getShowExportBtnArchived',
    getDownloadLive: 'common/getDownloadLive'
  }), {
    isTrashDiffusion: function isTrashDiffusion() {
      return this.getDiffusion === 'trash';
    },
    iframe: function iframe() {
      return '<iframe style="width:100%;height:100%;min-height:560px" src="' + this.getLinkExportLives['embed'] + '" allowfullscreen mozallowfullscreen webkitallowfullscreen frameborder="0" allow="autoplay;"></iframe>';
    },
    shouldShowDiffusionButton: function shouldShowDiffusionButton() {
      var getDiffusion = this.getDiffusion,
          row = this.row;

      var isVisibleButton = (getDiffusion === 'endless' || getDiffusion === 'upcoming' || getDiffusion === 'all') && !row.item.isPearl && row.item.webinar;
      return isVisibleButton;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('lives', ['apiShareLink']), Object(vuex_esm["b" /* mapActions */])({
    paginate: 'lives/paginate',
    getAllContributors: 'lives/fetchContributors',
    deleteMultiLive: 'lives/deleteMultiLive',
    deleteLiveById: 'lives/deleteLiveById',
    exportQuestionsByLiveId: 'lives/exportQuestionsByLiveId',
    setDisableLiveById: 'lives/setDisableLiveById',
    setStopLiveById: 'lives/setStopLiveById',
    setEnableLiveById: 'lives/setEnableLiveById',
    getLiveById: 'lives/getLiveById',
    getInfosDetail: 'lives/getInfosDetail',
    getLinkExport: 'lives/getLinkExport',
    sendInvitationsMails: 'lives/sendInvitationsMails',
    setScreenShare: 'lives/setScreenShare',
    getUrlDownloadFile: 'lives/getUrlDownloadFile',
    getSubscriptionUserList: 'lives/getSubscriptionUserList',
    getSubscriptionGroupUsersList: 'lives/getSubscriptionGroupUsersList',
    getUrlLinkArchivedVideo: 'lives/getUrlLinkArchivedVideo',
    setLives: 'lives/setLives',
    removeLiveById: 'lives/removeLiveById',
    restartDiffusionLive: 'lives/restartDiffusionLive',
    downloadLive: 'lives/downloadLive',
    setShowModal: 'common/setShowModal'
  }), {
    handleDiffusionClick: function handleDiffusionClick(item) {
      if (item.status === 1 && !this.getArchivedLive) {
        this.restartLive(item.id);
      } else if (this.shouldShowDiffusionButton) {
        this.sendPostMessageDiffusionLive(item, "goToDiffusionLive");
      }
    },
    hasUrlFlow: function hasUrlFlow(urlFlow) {
      return (this.getDiffusion === 'endless' || this.getDiffusion === 'upcoming') && urlFlow && urlFlow !== '';
    },
    openModalDeleteLive: function openModalDeleteLive(live, action) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                access_service_acces_send('lives_delete_live_action');
                nprogress_nprogress_default.a.start();
                _this.liveId = live.id;
                _context.next = 5;
                return _this.$root.$emit('setDeleteLiveActivity', { action: action, live: live, multi: false });

              case 5:
                nprogress_nprogress_default.a.done();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setUrlFluxLive: function setUrlFluxLive(flow) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                access_service_acces_send('lives_flux_live_no_api_action');
                nprogress_nprogress_default.a.start();
                _context2.next = 4;
                return _this2.$root.$emit('setUrlFlow', flow);

              case 4:
                nprogress_nprogress_default.a.done();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    uploadLive: function uploadLive(id) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var ua, type, url;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                access_service_acces_send('lives_upload_no_api_action');
                nprogress_nprogress_default.a.start();
                ua = navigator.userAgent;
                type = 'success_download';
                _context3.prev = 4;
                url = router_router.generate('api_download_live', { id: id }) + '?isLive=true';
                _context3.next = 8;
                return HTTP(window.ApiToken).get(url).then(function (response) {
                  var downloadLive = response.data.data;
                  if (downloadLive) {
                    if (downloadLive.exist) {
                      if (ua.indexOf('Firefox') !== -1) {
                        window.open(downloadLive.file, '_blank');
                      } else {
                        window.location.href = downloadLive.file;
                      }
                      type = '';
                    } else {
                      type = 'not-exist';
                    }
                  }
                }).catch(function (e) {
                  type = 'error';
                });

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);

                type = 'error';

              case 13:
                if (type) {
                  _this3.callPopupConfirm(type, i18n.t("toast." + type));
                }
                nprogress_nprogress_default.a.done();

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 10]]);
      }))();
    },
    exportQuestions: function exportQuestions(id) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var response, strMimeType, downloadLink;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this4.exportQuestionsByLiveId(id);

              case 3:
                response = _context4.sent;

                console.log("response: ", response);
                strMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                downloadLink = document.createElement("a");

                downloadLink.href = window.URL.createObjectURL(new Blob([response.data], { type: strMimeType }));
                downloadLink.download = "les questions du live " + id + ".xlsx";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                _this4.showToast('success', i18n.t('toast.export_questions_success'), 'icon-success');
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](0);

                console.log("error while exporting questions", _context4.t0);
                if (_context4.t0.response.status === 404) {
                  _this4.showToast('error', i18n.t('toast.no_questions_to_export'), 'icon-warning');
                } else {
                  _this4.showToast('error', i18n.t('toast.export_questions_error'), 'icon-warning');
                }

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 15]]);
      }))();
    },
    callPopupConfirm: function callPopupConfirm(type, message) {
      var h = this.$createElement;
      var messageVNode = h('div', { class: ['msg-box-download '] }, [h('i', { class: ['icon-' + (type.indexOf('success') > -1 ? 'success' : 'warning') + (' btn-download--' + (type.indexOf('success') > -1 ? 'success' : 'error'))] }), h('p', { class: ['text-center message-box'] }, [message])]);
      this.$bvModal.msgBoxOk(messageVNode, {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: type.indexOf('success') > -1 ? 'success' : 'danger',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0 footer-box-download',
        centered: true
      }).then(function (value) {}).catch(function (err) {
        // An error occurred
      });
    },
    getDiffusionPermission: function getDiffusionPermission(item) {
      if (item.isPearl) {
        return "lives_pearl_diffuser_no_api";
      } else {
        return "lives_diffuser_no_api";
      }
    },
    startLive: function startLive(live) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                nprogress_nprogress_default.a.start();
                _this5.liveId = live.id;
                _context5.next = 4;
                return _this5.$root.$emit('ChangeActivity', { event: true, live: live });

              case 4:
                nprogress_nprogress_default.a.done();

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    stopLive: function stopLive(live) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                nprogress_nprogress_default.a.start();
                _this6.liveId = live.id;
                _context6.next = 4;
                return _this6.$root.$emit('ChangeActivity', { event: false, live: live });

              case 4:
                nprogress_nprogress_default.a.done();

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    GotToExport: function GotToExport(idLive) {
      parent.postMessage({
        info: 'goToListLive',
        id: idLive,
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      var exportLive = 'ExportLive';
      if (window.process.env.HAS_SKIN === 'true') {
        exportLive = 'ExportLiveV2';
      }
      this.$router.push({ name: exportLive, params: { id: idLive }, query: cryptext });
      // this.eventPostMessage();
    },
    GoToEditLive: function GoToEditLive(idLive) {
      access_service_acces_send('lives_post_edit_action');
      parent.postMessage({
        info: 'goToEditLive',
        id: idLive,
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      var editLive = 'EditLive';
      if (window.process.env.HAS_SKIN === 'true') {
        editLive = 'EditLiveV2';
      }
      this.$router.push({ name: editLive, params: { id: idLive }, query: cryptext });
      // this.eventPostMessage();
    },
    openViewModalById: function openViewModalById(id) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                access_service_acces_send('lives_live_detail_no_api_action');
                nprogress_nprogress_default.a.start();
                _this7.liveId = id;
                _context7.next = 5;
                return _this7.getLiveById(id);

              case 5:
                _this7.$root.$emit('bv::show::modal', 'modal-view-row');
                _context7.next = 8;
                return _this7.$root.$emit('isOpenModal', {
                  id: 'modal-view-row'
                });

              case 8:
                _context7.next = 10;
                return _context7.sent;

              case 10:
                //this.$refs['modal-view-row'].show();
                nprogress_nprogress_default.a.done();

              case 11:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    openExportLinkLive: function openExportLinkLive(id) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                access_service_acces_send('lives_export_link_no_api_action');
                nprogress_nprogress_default.a.start();
                _context8.next = 4;
                return _this8.getLinkExport(id);

              case 4:
                _context8.next = 6;
                return _this8.$root.$emit('bv::show::modal', 'modal-link-export-row');

              case 6:
                _context8.next = 8;
                return _this8.$root.$emit('isOpenModal', {
                  id: 'modal-link-export-row'
                });

              case 8:
                //this.$refs['modal-link-export-row'].show();
                nprogress_nprogress_default.a.done();

              case 9:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    goToExportLinkLive: function goToExportLinkLive(id) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var response, exportLink;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.getLinkExport(id);

              case 2:
                response = _context9.sent;

                if (response.code === 200) {
                  exportLink = response.permalien;

                  if (Array.isArray(response.permalien)) {
                    exportLink = response.permalien[0];
                  }
                  window.open(exportLink, '_blank');
                }

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    sendPostMessageLive: function sendPostMessageLive(value, info) {

      switch (info) {
        case "goToStaticsLive":
          access_service_acces_send('lives_stats_no_api_action');
          break;
        case "goToCommentLive":
          access_service_acces_send('lives_comments_no_api_action');
          break;
        case "goToEncodingLive":
          access_service_acces_send('lives_encoder_no_api_action');
          break;
      }

      nprogress_nprogress_default.a.start();
      parent.postMessage({
        info: info,
        id: value.id
      }, '*');
      nprogress_nprogress_default.a.done();
    },
    actionDetail: function actionDetail(data) {
      if (data.status == 1) {
        this.openPreviewArchivedVideo(data.id);
      } else {
        this.goToExportLinkLive(data.id);
      }
    },
    restartLive: function restartLive(liveId) {
      access_service_acces_send('lives_restart_live_no_api_action');
      this.restartDiffusionLive(liveId);
    },
    sendPostMessageDiffusionLive: function sendPostMessageDiffusionLive(value, info) {
      access_service_acces_send('lives_diffuser_no_api_action');
      if (window.process.env.HAS_DIFFUSION_ENCODER) {
        nprogress_nprogress_default.a.start();
        parent.postMessage({
          info: info,
          live: value
        }, '*');
        nprogress_nprogress_default.a.done();
      } else {
        var objectPusher = {
          data: stringify_default()({ date: new Date().getTime() }),
          prefixChannelName: 'broadcast',
          event: 'show-in-stream'
        };
        this.setEnableLiveById({ id: value.id, active: true });
      }
    },
    openInfosLive: function openInfosLive(id) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                access_service_acces_send('lives_live_info_no_api_action');
                nprogress_nprogress_default.a.start();

                _this10.liveId = id;
                _context10.next = 5;
                return _this10.getInfosDetail(id);

              case 5:
                _context10.next = 7;
                return _this10.$root.$emit('isOpenModal', {
                  id: 'modal-infos-live-row'
                });

              case 7:
                nprogress_nprogress_default.a.done();

              case 8:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    openInvitationModalLive: function openInvitationModalLive(live) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                access_service_acces_send('lives_send_mail_no_api_action');
                nprogress_nprogress_default.a.start();
                _this11.liveId = live.id;
                _context11.next = 5;
                return _this11.getSubscriptionUserList();

              case 5:
                _this11.$root.$emit('setLiveId', live.id);
                _this11.$root.$emit('setLiveObject', live);
                _context11.next = 9;
                return _this11.$root.$emit('bv::show::modal', 'modal-send-invitations-row');

              case 9:
                _context11.next = 11;
                return _this11.$root.$emit('isOpenModal', {
                  id: 'modal-send-invitations-row'
                });

              case 11:
                // this.$refs['modal-send-invitations-row'].show();
                nprogress_nprogress_default.a.done();

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    redirectToFormSendGrid: function redirectToFormSendGrid(live) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                access_service_acces_send('lives_send_mail_send_grid_no_api_action');
                nprogress_nprogress_default.a.start();
                _this12.liveId = live.id;
                _this12.$router.push({ name: "mailSendGrid", params: { id: _this12.liveId } });
                nprogress_nprogress_default.a.done();

              case 5:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    openGroupMailsModalLive: function openGroupMailsModalLive(id) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                access_service_acces_send('lives_send_group_mails_no_api_action');
                nprogress_nprogress_default.a.start();
                _this13.liveId = id;
                _context13.next = 6;
                return _this13.getSubscriptionGroupUsersList();

              case 6:
                _this13.$root.$emit('setLiveId', id);
                _context13.next = 9;
                return _this13.$root.$emit('bv::show::modal', 'modal-send-group-mails-row');

              case 9:
                _context13.next = 11;
                return _this13.$root.$emit('isOpenModal', {
                  id: 'modal-send-group-mails-row'
                });

              case 11:
                nprogress_nprogress_default.a.done();
                _context13.next = 18;
                break;

              case 14:
                _context13.prev = 14;
                _context13.t0 = _context13['catch'](0);

                console.log("ERROR:", _context13.t0);
                nprogress_nprogress_default.a.done();

              case 18:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13, [[0, 14]]);
      }))();
    },
    openShareLiveModalLive: function openShareLiveModalLive(id) {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                access_service_acces_send('lives_share_email_no_api_action');
                nprogress_nprogress_default.a.start();
                _this14.liveId = id;
                _context14.prev = 3;
                _context14.next = 6;
                return _this14.getLiveById(id);

              case 6:
                _context14.next = 8;
                return _this14.getSubscriptionGroupUsersList();

              case 8:
                _context14.next = 10;
                return _this14.getSubscriptionUserList();

              case 10:
                // input id output  link
                // set store  output  {link id }
                _this14.apiShareLink(id);
                _this14.setShowModal(true);

                _this14.$root.$emit('setLiveId', id);
                _context14.next = 15;
                return _this14.$root.$emit('bv::show::modal', 'modal-share-link');

              case 15:
                _context14.next = 17;
                return _this14.$root.$emit('isOpenModal', {
                  id: 'modal-share-link'
                });

              case 17:
                nprogress_nprogress_default.a.done();
                _context14.next = 24;
                break;

              case 20:
                _context14.prev = 20;
                _context14.t0 = _context14['catch'](3);

                console.log("ERROR: ", _context14.t0);
                nprogress_nprogress_default.a.done();

              case 24:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this14, [[3, 20]]);
      }))();
    },
    openScreenShareModal: function openScreenShareModal(id) {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                access_service_acces_send('lives_add_screen_share_action');
                nprogress_nprogress_default.a.start();
                //this.liveId = id;
                _this15.$root.$emit('setLiveId', id);
                _context15.next = 5;
                return _this15.$root.$emit('bv::show::modal', 'modal-screen-share-row');

              case 5:
                _context15.next = 7;
                return _this15.$root.$emit('isOpenModal', {
                  id: 'modal-screen-share-row'
                });

              case 7:
                nprogress_nprogress_default.a.done();
                //   this.$refs['modal-screen-share-row'].show();

              case 8:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this15);
      }))();
    },
    downloadScreenFile: function downloadScreenFile(item) {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var message;
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                access_service_acces_send('lives_add_screen_share_action');
                nprogress_nprogress_default.a.start();
                message = void 0;
                _context16.prev = 3;
                _context16.next = 6;
                return _this16.getUrlDownloadFile(item.id);

              case 6:
                _context16.next = 8;
                return _this16.downloadURI(_this16.downloadFile.url_jnlp_file, item.title);

              case 8:
                message = i18n.t('toast.success_download');
                _this16.showToast('success', message, 'icon-success');
                _context16.next = 16;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16['catch'](3);

                message = i18n.t('toast.error');
                _this16.showToast('error', message, 'icon-warning');

              case 16:
                nprogress_nprogress_default.a.done();

              case 17:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this16, [[3, 12]]);
      }))();
    },
    openPreviewArchivedVideo: function openPreviewArchivedVideo(id) {
      var _this17 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                nprogress_nprogress_default.a.start();
                _context17.prev = 1;
                _context17.next = 4;
                return _this17.getUrlLinkArchivedVideo(id);

              case 4:
                _context17.next = 9;
                break;

              case 6:
                _context17.prev = 6;
                _context17.t0 = _context17['catch'](1);

                if (_context17.t0.code === 404 || _context17.t0.code === 500) {
                  console.log('ereeeur not found');
                } else {
                  console.log('ereeeur not transcripted');
                }

              case 9:
                _context17.next = 11;
                return _this17.$root.$emit('bv::show::modal', 'modal-preview-archived-video');

              case 11:
                _context17.next = 13;
                return _this17.$root.$emit('isOpenModal', {
                  id: 'modal-preview-archived-video'
                });

              case 13:
                nprogress_nprogress_default.a.done();

              case 14:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this17, [[1, 6]]);
      }))();
    }
  }),
  mounted: function mounted() {
    this.$root.$on('setFormLang', function (lang) {
      // this.$i18n.locale = lang;

      i18n.locale = lang;
    });
    moment["locale"]('fr');
    //this.eventPostMessage();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69dcda71","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/ActionButtons.vue
var ActionButtons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isTrashDiffusion)?_c('div',{staticClass:"actions-cell"},[(_vm.hasUrlFlow(_vm.row.item.url_player))?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_flux_live_no_api'),expression:"'lives_flux_live_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_flux_live_no_api","title":_vm.$t('button.flow'),"target":"_blank"},on:{"click":function($event){return _vm.setUrlFluxLive(_vm.row.item.url_player)}}},[_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"diffusion"}},[_c('i',{staticClass:"actionIcons btn-icons icon-flux"}),_vm._v("\n          "+_vm._s(_vm.$t('button.flow'))+"\n        ")])],1):_vm._e(),_vm._v(" "),( _vm.row.item.status !== 1  && !_vm.getArchivedLive  && _vm.row.item.isPearl && !!!_vm.row.item.active)?_c('a',{staticClass:"actions",attrs:{"title":"start","target":"_blank"},on:{"click":function($event){return _vm.startLive(_vm.row.item)}}},[_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"diffusion"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons play-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'play' }}}),_vm._v("\n\n          Start\n        ")],1)],1):_vm._e(),_vm._v(" "),((_vm.row.item.isPearl) && _vm.row.item.active && _vm.row.item.status !== 1)?_c('a',{staticClass:"actions",attrs:{"title":"stop","target":"_blank"},on:{"click":function($event){return _vm.stopLive(_vm.row.item)}}},[_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"diffusion"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons stop-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'stop' }}}),_vm._v("\n\n          Stop\n        ")],1)],1):_vm._e(),_vm._v(" "),(_vm.row.item.active)?_c('a',{staticClass:"actions",attrs:{"title":_vm.$t('button.view'),"target":"_blank"},on:{"click":function($event){return _vm.actionDetail(_vm.row.item)}}},[_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"diffusion"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons",attrs:{"icon":{ prefix: 'fas', iconName: 'eye' }}}),_vm._v("\n          "+_vm._s(_vm.$t('button.visualize'))+"\n        ")],1)],1):_vm._e(),_vm._v(" "),((_vm.row.item.status === 1 && !_vm.getArchivedLive) || _vm.shouldShowDiffusionButton)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(_vm.getDiffusionPermission(_vm.row.item)),expression:"getDiffusionPermission(row.item)"}],staticClass:"actions",attrs:{"has-permission":_vm.getDiffusionPermission(_vm.row.item),"title":_vm.$t('button.diffusion'),"target":"_blank"},on:{"click":function($event){return _vm.handleDiffusionClick(_vm.row.item)}}},[(_vm.row.item.status === 1 && !_vm.getArchivedLive)?_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"reduffison"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons",attrs:{"icon":{ prefix: 'fas', iconName: 'video' }}}),_vm._v("\n       "+_vm._s(_vm.$t('button.restart'))+"\n       ")],1):(_vm.shouldShowDiffusionButton)?_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"diffusion"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons",attrs:{"icon":{ prefix: 'fas', iconName: 'video' }}}),_vm._v("\n      "+_vm._s(_vm.$t('button.diffusion'))+"\n  ")],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.getArchivedLive)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_restart_live_no_api'),expression:"'lives_restart_live_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_restart_live_no_api","title":_vm.$t('button.restart')},on:{"click":function($event){return _vm.restartLive(_vm.row.item.id)}}},[_c('b-button',{staticClass:"diffusion-btn",attrs:{"variant":"diffusion"}},[_c('font-awesome-icon',{staticClass:"actionIcons btn-icons",attrs:{"icon":{ prefix: 'fas', iconName: 'video' }}}),_vm._v("\n          "+_vm._s(_vm.$t('button.restart'))+"\n        ")],1)],1):_vm._e(),_vm._v(" "),(!_vm.getArchivedLive && _vm.row.item.status !== 1)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_post_edit'),expression:"'lives_post_edit'"}],staticClass:"actions",attrs:{"title":_vm.$t('button.edit'),"target":"_blank","has-permission":"lives_post_edit"},on:{"click":function($event){return _vm.GoToEditLive(_vm.row.item.id)}}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'pencil-alt' }}})],1):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_live_detail_no_api'),expression:"'lives_live_detail_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_live_detail_no_api","title":_vm.$t('button.view'),"target":"_blank"},on:{"click":function($event){return _vm.openViewModalById(_vm.row.item.id)}}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'eye' }}})],1),_vm._v(" "),_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_delete_live'),expression:"'lives_delete_live'"}],staticClass:"actions",attrs:{"has-permission":"lives_delete_live","title":_vm.$t('button.delete'),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'trash' }},on:{"click":function($event){return _vm.openModalDeleteLive(_vm.row.item, 'archiving')}}})],1),_vm._v(" "),_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_stats_no_api'),expression:"'lives_stats_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_stats_no_api","title":_vm.$t('button.statistics'),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'chart-bar' }},on:{"click":function($event){return _vm.sendPostMessageLive(_vm.row.item, 'goToStaticsLive')}}})],1),_vm._v(" "),(_vm.row.item.screenShare && !_vm.getArchivedLive)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_add_screen_share'),expression:"'lives_add_screen_share'"}],staticClass:"actions",attrs:{"has-permission":"lives_add_screen_share","title":_vm.$t('button.share'),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fab', iconName: 'chromecast' }},on:{"click":function($event){return _vm.openScreenShareModal(_vm.row.item.id)}}})],1):_vm._e(),_vm._v(" "),(_vm.row.item.screenShare)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_add_screen_share'),expression:"'lives_add_screen_share'"}],staticClass:"actions",attrs:{"has-permission":"lives_add_screen_share","title":_vm.$t('button.download'),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'file-download' }},on:{"click":function($event){return _vm.downloadScreenFile(_vm.row.item)}}})],1):_vm._e(),_vm._v(" "),(_vm.row.item.status !== 1 || _vm.getShowExportBtnArchived)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_export_link_no_api'),expression:"'lives_export_link_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_export_link_no_api","title":_vm.$t('button.link_export'),"target":"_blank"},on:{"click":function($event){return _vm.openExportLinkLive(_vm.row.item.id)}}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'link' }}})],1):_vm._e(),_vm._v(" "),(!_vm.row.item.webinar)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_live_info_no_api'),expression:"'lives_live_info_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_live_info_no_api","title":_vm.$t('button.infos'),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'info-circle' }},on:{"click":function($event){return _vm.openInfosLive(_vm.row.item.id)}}})],1):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_live_inscrits_list_no_api'),expression:"'lives_live_inscrits_list_no_api'"}],staticClass:"actions",attrs:{"has-permission":"lives_live_inscrits_list_no_api","target":"_blank","title":_vm.$t('button.export')},on:{"click":function($event){return _vm.GotToExport(_vm.row.item.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('path',{attrs:{"d":"M1.615 16C1.155 16 0.771 15.846 0.463 15.538C0.154333 15.2293 0 14.845 0 14.385V1.615C0 1.155 0.154333 0.771 0.463 0.463C0.771 0.154333 1.155 0 1.615 0H14.385C14.845 0 15.229 0.154333 15.537 0.463C15.8457 0.771 16 1.155 16 1.615V14.385C16 14.845 15.846 15.229 15.538 15.537C15.2293 15.8457 14.845 16 14.385 16H1.615ZM1 4.998H15V1.615C15 1.46167 14.936 1.32067 14.808 1.192C14.6793 1.064 14.5383 1 14.385 1H1.615C1.46167 1 1.32067 1.064 1.192 1.192C1.064 1.32067 1 1.46167 1 1.615V4.998ZM1 10.002H15V5.998H1V10.002ZM1.615 15H14.385C14.5383 15 14.6793 14.936 14.808 14.808C14.936 14.6793 15 14.5383 15 14.385V11.002H1V14.385C1 14.5383 1.064 14.6793 1.192 14.808C1.32067 14.936 1.46167 15 1.615 15ZM2.77 3.804V2.188H4.386V3.804H2.77ZM2.77 8.808V7.192H4.386V8.808H2.77ZM2.77 13.812V12.196H4.386V13.812H2.77Z","fill":"#757575"}})])]),_vm._v(" "),(_vm.getArchivedLive)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_upload_no_api'),expression:"'lives_upload_no_api'"}],staticClass:"actions upload-btn",attrs:{"has-permission":"lives_upload_no_api","title":_vm.$t('button.upload'),"target":"_blank"},on:{"click":function($event){return _vm.uploadLive(_vm.row.item.id)}}},[_c('i',{staticClass:"icon-upload"})]):_vm._e(),_vm._v(" "),(_vm.getArchivedLive)?_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('comment_post_export'),expression:"'comment_post_export'"}],staticClass:"actions",attrs:{"has-permission":"comment_post_export_action","title":_vm.$t('button.export_questions'),"target":"_blank"},on:{"click":function($event){return _vm.exportQuestions(_vm.row.item.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"}},[_c('path',{attrs:{"d":"M14.625 9.32812C14.625 11.599 13.1111 15.3837 7.8125 15.3837C2.51389 15.3837 1 11.599 1 9.32812","stroke":"#757575","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.81543 1.03906V11.5983","stroke":"#757575","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.27075 5.54167L7.81242 1L12.3541 5.54167","stroke":"#757575","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isTrashDiffusion)?_c('div',{staticClass:"actions-cell"},[_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_trash_delete_live'),expression:"'lives_trash_delete_live'"}],staticClass:"actions",attrs:{"has-permission":"lives_trash_delete_live","title":_vm.$t('button.delete'),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"actionIcons",attrs:{"icon":{ prefix: 'fas', iconName: 'trash' }},on:{"click":function($event){return _vm.openModalDeleteLive(_vm.row.item, 'deleting')}}})],1),_vm._v(" "),_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_restore_no_api'),expression:"'lives_restore_no_api'"}],staticClass:"actions restore-btn",attrs:{"has-permission":"lives_restore_no_api","title":_vm.$t('button.restore'),"target":"_blank"},on:{"click":function($event){return _vm.openModalDeleteLive(_vm.row.item, 'restoring')}}},[_c('i',{staticClass:"icon-backup-restore"})])]):_vm._e()])}
var ActionButtons_staticRenderFns = []
var ActionButtons_esExports = { render: ActionButtons_render, staticRenderFns: ActionButtons_staticRenderFns }
/* harmony default export */ var components_ActionButtons = (ActionButtons_esExports);
// CONCATENATED MODULE: ./src/components/components/ActionButtons.vue
function ActionButtons_injectStyle (ssrContext) {
  __webpack_require__("Dq3X")
}
var ActionButtons_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ActionButtons___vue_template_functional__ = false
/* styles */
var ActionButtons___vue_styles__ = ActionButtons_injectStyle
/* scopeId */
var ActionButtons___vue_scopeId__ = "data-v-69dcda71"
/* moduleIdentifier (server only) */
var ActionButtons___vue_module_identifier__ = null
var ActionButtons_Component = ActionButtons_normalizeComponent(
  ActionButtons,
  components_ActionButtons,
  ActionButtons___vue_template_functional__,
  ActionButtons___vue_styles__,
  ActionButtons___vue_scopeId__,
  ActionButtons___vue_module_identifier__
)

/* harmony default export */ var components_components_ActionButtons = (ActionButtons_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/RatingStars.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RatingStars = ({
  name: 'RatingStars',
  props: {
    nbVote: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      stars: []
    };
  },

  computed: {
    rating: function rating() {
      return Math.round(this.nbVote * 2) / 2;
    }
  },
  created: function created() {
    for (var i = 5; i > 0; i -= 0.5) {
      var star = {
        id: 'star-' + i + this.id,
        value: i,
        class: i % 1 === 0 ? 'full' : 'half'
      };
      this.stars.push(star);
    }
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b75626","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/RatingStars.vue
var RatingStars_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"rating"},[_vm._l((_vm.stars),function(star){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rating),expression:"rating"}],attrs:{"type":"radio","id":star.id,"name":'rating-' + _vm.id,"disabled":""},domProps:{"value":star.value,"checked":_vm._q(_vm.rating,star.value)},on:{"change":function($event){_vm.rating=star.value}}}),_vm._v(" "),_c('label',{class:star.class,attrs:{"for":star.id}})]})],2)}
var RatingStars_staticRenderFns = []
var RatingStars_esExports = { render: RatingStars_render, staticRenderFns: RatingStars_staticRenderFns }
/* harmony default export */ var components_RatingStars = (RatingStars_esExports);
// CONCATENATED MODULE: ./src/components/components/RatingStars.vue
function RatingStars_injectStyle (ssrContext) {
  __webpack_require__("/K/w")
}
var RatingStars_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RatingStars___vue_template_functional__ = false
/* styles */
var RatingStars___vue_styles__ = RatingStars_injectStyle
/* scopeId */
var RatingStars___vue_scopeId__ = "data-v-19b75626"
/* moduleIdentifier (server only) */
var RatingStars___vue_module_identifier__ = null
var RatingStars_Component = RatingStars_normalizeComponent(
  RatingStars,
  components_RatingStars,
  RatingStars___vue_template_functional__,
  RatingStars___vue_styles__,
  RatingStars___vue_scopeId__,
  RatingStars___vue_module_identifier__
)

/* harmony default export */ var components_components_RatingStars = (RatingStars_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/LikeDislike.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LikeDislike = ({
  name: 'LikeDislike',
  props: {
    nbLike: {
      type: Number,
      default: 0
    },
    nbNotLike: {
      type: Number,
      default: 0
    }
  },
  directives: {
    HasPermission: HasPermission
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eeb3119","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/LikeDislike.vue
var LikeDislike_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like-dislike-container"},[_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_show_like'),expression:"'lives_dtable_show_like'"}],staticClass:"like-wrapper",attrs:{"has-permission":"lives_dtable_show_like"}},[_c('i',{staticClass:"icon-thumbs-up"}),_vm._v(" "+_vm._s(_vm.nbLike)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_show_not_like'),expression:"'lives_dtable_show_not_like'"}],staticClass:"like-wrapper like-wrapper__dislike",attrs:{"has-permission":"lives_dtable_show_not_like"}},[_c('i',{staticClass:"icon-thumbs-up"}),_vm._v(" "+_vm._s(_vm.nbNotLike)+"\n  ")])])}
var LikeDislike_staticRenderFns = []
var LikeDislike_esExports = { render: LikeDislike_render, staticRenderFns: LikeDislike_staticRenderFns }
/* harmony default export */ var components_LikeDislike = (LikeDislike_esExports);
// CONCATENATED MODULE: ./src/components/components/LikeDislike.vue
function LikeDislike_injectStyle (ssrContext) {
  __webpack_require__("nnzz")
}
var LikeDislike_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LikeDislike___vue_template_functional__ = false
/* styles */
var LikeDislike___vue_styles__ = LikeDislike_injectStyle
/* scopeId */
var LikeDislike___vue_scopeId__ = "data-v-7eeb3119"
/* moduleIdentifier (server only) */
var LikeDislike___vue_module_identifier__ = null
var LikeDislike_Component = LikeDislike_normalizeComponent(
  LikeDislike,
  components_LikeDislike,
  LikeDislike___vue_template_functional__,
  LikeDislike___vue_styles__,
  LikeDislike___vue_scopeId__,
  LikeDislike___vue_module_identifier__
)

/* harmony default export */ var components_components_LikeDislike = (LikeDislike_Component.exports);

// EXTERNAL MODULE: ./src/assets/icons/Close.svg
var Close = __webpack_require__("/Qkg");
var Close_default = /*#__PURE__*/__webpack_require__.n(Close);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modal/shareLink.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























var moments = __webpack_require__("PJh5");
/* harmony default export */ var shareLink = ({
  name: 'ShareLink',
  components: {
    'v-select': vue_select_default.a,
    VuePerfectScrollbar: dist_default.a,
    VueMoment: vue_moment_default.a,
    moment: moment,
    Toasted: vue_toasted_min_default.a,
    ActionsButtons: components_components_ActionButtons,
    RatingStars: components_components_RatingStars,
    LikeDislike: components_components_LikeDislike,
    InputTag: vueInputTag_common_default.a,
    Multiselect: vue_multiselect_min_default.a
  },
  directives: {
    ClickOutside: vue_click_outside_default.a,
    HasPermission: HasPermission
  },
  mixins: [UploadMixin, UtilsMixin],
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  data: function data() {
    return {
      Close: Close_default.a,
      loading: false,
      showPassword: false,
      emailInput: '',
      dateToSend: new Date(),
      share: {
        user: '',
        modelgroup: [],
        modelUser: [],
        modelWebtvUsers: [],
        startDate: new Date(),
        emails: [],
        private: false,
        pwd: '',
        shareLink: '',
        liveId: ''
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    allLives: 'lives/getAllLives',
    getContributors: 'lives/getContributors',
    getLive: 'lives/getLive',
    getTotalLive: 'lives/getTotalLive',
    isBusy: 'lives/getIsLoading',
    getInfoDetailLive: 'lives/getInfoDetailLive',
    getLinkExportLives: 'lives/getLinkExportLives',
    getSubscriptionUser: 'lives/getSubscriptionUser',
    getSubscriptionGroupUsers: 'lives/getSubscriptionGroupUsers',
    getWebtvUsers: 'lives/getWebtvUsers',
    getWebtvGroups: 'lives/getWebtvGroups',
    getUseJitsi: 'common/getUseJitsi',
    getDiffusionObject: 'lives/getDiffusionObject',
    getLinkArchivedVideo: 'lives/getLinkArchivedVideo',
    getDiffusion: 'common/getDiffusion',
    me: 'common/getUserName',
    getDataShareLink: 'lives/getDataShareLink',
    id: 'lives/getLiveId',
    showModal: 'common/getShowModal'
  }), {
    getActiveColor: function getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('lives', ['apiSendDataMail']), Object(vuex_esm["b" /* mapActions */])({
    paginate: 'lives/paginate',
    getAllContributors: 'lives/fetchContributors',
    deleteMultiLive: 'lives/deleteMultiLive',
    deleteLiveById: 'lives/deleteLiveById',
    setDisableLiveById: 'lives/setDisableLiveById',
    setEnableLiveById: 'lives/setEnableLiveById',
    getLiveById: 'lives/getLiveById',
    getInfosDetail: 'lives/getInfosDetail',
    getLinkExport: 'lives/getLinkExport',
    getSubscriptionUserList: 'lives/getSubscriptionUserList',
    getSubscriptionGroupUsersList: 'lives/getSubscriptionGroupUsersList',
    getWebtvUsersList: 'lives/getWebtvUsersList',
    getWebtvGroupsList: 'lives/getWebtvGroupsList',
    sendInvitationsMails: 'lives/sendInvitationsMails',
    sendInvitationsGroupMails: 'lives/sendInvitationsGroupMails',
    setScreenShare: 'lives/setScreenShare',
    getUrlDownloadFile: 'lives/getUrlDownloadFile',
    setDiffusionObject: 'lives/setDiffusionObject',
    setLives: 'lives/setLives',
    removeLiveById: 'lives/removeLiveById',
    isArchivedLive: 'lives/isArchivedLive',
    setDiffusion: 'common/setDiffusionLive',
    setShowModal: 'common/setShowModal'
  }), {
    getNamePermalink: function getNamePermalink(index) {
      if (index === 0) {
        return i18n.t('modal.export.permalink');
      } else {
        return i18n.t('modal.export.standAlone');
      }
    },
    disablePastDays: function disablePastDays(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var selectedDate = moment(date, 'DD MMM YYYY').toDate();
      selectedDate.setHours(0, 0, 0, 0);
      return selectedDate < today;
    },
    sendsharelink: function sendsharelink() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var message, webtvUsersEmails, emails, groups, dataToSend;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                message = void 0;
                _context.prev = 1;

                _this.loading = true;
                _this.share.shareLink = _this.getDataShareLink;
                _this.share.user = _this.me;
                _this.share.liveId = _this.id;

                if (!(!_this.share.emails.length && !_this.share.modelgroup.length && !_this.share.modelWebtvUsers.length)) {
                  _context.next = 11;
                  break;
                }

                message = i18n.t('toast.no_emails_provided');
                _this.showToast('error', message, 'icon-warning');
                _this.loading = false;
                return _context.abrupt('return');

              case 11:
                if (_this.dateToSend) {
                  _context.next = 16;
                  break;
                }

                message = i18n.t('toast.no_date_provided');
                _this.showToast('error', message, 'icon-warning');
                _this.loading = false;
                return _context.abrupt('return');

              case 16:
                webtvUsersEmails = _this.share.modelWebtvUsers.map(function (user) {
                  return {
                    email: user.email,
                    role: user.role,
                    nom: user.firstName,
                    prenom: user.lastName
                  };
                });
                emails = [].concat(toConsumableArray_default()(_this.share.emails), toConsumableArray_default()(webtvUsersEmails));
                groups = _this.share.modelgroup.map(function (group) {
                  return { id: group.id, role: group.role };
                });
                dataToSend = {
                  groups: groups,
                  live_id: _this.share.liveId,
                  emails: emails,
                  live_description: _this.getLive.description
                };


                console.log('data to send : ', dataToSend);

                _context.next = 23;
                return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/send-live-invitation', dataToSend, {
                  headers: {
                    Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
                  }
                });

              case 23:
                message = i18n.t('toast.success_send_link');
                _this.loading = false;
                _this.$root.$emit('bv::hide::modal', 'modal-send-group-mails-row');
                _this.showToast('success', message, 'icon-success');
                _context.next = 35;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context['catch'](1);

                console.log('ERROR: sending mail', _context.t0);
                _this.loading = false;
                message = i18n.t('toast.error');
                _this.showToast('error', message, 'icon-warning');

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 29]]);
      }))();
    },
    changeEmails: function changeEmails() {
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (this.emailInput.trim() !== '' && emailRegex.test(this.emailInput.trim())) {
        this.share.emails.push({
          email: this.emailInput.trim(),
          role: 'listener'
        });
        this.emailInput = '';
      }
    },
    roleHandler: function roleHandler(e, index) {
      this.share.emails[index].role = e.target.value;
    },
    userRoleHandler: function userRoleHandler(e, id) {
      var index = this.share.modelWebtvUsers.findIndex(function (user) {
        return user.id === id;
      });
      this.share.modelWebtvUsers[index].role = e.target.value;
    },
    groupRoleHandler: function groupRoleHandler(e, id) {
      var index = this.share.modelgroup.findIndex(function (group) {
        return group.id === id;
      });
      this.share.modelgroup[index].role = e.target.value;
    },
    closeModal: function closeModal() {
      this.share.emails = [];
      this.share.modelgroup = [];
      this.share.modelWebtvUsers = [];
      this.setShowModal(false);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              moment["locale"]('en');
              _this2.getWebtvUsersList();
              _this2.getWebtvGroupsList();

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596e901f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/shareLink.vue
var shareLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"modal-container-1",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-content-1",on:{"click":function (e) { return e.stopPropagation(); }}},[_c('div',{staticClass:"modal-header-1"},[_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('modal.send_email')))]),_vm._v(" "),_c('span',[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.Close,"alt":"Close Icon"},on:{"click":_vm.closeModal}})])]),_vm._v(" "),_c('div',{staticClass:"modal-body-1"},[_c('div',{staticClass:"mb-1 group-mails card-to-show"},[_c('div',{staticClass:"groups-header"},[_c('label',{staticStyle:{"margin":"0","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('modal.select_groups')))])]),_vm._v(" "),_c('div',{staticClass:"multiSelect-container"},[_c('span',[_vm._v(_vm._s(_vm.$t('modal.groups')))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getWebtvGroups.map(function (group) {
                return Object.assign({}, group,
                  {role: 'listener'});
              }),"multiple":true,"track-by":"id","label":"name","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('shareLink.selected')},scopedSlots:_vm._u([{key:"tag",fn:function(ref){
              var option = ref.option;
              var remove = ref.remove;
return [_c('div',{staticClass:"custom-tag"},[_c('span',[_vm._v(_vm._s(option.name))]),_vm._v(" "),_c('select',{staticClass:"select-input",domProps:{"value":option.role},on:{"change":function (e) { return _vm.groupRoleHandler(e, option.id); }}},[_c('option',{attrs:{"value":"listener"}},[_vm._v(_vm._s(_vm.$t('shareLink.listener')))]),_vm._v(" "),(!_vm.getLive.isPearl)?_c('option',{attrs:{"value":"participant"}},[_vm._v("\n                    "+_vm._s(_vm.$t('shareLink.participant'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"moderator"}},[_vm._v(_vm._s(_vm.$t('shareLink.moderator')))])]),_vm._v(" "),_c('span',{staticClass:"close-icon",on:{"click":function($event){return remove(option)}}},[_c('font-awesome-icon',{staticClass:"actionIcons icon-add-email",staticStyle:{"cursor":"pointer"},attrs:{"icon":{ prefix: 'fas', iconName: 'times' }}})],1)])]}}],null,false,1351535258),model:{value:(_vm.share.modelgroup),callback:function ($$v) {_vm.$set(_vm.share, "modelgroup", $$v)},expression:"share.modelgroup"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('modal.users'))+" ")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.getWebtvUsers.map(function (user) {
                return Object.assign({}, user,
                  {role: 'listener'});
              }),"multiple":true,"track-by":"id","label":"email","placeholder":"","close-on-select":false,"select-label":_vm.$t('form_live.tabs.advanced.contributors.select_item'),"deselect-label":_vm.$t('form_live.tabs.advanced.contributors.delete_item'),"selected-label":_vm.$t('shareLink.selected')},scopedSlots:_vm._u([{key:"tag",fn:function(ref){
              var option = ref.option;
              var remove = ref.remove;
return [_c('div',{staticClass:"custom-tag"},[_c('span',[_vm._v(_vm._s(option.email))]),_vm._v(" "),_c('select',{staticClass:"select-input",domProps:{"value":option.role},on:{"change":function (e) { return _vm.userRoleHandler(e, option.id); }}},[_c('option',{attrs:{"value":"listener"}},[_vm._v(_vm._s(_vm.$t('shareLink.listener')))]),_vm._v(" "),(!_vm.getLive.isPearl)?_c('option',{attrs:{"value":"participant"}},[_vm._v("\n                    "+_vm._s(_vm.$t('shareLink.participant'))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"moderator"}},[_vm._v(_vm._s(_vm.$t('shareLink.moderator')))])]),_vm._v(" "),_c('span',{staticClass:"close-icon",on:{"click":function($event){return remove(option)}}},[_c('font-awesome-icon',{staticClass:"actionIcons icon-add-email",staticStyle:{"cursor":"pointer"},attrs:{"icon":{ prefix: 'fas', iconName: 'times' }}})],1)])]}}],null,false,1586415071),model:{value:(_vm.share.modelWebtvUsers),callback:function ($$v) {_vm.$set(_vm.share, "modelWebtvUsers", $$v)},expression:"share.modelWebtvUsers"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_result')))]),_vm._v(" "),_c('span',{attrs:{"slot":"noOptions"},slot:"noOptions"},[_vm._v(_vm._s(_vm.$t('form_live.tabs.advanced.contributors.no_options')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"emails-list"},[_c('label',[_vm._v(_vm._s(_vm.$t('modal.send_group_mails.insert_mails.label')))]),_vm._v(" "),_c('div',{staticClass:"tags-input"},[_vm._l((_vm.share.emails),function(tag,index){return _c('div',{key:index,staticClass:"tag"},[_vm._v("\n            "+_vm._s(tag.email)+"\n            "),_c('select',{staticClass:"select-input",domProps:{"value":tag.role},on:{"change":function (e) { return _vm.roleHandler(e, index); }}},[_c('option',{attrs:{"value":"listener"}},[_vm._v(_vm._s(_vm.$t('shareLink.listener')))]),_vm._v(" "),(!_vm.getLive.isPearl)?_c('option',{attrs:{"value":"participant"}},[_vm._v("\n                "+_vm._s(_vm.$t('shareLink.participant'))+"\n              ")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"close-icon",on:{"click":function($event){return _vm.share.emails.splice(index, 1)}}},[_c('font-awesome-icon',{staticClass:"actionIcons icon-add-email",attrs:{"icon":{ prefix: 'fas', iconName: 'times' }}})],1)])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailInput),expression:"emailInput"}],staticStyle:{"border":"none","outline":"none","padding":"5px","flex-grow":"1"},attrs:{"type":"text","placeholder":_vm.$t('shareLink.emails_placeholder')},domProps:{"value":(_vm.emailInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changeEmails.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.emailInput=$event.target.value}}})],2)]),_vm._v(" "),_c('div',{staticClass:"buttons_container-1"},[_c('button',{staticClass:"cancel_button",on:{"click":_vm.closeModal}},[_vm._v(_vm._s(_vm.$t('button.cancel')))]),_vm._v(" "),_c('button',{staticClass:"send_button",on:{"click":_vm.sendsharelink}},[_vm._v("\n          "+_vm._s(_vm.$t('button.send'))+"\n\n          "),(_vm.loading)?_c('span',{staticClass:"loader"}):_vm._e()])])])])]):_vm._e()}
var shareLink_staticRenderFns = []
var shareLink_esExports = { render: shareLink_render, staticRenderFns: shareLink_staticRenderFns }
/* harmony default export */ var modal_shareLink = (shareLink_esExports);
// CONCATENATED MODULE: ./src/components/modal/shareLink.vue
function shareLink_injectStyle (ssrContext) {
  __webpack_require__("dHfH")
}
var shareLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var shareLink___vue_template_functional__ = false
/* styles */
var shareLink___vue_styles__ = shareLink_injectStyle
/* scopeId */
var shareLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var shareLink___vue_module_identifier__ = null
var shareLink_Component = shareLink_normalizeComponent(
  shareLink,
  modal_shareLink,
  shareLink___vue_template_functional__,
  shareLink___vue_styles__,
  shareLink___vue_scopeId__,
  shareLink___vue_module_identifier__
)

/* harmony default export */ var components_modal_shareLink = (shareLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ListLive.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import * as lang from 'vuejs-datepicker/src/locale';

























/* harmony default export */ var ListLive = ({
  name: 'ListLive',
  components: {
    Datepicker: vue2_datepicker_lib_default.a,
    'v-select': vue_select_default.a,
    VuePerfectScrollbar: dist_default.a,
    VueMoment: vue_moment_default.a,
    moment: moment,
    Toasted: vue_toasted_min_default.a,
    ActionsButtons: components_components_ActionButtons,
    RatingStars: components_components_RatingStars,
    LikeDislike: components_components_LikeDislike,
    InputTag: vueInputTag_common_default.a,
    ShareLink: components_modal_shareLink
  },
  directives: {
    ClickOutside: vue_click_outside_default.a,
    HasPermission: HasPermission
  },
  mixins: [UploadMixin, UtilsMixin],
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  data: function data() {
    var _this = this;

    return {
      isArchived: false,
      currentPage: 1,
      perPage: 20,
      pageOptions: [{ item: '5', name: '5' }, { item: '10', name: '10' }, { item: '20', name: '20' }, { item: '30', name: '30' }, { item: '50', name: '50' }, { item: '100', name: '100' }],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      checkedAll: true,
      mdTime: { date: '', time: '', endtime: '' },
      //languages: lang,
      active: false,
      indeterminate: false,
      tableValues: [],
      totalRows: 1,
      allSelected: false,
      type: 'endless',
      obj: {},
      showTrash: false,
      checkedItems: false,
      selected: [],
      selectedAll: [],
      checked: false,
      isActive: true,
      selectedList: [],
      openModalDelete: false,
      isLoading: false,
      selectedContributor: '',
      substitle: '',
      liveId: '',
      liveObject: '',
      live: {},
      showAllSlides: false,
      diffusionSelected: false,
      numColumn: 0,
      selectedRows: [],
      clickedEmbed: false,
      clickedModerator: false,
      clickedJournalist: false,
      clickedPermalink: false,
      clickedUrlExport: false,
      selectedUser: false,
      selectedGroupUser: false,
      hasGroupMails: false,
      invitations: [],
      groupInvitations: [],
      groupMails: [],
      headerBgVariant: 'primary',
      headerTextVariant: 'white',
      screenType: 'pip',
      screenTypeOptions: [{ value: 'pip', text: 'Picture in Picture PIP' }, { value: 'sbs', text: 'Side by Side' }],
      titleSelected: 'all',
      /////newwwww date picker
      time1: '',
      time2: '',
      time3: '',
      // custom lang

      // custom range shortcuts
      shortcuts: [{
        text: 'Today',
        onClick: function onClick() {
          _this.time3 = [new Date(), new Date()];
        }
      }],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      permalinkIndex: '',
      period: '',
      form: {
        defaultChoice: false,
        emails: []
      },
      show: true,
      colors: {},
      statusLive: 'start',
      titleOnDeletedLive: 'archiving',
      isSatusChanged: false,
      isRestoreingLive: false,
      isArchivingLive: false,
      isMultiDelete: false,
      isArchivedMulti: '',
      urlFlow: ''
    };
  },

  watch: {
    checkedItems: function checkedItems(a, b) {
      this.allSelected = this.tableValues.length === a.length;
    },

    allLives: {
      handler: function handler(lives) {
        this.syncLivesSockets({ lives: lives, diffusionType: this.getDiffusion });
      },

      deep: true,
      immediate: true

    },
    getReloadListFlag: function getReloadListFlag() {
      // Trigger your method to reload the live list
      this.paginate(this.obj);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    allLives: 'lives/getAllLives',
    getContributors: 'lives/getContributors',
    getLive: 'lives/getLive',
    getTotalLive: 'lives/getTotalLive',
    isBusy: 'lives/getIsLoading',
    getInfoDetailLive: 'lives/getInfoDetailLive',
    getLinkExportLives: 'lives/getLinkExportLives',
    getSubscriptionUser: 'lives/getSubscriptionUser',
    getSubscriptionGroupUsers: 'lives/getSubscriptionGroupUsers',
    getUseJitsi: 'common/getUseJitsi',
    getDiffusionObject: 'lives/getDiffusionObject',
    getLinkArchivedVideo: 'lives/getLinkArchivedVideo',
    getDiffusion: 'common/getDiffusion',
    defaultThumbnail: 'common/getDefaultThumbnail',
    getArchivedLive: 'lives/getArchivedLive',
    getResponseDelete: 'lives/getResponseDelete',
    getReloadListFlag: 'socket/getReloadListFlag'
  }), {
    getFirstUniquePermalink: function getFirstUniquePermalink() {
      var filteredPermalinks = this.getLinkExportLives['permalien'].filter(function (perm) {
        return perm.includes('/live-event/');
      });
      return filteredPermalinks.length > 0 ? [filteredPermalinks[0]] : [];
    },
    formattedContributors: function formattedContributors() {
      return this.getContributors.map(function (contributor) {
        return {
          id: contributor.id,
          name: '' + contributor.name
        };
      });
    },
    getUrlFlow: function getUrlFlow() {
      return this.urlFlow;
    },
    isTrashDiffusion: function isTrashDiffusion() {
      return this.getDiffusion === 'trash';
    },
    isArchivingMultiLive: function isArchivingMultiLive() {
      return this.isArchivedMulti === 'archiving';
    },
    getStatusLive: function getStatusLive() {
      return this.statusLive;
    },
    getTitleOnDeletedLive: function getTitleOnDeletedLive() {
      return this.titleOnDeletedLive;
    },
    getDefaultThumb: function getDefaultThumb() {
      return "/" + 'liste-lives/static/vignette/' + this.thumbnail;
    },
    iframe: function iframe() {
      return '<iframe style="width:100%;height:100%;min-height:560px" src="' + this.getLinkExportLives['embed'] + '" allowfullscreen mozallowfullscreen webkitallowfullscreen frameborder="0" allow="autoplay;"></iframe>';
    },
    thumbnail: function thumbnail() {
      var defaultTumbnail = 'vignette_purple.jpg';
      if (window.process.env.ISFM && window.process.env.ISFM !== "false") {
        defaultTumbnail = 'vignette_green.jpeg';
      }
      if (this.defaultThumbnail && this.defaultThumbnail !== null && this.defaultThumbnail !== '' && this.defaultThumbnail !== undefined) {
        defaultTumbnail = this.defaultThumbnail;
      }
      return defaultTumbnail;
    },
    noArchivedVideo: function noArchivedVideo() {
      return 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MCA4MCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBmaWxsPSIjODM5Y2IyIiBkPSJNMzIuNSA1NC41SDQ3LjVWNjcuNUgzMi41eiIvPjxwYXRoIGZpbGw9IiM2Njc5OGYiIGQ9Ik00Nyw1NXYxMkgzM1Y1NUg0NyBNNDgsNTRIMzJ2MTRoMTZWNTRMNDgsNTR6Ii8+PHBhdGggZmlsbD0iI2IwYzFkNCIgZD0iTTE3LjUgNjQuNUg2Mi41VjcwLjVIMTcuNXoiLz48cGF0aCBmaWxsPSIjNjY3OThmIiBkPSJNNjIsNjV2NUgxOHYtNUg2MiBNNjMsNjRIMTd2N2g0NlY2NEw2Myw2NHoiLz48cGF0aCBmaWxsPSIjZjJmYWZmIiBkPSJNMS41IDkuNUg3OC41VjU3LjVIMS41eiIvPjxwYXRoIGZpbGw9IiM3ODhiOWMiIGQ9Ik03OCwxMHY0N0gyVjEwSDc4IE03OSw5SDF2NDloNzhWOUw3OSw5eiIvPjxnPjxwYXRoIGZpbGw9IiNmNzhmOGYiIGQ9Ik0xMi41LDM5LjV2LTM5aDU1djM5SDEyLjV6IE01OC41LDM2LjVoNnYtNmgtNlYzNi41eiBNMTUuNSwzNi41aDZ2LTZoLTZWMzYuNXogTTU4LjUsMjcuNWg2di02aC02IFYyNy41eiBNMTUuNSwyNy41aDZ2LTZoLTZWMjcuNXogTTU4LjUsMTguNWg2di02aC02VjE4LjV6IE0xNS41LDE4LjVoNnYtNmgtNlYxOC41eiBNNTguNSw5LjVoNnYtNmgtNlY5LjV6IE0xNS41LDkuNWg2di02aC02VjkuNSB6Ii8+PHBhdGggZmlsbD0iI2M3NDM0MyIgZD0iTTY3LDF2MzhIMTNWMUg2NyBNNTgsMTBoMWg1aDFWOVY0VjNoLTFoLTVoLTF2MXY1VjEwIE0xNSwxMGgxaDVoMVY5VjRWM2gtMWgtNWgtMXYxdjVWMTAgTTU4LDE5aDEgaDVoMXYtMXYtNXYtMWgtMWgtNWgtMXYxdjVWMTkgTTE1LDE5aDFoNWgxdi0xdi01di0xaC0xaC01aC0xdjF2NVYxOSBNNTgsMjhoMWg1aDF2LTF2LTV2LTFoLTFoLTVoLTF2MXY1VjI4IE0xNSwyOGgxaDVoMXYtMXYtNSB2LTFoLTFoLTVoLTF2MXY1VjI4IE01OCwzN2gxaDVoMXYtMXYtNXYtMWgtMWgtNWgtMXYxdjVWMzcgTTE1LDM3aDFoNWgxdi0xdi01di0xaC0xaC01aC0xdjF2NVYzNyBNNjgsMEgxMnY0MGg1NlYwTDY4LDB6IE01OSw5VjQgaDV2NUg1OUw1OSw5eiBNMTYsOVY0aDV2NUgxNkwxNiw5eiBNNTksMTh2LTVoNXY1SDU5TDU5LDE4eiBNMTYsMTh2LTVoNXY1SDE2TDE2LDE4eiBNNTksMjd2LTVoNXY1SDU5TDU5LDI3eiBNMTYsMjd2LTVoNXY1SDE2IEwxNiwyN3ogTTU5LDM2di01aDV2NUg1OUw1OSwzNnogTTE2LDM2di01aDV2NUgxNkwxNiwzNnoiLz48L2c+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTI4IDE4SDUyVjIySDI4eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjAwMSA0MC4wMDcgMjAuMDA4KSIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0zOCA4SDQyVjMySDM4eiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjAwMSA0MC4wMyAyMC4wMjkpIi8+PC9zdmc+';
    },
    periods: function periods() {
      return [{ label: i18n.t('parameters.period.week'), value: 'week' }, { label: i18n.t('parameters.period.month'), value: 'month' }, {
        label: i18n.t('parameters.period.trimester'),
        value: 'trimester'
      }, {
        label: i18n.t('parameters.period.semester'),
        value: 'semester'
      }, { label: i18n.t('parameters.period.year'), value: 'year' }];
    },
    fields: function fields() {
      return [{ key: 'check', label: '', class: 'd-none d-md-table-cell' }, {
        key: 'id',
        id: '0',
        label: i18n.t('table.list.id'),
        sortable: true,
        class: 'd-none d-lg-table-cell'
      }, {
        key: 'thumbnail',
        id: '1',
        label: i18n.t('table.list.preview'),
        sortable: false,
        class: 'd-none d-lg-table-cell w-150px'
      }, {
        key: 'title',
        id: '2',
        label: i18n.t('table.list.title'),
        sortable: true,
        class: 'd-none d-md-table-cell'
      }, {
        key: 'active',
        id: '3',
        label: window.process.env.CLIENT_NAME == 'empreinte' ? i18n.t('table.list.statut') : i18n.t('table.list.active'),
        sortable: false,
        class: 'd-none d-md-table-cell'
      }, {
        key: 'dateStart',
        id: '4',
        label: i18n.t('table.list.date'),
        sortable: true,
        class: 'd-none d-lg-table-cell'
      }, {
        key: 'actions',
        id: '5',
        label: i18n.t('table.list.actions'),
        sortable: false,
        class: 'd-none d-md-table-cell actions-td'
      }, { key: 'mobile-details', id: '6', class: 'd-table-cell d-md-none' }, { key: 'show_details', id: '7', class: 'd-table-cell d-md-none w-50px' }];
    },
    disabledSendButton: function disabledSendButton() {
      return !this.selectedGroupUser && this.form.emails.length === 0;
    },
    getColorModal: function getColorModal() {
      return {
        background: this.getActiveColor
      };
    },
    getActiveColor: function getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    paginate: 'lives/paginate',
    getAllContributors: 'lives/fetchContributors',
    deleteMultiLive: 'lives/deleteMultiLive',
    deleteLiveById: 'lives/deleteLiveById',
    setDisableLiveById: 'lives/setDisableLiveById',
    setEnableLiveById: 'lives/setEnableLiveById',
    getLiveById: 'lives/getLiveById',
    getInfosDetail: 'lives/getInfosDetail',
    getLinkExport: 'lives/getLinkExport',
    getSubscriptionUserList: 'lives/getSubscriptionUserList',
    getSubscriptionGroupUsersList: 'lives/getSubscriptionGroupUsersList',
    sendInvitationsMails: 'lives/sendInvitationsMails',
    sendSendGridEmail: 'lives/sendSendGridEmail',
    sendInvitationsGroupMails: 'lives/sendInvitationsGroupMails',
    setScreenShare: 'lives/setScreenShare',
    getUrlDownloadFile: 'lives/getUrlDownloadFile',
    setDiffusionObject: 'lives/setDiffusionObject',
    setLives: 'lives/setLives',
    removeLiveById: 'lives/removeLiveById',
    isArchivedLive: 'lives/isArchivedLive',
    setDiffusion: 'common/setDiffusionLive',
    setStopLiveById: 'lives/setStopLiveById',
    setStartLiveById: 'lives/setStartLiveById',
    restoreArchivedLive: 'lives/restoreArchivedLive',
    restoreArchivedMultiLive: 'lives/restoreArchivedMultiLive',
    deleteMultipleLives: 'lives/deleteMultipleLives',
    deleteLiveByOne: 'lives/deleteLiveByOne',
    syncLivesSockets: "socket/syncLivesSockets"
  }), {
    isArrayInfoLive: function isArrayInfoLive(urlDiffusion) {
      if (urlDiffusion) {
        var checkArray = urlDiffusion.indexOf('[') + urlDiffusion.indexOf(']') > -1;
        return checkArray;
      }
    },
    parsingArrayUrlDiffusion: function parsingArrayUrlDiffusion(urlDiffusion) {
      var subStringArray = urlDiffusion.substring(1, urlDiffusion.length - 1);
      return subStringArray.toString().split(',');
    },
    openModalDeleteMultiLive: function openModalDeleteMultiLive() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                access_service_acces_send('lives_multi_delete_action');
                nprogress_nprogress_default.a.start();
                _this2.isArchivedMulti = _this2.isTrashDiffusion ? 'deleting' : 'archiving';
                _context.next = 5;
                return _this2.setDeleteLiveActivity(_this2.isTrashDiffusion ? 'deleting' : 'archiving', {}, true);

              case 5:
                nprogress_nprogress_default.a.done();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setActionDeleteLive: function setActionDeleteLive(_ref) {
      var _this3 = this;

      var live = _ref.live,
          action = _ref.action,
          multi = _ref.multi;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = action;
                _context2.next = _context2.t0 === 'archiving' ? 3 : _context2.t0 === 'restoring' ? 15 : _context2.t0 === 'deleting' ? 20 : 32;
                break;

              case 3:
                if (!_this3.isArchivingMultiLive) {
                  _context2.next = 10;
                  break;
                }

                list = { live_list: _this3.selectedList, action: action };

                _this3.indeterminate = false;
                _context2.next = 8;
                return _this3.restoreArchivedMultiLive(list);

              case 8:
                _context2.next = 12;
                break;

              case 10:
                _context2.next = 12;
                return _this3.restoreArchivedLive({ id: live.id, action: action });

              case 12:
                _context2.next = 14;
                return _this3.hasErrorDeleteMulti(live, action, multi);

              case 14:
                return _context2.abrupt('break', 32);

              case 15:
                _context2.next = 17;
                return _this3.restoreArchivedLive({ id: live.id, action: action });

              case 17:
                _context2.next = 19;
                return _this3.hasErrorDeleteMulti(live, action, multi);

              case 19:
                return _context2.abrupt('break', 32);

              case 20:
                if (!multi) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 23;
                return _this3.deleteListMultiLive();

              case 23:
                _context2.next = 29;
                break;

              case 25:
                _context2.next = 27;
                return _this3.removeLiveById(live.id);

              case 27:
                _context2.next = 29;
                return _this3.deleteLiveByOne(live.id);

              case 29:
                _context2.next = 31;
                return _this3.hasErrorDeleteMulti(live, action, multi);

              case 31:
                return _context2.abrupt('break', 32);

              case 32:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    hasErrorDeleteMulti: function hasErrorDeleteMulti(live, action, multi) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response, type, livesShadow;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = _this4.getResponseDelete;
                type = 'success';

                if (response.error) {
                  type = 'error';
                  if (response.multi) {
                    if (response.action === 'deleting') {
                      livesShadow = [].concat(_this4.allLives);

                      _this4.setLives(livesShadow);
                      _this4.showTrash = true;
                    }
                  }
                } else {
                  type = 'success';
                  _this4.showTrash = false;
                }

                _context3.next = 5;
                return _this4.callToast(type, live, action, multi);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    callToast: function callToast(type, live, action, multi) {
      var message_confirm = i18n.t('toast.error');
      switch (type) {
        case 'success':
          message_confirm = (multi ? i18n.t('modal.direct.checked_elements') : live.title) + i18n.t('modal.direct.' + action + '.success.' + (this.showTrash || multi ? 'multi' : 'simple'));
          this.showToast(type, message_confirm, 'icon-success');
          break;

        case 'error':
          message_confirm = i18n.t('toast.error');
          this.showToast(type, message_confirm, 'icon-warning');
          break;
      }
    },
    handleEditExportPermalink: function handleEditExportPermalink() {
      console.log("handleEditExportPermalink");
      /** todo call edit + verif url live **/
    },
    getActiveLive: function getActiveLive(isActive, id) {
      return !isActive ? id : '-' + id;
    },
    getButtonVariant: function getButtonVariant(isActive) {
      return !isActive ? this.headerBgVariant : '';
    },
    getNamePermalink: function getNamePermalink(perm) {
      if (perm.includes('/studio-event/')) {
        return i18n.t('modal.export.standAlone_permalink_participant');
      }
      return i18n.t('modal.export.standAlone_permalink');
    },
    sortingChanged: function sortingChanged(ctx) {
      var _this5 = this;

      var sortExist = this.fields.find(function (f) {
        return f.key === ctx.sortBy;
      });
      if (sortExist && keys_default()(sortExist).length > 0) {
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.fields.forEach(function (field, index) {
          if (field.key === _this5.sortBy) {
            _this5.numColumn = index - 1;
          }
        });
        if (this.sortDesc === false) {
          this.sortDirection = 'asc';
          this.sortDesc = true;
        } else if (this.sortDesc === true) {
          this.sortDirection = 'desc';
          this.sortDesc = false;
        } else {
          this.sortDirection = 'asc';
          this.sortDesc = true;
        }
        this.obj['numColumn'] = this.numColumn;
        this.obj.params['order'] = this.sortDirection;
        this.setDiffusionObject(this.obj);
        this.paginate(this.obj);
      }
    },
    info: function info(item, index, button) {
      this.infoModal.title = 'Row index: ' + index;
      this.infoModal.content = stringify_default()(item, null, 2);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    resetInfoModal: function resetInfoModal() {
      this.infoModal.title = '';
      this.infoModal.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleFilter: function toggleFilter() {
      this.active = !this.active;
    },
    hideFilter: function hideFilter(e) {
      if (e && e.path) {
        if (e.path.some(function (item) {
          return item.id === 'toggle-filter';
        })) {
          return;
        }
        this.active = false;
      }
    },
    clearSelected: function clearSelected(event) {
      this.allSelected = false;
      this.checkedItems = [];
    },
    openDropDownDiffusion: function openDropDownDiffusion() {
      this.diffusionSelected = !this.diffusionSelected;
    },
    changeDiffusion: function changeDiffusion(type) {
      switch (type) {
        case 'all':
          access_service_acces_send('lives_dtable_lives_all_action');
          break;
        case 'archived':
          access_service_acces_send('lives_dtable_lives_archived_action');
          break;
        case 'endless':
          access_service_acces_send('lives_dtable_lives_endless_action');
          break;
        case 'upcoming':
          access_service_acces_send('lives_dtable_lives_upcoming_action');
          break;
        case 'trash':
          access_service_acces_send('lives_dtable_lives_trash_action');
      }
      this.obj['type'] = type;
      this.obj.params.start = 0;
      this.paginate(this.obj);
      this.titleSelected = type;
      this.setDiffusionObject(this.obj);
      var previewLive = false;
      if (type === 'archived') {
        previewLive = true;
      }
      this.isArchivedLive(previewLive);
      this.setTotalRows(this.allLives.length);
      this.setDiffusion(type);
      window.parent.postMessage({
        info: 'diffusionLive',
        value: type
      }, '*');
    },
    getLivesByParams: function getLivesByParams(event, param) {
      var value = event;

      if (param === 'startDate' && value !== null) {
        var date = event;
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = date.getFullYear();
        date = yyyy + '-' + mm + '-' + dd;
        value = date;
      }
      if (value === null) {
        value = '';
      }

      this.obj.params[param] = value;
      this.setDiffusionObject(this.obj);
    },
    reset: function reset() {
      this.selectedContributor = '';
      this.period = '';
      this.mdTime = { date: '', time: '', endtime: '' };
      this.obj.params['idContributor'] = '';
      this.obj.params['period'] = '';
      this.obj.params['startDate'] = '';
      this.search();
    },
    search: function search() {
      this.paginate(this.obj);
      this.toggleFilter();
    },
    getLivesByContributor: function getLivesByContributor(event) {
      if (event === null) {
        event = {
          id: '',
          name: ''
        };
      }
      this.selectedContributor = event.name;
      this.obj.params['idContributor'] = event.id;
      this.setDiffusionObject(this.obj);
    },
    changePerPage: function changePerPage(event) {
      this.setTotalRows(event);
      this.currentPage = 1;
      this.obj.params.currentPage = 1;
      this.obj.params.length = event;
      this.obj.params.start = 0;
      this.setDiffusionObject(this.obj);
      this.paginate(this.obj);
    },
    changeNumPage: function changeNumPage(event) {
      this.obj.params.start = (event - 1) * this.obj.params.length;
      this.obj.params.currentPage = event;
      this.setDiffusionObject(this.obj);
      this.paginate(this.obj);
    },
    checkAllLiveRows: function checkAllLiveRows(event) {
      this.checked = !this.checked;
      this.checkedItems = !(this.allSelected ? this.tableValues : []);
      var idSelectedLive = [];
      var idSelectedRows = [];
      this.allLives.forEach(function (live) {
        idSelectedLive.push(live.id);
        idSelectedRows.push(live);
      });
      this.$emit('list-all-deleted', {
        state: event,
        listRows: idSelectedRows,
        listId: idSelectedLive
      });
    },
    CheckRowLive: function CheckRowLive(event, row) {
      var idSelectedLive = row.item.id;
      this.$emit('list-multi-deleted', { state: event, row: row.item, id: idSelectedLive });
    },
    GoToAddLive: function GoToAddLive() {
      access_service_acces_send('lives_post_add_action');
      parent.postMessage({
        info: 'goToAddLive',
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      var createLive = 'CreateLive';
      if (window.process.env.HAS_SKIN === 'true') {
        createLive = 'CreateLiveV2';
      }
      this.$router.push({ name: createLive, query: cryptext });
      //this.eventPostMessage();
    },
    GoToEditLive: function GoToEditLive(idLive) {
      var cryptext = this.$route.query;
      var editLive = 'EditLive';
      if (window.process.env.HAS_SKIN === 'true') {
        editLive = 'EditLiveV2';
      }
      this.$router.push({ name: editLive, params: { id: idLive }, query: cryptext });
      //this.eventPostMessage();
    },
    setTotalRows: function setTotalRows(number) {
      this.totalRows = number;
    },
    openDeleteModal: function openDeleteModal() {
      this.$refs['modal-delete-rows'].show();
    },
    deleteListMultiLive: function deleteListMultiLive() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var selectedRowIndexes, livesShadow;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.indeterminate = false;
                selectedRowIndexes = [];
                livesShadow = [].concat(_this6.allLives);


                _this6.selectedList.forEach(function (id) {
                  _this6.removeLiveById(id);
                });
                _this6.selectedRows.forEach(function (row) {
                  var index = _this6.allLives.indexOf(row);
                  if (index !== -1) {
                    selectedRowIndexes.push(index);
                  }
                });
                _context4.next = 7;
                return _this6.deleteMultipleLives({ list_to_delete: _this6.selectedList });

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    closeViewModalById: function closeViewModalById() {
      //this.showAllSlides = !this.showAllSlides;
      this.$root.$emit('bv::hide::modal', 'modal-view-row');
      // this.$refs['modal-view-row'].hide();
    },
    openModalFlowLive: function openModalFlowLive(flow) {
      var _this7 = this;

      this.urlFlow = flow;
      this.$root.$emit('bv::show::modal', 'modal-flow-live-row');
      setTimeout(function () {
        var modal = document.querySelector('#modal-flow-live-row');
        if (modal) {
          modal.style.setProperty('--primary-color', _this7.getActiveColor);
        }
        var header = document.querySelector('#modal-flow-live-row .modal-header');
        if (header) {
          header.style.setProperty('background-color', _this7.getActiveColor, 'important');
        }
      }, 300);
    },
    ChangeActivity: function ChangeActivity(event, live) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var self;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = _this8;

                nprogress_nprogress_default.a.start();
                _this8.liveId = live.id;
                _this8.liveObject = live;
                if (event === true) {
                  _this8.isSatusChanged = true;
                  _this8.statusLive = 'start';
                } else {
                  _this8.isSatusChanged = false;
                  _this8.statusLive = 'stop';
                }
                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                  return regenerator_default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return self.$root.$emit('bv::show::modal', 'modal-' + _this8.statusLive + '-live');

                        case 2:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this8);
                })), 100);
                nprogress_nprogress_default.a.done();

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    setDeleteLiveActivity: function setDeleteLiveActivity(action, live, multi) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var self;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                self = _this9;

                nprogress_nprogress_default.a.start();
                if (!multi) {
                  if (keys_default()(live).length > 0) {
                    _this9.liveId = live.id;
                    _this9.liveObject = live;
                  }
                  _this9.isArchivedMulti = '';
                }

                _this9.isMultiDelete = multi;
                if (action === 'archiving') {
                  _this9.isRestoreingLive = false;
                  _this9.isArchivingLive = true;
                } else if (action === 'restoring') {
                  _this9.isRestoreingLive = true;
                  _this9.isArchivingLive = false;
                } else {
                  _this9.isRestoreingLive = false;
                  _this9.isArchivingLive = false;
                }
                _this9.titleOnDeletedLive = action;
                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                  return regenerator_default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return self.$root.$emit('bv::show::modal', 'modal-' + _this9.titleOnDeletedLive + '-live');

                        case 2:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this9);
                })), 100);
                nprogress_nprogress_default.a.done();

              case 8:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    searchFilter: function searchFilter(event) {
      this.obj.params['searchWord'] = event;
      this.obj.params.start = 0;
      this.setDiffusionObject(this.obj);
      this.paginate(this.obj);
    },
    closeInfosModal: function closeInfosModal() {
      this.$root.$emit('bv::hide::modal', 'modal-infos-live-row');
      // this.$refs['modal-infos-live-row'].hide();
    },
    closeExportLinkModal: function closeExportLinkModal() {
      this.$root.$emit('bv::hide::modal', 'modal-link-export-row');
      //this.$refs['modal-link-export-row'].hide();
    },
    closeSendInvitationsModal: function closeSendInvitationsModal() {
      this.$root.$emit('bv::hide::modal', 'modal-send-invitations-row');
      //this.$refs['modal-send-invitations-row'].hide();
    },
    closeSendGroupInvitationsModal: function closeSendGroupInvitationsModal() {
      this.$root.$emit('bv::hide::modal', 'modal-send-group-mails-row');
      //this.$refs['modal-send-invitations-row'].hide();
    },
    cancelAddGroupMailsModal: function cancelAddGroupMailsModal() {
      this.form.defaultChoice = false;
    },
    goToAddEmailsModal: function goToAddEmailsModal() {
      this.form.defaultChoice = true;
    },
    goToCalendar: function goToCalendar() {
      parent.postMessage({
        info: 'goToCalendar'
      }, '*');
      var cryptext = this.$route.query;
      this.$router.push({ name: 'CalendarLives', query: cryptext });
      // this.eventPostMessage();
    },
    copyExportLink: function copyExportLink(event, id, index) {
      event.target.classList.add('is-selected');
      var link = this.$refs[id];
      if (id === 'embed') {
        this.clickedEmbed = true;
        this.clickedPermalink = false;
        this.clickedModerator = false;
        this.clickedJournalist = false;
        this.clickedUrlExport = false;
      } else if (id === 'permalink') {
        this.clickedEmbed = false;
        this.clickedPermalink = true;
        this.clickedModerator = false;
        this.clickedJournalist = false;
        this.clickedUrlExport = false;
      } else if (id === 'link_moderator') {
        this.clickedEmbed = false;
        this.clickedPermalink = false;
        this.clickedModerator = true;
        this.clickedJournalist = false;
        this.clickedUrlExport = false;
      } else if (id === 'link_journalist') {
        this.clickedEmbed = false;
        this.clickedPermalink = false;
        this.clickedJournalist = true;
        this.clickedModerator = false;
        this.clickedUrlExport = false;
      } else {
        this.clickedEmbed = false;
        this.clickedPermalink = false;
        this.clickedModerator = false;
        this.clickedJournalist = false;
        this.clickedUrlExport = true;
      }
      if (link && (link.length >= 1 && link.length !== 2 || link.length === 2)) {
        for (var i = 0; i < link.length; i++) {
          if (i === index) {
            link[i].setAttribute('type', 'text');
            link[i].select();
            if (id === 'permalink' && i === index) {
              this.permalinkIndex = i;
            }
          }
        }
      } else {
        link.setAttribute('type', 'text');
        link.select();
      }

      try {
        var successful = document.execCommand('copy');
        if (successful) {
          event.target.classList.remove('is-selected');
        }
      } catch (err) {
        console.log('unable to copy');
      }
      var self = this;
      setTimeout(function () {
        if (id == 'embed') {
          self.clickedEmbed = false;
        } else if (id == 'permalink') {
          self.clickedPermalink = false;
        } else if (id == 'link_moderator') {
          self.clickedModerator = false;
        } else if (id == 'link_journalist') {
          self.clickedJournalist = false;
        } else {
          self.clickedUrlExport = false;
        }
      }, 1000);
    },
    selectUser: function selectUser(event, email) {
      event.target.classList.toggle('is-selected');
      if (event.target.classList.contains('is-selected')) {
        this.invitations.push(email);
      } else {
        this.invitations.splice(this.invitations.indexOf(email), 1);
      }
      if (keys_default()(this.invitations).length > 0) {
        this.selectedUser = true;
      } else {
        this.selectedUser = false;
      }
    },
    selectGroupUser: function selectGroupUser(event, id) {
      event.target.classList.toggle('is-group-selected');
      if (event.target.classList.contains('is-group-selected')) {
        this.groupInvitations.push(id);
      } else {
        this.groupInvitations.splice(this.groupInvitations.indexOf(id), 1);
      }
      if (keys_default()(this.groupInvitations).length > 0) {
        this.selectedGroupUser = true;
      } else {
        this.selectedGroupUser = false;
      }
    },
    addNewEmail: function addNewEmail(email) {
      this.groupMails = email;
      this.form.defaultChoice = false;
    },
    removeAddedMail: function removeAddedMail(mail) {
      var exist = this.groupMails.indexOf(mail);
      this.groupMails.splice(exist, 1);
      this.form.emails.splice(exist, 1);
    },

    // onReset(evt) {
    //   evt.preventDefault();
    //   this.form.email = '';
    //   this.show = false;
    //   this.$nextTick(() => {
    //     this.show = true;
    //   });
    // },
    sendInvitationMail: function sendInvitationMail() {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var intervenantSendGrid, logo, objSendGrid, message, obj, _message;

        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                nprogress_nprogress_default.a.start();

                if (!window.process.env.hasSendGrid) {
                  _context9.next = 22;
                  break;
                }

                intervenantSendGrid = [];

                _this10.invitations.map(function (inv) {
                  return intervenantSendGrid.push({
                    "pic": "-",
                    "name": _this10.getSubscriptionUser.filter(function (e) {
                      return e.email == inv;
                    })[0]["name"],
                    "lastName": _this10.getSubscriptionUser.filter(function (e) {
                      return e.email == inv;
                    })[0]["lastName"],
                    "description": "-",
                    "email": inv
                  });
                });
                logo = _this10.liveObject.thumbnail;

                logo = logo ? logo.indexOf('http') >= 0 ? logo : "https:" + logo : logo;
                objSendGrid = {
                  "cover": logo,
                  "logo": logo,
                  "title": _this10.liveObject.title,
                  "link": window.process.env.LinkWebinar + "" + _this10.liveObject.id + "-" + _this10.liveObject.streamName,
                  "webinarId": _this10.liveObject.id,
                  "description": _this10.liveObject.description,
                  "date": moment(_this10.liveObject.dateStart).format("YYYY-MM-DD"),
                  "hour": moment(_this10.liveObject.dateStart).format("HH:mm"),
                  "duration": moment(new Date(new Date(_this10.liveObject.dateEnd).getTime() - new Date(_this10.liveObject.dateStart).getTime() + new Date().getTimezoneOffset() * 60000)).format("HH:mm"),
                  "language": "fr",
                  "intervenants": intervenantSendGrid,
                  "configuration": {
                    "templateId": 2,
                    "sendRules": {
                      "accessEmails": [1],
                      "subscribedEmails": []
                    }
                  }
                };
                message = void 0;
                _context9.prev = 8;
                _context9.next = 11;
                return _this10.sendSendGridEmail(objSendGrid);

              case 11:
                message = i18n.t('toast.success_send');
                _this10.$root.$emit('bv::hide::modal', 'modal-send-invitations-row');
                _this10.showToast('success', message, 'icon-success');
                _context9.next = 20;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t0 = _context9['catch'](8);

                message = i18n.t('toast.error');
                _this10.showToast('error', message, 'icon-warning');

              case 20:
                _context9.next = 36;
                break;

              case 22:
                obj = {
                  id: _this10.liveId,
                  mails: _this10.invitations
                };
                _message = void 0;
                _context9.prev = 24;
                _context9.next = 27;
                return _this10.sendInvitationsMails(obj);

              case 27:
                _message = i18n.t('toast.success_send');
                _this10.$root.$emit('bv::hide::modal', 'modal-send-invitations-row');
                _this10.showToast('success', _message, 'icon-success');
                _context9.next = 36;
                break;

              case 32:
                _context9.prev = 32;
                _context9.t1 = _context9['catch'](24);

                _message = i18n.t('toast.error');
                _this10.showToast('error', _message, 'icon-warning');

              case 36:
                _this10.invitations = [];
                nprogress_nprogress_default.a.done();

              case 38:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[8, 16], [24, 32]]);
      }))();
    },
    sendInvitationGroupMails: function sendInvitationGroupMails() {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var obj, message;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                nprogress_nprogress_default.a.start();
                obj = {
                  id: _this11.liveId,
                  groups: _this11.groupInvitations,
                  mails: _this11.groupMails
                };
                message = void 0;
                _context10.prev = 3;
                _context10.next = 6;
                return _this11.sendInvitationsGroupMails(obj);

              case 6:

                message = i18n.t('toast.success_send');
                _this11.$root.$emit('bv::hide::modal', 'modal-send-group-mails-row');
                _this11.showToast('success', message, 'icon-success');
                _context10.next = 15;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10['catch'](3);

                message = i18n.t('toast.error');
                _this11.showToast('error', message, 'icon-warning');

              case 15:
                _this11.groupInvitations = [];
                _this11.groupMails = [];
                nprogress_nprogress_default.a.done();

              case 18:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11, [[3, 11]]);
      }))();
    },
    updateScreenShare: function updateScreenShare(screenType) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var objectShare, message;
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                nprogress_nprogress_default.a.start();
                objectShare = {
                  id: _this12.liveId,
                  screenType: screenType
                };
                message = void 0;
                _context11.prev = 3;
                _context11.next = 6;
                return _this12.setScreenShare(objectShare);

              case 6:
                _this12.paginate(_this12.obj);
                message = i18n.t('toast.success_edit');
                _this12.$root.$emit('bv::hide::modal', 'modal-screen-share-row');
                _this12.showToast('success', message, 'icon-success');
                _context11.next = 16;
                break;

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11['catch'](3);

                message = i18n.t('toast.error');
                _this12.showToast('error', message, 'icon-warning');

              case 16:
                nprogress_nprogress_default.a.done();

              case 17:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12, [[3, 12]]);
      }))();
    },
    closeScreenShareModal: function closeScreenShareModal() {
      this.$root.$emit('bv::hide::modal', 'modal-screen-share-row');
    },
    downloadScreenFile: function downloadScreenFile(id) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        var message;
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                nprogress_nprogress_default.a.start();
                message = void 0;
                _context12.prev = 2;
                _context12.next = 5;
                return _this13.getUrlDownloadFile(id);

              case 5:
                message = i18n.t('toast.success_download');
                _this13.showToast('success', message, 'icon-success');
                _context12.next = 13;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12['catch'](2);

                message = i18n.t('toast.error');
                _this13.showToast('error', message, 'icon-warning');

              case 13:
                nprogress_nprogress_default.a.done();

              case 14:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this13, [[2, 9]]);
      }))();
    },
    clearFilterDateLives: function clearFilterDateLives(param) {
      this.obj.params[param] = '';
      this.setDiffusionObject(this.obj);
    },
    closeModalArchivedVideo: function closeModalArchivedVideo() {
      this.$root.$emit('bv::hide::modal', 'modal-preview-archived-video');
    },
    getStatut: function getStatut(item) {
      var currentDAte = new Date();
      var dateStart = new Date(item.dateStart);

      if (item.status === 1) return { class: 'badge-secondary', text: 'Archive' };else if (item.active && item.status !== 1) {
        return { class: 'badge-danger', text: 'Live' };
      } else if (!item.active && item.status === -1) {
        return { class: 'badge-warning', text: 'Waiting' };
      } else {
        return { class: 'badge', text: 'error' };
      }
    },
    handleStatusModal: function handleStatusModal() {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var self;
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!_this14.isLoading) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt('return');

              case 2:
                _this14.isLoading = true;
                self = _this14;

                if (_this14.statusLive === 'start') {
                  _this14.setEnableLiveById({ id: _this14.liveObject.id, active: true, streamName: _this14.liveObject.streamName }); //, obj: this.obj
                  _this14.setStartLiveById(_this14.liveObject);
                  _this14.liveObject.active = !_this14.liveObject.active;
                } else {
                  nprogress_nprogress_default.a.start();
                  _this14.setStopLiveById({ id: _this14.liveObject.id, active: false, streamName: _this14.liveObject.streamName, live: _this14.liveObject });
                  setTimeout(function () {
                    self.paginate(self.obj);
                    nprogress_nprogress_default.a.done();
                  }, 3500);
                }
                _this14.closeStatusModal();
                _this14.isLoading = false;

              case 7:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this14);
      }))();
    },
    closeStatusModal: function closeStatusModal() {
      this.isSatusChanged = false;
      this.$root.$emit('bv::hide::modal', 'modal-' + this.statusLive + '-live');
    },
    handleDeleteLiveModal: function handleDeleteLiveModal() {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        var live, action, multi, self;
        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                live = _this15.liveObject;
                action = _this15.titleOnDeletedLive;
                multi = false;
                self = _this15;

                nprogress_nprogress_default.a.start();
                if (_this15.isRestoreingLive && !_this15.isArchivingLive) {
                  action = 'restoring';
                  multi = false;
                  live = _this15.liveObject;
                } else if (_this15.isArchivingLive && !_this15.isRestoreingLive) {
                  action = 'archiving';
                  multi = _this15.isArchivingMultiLive ? true : false;
                  live = _this15.isArchivingMultiLive ? {} : _this15.liveObject;
                } else {
                  action = 'deleting';
                  if (_this15.isMultiDelete) {
                    multi = true;
                    live = {};
                  } else {
                    multi = false;
                    live = _this15.liveObject;
                  }
                }
                _this15.closeDeleteLiveModal();
                _context15.next = 9;
                return _this15.setActionDeleteLive({ live: live, action: action, multi: multi });

              case 9:
                if (_this15.isArchivingLive || _this15.isRestoreingLive) {
                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
                    return regenerator_default.a.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            _context14.next = 2;
                            return self.paginate(self.obj);

                          case 2:
                            nprogress_nprogress_default.a.done();

                          case 3:
                          case 'end':
                            return _context14.stop();
                        }
                      }
                    }, _callee14, _this15);
                  })), 200);
                } else {
                  nprogress_nprogress_default.a.done();
                }

              case 10:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this15);
      }))();
    },
    closeDeleteLiveModal: function closeDeleteLiveModal() {
      this.$root.$emit('bv::hide::modal', 'modal-' + this.titleOnDeletedLive + '-live');
    }
  }),

  mounted: function mounted() {
    var _this16 = this;

    this.$root.$on('setFormLang', function (lang) {

      var firstRow = _this16.getLinkExportLives['permalien'][0];
      var secondRow = _this16.getLinkExportLives['permalien'][1];
      var moderatorlink = _this16.getLinkExportLives['link_moderator'].replace("fr", lang).replace("/en", '/' + lang);
      var journalistlink = _this16.getLinkExportLives['link_journalist'].replace("fr", lang).replace("/en", '/' + lang);

      firstRow = firstRow.replace("fr", lang).replace("/en", '/' + lang);
      secondRow = secondRow.replace("fr", lang).replace("/en", '/' + lang);

      _this16.getLinkExportLives['permalien'] = [firstRow, secondRow];
      _this16.getLinkExportLives['link_moderator'] = moderatorlink;
      _this16.getLinkExportLives['link_journalist'] = journalistlink;
    });
    access_service_acces_send("lives_dtable_lives_all_action");
    // Set the initial number of items
    this.setTotalRows(this.allLives.length);
    // this.totalRows = this.allLives.length;

    if (keys_default()(this.getDiffusionObject).length > 0) {
      this.obj = this.getDiffusionObject;
      this.titleSelected = this.getDiffusionObject.type;
      this.currentPage = this.getDiffusionObject.params ? this.getDiffusionObject.params.currentPage : this.currentPage;
      this.perPage = this.getDiffusionObject.params ? this.getDiffusionObject.params.length : this.perPage;
      this.obj.params.searchWord = "";
    } else {
      this.obj = {
        type: this.getDiffusion,
        numColumn: this.numColumn,
        params: {
          length: this.perPage,
          start: 0,
          order: this.sortDirection,
          orderable: true,
          idContributor: '',
          period: '',
          startDate: '',
          searchWord: '',
          currentPage: 1
        }
      };
    }
    this.titleSelected = this.getDiffusion;
    this.setDiffusionObject(this.obj);
    if (this.getDiffusion === 'archived') {
      this.isArchivedLive(true);
    }
    if (this.$route.query.archived == "true") {
      this.obj.type = "trash";this.isArchived = true;
    }
    this.paginate(this.obj);
    this.getAllContributors();
    eventHub.$on("restartLive", function (_ref5) {
      var value = _ref5.value,
          count = _ref5.count;

      if (value && count === 0) {
        _this16.changeDiffusion('endless');
        count++;
      }
    });

    eventHub.$on("paginateLive", function (_ref6) {
      var value = _ref6.value,
          count = _ref6.count;

      _this16.paginate(_this16.obj);
    });

    this.$on('list-multi-deleted', function (obj) {
      var exist = _this16.selectedList.indexOf(obj.id);
      if (obj.state === true) {
        if (exist > -1) {
          _this16.selectedList.splice(exist, 1);
          _this16.selectedRows.splice(exist, 1);
        } else {
          _this16.selectedList.push(obj.id);
          _this16.selectedRows.push(obj.row);
        }
      } else {
        _this16.selectedList.splice(exist, 1);
        _this16.selectedRows.splice(exist, 1);
      }
      if (_this16.selectedList.length > 0) {
        _this16.showTrash = true;
        _this16.indeterminate = true;
      } else {
        _this16.showTrash = false;
        _this16.indeterminate = false;
      }
    });
    this.$on('list-all-deleted', function (obj) {
      if (obj.state === true) {
        _this16.selectedList = obj.listId;
        _this16.selectedRows = obj.listRows;
      } else {
        _this16.selectedList = [];
        _this16.selectedRows = [];
      }
      if (_this16.selectedList.length > 0) {
        _this16.showTrash = true;
      } else {
        _this16.showTrash = false;
      }
    });
    this.$root.$on('setFormLang', function (lang) {
      //this.$root.i18n.locale = lang;
      console.log('i18n.locale', i18n.locale);
      i18n.locale = lang;
    });
    this.$root.$on('setLiveId', function (id) {
      _this16.liveId = id;
    });
    this.$root.$on('setLiveObject', function (live) {
      console.log(live);
      _this16.liveObject = live;
    });
    this.$root.$on('ChangeActivity', function (_ref7) {
      var event = _ref7.event,
          live = _ref7.live;
      return _this16.ChangeActivity(event, live);
    });
    this.$root.$on('setUrlFlow', function (flow) {
      return _this16.openModalFlowLive(flow);
    });
    this.$root.$on('setDeleteLiveActivity', function (_ref8) {
      var action = _ref8.action,
          live = _ref8.live,
          multi = _ref8.multi;
      return _this16.setDeleteLiveActivity(action, live, multi);
    });
    this.$root.$on('isOpenModal', function (obj) {
      _this16.$refs[obj.id].show();
      var id = _this16.$refs[obj.id].id;
      setTimeout(function () {
        var modal = document.querySelector('#' + id);
        modal.style.setProperty('--primary-color', _this16.getActiveColor);
        var header = document.querySelector('#' + id + ' .modal-dialog.modal-lg .modal-content .modal-header');
        header.style.setProperty('background-color', _this16.getActiveColor, 'important');
      }, 100);
    });
    moment["locale"]('en');
    this.$nextTick(function () {
      if (_this16.$i18n.locale === 'fr') {
        vue2_datepicker_lib_default.a.fecha.i18n.monthNamesShort = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'];
      }
    });
    this.getSubscriptionUserList();
    this.getSubscriptionGroupUsersList();

    //this.eventPostMessage();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b75d5c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListLive.vue
var ListLive_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-live-wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"tabs-wrapper"},[_c('b-row',{staticClass:"mb-15"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"cards",attrs:{"align":"center"}},[_c('b-row',[_c('div',{staticClass:"diffusion-select",attrs:{"align":"center","id":"diffusion-select"}},[_c('i',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_multi_delete'),expression:"'lives_multi_delete'"},{name:"show",rawName:"v-show",value:(_vm.showTrash),expression:"showTrash"}],staticClass:"icon-trash c-deep-orange-600 clickable",attrs:{"has-permission":"lives_multi_delete"},on:{"click":function($event){return _vm.openModalDeleteMultiLive($event)}}}),_vm._v(" "),(_vm.isArchived != true)?_c('b-button',{staticClass:"calendar-lives-btn buttons-link",attrs:{"variant":"link"},on:{"click":_vm.goToCalendar}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-alt"}}),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline-block ml-1"},[_vm._v(_vm._s(_vm.$t('calendar.title')))])],1):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"thumbnail-container"},[(_vm.isArchived != true)?_c('div',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_lives_archived,lives_dtable_lives_endless'),expression:"'lives_dtable_lives_archived,lives_dtable_lives_endless'"}],attrs:{"has-permission":"lives_dtable_lives_archived,lives_dtable_lives_endless"}},[_c('b-dropdown',{staticClass:"buttons-link",attrs:{"variant":"link","toggle-class":"text-decoration-none"}},[_c('template',{slot:"button-content"},[_c('a',{staticClass:"text-decoration-none buttons-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.openDropDownDiffusion()}}},[_c('font-awesome-icon',{staticClass:"icon-video",attrs:{"icon":{ prefix: 'fas', iconName: 'video' }}}),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline-block"},[_vm._v(_vm._s(_vm.$t('modal.setting.diffusion.title')))])],1)]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_lives_all'),expression:"'lives_dtable_lives_all'"}],staticClass:"diffusion-items",class:[{ active: _vm.titleSelected === 'all' }],attrs:{"has-permission":"lives_dtable_lives_all"},on:{"click":function($event){return _vm.changeDiffusion('all')}}},[_c('a',{staticClass:"diffusion-icons",attrs:{"target":"_blank"}},[_c('svg',{attrs:{"height":"18px","version":"1.1","viewBox":"0 0 18 18","width":"18px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"fill":"#000000","id":"Core","transform":"translate(-381.000000, -381.000000)"}},[_c('g',{attrs:{"id":"select-all","transform":"translate(381.000000, 381.000000)"}},[_c('path',{attrs:{"d":"M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z","id":"Shape"}})])])])]),_vm._v(" "),_c('span',{staticClass:"diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.setting.diffusion.all')))])]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_lives_archived'),expression:"'lives_dtable_lives_archived'"}],staticClass:"diffusion-items",class:[{ active: _vm.titleSelected === 'archived' }],attrs:{"has-permission":"lives_dtable_lives_archived"},on:{"click":function($event){return _vm.changeDiffusion('archived')}}},[_c('a',{staticClass:"diffusion-icons",attrs:{"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'archive' }}})],1),_vm._v(" "),_c('span',{staticClass:"diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.setting.diffusion.archived')))])]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_lives_endless'),expression:"'lives_dtable_lives_endless'"}],staticClass:"diffusion-items",class:[{ active: _vm.titleSelected === 'endless' }],attrs:{"has-permission":"lives_dtable_lives_endless"},on:{"click":function($event){return _vm.changeDiffusion('endless')}}},[_c('a',{staticClass:"diffusion-icons",attrs:{"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fas', iconName: 'play' }}})],1),_vm._v(" "),_c('span',{staticClass:"diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.setting.diffusion.endless')))])]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_lives_upcoming'),expression:"'lives_dtable_lives_upcoming'"}],staticClass:"diffusion-items",class:[{ active: _vm.titleSelected === 'upcoming' }],attrs:{"has-permission":"lives_dtable_lives_upcoming"},on:{"click":function($event){return _vm.changeDiffusion('upcoming')}}},[_c('a',{staticClass:"diffusion-icons",attrs:{"target":"_blank"}},[_c('svg',{attrs:{"height":"24px","version":"1.1","viewBox":"0 0 24 24","width":"24px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"Artboard-1","transform":"translate(-395.000000, -119.000000)"}},[_c('path',{attrs:{"d":"M397.181376,129 C398.121889,123.879764 402.60786,120 408,120 C414.075133,120 419,124.924867 419,131 C419,137.075133 414.075133,142 408,142 C403.727268,142 400.023517,139.563904 398.201917,136.004883 L400.51882,136.004883 C402.133783,138.414115 404.88169,140 408,140 C412.970563,140 417,135.970563 417,131 C417,126.029437 412.970563,122 408,122 C403.716825,122 400.132475,124.992022 399.223016,129 L397.181376,129 L397.181376,129 Z M407.5,131.349626 L412.710685,134.421329 L413.218515,133.559872 L408.5,130.754395 L408.5,124.031738 L407.5,124.031738 L407.5,131.349626 Z M398,133 L401,129 L395,129 L398,133 Z","fill":"#000000","id":"circle-backup-time-history-recent-time-machine-glyph"}})])])]),_vm._v(" "),_c('span',{staticClass:"diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.setting.diffusion.upcoming')))])]),_vm._v(" "),_c('b-dropdown-item',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_lives_trash'),expression:"'lives_dtable_lives_trash'"}],staticClass:"diffusion-items",class:[{ active: _vm.titleSelected === 'trash' }],attrs:{"has-permission":"lives_dtable_lives_trash"},on:{"click":function($event){return _vm.changeDiffusion('trash')}}},[_c('a',{staticClass:"diffusion-icons",attrs:{"target":"_blank"}},[_c('i',{staticClass:"icon-trash icons-trash-diffusion clickable"})]),_vm._v(" "),_c('span',{staticClass:"diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.setting.diffusion.trash')))])])],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline-block title-selected"},[_vm._v("-- "+_vm._s(_vm.$t('modal.setting.diffusion.' +
                        _vm.titleSelected))+" --")])],1):_vm._e()])])],1),_vm._v(" "),_c('b-col',{staticClass:"flex-grow-1"},[_c('b-form-group',{staticClass:"mb-0 input-search"},[_c('b-input-group',[_c('b-input-group-prepend',[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":_vm.$t('parameters.search.title') + ',' + _vm.$t('parameters.search.description')},on:{"input":function($event){return _vm.searchFilter($event)}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-append',[_c('font-awesome-icon',{attrs:{"icon":"filter","id":"toggle-filter"},on:{"click":_vm.toggleFilter}})],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideFilter),expression:"hideFilter"}],staticClass:"filter-wrapper text-left"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('label',[_vm._v(_vm._s(_vm.$t('parameters.filter.period')))]),_vm._v(" "),_c('b-form-group',[_c('v-select',{attrs:{"disabled":!!_vm.mdTime.date,"options":_vm.periods},on:{"input":function($event){return _vm.getLivesByParams($event.value, 'period')}},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("\n                                "+_vm._s(_vm.$t('parameters.filter.no_options'))+"\n                              ")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","sm":"12"}},[_c('label',[_vm._v(_vm._s(_vm.$t('parameters.filter.date')))]),_vm._v(" "),_c('b-form-group',[_c('div',{staticClass:"input_css input filter-date",attrs:{"id":"filter-date"}},[_c('datepicker',{attrs:{"disabled":!!_vm.period,"id":"start-date","input-class":"form-control selectedDate","wrapper-class":"start-date-picker","bootstrap-styling":true,"calendar-button":true,"required":true,"lang":_vm.$i18n.locale,"format":'DD MMM YYYY',"active-color":_vm.getActiveColor,"clearable":false,"placeholder":_vm.$t('date.placeholder')},on:{"input":function($event){return _vm.getLivesByParams($event, 'startDate')},"clear":function($event){return _vm.clearFilterDateLives('startDate')}},model:{value:(_vm.mdTime.date),callback:function ($$v) {_vm.$set(_vm.mdTime, "date", $$v)},expression:"mdTime.date"}},[_c('template',{slot:"calendar-icon"},[_c('font-awesome-icon',{staticClass:"calendar-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'calendar-alt' }}})],1)],2)],1)])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('label',[_vm._v(_vm._s(_vm.$t('parameters.filter.contributors')))]),_vm._v(" "),_c('b-form-group',[_c('v-select',{attrs:{"options":_vm.formattedContributors,"label":"name","filterable":true},on:{"input":function($event){return _vm.getLivesByContributor($event)}},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('span',{class:option.icon}),_vm._v("\n        "+_vm._s(option.name)+"\n      ")]}}]),model:{value:(_vm.selectedContributor),callback:function ($$v) {_vm.selectedContributor=$$v},expression:"selectedContributor"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("\n        "+_vm._s(_vm.$t('parameters.filter.no_contributor'))+"\n      ")])])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[_c('button',{staticClass:"submit reset-filter-btn",attrs:{"variant":_vm.headerBgVariant,"type":"button"},on:{"click":function($event){return _vm.search()}}},[_vm._v(_vm._s(_vm.$t('parameters.filter.search')))]),_vm._v(" "),_c('button',{staticClass:"submit filter-btn",attrs:{"variant":"light"},on:{"click":_vm.reset}},[_vm._v("\n                            "+_vm._s(_vm.$t('parameters.filter.reset'))+"\n                          ")])])],1)],1)])],1)],1),_vm._v(" "),(_vm.isArchived != true)?_c('div',{staticClass:"flex-grow-0 btn-add-live"},[_c('b-button',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_post_add'),expression:"'lives_post_add'"}],staticClass:"button-add buttons-primary",attrs:{"has-permission":"lives_post_add","variant":_vm.headerBgVariant},on:{"click":_vm.GoToAddLive}},[_c('svg',{staticClass:"mr-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 30 30"}},[_c('path',{attrs:{"id":"Color","d":"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z","transform":"translate(3.75 3.75)","fill":"#ffffff"}})]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-inline-block ml-20"},[_vm._v(_vm._s(_vm.$t('button.add')))])])],1):_vm._e()],1)],1)])]),_vm._v(" "),_c('b-row',[_c('div',{staticClass:"col-sm-12 list-container"},[_c('div',{staticClass:"cards",attrs:{"align":"center"}},[_c('VuePerfectScrollbar',{ref:"ps-chapters",staticClass:"table-wrapper"},[_c('b-table',{staticClass:"tableFixHead",attrs:{"thead-top":"","show-empty":"","id":"table-list-lives","per-page":"0","busy":_vm.isBusy,"items":_vm.allLives,"fields":_vm.fields,"current-page":_vm.currentPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"sort-direction":_vm.sortDirection,"checkedAll":_vm.checkedAll},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sort-by":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"update:sort-desc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"sort-changed":_vm.sortingChanged,"head-clicked":function($event){return _vm.clearSelected($event)}},scopedSlots:_vm._u([{key:"HEAD_check",fn:function(head){return [_vm._v("\n                  "+_vm._s(head.label)+"\n                  "),_c('b-form-checkbox',{attrs:{"indeterminate":_vm.indeterminate,"button-variant":_vm.headerBgVariant,"switches":""},on:{"change":function($event){return _vm.checkAllLiveRows($event)},"update:indeterminate":function($event){_vm.indeterminate=$event}},model:{value:(_vm.allSelected),callback:function ($$v) {_vm.allSelected=$$v},expression:"allSelected"}})]}},{key:"check",fn:function(row){return [_c('b-form-checkbox',{key:row.item.id,attrs:{"name":'checked-' + row.item.id.toString(),"id":'check-' + row.item.id.toString(),"checked":_vm.checked,"button-variant":_vm.headerBgVariant,"switches":""},on:{"change":function($event){return _vm.CheckRowLive($event, row)}}})]}},{key:"thumbnail",fn:function(row){return [_c('b-img',{staticClass:"fluid brad-3 thumbnail-image",attrs:{"src":row.item.thumbnail || _vm.getDefaultThumb,"alt":"thumbnail Image"}}),_vm._v(" "),_c('div',{staticClass:"metadata-info"},[(!isNaN(row.item.nbVote))?_c('rating-stars',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_show_vote'),expression:"'lives_dtable_show_vote'"}],attrs:{"has-permission":"lives_dtable_show_vote","nbVote":row.item.nbVote,"id":row.item.id}}):_vm._e(),_vm._v(" "),(!isNaN(row.item.nbLike + row.item.nbNotLike))?_c('like-dislike',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_dtable_show_like,lives_dtable_show_not_like'),expression:"'lives_dtable_show_like,lives_dtable_show_not_like'"}],attrs:{"has-permission":"lives_dtable_show_like,lives_dtable_show_not_like","nbLike":row.item.nbLike,"nbNotLike":row.item.nbNotLike}}):_vm._e()],1)]}},{key:"dateStart",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(row.item.dateStart,' DD/MM/YYYY '))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(row.item.dateStart,'HH:mm:ss'))+" ")])]}},{key:"active",fn:function(row){return [_c('b-form-group',[_c('span',{staticClass:"badge",class:_vm.getStatut(row.item).class,model:{value:(row.item.active),callback:function ($$v) {_vm.$set(row.item, "active", $$v)},expression:"row.item.active"}},[_vm._v("\n                      "+_vm._s(_vm.$t('statut.' + _vm.getStatut(row.item).text))+"\n                    ")])])]}},{key:"actions",fn:function(row){return [_c('actions-buttons',{attrs:{"row":row}})]}},{key:"empty",fn:function(scope){return [_c('div',{staticClass:"my-5 text-center"},[_vm._v(_vm._s(_vm.$t('table.empty')))])]}},{key:"mobile-details",fn:function(row){return [_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex live-content"},[_c('div',{staticClass:"live-content__thumbnail-container"},[_c('b-img',{attrs:{"src":row.item.thumbnail || _vm.getDefaultThumb}})],1),_vm._v(" "),_c('div',{staticClass:"live-content__data d-flex flex-column"},[_c('div',{staticClass:"live-content__data__title"},[_c('h4',[_vm._v(_vm._s(row.item.title))])]),_vm._v(" "),_c('div',{staticClass:"live-content__data__date"},[_vm._v("\n                          "+_vm._s(_vm._f("moment")(row.item.dateStart,' DD/MM/YYYY'))+"\n                          "),_c('div',[_c('font-awesome-icon',{attrs:{"icon":"clock"}}),_vm._v("\n                            "+_vm._s(_vm._f("moment")(row.item.dateStart,'HH:mm:ss'))+"\n                          ")],1)])])])])]}},{key:"show_details",fn:function(row){return [_c('b-button',{staticClass:"show-actions-btn c-grey-700",class:{ active: row.detailsShowing },attrs:{"variant":"link"},on:{"click":row.toggleDetails}},[_c('font-awesome-icon',{attrs:{"icon":"ellipsis-v"}})],1)]}},{key:"row-details",fn:function(row){return [_c('div',{directives:[{name:"show",rawName:"v-show",value:(row.item._showDetails),expression:"row.item._showDetails"}],staticClass:"actions-container"},[_c('actions-buttons',{attrs:{"row":row}})],1)]}}]),model:{value:(_vm.tableValues),callback:function ($$v) {_vm.tableValues=$$v},expression:"tableValues"}},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"my-5 text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle",staticStyle:{"width":"1.5rem","height":"1.5rem","border":"0.15em solid currentColor","border-right-color":"transparent","margin-right":"10px"}}),_vm._v(" "),_c('span',[_vm._v("Data loading...")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"border-top p-15"},[_c('b-row',[_c('b-col',{staticClass:"d-none d-md-flex justify-content-start align-items-center"},[_c('span',{staticStyle:{"padding-right":"10px"}},[_vm._v(_vm._s(_vm.$t('table.pagination.show')))]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0"},[_c('b-form-select',{attrs:{"options":_vm.pageOptions,"value-field":"item","text-field":"name","aria-selected":_vm.perPage},on:{"change":function($event){return _vm.changePerPage($event)}},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('table.pagination.elements')))]),_vm._v(" "),(_vm.getTotalLive)?_c('span',[_vm._v(" / "+_vm._s(_vm.getTotalLive))]):_c('span',[_vm._v("/ 0")])],1),_vm._v(" "),_c('b-col',{staticClass:"d-flex justify-content-start align-items-center position-relative justify-content-end lives-pagination"},[_c('b-pagination',{staticClass:"mb-0 buttons-link",attrs:{"total-rows":_vm.getTotalLive,"per-page":_vm.perPage,"first-text":_vm.$t('table.pagination.first'),"prev-text":_vm.$t('table.pagination.prev'),"next-text":_vm.$t('table.pagination.next'),"last-text":_vm.$t('table.pagination.last'),"variant":_vm.headerBgVariant},on:{"change":function($event){return _vm.changeNumPage($event)}},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"modal-view-row",attrs:{"scrollable":"","title":_vm.$t('modal.view.title') + _vm.getLive['title'],"size":"lg","id":"modal-view-row","header-class":"buttons-primary","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',[_c('b-row',{staticClass:"mb-1 text-center live-details"},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.id')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.getLive['id']))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center live-details"},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.title')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.getLive['title']))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center live-details"},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.description')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.getLive['description']))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center live-details"},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.tags')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.getLive['tags']))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center live-details"},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.date')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm._f("moment")(_vm.getLive['dateStart'],' DD/MM/YYYY (HH:mm:ss'))+" -\n                "+_vm._s(_vm._f("moment")(_vm.getLive['dateEnd'],'HH:mm:ss)'))+"\n              ")])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_private_no_api'),expression:"'lives_private_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_private_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.private')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['private'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_autopub_no_api'),expression:"'lives_autopub_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_autopub_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.automatic_share')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['autoPub'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_active_no_api'),expression:"'lives_active_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_active_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.active')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['active'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center live-details"},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.vignette')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[_c('b-img',{staticClass:"fluid brad-3",attrs:{"src":_vm.getLive['thumbnail'] || _vm.getDefaultThumb,"alt":"thumbnail Image"}})],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_like_no_api'),expression:"'lives_fo_like_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_fo_like_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.like')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['foLike'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_sondage_no_api'),expression:"'lives_fo_sondage_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_fo_sondage_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.poll')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['foSondage'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_subscript_no_api'),expression:"'lives_fo_subscript_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_fo_subscript_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.registration')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['foSubscript'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_comment_no_api'),expression:"'lives_fo_comment_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_fo_comment_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.send_mails')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['foComment'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_fo_files_share_no_api'),expression:"'lives_fo_files_share_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_fo_files_share_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.share_file')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['foFilesShare'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_screen_share_no_api'),expression:"'lives_screen_share_no_api'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_screen_share_no_api"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.screen_share')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['screenShare'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_conf_post_add'),expression:"'lives_conf_post_add'"}],staticClass:"mb-1 text-center live-details",attrs:{"has-permission":"lives_conf_post_add"}},[_c('b-col',{staticClass:"live-column"},[_c('span',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.$t('modal.view.params.config')))])]),_vm._v(" "),_c('b-col',{staticClass:"live-column"},[(_vm.getLive['defaultConf'] === true)?_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.yes')))]):_c('b',{staticClass:"live-value"},[_vm._v(_vm._s(_vm.$t('modal.view.params.no')))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","size":"sm","id":"btn_cancel"},on:{"click":function($event){return _vm.closeViewModalById()}}},[_vm._v("\n            "+_vm._s(_vm.$t('modal.view.btn_cancel'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"modal-infos-live-row",staticStyle:{"font-size":"15px"},attrs:{"size":"lg","title":_vm.$t('modal.infos.title') + _vm.getInfoDetailLive['title'],"id":"modal-infos-live-row","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',{staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[_vm._l((_vm.getInfoDetailLive['streamingURLs']),function(item,index){return [_c('b-row',{staticClass:"mb-1 text-center"},[_c('span',{staticClass:"live-diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.infos.url_diffusion'))+" "+_vm._s(index + 1))])]),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center link-key"},[_c('label',[_vm._v(_vm._s(_vm.$t('modal.infos.link')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"disabled":""},domProps:{"value":item.link}})]),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center link-key"},[_c('label',[_vm._v(_vm._s(_vm.$t('modal.infos.key')))]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"disabled":""},domProps:{"value":item.key}})])]}),_vm._v(" "),_c('b-row',[((_vm.getInfoDetailLive['login'] !== '' || _vm.getInfoDetailLive['pwd'] !== '' || (!_vm.getInfoDetailLive['is_pearl'] && _vm.getInfoDetailLive['token'] )))?_c('span',{staticClass:"separator"}):_vm._e()]),_vm._v(" "),((_vm.getInfoDetailLive['login'] !== null) && (_vm.getInfoDetailLive['login'] !== ''))?_c('b-row',{staticClass:"mb-1 text-center"},[_c('span',{staticClass:"live-diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.infos.login')))])]):_vm._e(),_vm._v(" "),((_vm.getInfoDetailLive['login'] !== null) && (_vm.getInfoDetailLive['login'] !== ''))?_c('b-row',{staticClass:"mb-1 text-center"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":_vm.$t('modal.infos.login'),"disabled":""},domProps:{"value":_vm.getInfoDetailLive['login']}})]):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center"},[((_vm.getInfoDetailLive['pwd'] !== null) && (_vm.getInfoDetailLive['pwd'] !== ''))?_c('span',{staticClass:"live-diffusion-title"},[_vm._v(_vm._s(_vm.$t('modal.infos.pass')))]):_vm._e()]),_vm._v(" "),((_vm.getInfoDetailLive['pwd'] !== null) && (_vm.getInfoDetailLive['pwd'] !== ''))?_c('b-row',{staticClass:"mb-1 text-center"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":_vm.$t('modal.infos.pass'),"disabled":""},domProps:{"value":_vm.getInfoDetailLive['pwd']}})]):_vm._e(),_vm._v(" "),(!_vm.getInfoDetailLive['is_pearl'] && (_vm.getInfoDetailLive['token'] !== null) && (_vm.getInfoDetailLive['token'] !== ''))?_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_export_token'),expression:"'lives_export_token'"}],staticClass:"mb-1 text-center",attrs:{"has-permission":"lives_export_token"}},[_c('span',{staticClass:"live-diffusion-title"},[_vm._v("Token")])]):_vm._e(),_vm._v(" "),((!_vm.getInfoDetailLive['is_pearl'] && _vm.getInfoDetailLive['token'] !== null) && (_vm.getInfoDetailLive['token'] !== ''))?_c('b-row',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_export_token'),expression:"'lives_export_token'"}],staticClass:"mb-1 text-center",attrs:{"has-permission":"lives_export_token"}},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"token live","disabled":""},domProps:{"value":_vm.getInfoDetailLive['token']}})]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","size":"sm","id":"btn_cancel"},on:{"click":function($event){return _vm.closeInfosModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('modal.infos.btn_cancel'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"modal-link-export-row",staticClass:"buttons-primary",staticStyle:{"font-size":"15px"},attrs:{"scrollable":"","size":"lg","title":_vm.$t('modal.export.title') + _vm.getLinkExportLives['title'],"id":"modal-link-export-row","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',{staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[(_vm.getUseJitsi && _vm.getLinkExportLives['url_export_admin'])?_c('b-row',{staticClass:"mb-1 text-row-export export-position"},[_c('b-col',{attrs:{"sm":"3"}},[_c('span',{staticClass:"text-export"},[_vm._v(_vm._s(_vm.$t('modal.export.url')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"7"}},[_c('div',[_c('input',{ref:"url_export",staticClass:"form-control live-title live-text-title",attrs:{"readonly":""},domProps:{"value":_vm.getLinkExportLives['url_export_admin']},on:{"update:value":function($event){return _vm.$set(_vm.getLinkExportLives, 'url_export_admin', $event)}}})])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{staticClass:"float-left multi-buttons buttons-modal",class:['link-button', { 'is-active': _vm.clickedUrlExport }],attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyExportLink($event, 'url_export')}}},[(_vm.clickedUrlExport)?_c('font-awesome-icon',{staticClass:"check-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'check' }}}):_c('span',[_vm._v(_vm._s(_vm.$t('modal.export.copy')))])],1)],1)],1):_vm._e(),_vm._v(" "),(Array.isArray(_vm.getLinkExportLives['permalien']))?_c('div',[(_vm.getLinkExportLives['permalien'].length >= 1 &&
              _vm.getLinkExportLives['permalien'].length !== 2
              )?_c('b-row',{staticClass:"mb-1 text-row-export permalink-position"},[_c('b-col',{attrs:{"sm":"3"}},[_c('span',{staticClass:"text-export text-export-position"},[_vm._v(_vm._s(_vm.$t('modal.export.permalink')))])]),_vm._v(" "),_c('b-col',{staticClass:"text-export-col-position",attrs:{"sm":"9"}},_vm._l((_vm.getLinkExportLives['permalien']),function(permalink,index){return _c('b-row',{key:index,staticClass:"mb-1"},[_c('b-col',{attrs:{"sm":"9"}},[_c('input',{ref:"permalink",refInFor:true,staticClass:"form-control multi-links live-title live-text-title live-text-position",attrs:{"readonly":""},domProps:{"value":permalink},on:{"update:value":function($event){permalink=$event}}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{staticClass:"float-left multi-buttons buttons-modal multi-buttons-position",class:[
                        'link-button',
                        { 'is-active': _vm.clickedPermalink && _vm.permalinkIndex === index } ],attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyExportLink($event, 'permalink', index)}}},[(_vm.clickedPermalink && _vm.permalinkIndex === index)?_c('font-awesome-icon',{staticClass:"check-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'check' }}}):_c('span',[_vm._v(_vm._s(_vm.$t('modal.export.copy'))+" ")])],1)],1)],1)}),1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.getLinkExportLives['permalien']),function(permalink,index){return (_vm.getLinkExportLives['permalien'].length === 2)?_c('b-row',{key:index,staticClass:"mb-1 text-row-export"},[(permalink)?_c('b-col',{attrs:{"sm":"3"}},[_c('span',{staticClass:"text-export",domProps:{"textContent":_vm._s(_vm.getNamePermalink(permalink))}})]):_vm._e(),_vm._v(" "),(permalink)?_c('b-col',{attrs:{"sm":"7"}},[_c('input',{ref:"permalink",refInFor:true,staticClass:"form-control multi-links live-title live-text-title live-text-position",attrs:{"readonly":""},domProps:{"value":permalink},on:{"update:value":function($event){permalink=$event}}})]):_vm._e(),_vm._v(" "),(permalink)?_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{staticClass:"float-left multi-buttons buttons-modal multi-buttons-position",class:[
                    'link-button',
                    { 'is-active': _vm.clickedPermalink && _vm.permalinkIndex === index } ],attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyExportLink($event, 'permalink', index)}}},[(_vm.clickedPermalink && _vm.permalinkIndex === index)?_c('font-awesome-icon',{staticClass:"check-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'check' }}}):_c('span',[_vm._v(_vm._s(_vm.$t('modal.export.copy')))])],1)],1):_vm._e()],1):_vm._e()})],2):_c('div',[_c('b-row',{staticClass:"mb-1 text-row-export export-position"},[_c('b-col',{attrs:{"sm":"3"}},[_c('span',{staticClass:"text-export"},[_vm._v(_vm._s(_vm.$t('modal.export.permalink')))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"7"}},[_c('input',{ref:"permalink",staticClass:"form-control live-title live-text-title",attrs:{"readonly":""},domProps:{"value":_vm.getLinkExportLives['permalien']},on:{"update:value":function($event){return _vm.$set(_vm.getLinkExportLives, 'permalien', $event)}}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{staticClass:"float-left multi-buttons buttons-modal",class:['link-button', { 'is-active': _vm.clickedPermalink }],attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyExportLink($event, 'permalink')}}},[(_vm.clickedPermalink)?_c('font-awesome-icon',{staticClass:"check-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'check' }}}):_c('span',[_vm._v(_vm._s(_vm.$t('modal.export.copy')))])],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-row-export"},[_c('b-col',{attrs:{"sm":"3"}},[_c('span',{staticClass:"text-export"},[_vm._v(_vm._s(_vm.$t('modal.export.embed')))])]),_vm._v(" "),_c('b-col',{staticClass:"textarea-col-position",attrs:{"sm":"7"}},[_c('textarea',{ref:"embed",staticClass:"textarea-height",class:['form-control'],attrs:{"readonly":""},domProps:{"textContent":_vm._s(_vm.iframe)}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{staticClass:"float-left multi-buttons buttons-modal",class:['link-button', { 'is-active': _vm.clickedEmbed }],attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyExportLink($event, 'embed')}}},[(_vm.clickedEmbed)?_c('font-awesome-icon',{staticClass:"check-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'check' }}}):_c('span',[_vm._v(_vm._s(_vm.$t('modal.export.copy')))])],1)],1)],1),_vm._v(" "),(this.getLinkExportLives['link_journalist'])?_c('b-row',{staticClass:"mb-1 text-row-export"},[_c('b-col',{attrs:{"sm":"3"}},[_c('span',{staticClass:"text-export"},[_vm._v(_vm._s(_vm.$t('modal.export.journalist')))])]),_vm._v(" "),_c('b-col',{staticClass:"textarea-col-position",attrs:{"sm":"7"}},[_c('input',{ref:"link_journalist",staticClass:"form-control live-title live-text-title",attrs:{"readonly":""},domProps:{"value":this.getLinkExportLives['link_journalist']},on:{"update:value":function($event){return _vm.$set(this.getLinkExportLives, 'link_journalist', $event)}}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{staticClass:"float-left multi-buttons buttons-modal",class:['link-button', { 'is-active': _vm.clickedJournalist }],attrs:{"variant":"light","size":"sm"},on:{"click":function($event){return _vm.copyExportLink($event, 'link_journalist')}}},[(_vm.clickedJournalist)?_c('font-awesome-icon',{staticClass:"check-icon",attrs:{"icon":{ prefix: 'fas', iconName: 'check' }}}):_c('span',[_vm._v(_vm._s(_vm.$t('modal.export.copy')))])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","size":"sm","id":"btn_cancel"},on:{"click":function($event){return _vm.closeExportLinkModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('modal.infos.btn_cancel'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"modal-send-invitations-row",staticClass:"buttons-primary",attrs:{"size":"lg","title":_vm.$t('modal.send_invitations.title'),"id":"modal-send-invitations-row","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',{staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-1 text-center"},_vm._l((_vm.getSubscriptionUser),function(user,index){
                  var _obj;
return _c('div',{key:index,class:['userItem']},[_c('span',{class:[
                'userSpan',
                ( _obj = {}, _obj['is-selected'] = _vm.invitations[_vm.invitations.indexOf(user.email)], _obj ) ],on:{"click":function($event){return _vm.selectUser($event, user.email)}}},[_vm._v(_vm._s(user.email))])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-primary",attrs:{"id":"btn_send","variant":_vm.headerBgVariant,"disabled":!_vm.selectedUser},on:{"click":function($event){return _vm.sendInvitationMail()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.send'))+"\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","id":"btn_cancel"},on:{"click":function($event){return _vm.closeSendInvitationsModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.cancel'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"modal-send-group-mails-row",class:['buttons-primary'],attrs:{"size":"lg","title":_vm.$t('modal.send_invitations.title'),"id":"modal-send-group-mails-row","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',{staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.defaultChoice),expression:"!form.defaultChoice"}],staticClass:"mb-1 text-center group-mails"},[_c('div',{staticClass:"add-emails"},[_c('label',{staticClass:"primary text-email"},[_vm._v(_vm._s(_vm.$t('modal.send_group_mails.send_mails.text')))]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal buttons-group-mails button-add-mail buttons-outline-primary",attrs:{"variant":"outline-primary","id":"btn_add_email"},on:{"click":function($event){return _vm.goToAddEmailsModal()}}},[_c('font-awesome-icon',{staticClass:"actionIcons icon-add-email",attrs:{"icon":{ prefix: 'fas', iconName: 'plus' }}}),_vm._v("\n                "+_vm._s(_vm.$t('button.add_emails'))+"\n              ")],1)],1),_vm._v(" "),_c('VuePerfectScrollbar',{ref:"ps-group-mails",staticClass:"scroll-area-group scroll-group-list"},[_c('label',{staticClass:"primary label-group-list"},[_vm._v(_vm._s(_vm.$t('modal.send_group_mails.send_mails.groupLabel')))]),_vm._v(" "),_c('div',{staticClass:"list-groups"},[_c('div',{staticClass:"group-mails__all__list"},_vm._l((_vm.getSubscriptionGroupUsers),function(user,index){
              var _obj;
return _c('div',{key:index,class:[
                    'group-mails__all__list__user',
                    ( _obj = {}, _obj['is-group-selected'] = _vm.groupInvitations[_vm.groupInvitations.indexOf(user.id)], _obj ) ],on:{"click":function($event){return _vm.selectGroupUser($event, user.id)}}},[_vm._v("\n                    "+_vm._s(user.name)+"\n                  ")])}),0)]),_vm._v(" "),_c('label',{staticClass:"primary label-mail-list"},[_vm._v(_vm._s(_vm.$t('modal.send_group_mails.send_mails.mailLabel')))]),_vm._v(" "),_c('div',{staticClass:"list-groups"},[_c('div',{staticClass:"group-mails__all__list"},_vm._l((_vm.form.emails),function(item,iteration){return (_vm.form.emails.length > 0)?_c('span',{key:iteration,staticClass:"group-mails__all__list__email"},[_vm._v("\n                    "+_vm._s(_vm.form.emails[iteration])+"\n                    "),_c('a',{staticClass:"remove",on:{"click":function($event){return _vm.removeAddedMail(_vm.form.emails[iteration])}}})]):_vm._e()}),0)])])],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.defaultChoice),expression:"form.defaultChoice"}],staticClass:"mb-1 text-center"},[_c('div',{staticClass:"form-group form-email"},[_c('label',{staticClass:"primary text-email"},[_vm._v(_vm._s(_vm.$t('modal.send_group_mails.insert_mails.text')))]),_vm._v(" "),_c('label',{staticClass:"primary label-email"},[_vm._v(_vm._s(_vm.$t('modal.send_group_mails.insert_mails.label')))]),_vm._v(" "),_c('input-tag',{staticClass:"input-email",attrs:{"validate":"email"},model:{value:(_vm.form.emails),callback:function ($$v) {_vm.$set(_vm.form, "emails", $$v)},expression:"form.emails"}})],1)])],1),_vm._v(" "),(!_vm.form.defaultChoice)?_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-group-mails buttons-primary",attrs:{"id":"btn_send","variant":_vm.headerBgVariant,"disabled":_vm.disabledSendButton},on:{"click":function($event){return _vm.sendInvitationGroupMails()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.send'))+"\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal buttons-group-mails",attrs:{"variant":"light","id":"btn_cancel"},on:{"click":function($event){return _vm.closeSendGroupInvitationsModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.cancel'))+"\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.form.defaultChoice)?_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-group-mails buttons-primary",attrs:{"id":"btn_send","disabled":_vm.form.emails.length === 0,"variant":_vm.headerBgVariant},on:{"click":function($event){return _vm.addNewEmail(_vm.form.emails)}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.add'))+"\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal buttons-group-mails",attrs:{"variant":"light","id":"btn_cancel"},on:{"click":function($event){return _vm.cancelAddGroupMailsModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.cancel'))+"\n          ")])],1):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"modal-screen-share-row",staticClass:"buttons-primary",attrs:{"size":"lg","title":_vm.$t('modal.screen_share.title'),"id":"modal-screen-share-row","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',{staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-1 text-center"},[_c('span',[_vm._v(_vm._s(_vm.$t('modal.screen_share.type')))])]),_vm._v(" "),_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-form-select',{attrs:{"options":_vm.screenTypeOptions},model:{value:(_vm.screenType),callback:function ($$v) {_vm.screenType=$$v},expression:"screenType"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-primary",attrs:{"id":"btn_send","variant":_vm.headerBgVariant},on:{"click":function($event){return _vm.updateScreenShare(_vm.screenType)}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.validate'))+"\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","id":"btn_cancel"},on:{"click":function($event){return _vm.closeScreenShareModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.cancel'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"modal-preview-archived-video",staticClass:"buttons-primary",attrs:{"size":"lg","title":_vm.$t('modal.show_archived_live.title'),"id":"modal-preview-archived-video","header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('b-container',{staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[(_vm.getLinkArchivedVideo.code === 200)?_c('b-row',{staticClass:"mb-1 text-center"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.getLinkArchivedVideo.data.link,"allowfullscreen":""}})],1):_vm._e(),_vm._v(" "),(_vm.getLinkArchivedVideo.code === 404 || _vm.getLinkArchivedVideo.code === 500)?_c('b-row',{staticClass:"mb-1 no-archived-position"},[_c('b-img',{staticClass:"no-archived-img",attrs:{"src":_vm.noArchivedVideo}}),_vm._v(" "),_c('span',{staticClass:"no-archived-text"},[_vm._v(_vm._s(_vm.$t('modal.show_archived_live.not_found')))])],1):_vm._e(),_vm._v(" "),(_vm.getLinkArchivedVideo.code === 400)?_c('b-row',{staticClass:"mb-1 no-archived-position"},[_c('b-img',{staticClass:"no-archived-img",attrs:{"src":_vm.noArchivedVideo}}),_vm._v(" "),_c('span',{staticClass:"no-archived-text"},[_vm._v(_vm._s(_vm.$t('modal.show_archived_live.not_transcripted')))])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-primary",attrs:{"id":"btn_send","variant":_vm.headerBgVariant},on:{"click":function($event){return _vm.closeModalArchivedVideo()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.ok'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:'modal-' + _vm.getStatusLive + '-live',staticClass:"buttons-primary",attrs:{"size":"lg","title":_vm.$t('modal.direct.' + _vm.getStatusLive + '.title'),"id":'modal-' + _vm.getStatusLive + '-live',"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"hide":function($event){return _vm.closeStatusModal()}}},[_c('div',{staticClass:"subTitles"},[_vm._v(" "+_vm._s(_vm.$t('modal.direct.' + _vm.getStatusLive + '.subtitle'))+" ")]),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-primary",attrs:{"id":"btn_send","variant":_vm.headerBgVariant},on:{"click":function($event){return _vm.handleStatusModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.ok'))+" \n          ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","id":"btn_cancel"},on:{"click":function($event){return _vm.closeStatusModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.cancel'))+"\n          ")])],1)]),_vm._v(" "),_c('b-modal',{ref:'modal-' + _vm.getTitleOnDeletedLive + '-live',staticClass:"buttons-primary",attrs:{"size":"lg","title":_vm.$t('modal.direct.' + _vm.getTitleOnDeletedLive + '.title.' + (_vm.showTrash ? 'multi' : 'simple')),"id":'modal-' + _vm.getTitleOnDeletedLive + '-live',"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant}},[_c('div',{staticClass:"subTitles"},[_vm._v(" "+_vm._s(_vm.showTrash ? _vm.$t('modal.direct.checked_elements') : _vm.liveObject.title)+_vm._s(_vm.$t('modal.direct.' + _vm.getTitleOnDeletedLive + '.subtitle.' + (_vm.showTrash ? 'multi' : 'simple')))+" ")]),_vm._v(" "),_c('div',{staticClass:"w-100",staticStyle:{"border-top":"none"},attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"float-right buttons-modal buttons-primary",attrs:{"id":"btn_send","variant":_vm.headerBgVariant},on:{"click":function($event){return _vm.handleDeleteLiveModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.ok'))+"\n          ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right buttons-modal",attrs:{"variant":"light","id":"btn_cancel"},on:{"click":function($event){return _vm.closeDeleteLiveModal()}}},[_vm._v("\n            "+_vm._s(_vm.$t('button.cancel'))+"\n          ")])],1)]),_vm._v(" "),_c('b-modal',{ref:'modal-flow-live-row',staticClass:"buttons-primary",attrs:{"size":"xl","centered":"","title":_vm.$t('modal.direct.flow'),"id":'modal-flow-live-row',"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant,"hide-footer":""}},[_c('b-container',{staticClass:"flow--container",staticStyle:{"border-bottom":"none"},attrs:{"fluid":""}},[_c('iframe',{staticClass:"flow-iframe",attrs:{"src":_vm.getUrlFlow,"width":"100%","height":"100%","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","frameborder":"0"}})])],1)],1)]),_vm._v(" "),_c('share-link')],1)}
var ListLive_staticRenderFns = []
var ListLive_esExports = { render: ListLive_render, staticRenderFns: ListLive_staticRenderFns }
/* harmony default export */ var components_ListLive = (ListLive_esExports);
// CONCATENATED MODULE: ./src/components/ListLive.vue
function ListLive_injectStyle (ssrContext) {
  __webpack_require__("lR5z")
}
var ListLive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListLive___vue_template_functional__ = false
/* styles */
var ListLive___vue_styles__ = ListLive_injectStyle
/* scopeId */
var ListLive___vue_scopeId__ = "data-v-0b75d5c0"
/* moduleIdentifier (server only) */
var ListLive___vue_module_identifier__ = null
var ListLive_Component = ListLive_normalizeComponent(
  ListLive,
  components_ListLive,
  ListLive___vue_template_functional__,
  ListLive___vue_styles__,
  ListLive___vue_scopeId__,
  ListLive___vue_module_identifier__
)

/* harmony default export */ var src_components_ListLive = (ListLive_Component.exports);

// EXTERNAL MODULE: ./node_modules/@fullcalendar/vue/main.esm.js
var main_esm = __webpack_require__("l7UG");

// EXTERNAL MODULE: ./node_modules/@fullcalendar/daygrid/main.esm.js
var daygrid_main_esm = __webpack_require__("uJAD");

// EXTERNAL MODULE: ./node_modules/@fullcalendar/resource-timeline/main.esm.js + 2 modules
var resource_timeline_main_esm = __webpack_require__("aH/+");

// EXTERNAL MODULE: ./node_modules/@fullcalendar/timegrid/main.esm.js
var timegrid_main_esm = __webpack_require__("U2C2");

// EXTERNAL MODULE: ./node_modules/@fullcalendar/interaction/main.esm.js
var interaction_main_esm = __webpack_require__("uX+s");

// EXTERNAL MODULE: ./node_modules/@fullcalendar/core/main.esm.js
var core_main_esm = __webpack_require__("ECba");

// EXTERNAL MODULE: ./node_modules/@fullcalendar/core/locales/es.js
var locales_es = __webpack_require__("ER/K");
var locales_es_default = /*#__PURE__*/__webpack_require__.n(locales_es);

// EXTERNAL MODULE: ./node_modules/@fullcalendar/core/locales/fr.js
var fr = __webpack_require__("o868");
var fr_default = /*#__PURE__*/__webpack_require__.n(fr);

// EXTERNAL MODULE: ./node_modules/@fullcalendar/core/main.css
var core_main = __webpack_require__("CkkA");
var core_main_default = /*#__PURE__*/__webpack_require__.n(core_main);

// EXTERNAL MODULE: ./node_modules/@fullcalendar/daygrid/main.css
var daygrid_main = __webpack_require__("QADr");
var daygrid_main_default = /*#__PURE__*/__webpack_require__.n(daygrid_main);

// EXTERNAL MODULE: ./node_modules/@fullcalendar/timegrid/main.css
var timegrid_main = __webpack_require__("AP3z");
var timegrid_main_default = /*#__PURE__*/__webpack_require__.n(timegrid_main);

// EXTERNAL MODULE: ./node_modules/@fullcalendar/resource-timeline/main.css
var resource_timeline_main = __webpack_require__("je/n");
var resource_timeline_main_default = /*#__PURE__*/__webpack_require__.n(resource_timeline_main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/CalendarLives.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ var CalendarLives = ({
  locales: [locales_es_default.a, fr_default.a],
  locale: 'fr',
  components: {
    FullCalendar: main_esm["a" /* default */]
  },
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  directives: {
    HasPermission: HasPermission
  },
  data: function data() {
    return {
      calendarPlugins: [daygrid_main_esm["d" /* default */], resource_timeline_main_esm["a" /* default */], interaction_main_esm["a" /* default */], timegrid_main_esm["a" /* default */]],
      calendarEvents: [{
        id: 1,
        title: 'Event 1',
        start: new Date('2019-07-08T19:07:18Z'),
        end: new Date('2019-07-10T20:20:15Z'),
        logo: 'https://picsum.photos/600/300/?image=25',
        borderColor: 'red',
        textColor: 'red',
        backgroundColor: 'red'
      }, {
        id: 2,
        title: 'Event 2',
        start: new Date('2019-07-09'),
        logo: '',
        borderColor: 'blue',
        textColor: 'blue',
        backgroundColor: 'blue'
      }, {
        id: 3,
        title: 'Event 3',
        start: new Date('2019-07-10'),
        logo: 'https://placekitten.com/300/300',
        borderColor: 'green',
        textColor: 'green',
        backgroundColor: 'green'
      }],
      image: '',
      calendarWeekends: true,
      eventLive: '',
      allperiodLives: [],
      initialLocaleCode: 'en',
      initialLocaleDayText: 'allDay',
      selected: '',
      allLivesByPeriod: [],
      calendarApi: {},
      currentDate: '',
      currentMonth: '',
      currentYear: '',
      allDay: true,
      changePeriods: false,
      options: [{
        id: 'today',
        value: 'today'
      }, {
        id: 'timeGridDay',
        value: 'day'
      }, {
        id: 'timeGridWeek',
        value: 'week'
      }, {
        id: 'dayGridMonth',
        value: 'month'
      }]
    };
  },

  mixins: [UtilsMixin],
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    getAllLivesByPeriod: 'lives/getAllLivesByPeriod',
    deleteLiveById: 'lives/deleteLiveById'
  }), {
    handleLiveClick: function handleLiveClick(args) {
      this.eventLive = args.event;
      this.image = this.eventLive.extendedProps.logo;

      this.$refs['modal-live-details-rows'].show();
    },
    closeLiveModal: function closeLiveModal() {
      this.$refs['modal-live-details-rows'].hide();
    },
    deleteLiveDate: function deleteLiveDate(event) {
      var _this = this;

      this.$refs['modal-live-details-rows'].hide();
      this.eventLive.remove();
      var deleteLive = true;
      var message_confirm = i18n.t('modal.delete.form.subtitle');
      var message_reset = i18n.t('modal.delete.selection.btn_cancel');
      var TOAST_DURATION = 5000;
      var TOAST_DURATION_DELETE = TOAST_DURATION + 1;
      this.$toasted.show(message_confirm, {
        theme: 'bubble',
        position: 'bottom-right',
        icon: {
          name: 'icon-warning mr-2'
        },
        duration: TOAST_DURATION,
        action: {
          text: message_reset,
          onClick: function onClick(e, toastObject) {
            deleteLive = false;
            _this.calendarApi.addEvent(_this.eventLive);
            toastObject.goAway(0);
          }
        }
      });
      setTimeout(function () {
        if (deleteLive === true && TOAST_DURATION_DELETE) {
          _this.deleteLiveById(_this.eventLive.id);
        }
      }, TOAST_DURATION_DELETE);
    },
    getDateLive: function getDateLive(date) {
      var dd = date.getDate();
      var mm = date.getMonth() + 1;

      var yyyy = date.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      return date = yyyy + '-' + mm + '-' + dd;
    },
    setStartEndLive: function setStartEndLive(start, end) {
      var period = {
        startDate: start,
        endDate: end
      };
      this.getAllLivesByPeriod(period);
    },
    initPeriodSelect: function initPeriodSelect(event) {
      this.changePeriods = true;
      this.selected = event.srcElement.text;
      if (event.target.id === 'today') {
        this.calendarApi.today();
      } else {
        this.calendarApi.changeView(event.target.id);
      }
      var start = this.getDateLive(this.calendarApi.view.activeStart);
      var end = this.getDateLive(this.calendarApi.view.activeEnd);
      this.setStartEndLive(start, end);
      this.updateCurrentDate();
    },
    updateCurrentDate: function updateCurrentDate() {
      this.currentDate = document.querySelector('.fc .fc-toolbar .fc-center').innerText;
    },
    prev: function prev() {
      this.calendarApi.prev();
      var start = this.getDateLive(this.calendarApi.view.activeStart);
      var end = this.getDateLive(this.calendarApi.view.activeEnd);
      this.setStartEndLive(start, end);
      this.updateCurrentDate();
    },
    next: function next() {
      this.calendarApi.next();
      var start = this.getDateLive(this.calendarApi.view.activeStart);
      var end = this.getDateLive(this.calendarApi.view.activeEnd);
      this.setStartEndLive(start, end);
      this.updateCurrentDate();
    },
    handleEventRender: function handleEventRender(params) {
      var bgColor = params.event.borderColor;
      if (bgColor) {
        var overlayEl = params.el.querySelector('.fc-time');
        if (!overlayEl) {
          var span = document.createElement('span');
          span.className = 'fc-time';
          params.el.querySelector('.fc-content').appendChild(span);
          overlayEl = params.el.querySelector('.fc-time');
        }
        overlayEl.style.backgroundColor = bgColor;
      }
    },
    goToListLive: function goToListLive() {
      parent.postMessage({
        info: 'goToListLive',
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    getLivesByPeriod: 'lives/getLivesByPeriod',
    getDiffusion: 'common/getDiffusion'
  })),
  mounted: function mounted() {
    var _this2 = this;

    this.calendarApi = this.$refs.fullCalendar.getApi();
    this.calendarApi.today();
    this.$refs.fullCalendar.$on('refetch-events', function () {
      var start = _this2.getDateLive(_this2.calendarApi.view.activeStart);
      var end = _this2.getDateLive(_this2.calendarApi.view.activeEnd);
      _this2.setStartEndLive(start, end);
    });
    this.calendarApi.setOption('locale', this.$i18n.locale);
    var start = this.getDateLive(this.calendarApi.view.activeStart);
    var end = this.getDateLive(this.calendarApi.view.activeEnd);
    this.setStartEndLive(start, end);
    this.updateCurrentDate();
    this.$root.$on('setCalendarLang', function (lang) {
      _this2.calendarApi.setOption('locale', lang);
      _this2.$i18n.locale = lang;
      i18n.locale = lang;
      _this2.updateCurrentDate();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c28860","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/CalendarLives.vue
var CalendarLives_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-lives"},[_c('button',{staticClass:"btn btn-light to-list-lives",on:{"click":_vm.goToListLive}},[_c('font-awesome-icon',{staticClass:"back-left-icon",attrs:{"icon":"arrow-left"}}),_vm._v(" "),_c('span',{staticClass:"button-back d-none d-md-inline-block"},[_vm._v(" "+_vm._s(_vm.$t('calendar.back'))+" ")])],1),_vm._v(" "),_c('div',{staticClass:"fc-toolbar fc-header-toolbar"},[_c('div',{staticClass:"fc-left",staticStyle:{"width":"100px"}}),_vm._v(" "),_c('div',{staticClass:"fc-center"},[_c('div',[_c('button',{staticClass:"fc-prev-button fc-button fc-button-primary",attrs:{"type":"button","aria-label":"prev"},on:{"click":function($event){return _vm.prev()}}},[_c('span',{staticClass:"fc-icon fc-icon-chevron-left"})]),_vm._v(" "),_c('h2',{staticClass:"current-date"},[_vm._v("\n          "+_vm._s(_vm.currentDate)+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"fc-next-button fc-button fc-button-primary",attrs:{"type":"button","aria-label":"next"},on:{"click":function($event){return _vm.next()}}},[_c('span',{staticClass:"fc-icon fc-icon-chevron-right"})])])]),_vm._v(" "),_c('div',{staticClass:"fc-right"},[_c('b-dropdown',{staticClass:"dropdown-lives-periods",attrs:{"variant":"link","toggle-class":"text-decoration-none","caret":""}},[_c('template',{slot:"button-content"},[(!_vm.changePeriods)?_c('span',{staticClass:"text-right-size"},[_vm._v(_vm._s(_vm.$t('calendar.period.show'))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.changePeriods)?_c('span',{staticClass:"text-right-size"},[_vm._v(_vm._s(_vm.selected))]):_vm._e()]),_vm._v(" "),_vm._l((_vm.options),function(item,index){return _c('b-dropdown-item',{key:index,staticClass:"text-right-size",attrs:{"id":item.id},on:{"click":function($event){return _vm.initPeriodSelect($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('calendar.period.' + item.value))+"\n        ")])})],2)],1)]),_vm._v(" "),_c('full-calendar',{ref:"fullCalendar",attrs:{"defaultView":"dayGridMonth","header":{
      left: '',
      center: 'title',
      right: '',
    },"events":_vm.getLivesByPeriod,"plugins":_vm.calendarPlugins,"weekends":_vm.calendarWeekends,"locale":_vm.initialLocaleCode,"allDayText":_vm.$t('calendar.' + _vm.initialLocaleDayText),"height":'parent'},on:{"eventClick":_vm.handleLiveClick,"eventRender":_vm.handleEventRender}}),_vm._v(" "),_c('b-modal',{ref:"modal-live-details-rows",attrs:{"id":"modal-live-details-rows","hide-footer":""}},[(_vm.eventLive)?_c('template',{slot:"modal-header"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-container__content",style:({ borderLeftColor: _vm.eventLive.borderColor })},[_c('strong',{staticClass:"title"},[_vm._v(_vm._s(_vm.eventLive.title))])])]),_vm._v(" "),_c('div',{staticClass:"list-icones"},[_c('a',{directives:[{name:"has-permission",rawName:"v-has-permission",value:('lives_delete_live'),expression:"'lives_delete_live'"}],staticStyle:{"font-size":"40px","color":"#d4d4d4","cursor":"pointer"},attrs:{"has-permission":"lives_delete_live","title":_vm.$t('button.close'),"target":"_blank"},on:{"click":_vm.closeLiveModal}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"icon-trash",staticStyle:{"font-size":"1.1em","color":"#d4d4d4","cursor":"pointer"},attrs:{"title":_vm.$t('button.delete')},on:{"click":function($event){return _vm.deleteLiveDate($event)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-block text-center custom-img"},[_c('img',{attrs:{"src":_vm.image
            ? _vm.image
            : 'data:image/jpeg;base64,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'}})])],2)],1)}
var CalendarLives_staticRenderFns = []
var CalendarLives_esExports = { render: CalendarLives_render, staticRenderFns: CalendarLives_staticRenderFns }
/* harmony default export */ var components_CalendarLives = (CalendarLives_esExports);
// CONCATENATED MODULE: ./src/components/components/CalendarLives.vue
function CalendarLives_injectStyle (ssrContext) {
  __webpack_require__("rh3Q")
}
var CalendarLives_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CalendarLives___vue_template_functional__ = false
/* styles */
var CalendarLives___vue_styles__ = CalendarLives_injectStyle
/* scopeId */
var CalendarLives___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CalendarLives___vue_module_identifier__ = null
var CalendarLives_Component = CalendarLives_normalizeComponent(
  CalendarLives,
  components_CalendarLives,
  CalendarLives___vue_template_functional__,
  CalendarLives___vue_styles__,
  CalendarLives___vue_scopeId__,
  CalendarLives___vue_module_identifier__
)

/* harmony default export */ var components_components_CalendarLives = (CalendarLives_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/components/SendMail.vue
//
//
//
//
//
//


/* harmony default export */ var SendMail = ({
  components: {},
  directives: {},
  data: function data() {
    return {
      link: window.process.env.LinkFoSendGrid + this.$route.params.id + "?v=" + Math.random()
    };
  },

  methods: {},
  computed: {},
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223fa09a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/SendMail.vue
var SendMail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-mail"},[_c('iframe',{staticClass:"iframe-send-mail",attrs:{"src":_vm.link}})])}
var SendMail_staticRenderFns = []
var SendMail_esExports = { render: SendMail_render, staticRenderFns: SendMail_staticRenderFns }
/* harmony default export */ var components_SendMail = (SendMail_esExports);
// CONCATENATED MODULE: ./src/components/components/SendMail.vue
function SendMail_injectStyle (ssrContext) {
  __webpack_require__("TEnX")
}
var SendMail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SendMail___vue_template_functional__ = false
/* styles */
var SendMail___vue_styles__ = SendMail_injectStyle
/* scopeId */
var SendMail___vue_scopeId__ = "data-v-223fa09a"
/* moduleIdentifier (server only) */
var SendMail___vue_module_identifier__ = null
var SendMail_Component = SendMail_normalizeComponent(
  SendMail,
  components_SendMail,
  SendMail___vue_template_functional__,
  SendMail___vue_styles__,
  SendMail___vue_scopeId__,
  SendMail___vue_module_identifier__
)

/* harmony default export */ var components_components_SendMail = (SendMail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExportRegistrant.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// import common from '../helpers/common';





/* harmony default export */ var ExportRegistrant = ({
  name: 'ExportLive',
  mixins: [UploadMixin, UtilsMixin],
  components: {
    VuePerfectScrollbar: dist_default.a,
    VueMoment: vue_moment_default.a,
    moment: moment
  },
  i18n: {
    messages: {
      en: en_US,
      fr: fr_FR
    }
  },
  directives: {
    HasPermission: HasPermission
  },
  data: function data() {
    return {
      registrants: [],
      currentPage: 1,
      searchWord: '',
      perPage: 20,
      recordTotal: 0,
      filteredRecord: 0,
      isBusy: false,
      pageOptions: [{ item: '5', name: '5' }, { item: '10', name: '10' }, { item: '20', name: '20' }]
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isPermission: 'common/getPermission',
    isSuperAdmin: 'common/getSuperAdmin',
    getDiffusion: 'common/getDiffusion'

  }), {
    fields: function fields() {
      return [{
        key: 'id',
        id: '0',
        label: i18n.t('table.list.idInscrit'),
        sortable: false,
        class: 'd-lg-table-cell w-80px custom-thead-class'
      }, {
        key: 'nom',
        id: '1',
        label: i18n.t('table.list.nom'),
        sortable: false,
        class: ' d-lg-table-cell custom-thead-class'
      }, {
        key: 'email',
        id: '2',
        label: i18n.t('table.list.email'),
        sortable: false,
        class: 'd-md-table-cell custom-thead-class'
      }, {
        key: 'entreprise',
        id: '3',
        label: i18n.t('table.list.entreprise'),
        sortable: false,
        class: 'd-none d-md-table-cell custom-thead-class'
      }, {
        key: 'date',
        id: '4',
        label: i18n.t('table.list.date'),
        sortable: false,
        class: 'd-none d-lg-table-cell custom-thead-class'
      }, {
        key: 'participation',
        id: '5',
        label: i18n.t('table.list.participation'),
        sortable: false,
        class: 'd-none d-md-table-cell  custom-thead-class'
      }];
    }
  }),
  watch: {},
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    setDiffusionObject: 'lives/setDiffusionObject',
    paginate: 'lives/paginate',
    setLoading: 'lives/setLoading'

  }), {
    goToListLive: function goToListLive() {
      parent.postMessage({
        info: 'goToListLive',
        value: this.getDiffusion
      }, '*');
      var cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    },
    exportFile: function exportFile() {
      var _this = this;

      if (this.$route.params.id) {
        if (this.recordTotal === 0) {
          var msg = i18n.t('toast.export_empty');
          this.showToast('error', msg, 'icon-warning');
          return;
        }

        nprogress_nprogress_default.a.start();
        axios_default.a.get(window.process.env.API_HOST_GLOBAL + '/live/subscriptions/subscribers/exportExcelSubscribersByLiveId/' + this.$route.params.id, {
          headers: {
            Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
          }
        }).then(function (response) {
          var messageSuccess = i18n.t('toast.export_success');
          var binaryData = atob(response.data.data);
          var byteArray = new Uint8Array(binaryData.length);
          for (var i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
          }
          var blob = new Blob([byteArray]);
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.style.display = "none";
          a.href = blobUrl;
          a.download = "subscribers.xlsx";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(a);
          nprogress_nprogress_default.a.done();
          _this.showToast('success', messageSuccess, 'icon-success');
        }).catch(function (error) {
          var message = i18n.t('toast.export_Error');
          _this.showToast('error', message, 'icon-warning');
        });
      }
    },
    fetchRegistrants: function fetchRegistrants() {
      var _this2 = this;

      if (this.$route.params.id) {
        this.isBusy = true;
        // this.setLoading({ type: 'videos', value: true }); // Set loading to true before API call
        axios_default.a.get(window.process.env.API_HOST_GLOBAL + '/live/subscriptions/subscribers/GetSubscribersByLiveId/' + this.$route.params.id,
        // `https://a748-41-230-33-70.ngrok-free.app/live/subscriptions/subscribers/GetSubscribersByLiveId/${this.$route.params.id}`,
        {
          params: {
            searchWord: this.searchWord,
            length: this.perPage,
            page: this.currentPage
          },
          headers: {
            Authorization: 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX1BMQVlFUiIsIlJPTEVfVVNFUiJdLCJ1c2VybmFtZSI6Il9fcGxheWVyIiwiaWF0IjoxNTAyMTE3MzU1LCJleHAiOjc4MDkzMTczNTV9.Rha_5FwSKn2wF7Fb5E8fiSQQY2a5sPR_8l5jLaX9nIBiGkijtMjAFeTGjnajDAVcntq5JHv73XSLlAoz-TfqsV2xTBJKjJsUhVtrfs5QxlChiIYhNlTWh0nW3fXMTCSRMshaehLBbcDCVFFBgIJh1Uvyiu341aJ2GgTUQGVZd-NJCEhBm1D3dUHiF_Hx4uG5p4Wh0U6CyKUbRfowts28kFZ0XJHNSSxkI0iWR1rBNqJrHlNYPZz8jnJ0BbTzC3pa4ANi0b3F5hSUySq4b5k5sQkXJrd2BhWzKyNlrBGt0bgEnz1eztOjxNR3Pqneito4hDtgwGcjX5fVuAMCPKUAVl0eLZXhkqh7IPk8hPj6zEje6_k5C13LFpbVoJp47WP4aFEKhNCYQAjLxSioXCFvBIzpRsTWEAtaacupJhfdSN90TDJpM4FiKPGSqwzmwuyNzxpuv8HoAKbeZEhhKXgZ7xe0Iz9TxD9yS_Pt6HiagLds0jjVmfobBnppFQ620lc7GhMa_M_WUS898sHEvt7AMsZ2u4bhCKdsy0jBVAMg0ubNt0327ltBl09voeyk56LVOkbH3v-qP2qupBG9P2Ub_A-wyuqstSzfC4vkS_nU7BcrnPKwYvFzDyWiU7rDT8UyxqQtWzcM7AV_cA1ZKCjJXFbiNFhDQMRcxiKXKcn6bcA"
          }
        }).then(function (res) {
          _this2.registrants = res.data.subscribers;
          _this2.recordTotal = res.data.recordsTotal;
          _this2.filteredRecord = res.data.recordsFiltered;
          _this2.isBusy = false;
          // this.setLoading({ type: 'videos', value: false }); // Set loading to false after API call
        });
      }
    },
    setTotalRows: function setTotalRows(number) {
      this.recordTotal = number;
    },
    changePerPage: function changePerPage(event) {
      this.perPage = event;
      this.currentPage = 1;
      this.fetchRegistrants();
    },
    changeNumPage: function changeNumPage(page) {
      this.currentPage = page;
      this.fetchRegistrants();
    },
    searchFilter: function searchFilter(event) {

      this.searchWord = event;
      this.currentPage = 1;
      this.fetchRegistrants();
    }
  }),
  created: function created() {
    this.fetchRegistrants();
  },
  mounted: function mounted() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.setTotalRows(_this3.filteredRecord);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc6d72e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportRegistrant.vue
var ExportRegistrant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('b-card',{staticClass:"Export-container"},[_c('div',{staticClass:"Header"},[_c('b-row',{attrs:{"g":"6"}},[_c('b-col',{staticClass:"col-12 col-md-8"},[_c('b-row',{staticClass:"align-items-center"},[_c('b-button',{attrs:{"variant":"light"},on:{"click":_vm.goToListLive}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'arrow-left']}})],1),_vm._v(" "),_c('span',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.$t('table.list.subscribersList')))])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"col-6 col-md-4 col-sm-12 col-12 input-search"},[_c('b-row',{staticClass:"flex-nowrap right-content"},[_c('b-input-group',{staticClass:"mb-2",attrs:{"size":"lg"}},[_c('b-input-group',{staticClass:"input-group-search"},[_c('b-input-group-prepend',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M23.663 21.9767L19.2137 17.56C20.9408 15.4049 21.7771 12.6695 21.5508 9.91628C21.3245 7.16303 20.0528 4.60118 17.997 2.75751C15.9412 0.913839 13.2578 -0.0715191 10.4983 0.00404582C7.73893 0.0796108 5.11331 1.21035 3.16137 3.16377C1.20944 5.11719 0.0795504 7.74481 0.00404275 10.5063C-0.0714649 13.2678 0.913145 15.9534 2.75542 18.0107C4.59769 20.068 7.15759 21.3407 9.90875 21.5672C12.6599 21.7937 15.3932 20.9567 17.5466 19.2283L21.96 23.645C22.0715 23.7575 22.2042 23.8468 22.3503 23.9077C22.4964 23.9686 22.6532 24 22.8115 24C22.9698 24 23.1266 23.9686 23.2727 23.9077C23.4189 23.8468 23.5515 23.7575 23.663 23.645C23.8792 23.4212 24 23.1221 24 22.8108C24 22.4996 23.8792 22.2005 23.663 21.9767ZM10.8186 19.2283C9.15827 19.2283 7.53518 18.7355 6.15463 17.8124C4.77408 16.8892 3.69807 15.5771 3.06267 14.0419C2.42727 12.5068 2.26102 10.8175 2.58495 9.18784C2.90887 7.55813 3.70842 6.06115 4.88248 4.88619C6.05654 3.71124 7.55239 2.91108 9.18086 2.58691C10.8093 2.26274 12.4973 2.42912 14.0313 3.065C15.5653 3.70088 16.8764 4.77771 17.7988 6.15931C18.7213 7.54091 19.2137 9.16523 19.2137 10.8269C19.2137 13.0551 18.3292 15.192 16.7548 16.7675C15.1804 18.3431 13.0451 19.2283 10.8186 19.2283Z","fill":"#62626B"}})])]),_vm._v(" "),_c('b-form-input',{staticClass:"search-field",attrs:{"type":"search","placeholder":_vm.$t('parameters.search.search')},on:{"input":function($event){return _vm.searchFilter($event)}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)],1),_vm._v(" "),_c('b-button',{staticClass:"invisible-button",attrs:{"title":"exportFile","variant":"light"},on:{"click":_vm.exportFile}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","viewBox":"0 0 27 27","fill":"none"}},[_c('path',{attrs:{"d":"M8.5 25.9999H18.5C22.035 25.9999 23.8038 25.9999 24.9013 24.9024C26 23.8024 26 22.0362 26 18.4999V17.2499C26 13.7149 26 11.9474 24.9013 10.8487C23.9413 9.88869 22.4687 9.76744 19.75 9.75244M7.25 9.75244C4.53125 9.76744 3.05875 9.88869 2.09875 10.8487C1 11.9474 1 13.7149 1 17.2499V18.4999C1 22.0362 1 23.8037 2.09875 24.9024C2.47375 25.2774 2.92625 25.5237 3.5 25.6862","stroke":"#62626B","stroke-width":"2","stroke-linecap":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.5 1V17.25M13.5 17.25L9.75 12.875M13.5 17.25L17.25 12.875","stroke":"#62626B","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 list-container"},[_c('div',{staticClass:"cards",attrs:{"align":"center"}},[_c('VuePerfectScrollbar',{ref:"ps-chapters",staticClass:"table-wrapper"},[_c('b-table',{staticClass:"tableFixHead",attrs:{"thead-top":"","show-empty":"","per-page":"0","busy":_vm.isBusy,"id":"table-list-lives","items":_vm.registrants,"fields":_vm.fields,"current-page":_vm.currentPage,"tbody-tr-class":"custom-row"},scopedSlots:_vm._u([{key:"HEAD_check",fn:function(head){return [_vm._v("\n                "+_vm._s(head.label)+"\n              ")]}},{key:"id",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.id)+" ")])]}},{key:"nom",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.name)+" "+_vm._s(row.item.last_name))])]}},{key:"email",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.webtvSubscriptionUser.email)+"  ")])]}},{key:"entreprise",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.webtvSubscriptionUser.society)+"  ")])]}},{key:"date",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm._f("moment")(row.item.created_at,' DD/MM/YYYY '))+" ")]),_vm._v(" "),_c('span',[_vm._v("( "+_vm._s(_vm._f("moment")(row.item.created_at,'HH:mm'))+" )")])]}},{key:"participation",fn:function(row){return [_c('span',{class:{'is_Participated': row.item.is_participated, 'not_Participated': !row.item.is_participated}},[_vm._v("\n                  "+_vm._s(row.item.is_participated ? _vm.$t('modal.view.params.yes') : _vm.$t('modal.view.params.no'))+"\n                 ")])]}},{key:"empty",fn:function(scope){return [_c('div',{staticClass:"my-5 text-center"},[_vm._v(_vm._s(_vm.$t('table.empty')))])]}}]),model:{value:(_vm.tableValues),callback:function ($$v) {_vm.tableValues=$$v},expression:"tableValues"}},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"my-5 text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle",staticStyle:{"width":"1.5rem","height":"1.5rem","border":"0.15em solid currentColor","border-right-color":"transparent","margin-right":"10px","color":"grey"}}),_vm._v(" "),_c('span',{staticClass:"spinner"},[_vm._v("Data loading...")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"p-15 border-top",staticStyle:{"padding-inline":"0","margin-top":"15 !important"}},[_c('b-row',[_c('b-col',{staticClass:"d-none d-md-flex justify-content-start align-items-center"},[_c('b-pagination',{staticClass:"mb-0 buttons-link",attrs:{"total-rows":this.filteredRecord,"per-page":_vm.perPage,"first-text":String.fromCharCode(171),"prev-text":String.fromCharCode(60),"next-text":String.fromCharCode(62),"last-text":String.fromCharCode(187),"variant":_vm.headerBgVariant},on:{"change":function($event){return _vm.changeNumPage($event)}},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"d-flex justify-content-start align-items-center position-relative justify-content-end subscibers-pagination"},[_c('span',{staticStyle:{"padding-right":"10px"}},[_vm._v(_vm._s(_vm.$t('table.pagination.elementPerPage')))]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0"},[_c('b-form-select',{attrs:{"options":_vm.pageOptions,"value-field":"item","text-field":"name","aria-selected":_vm.perPage},on:{"change":function($event){return _vm.changePerPage($event)}},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1)],1)],1)])])],1)}
var ExportRegistrant_staticRenderFns = []
var ExportRegistrant_esExports = { render: ExportRegistrant_render, staticRenderFns: ExportRegistrant_staticRenderFns }
/* harmony default export */ var components_ExportRegistrant = (ExportRegistrant_esExports);
// CONCATENATED MODULE: ./src/components/ExportRegistrant.vue
function ExportRegistrant_injectStyle (ssrContext) {
  __webpack_require__("kJvz")
}
var ExportRegistrant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExportRegistrant___vue_template_functional__ = false
/* styles */
var ExportRegistrant___vue_styles__ = ExportRegistrant_injectStyle
/* scopeId */
var ExportRegistrant___vue_scopeId__ = "data-v-0fc6d72e"
/* moduleIdentifier (server only) */
var ExportRegistrant___vue_module_identifier__ = null
var ExportRegistrant_Component = ExportRegistrant_normalizeComponent(
  ExportRegistrant,
  components_ExportRegistrant,
  ExportRegistrant___vue_template_functional__,
  ExportRegistrant___vue_styles__,
  ExportRegistrant___vue_scopeId__,
  ExportRegistrant___vue_module_identifier__
)

/* harmony default export */ var src_components_ExportRegistrant = (ExportRegistrant_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js











vue_esm["default"].use(vue_router_esm["a" /* default */]);
var addRoute = 'add';
var editRoute = 'edit';
var router_editLive = 'EditLive';
var exportLive = 'ExportLive';
var exportRoute = "exportList";
var addLive = 'CreateLive';
var componentForm = src_components_LiveForm;
var componentExport = src_components_ExportRegistrant;
if (window.process.env.HAS_SKIN === 'true') {
  addRoute = 'add-v2';
  editRoute = 'edit-v2';
  router_editLive = 'EditLiveV2';
  exportLive = 'ExportLiveV2';
  addLive = 'CreateLiveV2';
  componentForm = src_components_LiveFormV2;
}
var src_router_router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/liste-lives/live/list',
    name: 'ListLive',
    component: src_components_ListLive
  }, {
    path: '/liste-lives/live/' + addRoute,
    name: addLive,
    component: componentForm
  }, {
    path: '/liste-lives/live/:id/' + editRoute,
    name: router_editLive,
    component: componentForm,
    props: function props(route) {
      return { query: route.params.id };
    }
  }, {
    path: '/liste-lives/live/calendar',
    name: 'CalendarLives',
    component: components_components_CalendarLives
  }, {
    path: '/liste-lives/live/send-mail/:id',
    name: 'mailSendGrid',
    component: components_components_SendMail
  }, {
    path: '/liste-lives/:id/' + exportRoute,
    name: exportLive,
    component: componentExport,
    props: function props(route) {
      return { query: route.params.id };
    }
  }],
  mode: 'history'
});
src_router_router.beforeEach(function (routeTo, routeFrom, next) {
  nprogress_nprogress_default.a.start();
  next();
});

src_router_router.afterEach(function () {
  nprogress_nprogress_default.a.done();
});

/* harmony default export */ var src_router = (src_router_router);
// CONCATENATED MODULE: ./src/core/http/http-common-go.js


function HTTP_GO(token) {
  return axios_default.a.create({
    baseURL: window.process.env.API_GO_HOST,
    headers: {
      Authorization: token
    }
  });
}
// EXTERNAL MODULE: ./node_modules/vuex-live-service-api/dist/index.js
var vuex_live_service_api_dist = __webpack_require__("Z5pt");
var vuex_live_service_api_dist_default = /*#__PURE__*/__webpack_require__.n(vuex_live_service_api_dist);

// EXTERNAL MODULE: ./node_modules/vuex-skin-generator-service-api/dist/index.js
var vuex_skin_generator_service_api_dist = __webpack_require__("hOrh");
var vuex_skin_generator_service_api_dist_default = /*#__PURE__*/__webpack_require__.n(vuex_skin_generator_service_api_dist);

// CONCATENATED MODULE: ./src/service/index.js




var service_Go = new vuex_live_service_api_dist_default.a({
  baseURL: window.process.env.API_HOST_LIVE,
  token: "eyJhbGciOiJSUzI1NiJ9.eyJ1c2VybmFtZSI6ImVtcGFkbWluIiwiaWQiOjEsInJvbGVzIjpbIlJPTEVfU1VQRVJfQURNSU4iLCJST0xFX1VTRVIiXSwiaWF0IjoxNTYzNDUxMDY1LCJleHAiOjc4NzA2NTEwNjV9.BkXwGyvLUhYe_2-GtNHrbpfw_IqFE7J3d2CjFnTazVxtiBn5DGloIEHZHQUC68kE6ASMrfnrB-zcE-Uq7UDc6wceE5fatZrgoh_WA1ELBoMoiP0VZfJK9_2XLrK_k5zqD6Pf8iIsLOTzE2FgX_lFl-nN2VbcmsPNFq3Xzr--P6KIaneo3RpxpVEDkTqY4UG5c1OudJPug-NVFqsXAA-iR4i-EkWYg3GgxUaibDN4EBH2NhOQ12ChcfXTD7pk4oTBpJdtir4hgzSN4P4wYGl9nQPr92IaWd8CKWHvLPIXCF4Et8oXxZ0imthHPKFc-aQ1cozIPGDXZ6tLWIqS1MPVSQtDbNqWve_H3xavO_3mY6Um1dkvCDzIKM0rV3EAXOhA6vsV9aE9oUateF5Ke8WkNCB_jN2HB2CjgA2-CvYJxGRJmdbrgqye8vIXbdkVUu5DcIwFLVkCjE_4v2ntdKlHWhz9sNVa7pY7AEST-tvMx4HK8F811kTyu0G8pXzqGaQhwQU6ve3lVv6eu2Y6MN573u4CCfqjqOXfPOLT-LCq5urRgPrrcVgy67pXjXkUjArWcNcsTlhphpa1yJ6sJN00-c1Xm5bAEhgumtn6ClpiOKwcsEjRMYXoo6biMl8aVfYRb4T6Viuya7lCLKVVoX7tWM5HnIj9EOwB_wojcudkpWo"
});

var clientName = window.process.env.CLIENT_NAME;

function service(options) {
  var baseUrl = window.process.env.API_HOST_LIVE;
  var headers = {
    'Content-Type': 'application/json',
    Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + "eyJhbGciOiJSUzI1NiJ9.eyJ1c2VybmFtZSI6ImVtcGFkbWluIiwiaWQiOjc5LCJyb2xlcyI6WyJST0xFX1NVUEVSX0FETUlOIiwiUk9MRV9VU0VSIl0sImlhdCI6MTU1MTEwNjA4NSwiZXhwIjo3ODU4MzA2MDg1fQ.DDGHdnJUrjfwW-WcZDaKy7jhQgp6dDwLPqDk0UK5_2OnNKHfRvZ-oIKxaHo4ifeoZfS4fJqdfXd0QnQWZi2wriOTT44DNUNGLADitBm6avP2ejRX70Tsif-Q6dpBp60DaiQ-AGCdjj09VzeqiearQNzI5DneAJ9r9HqELKmE5JFqO_EUD7M4cQE38tytGBoiaLFLyOphvjdqiivQ7l-10GxPYpAOj5T3zeQuq3jEpszmjHZhbovgvunY8lpX8TdvE44KNbP5r7ozj4wagiMW3FHPGZflerZURAejNUZtphFBnB4CHtzKUeSKdeki6m6VaFU6IT5XzRFU7kZoV4nx93YTjOWjc0XeMTKcy-OGsGDEtTQT6T0BL0IpP96hEd5K-jh5OkcD1JjI2Yuijp6PkzFeTFUdTJ5GJz_LGE34FmUw9Qwm2VUBV1qR5D951Dnbhv9Y2xJXja-sj8SVZAM42dZkp0xcVfBIe6Y_96C1QVp_JbVXi2NUKLZVcE0EXGlL46Sur8Rgq_jMWdfz9ZKLCWhx8vt2hVSQNSH01nFpZAC2YBIb6lc88E-PVIXCSG3RW3wzMSjehGs3TH9cOz3wJXpYiHhGbmRUsrBlLarad7EnGCwP50kBaiJh2jdNpPcQFC7gEG6GewVN7FfAxEg_m8OnBj93OY3LMc6j9IIJyu5"
  };
  if (options) {
    headers['X-Tenant-USER'] = options;
  }
  var baseApiParams = {
    credentials: 'same-origin',
    headers: headers
    // redirect: 'follow',
  };

  return new vuex_skin_generator_service_api_dist["Api"]({
    baseUrl: baseUrl,
    baseApiParams: baseApiParams
  });
}
var HTTP_STREAMING = axios_default.a.create({
  baseURL: window.process.env.G_STREAMER_HOST,
  headers: {
    "Content-Type": "application/json"
  }
});
var HTTP_STREAMING_RECORD = axios_default.a.create({
  baseURL: window.process.env.G_STREAMER_HOST,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic ZW1wcmVpbnRlLWFjY2Vzcy10b2tlbg=="

  }
});
var API_G_STREAMER = {

  stopGStreamer: function stopGStreamer(data) {
    var promise = {};
    promise = HTTP_STREAMING.post('live/stop', data);
    return promise;
  },
  stopRecordGStreamer: function stopRecordGStreamer(data, isDvr) {
    var promise = {};
    promise = HTTP_STREAMING_RECORD.post('v1/vhosts/default/apps/' + (clientName + (isDvr ? "-dvr" : "")) + ':stopRecord', data);
    return promise;
  },
  startRecordGStreamer: function startRecordGStreamer(data, isDvr) {
    var promise = {};
    promise = HTTP_STREAMING_RECORD.post('v1/vhosts/default/apps/' + (clientName + (isDvr ? "-dvr" : "")) + ':startRecord', data);
    return promise;
  }

};
// CONCATENATED MODULE: ./src/store/modules/lives-data.js



















var lives_data_moment = __webpack_require__("PJh5");

var lives_data_state = {
  dataShareLink: '',
  all: [],
  selected: {},
  currentPage: 0,
  nbPerPage: 20,
  contributors: [],
  channels: [],
  types: [],
  live: {},
  totalLive: 0,
  periodLives: [],
  currentLang: 'fr',
  loading: false,
  exportLink: {},
  detailLive: {},
  users: {},
  webtvUsers: [],
  webtvGroups: [],
  groupUsers: {},
  screenShare: {},
  urlDownloadFile: {},
  objectDiffusion: {},
  linkArchivedVideo: {},
  isArchivedLive: false,
  liveId: '',
  allTemplates: [],
  listGroup: [],
  listMail: [],
  responseDelete: {},
  externalHls: false,
  linkHls: '',
  liveSkins: [],
  participants: []
};

var lives_data_mutations = {
  selectLive: function selectLive(state, data) {

    var tags = data.live.tags && data.live.tags.length > 0 ? data.live.tags.split(' ').filter(function (t) {
      return t.length > 0;
    }) : data.live.tags;
    if (tags == '') tags = [];

    var mappedData = {
      startDate: lives_data_moment(data.live.dateStart).format(),
      startTime: lives_data_moment(data.live.dateStart).format('HH:mm'),
      endTime: lives_data_moment(data.live.dateEnd).format('HH:mm'),
      tags: tags,
      survey: data.live.survey ? data.live.survey.id : null,
      diffusion: data.live.isPearl ? 'isPearl' : data.live.screenShare ? 'screenShare' : data.live.webinar ? "webinar" : "externalHls",
      linkHls: data.live.linkHls,
      screenType: data.live.screenType ? data.live.screenType : 'pip',
      contributors: data.live.contributors && data.live.contributors.length > 0 ? data.live.contributors.map(function (c) {
        return {
          id: c.id,
          name: c.firstName + ' ' + c.lastName
        };
      }) : data.live.contributors,
      editor: {
        dataAbout: data.live.editor !== undefined ? data.live.editor.dataAbout : null
      },
      allIntervenants: data.live.allIntervenants && data.live.allIntervenants.length > 0 ? data.live.allIntervenants : [],
      contact: {
        address: data.live.contact !== undefined ? data.live.contact.address : null,
        phone: data.live.contact !== undefined ? data.live.contact.phone : null,
        email: data.live.contact !== undefined ? data.live.contact.email : null
      },
      slides: data.slides && data.slides.length > 0 ? data.slides : [],
      chapters: data.chapters && data.chapters.length > 0 ? data.chapters : [],
      emails: data.live.emails && data.live.emails.length > 0 ? data.live.emails : [],
      groupEmails: data.live.groupEmails && data.live.groupEmails.length > 0 ? data.live.groupEmails : [],
      rules: data.live.rules && data.live.rules.length > 0 ? data.live.rules : [{
        nbDays: 1,
        beforeHour: lives_data_moment().format('HH:mm')
      }],

      themes: data.live.themes,
      conf: extends_default()({}, data.live.conf, { video: data.live.conf.video ? data.live.conf.video.id : null }),
      videoBeforeLive: data.live.conf.video ? data.live.conf.video : null,
      files: common.buildIcons(data.files),
      questions: data.questions && data.questions.length > 0 ? data.questions.map(function (q) {
        if (!q.choices) {
          q.choices = [];
          q.nsp = +q.nsp;
        }
        return q;
      }) : data.questions

    };

    if (mappedData.videoBeforeLive && !mappedData.videoBeforeLive.logo) {
      mappedData.videoBeforeLive.logo = 'data:image/png;base64,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';
    }

    state.selected = extends_default()({}, data.live, mappedData);
  },
  pushLives: function pushLives(state, lives) {
    //state.all = state.all.concat(lives);
    state.all = lives.map(function (live) {

      return extends_default()({}, live, {
        title: live.title.length > 30 ? live.title.substring(0, 30) + '...' : live.title
      });
    });
  },
  incrementPage: function incrementPage(state, number) {
    state.currentPage = number;
  },
  setHlsValue: function setHlsValue(state, value) {
    state.linkHls = value;
  },
  setEndReached: function setEndReached(state, endReached) {
    state.endReached = endReached;
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  setContributors: function setContributors(state, contributors) {
    state.contributors = contributors;
  },
  setChannels: function setChannels(state, channels) {
    state.channels = channels;
  },
  setTypes: function setTypes(state, types) {
    state.types = types;
  },
  setLiveById: function setLiveById(state, data) {
    state.live = data.live;
  },
  UpdateTotalLive: function UpdateTotalLive(state, recordTotal) {
    state.totalLive = recordTotal;
  },
  setPeriodLives: function setPeriodLives(state, data) {
    state.periodLives = data || [];
  },
  setCurrentLang: function setCurrentLang(state, data) {
    state.currentLang = data || {};
  },
  setInfoDetailLive: function setInfoDetailLive(state, data) {
    state.detailLive = data;
  },
  setLinkExportLives: function setLinkExportLives(state, data) {

    if (data['permalien']) {
      if (data['permalien'][0]) {
        data['permalien'][0] = data['permalien'][0].replace('/fr', '/' + i18n.locale).replace('/en', '/' + i18n.locale);
      }
      if (data["permalien"][1]) {
        data['permalien'][1] = data['permalien'][1].replace('/fr', '/' + i18n.locale).replace('/en', '/' + i18n.locale);
      }
    }
    if (data['link_moderator']) {
      data['link_moderator'] = data['link_moderator'].replace('/fr', '/' + i18n.locale).replace('/en', '/' + i18n.locale);
    }
    if (data['link_journalist']) {
      data['link_journalist'] = data['link_journalist'].replace('/fr', '/' + i18n.locale).replace('/en', '/' + i18n.locale);
    }

    state.exportLink = data;
  },
  setWebtvUsers: function setWebtvUsers(state, data) {
    state.webtvUsers = data;
  },
  setWebtvGroups: function setWebtvGroups(state, data) {
    state.webtvGroups = data;
  },
  setSubscriptionUser: function setSubscriptionUser(state, data) {
    state.users = data;
  },
  setSubscriptionGroupUsers: function setSubscriptionGroupUsers(state, data) {
    state.groupUsers = data;
  },
  setScreenShare: function setScreenShare(state, data) {
    state.screenShare = data;
  },
  setUrlDownloadFile: function setUrlDownloadFile(state, data) {
    state.urlDownloadFile = data;
  },
  setDiffusionObject: function setDiffusionObject(state, obj) {
    state.objectDiffusion = obj;
  },
  removeLiveById: function removeLiveById(state, id) {
    state.all = state.all.filter(function (l) {
      return l.id !== id;
    });
  },
  setLinkArchivedVideo: function setLinkArchivedVideo(state, link) {
    state.linkArchivedVideo = link;
  },
  setArchivedLive: function setArchivedLive(state, val) {
    state.isArchivedLive = val;
  },
  setDataShareLink: function setDataShareLink(state, data) {
    state.dataShareLink = data;
  },
  setLiveId: function setLiveId(state, id) {
    state.liveId = id;
  },
  setAllSkinTemplates: function setAllSkinTemplates(state, templates) {
    state.allTemplates = templates;
  },
  addToListGroup: function addToListGroup(state, group) {
    state.listGroup.push(group);
  },
  addOneMailIntoGroup: function addOneMailIntoGroup(state, data) {
    state.listGroup = state.listGroup.map(function (group, i) {
      if (group.id === data.id) {
        group.users.push({ email: data.email });
      }
      return group;
    });
  },
  setListMail: function setListMail(state, val) {
    state.listMail = val;
  },
  addIntoListMail: function addIntoListMail(state, email) {
    var find = state.listMail.find(function (item) {
      return item === email;
    });

    if (!find) {
      state.listMail.push(email);
    }
  },
  deleteOneMailIntoGroup: function deleteOneMailIntoGroup(state, data) {
    state.listGroup = state.listGroup.map(function (group, i) {
      if (group.id === data.id) {
        group.users = group.users.filter(function (mail) {
          return mail.email !== data.email;
        });
      }
      return group;
    });
  },
  deleteOneMailIntoListMail: function deleteOneMailIntoListMail(state, data) {
    state.listMail = state.listMail.filter(function (item) {
      return item !== data;
    });
  },
  deleteGroupMailFromListMail: function deleteGroupMailFromListMail(state, id) {
    var group = state.listGroup.find(function (item) {
      return item.id === id;
    });

    group.users.map(function (g) {
      state.listMail = state.listMail.filter(function (item) {
        return item !== g.email;
      });
    });
  },
  RESPONSE_DELETE: function RESPONSE_DELETE(state, data) {
    state.responseDelete = data;
  },
  setLiveSkins: function setLiveSkins(state, skins) {
    state.liveSkins = skins;
  }
};

var lives_data_actions = {
  addOneMailIntoGroup: function addOneMailIntoGroup(_ref, data) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('addOneMailIntoGroup', data);
  },
  deleteOneMailIntoGroup: function deleteOneMailIntoGroup(_ref2, data) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('deleteOneMailIntoGroup', data);
  },
  addIntoListMail: function addIntoListMail(_ref3, data) {
    var state = _ref3.state,
        commit = _ref3.commit;
    return commit('addIntoListMail', data);
  },

  deleteOneMailIntoListMail: function deleteOneMailIntoListMail(_ref4, data) {
    var state = _ref4.state,
        commit = _ref4.commit;
    return commit('deleteOneMailIntoListMail', data);
  },
  deleteGroupMailFromListMail: function deleteGroupMailFromListMail(_ref5, data) {
    var state = _ref5.state,
        commit = _ref5.commit;
    return commit('deleteGroupMailFromListMail', data);
  },

  setListMail: function setListMail(_ref6, data) {
    var state = _ref6.state,
        commit = _ref6.commit;
    return commit('setListMail', data);
  },
  setHlsLinkValue: function setHlsLinkValue(_ref7, data) {
    var state = _ref7.state,
        commit = _ref7.commit;
    return commit('setHlsValue', data);
  },

  addIntoListGroup: function addIntoListGroup(_ref8, id) {
    var _this = this;

    var commit = _ref8.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var self, url, _ref9, data, group;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              url = router_router.generate('api_subscription_user_get_users_by_group', { id: id });
              _context.next = 4;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url, { id: id }).then(function (response) {
                  resolve(response);
                });
              });

            case 4:
              _ref9 = _context.sent;
              data = _ref9.data;
              group = { id: id, users: JSON.parse(stringify_default()(data.data.users)) };

              commit('addToListGroup', group);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  restartDiffusionLive: function restartDiffusionLive(_ref10, idLive) {
    var _this2 = this;

    var commit = _ref10.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var self, url, _ref11, data;

      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;
              url = router_router.generate('api_post_live_revive', { id: idLive });
              _context2.next = 4;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).post(url, { id: idLive }).then(function (response) {
                  resolve(response);
                  if (response.data.code === 200 || response.status === 200) {
                    eventHub.$emit("restartLive", { value: true, count: 0 });
                  }
                });
              });

            case 4:
              _ref11 = _context2.sent;
              data = _ref11.data;

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setDiffusionObject: function setDiffusionObject(_ref12, obj) {
    var commit = _ref12.commit;

    commit('setDiffusionObject', obj);
  },
  paginate: function paginate(_ref13, obj) {
    var _this3 = this;

    var commit = _ref13.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var _payload;

      var idUser, payload, url, _ref14, data;

      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit('setLoading', true);
              idUser = common_data.state.idUser;
              payload = (_payload = {
                draw: obj.params.currentPage,
                length: obj.params.length,
                start: obj.params.start,
                'order[0][dir]': obj.params.order,
                'order[0][column]': obj.numColumn
              }, defineProperty_default()(_payload, 'columns[' + obj.numColumn + '][orderable]', obj.params.orderable), defineProperty_default()(_payload, 'idContributor', obj.params.idContributor), defineProperty_default()(_payload, 'period', obj.params.period), defineProperty_default()(_payload, 'startDate', obj.params.startDate), defineProperty_default()(_payload, 'searchWord', obj.params.searchWord), _payload);

              if (idUser) {
                payload.idUser = idUser;
              }
              url = router_router.generate('api_dtable_list_dtable_lives_' + obj.type, payload);
              _context3.next = 7;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 7:
              _ref14 = _context3.sent;
              data = _ref14.data;

              commit('incrementPage', obj.params.currentPage);
              commit('UpdateTotalLive', data.recordsFiltered);
              commit('pushLives', data.data);
              commit('setEndReached', true);
              commit('setLoading', false);

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getLiveById: function getLiveById(_ref15, id) {
    var _this4 = this;

    var commit = _ref15.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var url, _ref16, data;

      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = router_router.generate('api_get_lives_live_detail', { id: id });
              _context4.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref16 = _context4.sent;
              data = _ref16.data;

              commit('selectLive', data.data);
              commit('setLiveById', data.data);
              return _context4.abrupt('return', data);

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  fetchContributors: function fetchContributors(_ref17) {
    var _this5 = this;

    var commit = _ref17.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var url, _ref18, data;

      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url = router_router.generate('api_media_get_contributors');
              _context5.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref18 = _context5.sent;
              data = _ref18.data;

              commit('setContributors', data.contributors);

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  createLive: function createLive(_ref19, form) {
    var _this6 = this;

    var state = _ref19.state;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var url, fd, _form$empLivesForm, sourceType, sourceTypeId, Data, dataPayload, response, emailsPayload, payload;

      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              url = window.process.env.API_HOST_LIVE + '/live/add';
              _context6.prev = 1;

              // ----------------------------
              // 1) Build FormData payload
              // ----------------------------
              fd = new FormData();

              // 👉 add thumbnail file if exists

              if (form.empLivesForm.thumbnail && form.empLivesForm.thumbnail instanceof File) {
                fd.append("thumbnail", form.empLivesForm.thumbnail);
              }

              // ----------------------------
              // 2) Build JSON for "data" field
              // ----------------------------
              _form$empLivesForm = form.empLivesForm, sourceType = _form$empLivesForm.sourceType, sourceTypeId = _form$empLivesForm.sourceTypeId, Data = objectWithoutProperties_default()(_form$empLivesForm, ['sourceType', 'sourceTypeId']);
              dataPayload = extends_default()({}, Data, ['empreinte', 'cnam', 'gers'].includes(window.process.env.CLIENT_NAME) ? { sourceTypeId: form.empLivesForm.isPearl ? 3 : form.empLivesForm.sourceTypeId || 1 } : {}, {
                isCdn: form.empLivesForm.isCdn == "1", // fix type conversion
                active: form.empLivesForm.active ? 1 : 0,
                thumbnail: "", // the API wants an empty string here
                conf: form.empLivesForm.conf || null,
                types: form.empLivesForm.types || [],
                chapters: form.empLivesForm.chapters || [],
                questions: form.empLivesForm.questions || [],
                slides: form.empLivesForm.slides || [],
                themes: form.empLivesForm.themes || [],
                countries: form.empLivesForm.countries && form.empLivesForm.countries.length ? form.empLivesForm.countries.map(function (item) {
                  return item.id;
                }) : [],
                languages: form.empLivesForm.languages && form.empLivesForm.languages.length ? form.empLivesForm.languages.map(function (item) {
                  return item.label;
                }) : [],
                status: -1,
                screenShare: form.empLivesForm.screen_share || false,
                contributors: form.empLivesForm.contributorID

              });

              // 👉 "data" must be a STRING in FormData

              fd.append("data", stringify_default()(dataPayload));

              // ----------------------------
              // 3) POST multipart form-data
              // ----------------------------
              _context6.next = 9;
              return axios_default.a.post(url, fd, {
                headers: {
                  "Authorization": '' + window.ApiToken,
                  "Content-Type": "multipart/form-data"
                }
              });

            case 9:
              response = _context6.sent;


              // ----------------------------
              // 4) Send invitations
              // ----------------------------
              emailsPayload = [];

              // Moderators

              if (form.empLivesForm.contributors && form.empLivesForm.contributors.length > 0) {
                emailsPayload.push.apply(emailsPayload, toConsumableArray_default()(form.empLivesForm.contributors.map(function (m) {
                  return {
                    email: m.email,
                    nom: m.lastName,
                    prenom: m.firstName,
                    role: "contributor"
                  };
                })));
              }

              if (form.moderators && form.moderators.length > 0) {
                emailsPayload.push.apply(emailsPayload, toConsumableArray_default()(form.moderators.map(function (m) {
                  return {
                    email: m.email,
                    nom: m.lastName,
                    prenom: m.firstName,
                    role: "moderator"
                  };
                })));
              }

              // Contributors (IDs → objects)
              if (form.empLivesForm.participants && form.empLivesForm.participants.length > 0) {

                emailsPayload.push.apply(emailsPayload, toConsumableArray_default()(form.empLivesForm.participants.map(function (c) {
                  // 🔹 Custom contributor (typed email)
                  if (c.isCustom) {
                    return {
                      email: c.email,
                      nom: '',
                      prenom: '',
                      role: 'participant'
                    };
                  }

                  // 🔹 Existing user (from webtvUsers)
                  var user = state.webtvUsers.find(function (u) {
                    return u.email === c.email;
                  });

                  if (!user) return null;

                  return {
                    email: user.email,
                    nom: user.lastName,
                    prenom: user.firstName,
                    role: 'participant'
                  };
                }).filter(Boolean)));
              }

              if (emailsPayload.length) {
                _context6.next = 16;
                break;
              }

              return _context6.abrupt('return', response.data);

            case 16:
              payload = {
                emails: emailsPayload,
                groups: [],
                live_description: form.empLivesForm.description,
                live_id: response.data.Lives.id
              };
              _context6.next = 19;
              return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/send-live-invitation', payload, { headers: { Authorization: '' + window.ApiToken } });

            case 19:
              return _context6.abrupt('return', response.data);

            case 22:
              _context6.prev = 22;
              _context6.t0 = _context6['catch'](1);

              console.error("ERROR createLive", _context6.t0);
              throw _context6.t0;

            case 26:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[1, 22]]);
    }))();
  },
  updateLive: function updateLive(_ref20, form) {
    var _this7 = this;

    var state = _ref20.state;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var url, fd, _form$empLivesForm2, sourceType, sourceTypeId, DataForm, _ref21, files, empLivesFormWithoutFiles, dataPayload, response, emailsPayload, payload;

      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              url = window.process.env.API_HOST_LIVE + '/live/edit/' + form.id;
              _context7.prev = 1;

              // ----------------------------
              // 1) Build FormData payload
              // ----------------------------
              fd = new FormData();
              // 👉 Add thumbnail file (if updated)
              // 👉 add thumbnail file if exists

              if (form.empLivesForm.thumbnail && form.empLivesForm.thumbnail instanceof File) {
                fd.append("thumbnail", form.empLivesForm.thumbnail);
              }
              _form$empLivesForm2 = form.empLivesForm, sourceType = _form$empLivesForm2.sourceType, sourceTypeId = _form$empLivesForm2.sourceTypeId, DataForm = objectWithoutProperties_default()(_form$empLivesForm2, ['sourceType', 'sourceTypeId']);
              // ----------------------------
              // 2) Build JSON payload (same as create)
              // ----------------------------

              _ref21 = form.empLivesForm || {}, files = _ref21.files, empLivesFormWithoutFiles = objectWithoutProperties_default()(_ref21, ['files']);
              dataPayload = extends_default()({}, DataForm, {
                id: form.id
              }, ['empreinte', 'cnam', 'gers'].includes(window.process.env.CLIENT_NAME) ? { sourceTypeId: form.empLivesForm.isPearl ? 3 : form.empLivesForm.sourceTypeId || 1 } : {}, { // required for edit
                isCdn: form.empLivesForm.isCdn == "1",
                active: form.empLivesForm.active ? 1 : 0,
                thumbnail: "",
                conf: form.empLivesForm.conf || null,
                types: form.empLivesForm.types || [],
                chapters: form.empLivesForm.chapters || [],
                questions: form.empLivesForm.questions || [],
                slides: form.empLivesForm.slides || [],
                themes: form.empLivesForm.themes || [],
                countries: form.empLivesForm.countries && form.empLivesForm.countries.length ? form.empLivesForm.countries.map(function (item) {
                  return item.id;
                }) : [],
                languages: form.empLivesForm.languages && form.empLivesForm.languages.length ? form.empLivesForm.languages.map(function (item) {
                  return item.label;
                }) : [],
                screenShare: form.empLivesForm.screen_share || false,
                contributors: form.empLivesForm.contributorID
              });
              // 👉 Append as string

              fd.append("data", stringify_default()(dataPayload));

              // ----------------------------
              // 3) POST multipart form-data
              // ----------------------------
              _context7.next = 10;
              return axios_default.a.patch(url, fd, {
                headers: {
                  "Authorization": '' + window.ApiToken,
                  "Content-Type": "multipart/form-data"
                }
              });

            case 10:
              response = _context7.sent;


              // ----------------------------
              // 4) Send invitations
              // ----------------------------
              emailsPayload = [];
              // WE SEND EMPTY ARRAY IN EDIT TO CLEAR BASE
              // Moderators

              if (form.empLivesForm.contributors && form.empLivesForm.contributors.length > 0) {
                emailsPayload.push.apply(emailsPayload, toConsumableArray_default()(form.empLivesForm.contributors.map(function (m) {
                  return {
                    email: m.email,
                    nom: m.lastName,
                    prenom: m.firstName,
                    role: "contributor"
                  };
                })));
              }

              if (form.moderators && form.moderators.length > 0) {
                emailsPayload.push.apply(emailsPayload, toConsumableArray_default()(form.moderators.map(function (m) {
                  return {
                    email: m.email,
                    nom: m.lastName,
                    prenom: m.firstName,
                    role: "moderator"
                  };
                })));
              }

              // Contributors (IDs → objects)
              if (form.empLivesForm.participants && form.empLivesForm.participants.length > 0) {
                emailsPayload.push.apply(emailsPayload, toConsumableArray_default()(form.empLivesForm.participants.map(function (c) {
                  // 🔹 Custom contributor (typed email)
                  if (c.isCustom) {
                    return {
                      email: c.email,
                      nom: '',
                      prenom: '',
                      role: 'participant'
                    };
                  }

                  // 🔹 Existing user (from webtvUsers)
                  var user = state.webtvUsers.find(function (u) {
                    return u.email === c.email;
                  });

                  if (!user) return null;

                  return {
                    email: user.email,
                    nom: user.lastName,
                    prenom: user.firstName,
                    role: 'participant'
                  };
                }).filter(Boolean)));
              }

              // if (!emailsPayload.length) {
              //   return response.data;
              // }

              payload = {
                emails: emailsPayload,
                groups: [],
                live_description: form.empLivesForm.description,
                live_id: form.id
              };
              _context7.next = 18;
              return axios_default.a.post(window.process.env.API_HOST_LIVE + '/live/send-live-invitation', payload, { headers: { Authorization: '' + window.ApiToken } });

            case 18:
              return _context7.abrupt('return', response.data);

            case 21:
              _context7.prev = 21;
              _context7.t0 = _context7['catch'](1);

              console.error("ERROR updateLive", _context7.t0);
              throw _context7.t0;

            case 25:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[1, 21]]);
    }))();
  },
  setDisableLiveById: function setDisableLiveById(_ref22, id) {
    var _this8 = this;

    var state = _ref22.state,
        commit = _ref22.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              HTTP(window.ApiToken).post(router_router.generate('api_post_disable_live', id), {
                id: id
              }).then(function (response) {});

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  setStartLiveById: function setStartLiveById(_ref23, data) {
    var state = _ref23.state,
        commit = _ref23.commit;

    var changeActiveFormData = new FormData();
    var id = data.id;
    var streamName = data.streamName;
    changeActiveFormData.append('active', 1);
    HTTP(window.ApiToken).post("/live/change-active/" + id, changeActiveFormData).then(function () {
      var changeStatusFormData = new FormData();
      changeStatusFormData.append('status', 0);
      HTTP(window.ApiToken).post("/live/change-status/" + id, changeStatusFormData).then(function () {
        console.info("status changed to 0");
      }).catch(function (e) {
        console.log("error while changing status", e);
      });
    }).catch(function (e) {
      console.log("error while starting live", e);
    });
    if (data.protocolType === "SRT") {
      // sending isDvr as false for now ..
      var isDvr = data.isDvr ? data.isDvr : false;

      var startData = {
        id: streamName,
        stream: {
          name: streamName,
          variantNames: ["video_4000", "bypass_audio"]
        },
        interval: 900000,
        segmentationRule: "continuity"
      };
      API_G_STREAMER.startRecordGStreamer(startData, isDvr).then(function (res) {
        console.log('Starting record in progress', res);
      }).catch(function (err) {
        console.error("Error while Starting record", err);
      });
    }
  },
  setStopLiveById: function setStopLiveById(_ref24, data) {
    var _this9 = this;

    var state = _ref24.state,
        commit = _ref24.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      var changeActiveFormData, liveObject, isDvr, roomName, objectPusher;
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:

              if (data.streamName) {
                changeActiveFormData = new FormData();

                changeActiveFormData.append('active', 0);
                HTTP(window.ApiToken).post("/live/change-active/" + data.id, changeActiveFormData).then(function () {
                  var changeStatusFormData = new FormData();
                  changeStatusFormData.append('status', 1);
                  HTTP(window.ApiToken).post("/live/change-status/" + data.id, changeStatusFormData).then(function () {
                    console.info("status changed to 1");
                  }).catch(function (e) {
                    console.log("error while changing status", e);
                  });
                }).catch(function (e) {
                  console.log("error while ending live", e);
                });
                liveObject = data.live;

                if (liveObject.protocolType === "SRT") {
                  // sending isDvr as false for now ..
                  isDvr = liveObject.isDvr ? liveObject.isDvr : false;

                  API_G_STREAMER.stopRecordGStreamer({
                    id: data.streamName
                  }, isDvr).then(function (res) {
                    console.log('Stopping record in progress', res);
                    API_G_STREAMER.stopGStreamer({
                      stream_name: data.streamName,
                      client_name: window.process.env.CLIENT_NAME,
                      bucket_name: window.process.env.CLIENT_NAME,
                      piper_api: window.process.env.PIPER_ENDPOINT,
                      live_api: "https:" + window.process.env.API_HOST_LIVE,
                      is_auto: liveObject.isAuto ? liveObject.isAuto : false,
                      processor_guid: liveObject.processorGuid ? liveObject.processorGuid : "",
                      protocol_type: liveObject.protocolType ? liveObject.protocolType : "",
                      is_event: false
                    });
                  }).catch(function (err) {
                    console.error("Error while stopping record", err);
                  });
                } else {
                  API_G_STREAMER.stopGStreamer({
                    stream_name: data.streamName,
                    client_name: window.process.env.CLIENT_NAME,
                    bucket_name: window.process.env.CLIENT_NAME,
                    piper_api: window.process.env.PIPER_ENDPOINT,
                    live_api: "https:" + window.process.env.API_HOST_LIVE,
                    is_auto: liveObject.isAuto ? liveObject.isAuto : false,
                    processor_guid: liveObject.processorGuid ? liveObject.processorGuid : "",
                    protocol_type: liveObject.protocolType ? liveObject.protocolType : "",
                    is_event: false
                  });
                }

                roomName = data.id + '-' + data.streamName;
                objectPusher = {
                  data: stringify_default()({ date: new Date().getTime() }),
                  prefixChannelName: 'room-join',
                  event: 'end'
                };
              }

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  setEnableLiveById: function setEnableLiveById(_ref25, data) {
    var _this10 = this;

    var state = _ref25.state,
        commit = _ref25.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var roomName, objectPusher;
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (data.streamName) {
                roomName = data.id + '-' + data.streamName;
                objectPusher = {
                  data: stringify_default()({ date: new Date().getTime() }),
                  prefixChannelName: 'streams',
                  event: 'get'
                };
              }

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  deleteMultiLive: function deleteMultiLive(_ref26, obj) {
    var _this11 = this;

    var commit = _ref26.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      var list;
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              list = obj.join(',');

              HTTP(window.ApiToken).delete(router_router.generate('api_multi_delete_livess', { list: list }).replace(/%2C/g, ',')).then(function (response) {});

            case 2:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  deleteLiveById: function deleteLiveById(_ref27, id) {
    var _this12 = this;

    var commit = _ref27.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              HTTP(window.ApiToken).delete(router_router.generate('api_delete_lives_live', { id: id })).then(function (response) {});

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  exportQuestionsByLiveId: function exportQuestionsByLiveId(_ref28, id) {
    var commit = _ref28.commit;

    return axios_default.a.get(window.process.env.API_HOST_GLOBAL + "/live/questions/export/" + id, {
      headers: {
        "Content-Type": "application/json",
        Authorization: window.ApiToken
      },
      responseType: 'blob'
    });
  },
  fetchAllSkinTemplates: function fetchAllSkinTemplates(_ref29) {
    var _this13 = this;

    var commit = _ref29.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
      var data;
      return regenerator_default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return new promise_default.a(function (resolve, reject) {
                var uid = 'cvJntHgPp0mzeWSd';
                service(uid).api.templatesGetTemplatesList('').then(function (response) {
                  resolve(response);
                  console.log('response', response);
                }).catch(function (failure) {
                  console.log('failure', failure);
                });
              });

            case 2:
              data = _context13.sent;

              commit('setAllSkinTemplates', data.templates);

            case 4:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  sendSendGridEmail: function sendSendGridEmail(_ref30, obj) {
    var _this14 = this;

    var commit = _ref30.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
      var url, _ref31, data;

      return regenerator_default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              url = '/live/send-invitations';
              _context14.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP_GO(window.ApiToken).post(url, obj).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref31 = _context14.sent;
              data = _ref31.data;
              return _context14.abrupt('return', data);

            case 6:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  restoreArchivedLive: function restoreArchivedLive(_ref32, _ref33) {
    var _this15 = this;

    var commit = _ref32.commit;
    var id = _ref33.id,
        action = _ref33.action;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
      var _ref34, data;

      return regenerator_default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return new promise_default.a(function () {
                var _ref35 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15(resolve, reject) {
                  return regenerator_default.a.wrap(function _callee15$(_context15) {
                    while (1) {
                      switch (_context15.prev = _context15.next) {
                        case 0:
                          _context15.next = 2;
                          return service_Go.restoreArchivedLive({ liveId: id, action: action }).then(function (response) {
                            console.log('deleteMultipleLives', response);
                            resolve(response);
                            commit('RESPONSE_DELETE', { action: action, multi: false, error: false });
                          }).catch(function (error) {
                            console.log("deleteMultipleLives error", error);
                            commit('RESPONSE_DELETE', { action: action, multi: false, error: true });
                          });

                        case 2:
                        case 'end':
                          return _context15.stop();
                      }
                    }
                  }, _callee15, _this15);
                }));

                return function (_x, _x2) {
                  return _ref35.apply(this, arguments);
                };
              }());

            case 2:
              _ref34 = _context16.sent;
              data = _ref34.data;
              return _context16.abrupt('return', data);

            case 5:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this15);
    }))();
  },
  restoreArchivedMultiLive: function restoreArchivedMultiLive(_ref36, list) {
    var _this16 = this;

    var commit = _ref36.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
      var _ref37, data;

      return regenerator_default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return new promise_default.a(function () {
                var _ref38 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17(resolve, reject) {
                  return regenerator_default.a.wrap(function _callee17$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                          _context17.next = 2;
                          return service_Go.restoreArchivedMultiLive(list).then(function (response) {
                            console.log('restoreArchivedMultiLive', response);
                            resolve(response);
                            commit('RESPONSE_DELETE', { action: list.action, multi: false, error: false });
                          }).catch(function (error) {
                            console.log("restoreArchivedMultiLive error", error);
                            commit('RESPONSE_DELETE', { action: list.action, multi: false, error: true });
                          });

                        case 2:
                        case 'end':
                          return _context17.stop();
                      }
                    }
                  }, _callee17, _this16);
                }));

                return function (_x3, _x4) {
                  return _ref38.apply(this, arguments);
                };
              }());

            case 2:
              _ref37 = _context18.sent;
              data = _ref37.data;
              return _context18.abrupt('return', data);

            case 5:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this16);
    }))();
  },
  deleteMultipleLives: function deleteMultipleLives(_ref39, list) {
    var _this17 = this;

    var commit = _ref39.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
      var _ref40, data;

      return regenerator_default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return new promise_default.a(function () {
                var _ref41 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19(resolve, reject) {
                  return regenerator_default.a.wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          _context19.next = 2;
                          return service_Go.deleteMultiLive({ data: list }).then(function (response) {
                            console.log('deleteMultipleLives', response);
                            resolve(response);
                            commit('RESPONSE_DELETE', { action: 'deleting', multi: true, error: false });
                          }).catch(function (error) {
                            console.log("deleteMultipleLives error", error);
                            commit('RESPONSE_DELETE', { action: 'deleting', multi: true, error: true });
                          });

                        case 2:
                        case 'end':
                          return _context19.stop();
                      }
                    }
                  }, _callee19, _this17);
                }));

                return function (_x5, _x6) {
                  return _ref41.apply(this, arguments);
                };
              }());

            case 2:
              _ref40 = _context20.sent;
              data = _ref40.data;
              return _context20.abrupt('return', data);

            case 5:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this17);
    }))();
  },
  deleteLiveByOne: function deleteLiveByOne(_ref42, liveId) {
    var _this18 = this;

    var commit = _ref42.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
      var _ref43, data;

      return regenerator_default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return new promise_default.a(function () {
                var _ref44 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21(resolve, reject) {
                  return regenerator_default.a.wrap(function _callee21$(_context21) {
                    while (1) {
                      switch (_context21.prev = _context21.next) {
                        case 0:
                          _context21.next = 2;
                          return service_Go.deleteLive(liveId).then(function (response) {
                            console.log('deleteLiveByOne', response);
                            resolve(response);
                            commit('RESPONSE_DELETE', { action: 'deleting', multi: false, error: false });
                          }).catch(function (error) {
                            console.log("deleteLiveByOne error", error);
                            commit('RESPONSE_DELETE', { action: 'deleting', multi: false, error: true });
                          });

                        case 2:
                        case 'end':
                          return _context21.stop();
                      }
                    }
                  }, _callee21, _this18);
                }));

                return function (_x7, _x8) {
                  return _ref44.apply(this, arguments);
                };
              }());

            case 2:
              _ref43 = _context22.sent;
              data = _ref43.data;
              return _context22.abrupt('return', data);

            case 5:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this18);
    }))();
  },
  getAllLivesByPeriod: function getAllLivesByPeriod(_ref45, period) {
    var _this19 = this;

    var commit = _ref45.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
      var url, _ref46, data;

      return regenerator_default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              commit('setLoading', true);
              url = router_router.generate('api_get_lives_by_period', period);
              _context23.next = 4;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  if (response.data.lives) {
                    Array.prototype.slice.call(
                    // convert to array
                    response.data.lives).map(function (eventEl) {
                      var customColor = common.getMaterialColor();
                      var currentDate = common.getDateLive(new Date());
                      if (eventEl) {
                        var startDate = common.getDateLive(new Date(eventEl.start));
                        var endDate = common.getDateLive(new Date(eventEl.end));

                        if (startDate <= currentDate && endDate >= currentDate) {
                          eventEl.textColor = customColor[0]; ///green----->current
                          eventEl.status = 'Live';
                          eventEl.classType = 'badge-danger';
                        } else if (startDate > currentDate && endDate > currentDate) {
                          eventEl.textColor = customColor[1]; ///blue------>future
                          eventEl.status = 'Waiting';
                          eventEl.classType = 'badge-warning';
                        } else if (startDate < currentDate && endDate < currentDate) {
                          eventEl.textColor = customColor[2]; ///violet----->past
                          eventEl.status = 'Archive';
                          eventEl.classType = 'badge-secondary';
                        }
                        eventEl.borderColor = eventEl.textColor;
                        eventEl.backgroundColor = eventEl.textColor;
                      }
                    });

                    resolve(response);
                  }
                });
              });

            case 4:
              _ref46 = _context23.sent;
              data = _ref46.data;

              commit('setPeriodLives', data.lives);

            case 7:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this19);
    }))();
  },
  getInfosDetail: function getInfosDetail(_ref47, id) {
    var _this20 = this;

    var commit = _ref47.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24() {
      var url, _ref48, data;

      return regenerator_default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              url = router_router.generate('api_getInfosDetailLive', { id: id });
              _context24.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref48 = _context24.sent;
              data = _ref48.data;

              commit('setInfoDetailLive', data);
              return _context24.abrupt('return', data);

            case 7:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this20);
    }))();
  },
  getLinkExport: function getLinkExport(_ref49, id) {
    var _this21 = this;

    var commit = _ref49.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee25() {
      var url, _ref50, data;

      return regenerator_default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              url = router_router.generate('api_getlink_export', { id: id });
              _context25.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url + "?get_moderator=1").then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 3:
              _ref50 = _context25.sent;
              data = _ref50.data;

              commit('setLinkExportLives', data);
              return _context25.abrupt('return', data);

            case 7:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this21);
    }))();
  },
  getSubscriptionUserList: function getSubscriptionUserList(_ref51) {
    var _this22 = this;

    var commit = _ref51.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee26() {
      var url, _ref52, data;

      return regenerator_default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              url = router_router.generate('api_getSubscriptionUser_list');
              _context26.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 3:
              _ref52 = _context26.sent;
              data = _ref52.data;

              commit('setSubscriptionUser', data.data.users);
              return _context26.abrupt('return', data);

            case 7:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this22);
    }))();
  },
  getWebtvUsersList: function getWebtvUsersList(_ref53) {
    var _this23 = this;

    var commit = _ref53.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee27() {
      var _ref54, data;

      return regenerator_default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get("/dataTable/users?columns[0][orderable]=true&length=1000&idGroup=0&order[0][column]=0&order[0][dir]=asc&search[value]=&start=0").then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 2:
              _ref54 = _context27.sent;
              data = _ref54.data;

              commit('setWebtvUsers', data.data);
              return _context27.abrupt('return', data);

            case 6:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this23);
    }))();
  },
  getWebtvGroupsList: function getWebtvGroupsList(_ref55) {
    var _this24 = this;

    var commit = _ref55.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee28() {
      var _ref56, data;

      return regenerator_default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get("/dataTable/groups?columns[0][orderable]=true&length=1000&idGroup=0&order[0][column]=0&order[0][dir]=asc&search[value]=&start=0").then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 2:
              _ref56 = _context28.sent;
              data = _ref56.data;

              commit('setWebtvGroups', data.data);
              return _context28.abrupt('return', data);

            case 6:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this24);
    }))();
  },
  getSubscriptionGroupUsersList: function getSubscriptionGroupUsersList(_ref57) {
    var _this25 = this;

    var commit = _ref57.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee29() {
      var url, _ref58, data;

      return regenerator_default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              url = router_router.generate('api_subscription_group_get_groups');
              _context29.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 3:
              _ref58 = _context29.sent;
              data = _ref58.data;

              commit('setSubscriptionGroupUsers', data.data.groups);
              return _context29.abrupt('return', data);

            case 7:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this25);
    }))();
  },
  setCurrentLang: function setCurrentLang(_ref59, lang) {
    var _this26 = this;

    var commit = _ref59.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee30() {
      return regenerator_default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              commit('setCurrentLang', lang);

            case 1:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this26);
    }))();
  },
  sendInvitationsMails: function sendInvitationsMails(_ref60, obj) {
    var _this27 = this;

    var state = _ref60.state,
        commit = _ref60.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee31() {
      var url, _ref61, data;

      return regenerator_default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              url = router_router.generate('api_send_invitations_mails');
              _context31.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).post(url, obj).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref61 = _context31.sent;
              data = _ref61.data;
              return _context31.abrupt('return', data);

            case 6:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this27);
    }))();
  },
  sendInvitationsGroupMails: function sendInvitationsGroupMails(_ref62, obj) {
    var _this28 = this;

    var state = _ref62.state,
        commit = _ref62.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee32() {
      var url, _ref63, data;

      return regenerator_default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              url = router_router.generate('api_post_invitation_groups_mails');
              _context32.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).post(url, obj).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref63 = _context32.sent;
              data = _ref63.data;
              return _context32.abrupt('return', data);

            case 6:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this28);
    }))();
  },
  setScreenShare: function setScreenShare(_ref64, obj) {
    var _this29 = this;

    var commit = _ref64.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee33() {
      var url, _ref65, data;

      return regenerator_default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              url = router_router.generate('api_screen_share', { id: obj.id, screenType: obj.screenType });
              _context33.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 3:
              _ref65 = _context33.sent;
              data = _ref65.data;

              commit('setScreenShare', data);
              return _context33.abrupt('return', data);

            case 7:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this29);
    }))();
  },
  getUrlDownloadFile: function getUrlDownloadFile(_ref66, id) {
    var _this30 = this;

    var commit = _ref66.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee34() {
      var url, _ref67, data;

      return regenerator_default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              url = router_router.generate('api_get_url_download_file', { id: id });
              _context34.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  if (response.data) {
                    resolve(response);
                  }
                });
              });

            case 3:
              _ref67 = _context34.sent;
              data = _ref67.data;

              commit('setUrlDownloadFile', data);
              return _context34.abrupt('return', data);

            case 7:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this30);
    }))();
  },
  setLives: function setLives(_ref68, lives) {
    var commit = _ref68.commit;

    commit('pushLives', lives);
  },
  removeLiveById: function removeLiveById(_ref69, id) {
    var commit = _ref69.commit;

    commit('removeLiveById', id);
  },
  getUrlLinkArchivedVideo: function getUrlLinkArchivedVideo(_ref70, id) {
    var _this31 = this;

    var commit = _ref70.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee35() {
      var url, _ref71, data;

      return regenerator_default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              url = router_router.generate('api_get_link_video_live', { id: id });
              _context35.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  console.log('response', response);
                  if (response.data) {
                    resolve(response.data);
                    console.log('data', response.data);
                    commit('setLinkArchivedVideo', response.data);
                  }
                }).catch(function (error) {
                  reject(error.response.data);
                  console.log('data', error.response.data);
                  commit('setLinkArchivedVideo', error.response.data);
                });
              });

            case 3:
              _ref71 = _context35.sent;
              data = _ref71.data;

            case 5:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this31);
    }))();
  },
  isArchivedLive: function isArchivedLive(_ref72, val) {
    var commit = _ref72.commit;

    commit('setArchivedLive', val);
  },
  fetchLiveTypes: function fetchLiveTypes(_ref73) {
    var _this32 = this;

    var commit = _ref73.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee36() {
      var url, _ref74, data;

      return regenerator_default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              url = router_router.generate('api_parameters_get_live_types');
              _context36.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref74 = _context36.sent;
              data = _ref74.data;

              commit('setTypes', data.data);

            case 6:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this32);
    }))();
  },
  fetchChannels: function fetchChannels(_ref75) {
    var _this33 = this;

    var commit = _ref75.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee37() {
      var url, _ref76, data;

      return regenerator_default.a.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              url = router_router.generate('api_parameters_get_channels_group_by_themes');
              _context37.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref76 = _context37.sent;
              data = _ref76.data;

              commit('setChannels', data.channels);

            case 6:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, _this33);
    }))();
  },
  apiShareLink: function apiShareLink(_ref77, id) {
    var _this34 = this;

    var commit = _ref77.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee38() {
      return regenerator_default.a.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              try {
                commit('setLiveId', id);
              } catch (e) {
                console.log("ERROR:", e);
              }

            case 1:
            case 'end':
              return _context38.stop();
          }
        }
      }, _callee38, _this34);
    }))();
  },
  apiSendDataMail: function apiSendDataMail(_ref78, data) {
    var _this35 = this;

    var commit = _ref78.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee39() {
      var _ref79, reponse;

      return regenerator_default.a.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return service_Go.sendDataLinkShare(data);

            case 2:
              _ref79 = _context39.sent;
              reponse = _ref79.reponse;

              try {
                console.log('apisendDataMail', reponse);
              } catch (e) {}

            case 5:
            case 'end':
              return _context39.stop();
          }
        }
      }, _callee39, _this35);
    }))();
  },
  fetchLiveSkins: function fetchLiveSkins(_ref80) {
    var _this36 = this;

    var commit = _ref80.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee40() {
      var url, _ref81, data;

      return regenerator_default.a.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              url = router_router.generate('api_live_get_skins');
              _context40.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref81 = _context40.sent;
              data = _ref81.data;

              commit('setLiveSkins', data.skins);

            case 6:
            case 'end':
              return _context40.stop();
          }
        }
      }, _callee40, _this36);
    }))();
  }
};

var lives_data_getters = {
  getSelected: function getSelected(state) {
    return state.selected;
  },
  getLive: function getLive(state) {
    return state.live;
  },
  getContributors: function getContributors(state) {
    return state.contributors;
  },
  getChannels: function getChannels(state) {
    return state.channels;
  },
  getTypes: function getTypes(state) {
    return state.types;
  },
  getAllLives: function getAllLives(state) {
    return state.all;
  },
  getTotalLive: function getTotalLive(state) {
    return state.totalLive;
  },
  getLivesByPeriod: function getLivesByPeriod(state) {
    return state.periodLives;
  },
  getCurrentLang: function getCurrentLang(state) {
    return state.currentLang;
  },
  getIsLoading: function getIsLoading(state) {
    return state.loading;
  },
  getLinkExportLives: function getLinkExportLives(state) {
    return state.exportLink;
  },
  getInfoDetailLive: function getInfoDetailLive(state) {
    return state.detailLive;
  },
  getSubscriptionUser: function getSubscriptionUser(state) {
    return state.users;
  },
  getSubscriptionGroupUsers: function getSubscriptionGroupUsers(state) {
    return state.groupUsers;
  },
  getWebtvUsers: function getWebtvUsers(state) {
    return state.webtvUsers;
  },
  getWebtvGroups: function getWebtvGroups(state) {
    return state.webtvGroups;
  },
  getUrlDownloadFile: function getUrlDownloadFile(state) {
    return state.urlDownloadFile;
  },
  getDiffusionObject: function getDiffusionObject(state) {
    return state.objectDiffusion;
  },
  getLinkArchivedVideo: function getLinkArchivedVideo(state) {
    return state.linkArchivedVideo;
  },
  getArchivedLive: function getArchivedLive(state) {
    return state.isArchivedLive;
  },
  getDataShareLink: function getDataShareLink(state) {
    return state.dataShareLink;
  },
  getLiveId: function getLiveId(state) {
    return state.liveId;
  },
  getAllSkinTemplates: function getAllSkinTemplates(state) {
    return state.allTemplates;
  },
  getlistGroup: function getlistGroup(state) {
    return state.listGroup;
  },
  getlistMail: function getlistMail(state) {
    return state.listMail;
  },
  getGroupById: function getGroupById(state) {
    return function (id) {
      return state.listGroup.find(function (item) {
        return item.id === id;
      });
    };
  },
  isGroupExist: function isGroupExist(state) {
    return function (id) {
      return state.listGroup.some(function (g) {
        return g.id === id;
      });
    };
  },
  getResponseDelete: function getResponseDelete(state) {
    return state.responseDelete;
  },
  getHlsValue: function getHlsValue(state) {
    return state.linkHls;
  },
  getLiveSkins: function getLiveSkins(state) {
    return state.liveSkins;
  }

};

/* harmony default export */ var lives_data = ({
  namespaced: true,
  state: lives_data_state,
  getters: lives_data_getters,
  actions: lives_data_actions,
  mutations: lives_data_mutations
});
// CONCATENATED MODULE: ./src/store/modules/form-data.js







var form_data_moment = __webpack_require__("PJh5");

var form_data_state = {
  pagination: {
    videos: {
      currentPage: 0,
      nbPerPage: 12,
      loading: false,
      endReached: false
    }
  },
  videos: [],
  surveys: []
};

var form_data_mutations = {
  pushVideos: function pushVideos(state, videos) {
    state.videos = state.videos.concat(videos.map(function (v) {
      if (!v.thumbnail) {
        v.thumbnail = 'data:image/png;base64,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';
      }
      return v;
    }));
  },
  setSurveys: function setSurveys(state, surveys) {
    state.surveys = keys_default()(surveys).map(function (k) {
      return { value: surveys[k], text: k };
    });
  },
  setEndReached: function setEndReached(state, _ref) {
    var type = _ref.type,
        value = _ref.value;

    state.pagination[type].endReached = value;
  },
  setLoading: function setLoading(state, _ref2) {
    var type = _ref2.type,
        value = _ref2.value;

    state.pagination[type].loading = value;
  },
  incrementPage: function incrementPage(state, type) {
    state.pagination[type].currentPage += 1;
  },
  resetPagination: function resetPagination(state, type) {
    state.pagination[type].currentPage = 0;
    state.pagination[type].loading = false;
    state[type] = [];
  }
};

var form_data_actions = {
  fetchVideos: function fetchVideos(_ref3, keyword) {
    var _this = this;

    var commit = _ref3.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var url, _ref4, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('setLoading', { type: 'videos', value: true });
              commit('incrementPage', 'videos');
              url = router_router.generate('api_video_get_list_transcoded_videos', {
                page: form_data_state.pagination.videos.currentPage,
                nbPerPage: form_data_state.pagination.videos.nbPerPage,
                keyWord: keyword || ''
              });
              _context.next = 5;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 5:
              _ref4 = _context.sent;
              data = _ref4.data;

              commit('pushVideos', data.videos);

              if (data.videos.length < form_data_state.pagination.videos.nbPerPage) {
                commit('setEndReached', { type: 'videos', value: true });
              }
              commit('setLoading', { type: 'videos', value: false });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchSurveys: function fetchSurveys(_ref5) {
    var _this2 = this;

    var commit = _ref5.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var url, _ref6, data;

      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = router_router.generate('api_survey_get_list_surveys');
              _context2.next = 3;
              return new promise_default.a(function (resolve, reject) {
                HTTP(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref6 = _context2.sent;
              data = _ref6.data;

              commit('setSurveys', data.data.names);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  resetPagination: function resetPagination(_ref7, type) {
    var commit = _ref7.commit;

    commit('resetPagination', type);
  }
};

var form_data_getters = {
  getSurveys: function getSurveys(state) {
    return state.surveys;
  },
  getVideos: function getVideos(state) {
    return state.videos;
  },
  getEndReached: function getEndReached(state) {
    return function (type) {
      return state.pagination[type].endReached;
    };
  },
  getLoading: function getLoading(state) {
    return function (type) {
      return state.pagination[type].loading;
    };
  }
};

/* harmony default export */ var form_data = ({
  namespaced: true,
  state: form_data_state,
  getters: form_data_getters,
  actions: form_data_actions,
  mutations: form_data_mutations
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = window.process.env.NODE_ENV !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    lives: lives_data,
    common: common_data,
    form: form_data,
    socket: lives_socket
  },
  strict: debug
}));
// CONCATENATED MODULE: ./src/main.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

























var bus = new vue_esm["default"]();
var main_urlParams = new URLSearchParams(window.location.search);
var main_color = main_urlParams.get('color') ? main_urlParams.get('color') : '#2096f8';



vue_esm["default"].use(VueTimepicker_common_default.a);

window.eventHub = new vue_esm["default"]();

vue_esm["default"].use(vue_moment_default.a, {
  moment: moment_default.a
});
vue_esm["default"].use(ckeditor_default.a);
index_es["c" /* library */].add(free_solid_svg_icons_index_es["F" /* faPencilAlt */], free_solid_svg_icons_index_es["p" /* faEye */], free_solid_svg_icons_index_es["Q" /* faVideo */], free_solid_svg_icons_index_es["a" /* faArchive */], free_solid_svg_icons_index_es["G" /* faPlay */], free_solid_svg_icons_index_es["z" /* faImages */], free_solid_svg_icons_index_es["q" /* faFile */], free_solid_svg_icons_index_es["v" /* faFilePdf */], free_solid_svg_icons_index_es["x" /* faFileWord */], free_solid_svg_icons_index_es["u" /* faFileImage */], free_solid_svg_icons_index_es["t" /* faFileExcel */], free_solid_svg_icons_index_es["w" /* faFileVideo */], free_solid_svg_icons_index_es["r" /* faFileArchive */], free_solid_svg_icons_index_es["O" /* faTimesCircle */], free_solid_svg_icons_index_es["o" /* faExclamationTriangle */], free_solid_svg_icons_index_es["e" /* faChartBar */], free_solid_svg_icons_index_es["A" /* faInfoCircle */], free_solid_svg_icons_index_es["N" /* faTimes */], free_solid_svg_icons_index_es["k" /* faCommentAlt */], free_solid_svg_icons_index_es["i" /* faCode */], free_solid_svg_icons_index_es["E" /* faPen */], free_solid_svg_icons_index_es["j" /* faCog */], free_solid_svg_icons_index_es["l" /* faDesktop */], free_solid_svg_icons_index_es["C" /* faList */], free_solid_svg_icons_index_es["M" /* faThLarge */], free_solid_svg_icons_index_es["J" /* faPlusCircle */], free_solid_svg_icons_index_es["I" /* faPlus */], free_solid_svg_icons_index_es["c" /* faBars */], free_solid_svg_icons_index_es["n" /* faEnvelope */], free_solid_svg_icons_index_es["B" /* faLink */], free_regular_svg_icons_index_es["a" /* faCopy */], free_solid_svg_icons_index_es["h" /* faClock */], free_solid_svg_icons_index_es["m" /* faEllipsisV */], free_solid_svg_icons_index_es["K" /* faSearch */], free_solid_svg_icons_index_es["y" /* faFilter */], free_solid_svg_icons_index_es["d" /* faCalendarAlt */], free_brands_svg_icons_index_es["a" /* faChromecast */], free_brands_svg_icons_index_es["b" /* fab */], free_solid_svg_icons_index_es["R" /* fas */], free_regular_svg_icons_index_es["b" /* far */], free_solid_svg_icons_index_es["L" /* faShareSquare */], free_solid_svg_icons_index_es["s" /* faFileDownload */], free_solid_svg_icons_index_es["P" /* faTrash */], free_solid_svg_icons_index_es["f" /* faCheck */], free_solid_svg_icons_index_es["g" /* faCheckCircle */], free_solid_svg_icons_index_es["H" /* faPlayCircle */], free_solid_svg_icons_index_es["b" /* faArrowLeft */], free_solid_svg_icons_index_es["D" /* faObjectGroup */]);

vue_esm["default"].component('font-awesome-icon', vue_fontawesome_index_es["a" /* FontAwesomeIcon */]);
vue_esm["default"].use(es_default.a);
vue_esm["default"].use(lib_default.a);
vue_esm["default"].use(vue_cookies_default.a);
vue_esm["default"].use(vue_toasted_min_default.a, {
  iconPack: 'custom-class'
});
vue_esm["default"].use(nprogress_nprogress_default.a);
var progress = document.querySelector(nprogress_nprogress_default.a.settings.parent);
progress.setAttribute('style', '--primary-color:' + main_color);
vue_esm["default"].component('font-awesome-icon', vue_fontawesome_index_es["a" /* FontAwesomeIcon */]);
vue_esm["default"].use(vue_i18n_esm["a" /* default */]);
vue_esm["default"].config.productionTip = false;
vue_cookies_default.a.config('7d');
var main_locale = 'fr';
i18n.locale = main_locale;
bus.$on('setFormLang', function (lang) {
  main_locale = lang;
  i18n.locale = main_locale;
});
/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: src_router,
  store: store,
  i18n: i18n,
  components: { App: src_App },
  template: '<App/>'
});

/***/ }),

/***/ "QADr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SWQt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TEnX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dHfH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "je/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJvz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lR5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nnzz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qqS2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rh3Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// liste-lives/static/js/app.2c07730a0d95376efb5b.js